import * as v from "react";
import ee, { createElement as pl, createContext as dl, useState as re, useContext as Fa, useEffect as hu, useLayoutEffect as ls, Component as fl, useRef as Dt } from "react";
import "react-dom";
import Ze from "moment";
import ma from "@microlink/react";
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Au(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function hl(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(s, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), s;
}
var jt = { exports: {} }, Yu = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yn;
function Fl() {
  if (yn) return Yu;
  yn = 1;
  var e = ee, t = Symbol.for("react.element"), s = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, o, D) {
    var E, p = {}, m = null, c = null;
    D !== void 0 && (m = "" + D), o.key !== void 0 && (m = "" + o.key), o.ref !== void 0 && (c = o.ref);
    for (E in o) r.call(o, E) && !i.hasOwnProperty(E) && (p[E] = o[E]);
    if (l && l.defaultProps) for (E in o = l.defaultProps, o) p[E] === void 0 && (p[E] = o[E]);
    return { $$typeof: t, type: l, key: m, ref: c, props: p, _owner: n.current };
  }
  return Yu.Fragment = s, Yu.jsx = a, Yu.jsxs = a, Yu;
}
var Xu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bn;
function ml() {
  return Bn || (Bn = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ee, t = Symbol.for("react.element"), s = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), D = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), c = Symbol.for("react.offscreen"), f = Symbol.iterator, C = "@@iterator";
    function g(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = f && y[f] || y[C];
      return typeof P == "function" ? P : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function d(y) {
      {
        for (var P = arguments.length, Z = new Array(P > 1 ? P - 1 : 0), Q = 1; Q < P; Q++)
          Z[Q - 1] = arguments[Q];
        h("error", y, Z);
      }
    }
    function h(y, P, Z) {
      {
        var Q = x.ReactDebugCurrentFrame, ce = Q.getStackAddendum();
        ce !== "" && (P += "%s", Z = Z.concat([ce]));
        var Fe = Z.map(function(ae) {
          return String(ae);
        });
        Fe.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, Fe);
      }
    }
    var F = !1, A = !1, B = !1, w = !1, k = !1, U;
    U = Symbol.for("react.module.reference");
    function L(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === i || k || y === n || y === D || y === E || w || y === c || F || A || B || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === p || y.$$typeof === a || y.$$typeof === l || y.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === U || y.getModuleId !== void 0));
    }
    function T(y, P, Z) {
      var Q = y.displayName;
      if (Q)
        return Q;
      var ce = P.displayName || P.name || "";
      return ce !== "" ? Z + "(" + ce + ")" : Z;
    }
    function S(y) {
      return y.displayName || "Context";
    }
    function I(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case s:
          return "Portal";
        case i:
          return "Profiler";
        case n:
          return "StrictMode";
        case D:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case l:
            var P = y;
            return S(P) + ".Consumer";
          case a:
            var Z = y;
            return S(Z._context) + ".Provider";
          case o:
            return T(y, y.render, "ForwardRef");
          case p:
            var Q = y.displayName || null;
            return Q !== null ? Q : I(y.type) || "Memo";
          case m: {
            var ce = y, Fe = ce._payload, ae = ce._init;
            try {
              return I(ae(Fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, R = 0, q, ie, ne, O, b, N, M;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function z() {
      {
        if (R === 0) {
          q = console.log, ie = console.info, ne = console.warn, O = console.error, b = console.group, N = console.groupCollapsed, M = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        R++;
      }
    }
    function Y() {
      {
        if (R--, R === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, y, {
              value: q
            }),
            info: j({}, y, {
              value: ie
            }),
            warn: j({}, y, {
              value: ne
            }),
            error: j({}, y, {
              value: O
            }),
            group: j({}, y, {
              value: b
            }),
            groupCollapsed: j({}, y, {
              value: N
            }),
            groupEnd: j({}, y, {
              value: M
            })
          });
        }
        R < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = x.ReactCurrentDispatcher, X;
    function J(y, P, Z) {
      {
        if (X === void 0)
          try {
            throw Error();
          } catch (ce) {
            var Q = ce.stack.trim().match(/\n( *(at )?)/);
            X = Q && Q[1] || "";
          }
        return `
` + X + y;
      }
    }
    var H = !1, G;
    {
      var te = typeof WeakMap == "function" ? WeakMap : Map;
      G = new te();
    }
    function $(y, P) {
      if (!y || H)
        return "";
      {
        var Z = G.get(y);
        if (Z !== void 0)
          return Z;
      }
      var Q;
      H = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Fe;
      Fe = K.current, K.current = null, z();
      try {
        if (P) {
          var ae = function() {
            throw Error();
          };
          if (Object.defineProperty(ae.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ae, []);
            } catch (Se) {
              Q = Se;
            }
            Reflect.construct(y, [], ae);
          } else {
            try {
              ae.call();
            } catch (Se) {
              Q = Se;
            }
            y.call(ae.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Se) {
            Q = Se;
          }
          y();
        }
      } catch (Se) {
        if (Se && Q && typeof Se.stack == "string") {
          for (var se = Se.stack.split(`
`), ke = Q.stack.split(`
`), Ae = se.length - 1, ge = ke.length - 1; Ae >= 1 && ge >= 0 && se[Ae] !== ke[ge]; )
            ge--;
          for (; Ae >= 1 && ge >= 0; Ae--, ge--)
            if (se[Ae] !== ke[ge]) {
              if (Ae !== 1 || ge !== 1)
                do
                  if (Ae--, ge--, ge < 0 || se[Ae] !== ke[ge]) {
                    var Ie = `
` + se[Ae].replace(" at new ", " at ");
                    return y.displayName && Ie.includes("<anonymous>") && (Ie = Ie.replace("<anonymous>", y.displayName)), typeof y == "function" && G.set(y, Ie), Ie;
                  }
                while (Ae >= 1 && ge >= 0);
              break;
            }
        }
      } finally {
        H = !1, K.current = Fe, Y(), Error.prepareStackTrace = ce;
      }
      var wu = y ? y.displayName || y.name : "", ou = wu ? J(wu) : "";
      return typeof y == "function" && G.set(y, ou), ou;
    }
    function he(y, P, Z) {
      return $(y, !1);
    }
    function we(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function fe(y, P, Z) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return $(y, we(y));
      if (typeof y == "string")
        return J(y);
      switch (y) {
        case D:
          return J("Suspense");
        case E:
          return J("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case o:
            return he(y.render);
          case p:
            return fe(y.type, P, Z);
          case m: {
            var Q = y, ce = Q._payload, Fe = Q._init;
            try {
              return fe(Fe(ce), P, Z);
            } catch {
            }
          }
        }
      return "";
    }
    var eu = Object.prototype.hasOwnProperty, gt = {}, qu = x.ReactDebugCurrentFrame;
    function Bu(y) {
      if (y) {
        var P = y._owner, Z = fe(y.type, y._source, P ? P.type : null);
        qu.setExtraStackFrame(Z);
      } else
        qu.setExtraStackFrame(null);
    }
    function vt(y, P, Z, Q, ce) {
      {
        var Fe = Function.call.bind(eu);
        for (var ae in y)
          if (Fe(y, ae)) {
            var se = void 0;
            try {
              if (typeof y[ae] != "function") {
                var ke = Error((Q || "React class") + ": " + Z + " type `" + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ke.name = "Invariant Violation", ke;
              }
              se = y[ae](P, ae, Q, Z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ae) {
              se = Ae;
            }
            se && !(se instanceof Error) && (Bu(ce), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", Z, ae, typeof se), Bu(null)), se instanceof Error && !(se.message in gt) && (gt[se.message] = !0, Bu(ce), d("Failed %s type: %s", Z, se.message), Bu(null));
          }
      }
    }
    var gs = Array.isArray;
    function Zu(y) {
      return gs(y);
    }
    function yt(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, Z = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return Z;
      }
    }
    function vs(y) {
      try {
        return Bt(y), !1;
      } catch {
        return !0;
      }
    }
    function Bt(y) {
      return "" + y;
    }
    function bt(y) {
      if (vs(y))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yt(y)), Bt(y);
    }
    var wt = x.ReactCurrentOwner, iu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, au, Ku;
    function uu(y) {
      if (eu.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function ys(y) {
      if (eu.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function X0(y, P) {
      typeof y.ref == "string" && wt.current;
    }
    function J0(y, P) {
      {
        var Z = function() {
          au || (au = !0, d("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        Z.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: Z,
          configurable: !0
        });
      }
    }
    function Q0(y, P) {
      {
        var Z = function() {
          Ku || (Ku = !0, d("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        Z.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: Z,
          configurable: !0
        });
      }
    }
    var el = function(y, P, Z, Q, ce, Fe, ae) {
      var se = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: Z,
        props: ae,
        // Record the component responsible for creating this element.
        _owner: Fe
      };
      return se._store = {}, Object.defineProperty(se._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(se, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.defineProperty(se, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(se.props), Object.freeze(se)), se;
    };
    function ul(y, P, Z, Q, ce) {
      {
        var Fe, ae = {}, se = null, ke = null;
        Z !== void 0 && (bt(Z), se = "" + Z), ys(P) && (bt(P.key), se = "" + P.key), uu(P) && (ke = P.ref, X0(P, ce));
        for (Fe in P)
          eu.call(P, Fe) && !iu.hasOwnProperty(Fe) && (ae[Fe] = P[Fe]);
        if (y && y.defaultProps) {
          var Ae = y.defaultProps;
          for (Fe in Ae)
            ae[Fe] === void 0 && (ae[Fe] = Ae[Fe]);
        }
        if (se || ke) {
          var ge = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          se && J0(ae, ge), ke && Q0(ae, ge);
        }
        return el(y, se, ke, ce, Q, wt.current, ae);
      }
    }
    var Bs = x.ReactCurrentOwner, mn = x.ReactDebugCurrentFrame;
    function bu(y) {
      if (y) {
        var P = y._owner, Z = fe(y.type, y._source, P ? P.type : null);
        mn.setExtraStackFrame(Z);
      } else
        mn.setExtraStackFrame(null);
    }
    var bs;
    bs = !1;
    function ws(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function Cn() {
      {
        if (Bs.current) {
          var y = I(Bs.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function tl(y) {
      return "";
    }
    var En = {};
    function sl(y) {
      {
        var P = Cn();
        if (!P) {
          var Z = typeof y == "string" ? y : y.displayName || y.name;
          Z && (P = `

Check the top-level render call using <` + Z + ">.");
        }
        return P;
      }
    }
    function xn(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var Z = sl(P);
        if (En[Z])
          return;
        En[Z] = !0;
        var Q = "";
        y && y._owner && y._owner !== Bs.current && (Q = " It was passed a child from " + I(y._owner.type) + "."), bu(y), d('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Z, Q), bu(null);
      }
    }
    function An(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Zu(y))
          for (var Z = 0; Z < y.length; Z++) {
            var Q = y[Z];
            ws(Q) && xn(Q, P);
          }
        else if (ws(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ce = g(y);
          if (typeof ce == "function" && ce !== y.entries)
            for (var Fe = ce.call(y), ae; !(ae = Fe.next()).done; )
              ws(ae.value) && xn(ae.value, P);
        }
      }
    }
    function rl(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var Z;
        if (typeof P == "function")
          Z = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === p))
          Z = P.propTypes;
        else
          return;
        if (Z) {
          var Q = I(P);
          vt(Z, y.props, "prop", Q, y);
        } else if (P.PropTypes !== void 0 && !bs) {
          bs = !0;
          var ce = I(P);
          d("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && d("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function nl(y) {
      {
        for (var P = Object.keys(y.props), Z = 0; Z < P.length; Z++) {
          var Q = P[Z];
          if (Q !== "children" && Q !== "key") {
            bu(y), d("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), bu(null);
            break;
          }
        }
        y.ref !== null && (bu(y), d("Invalid attribute `ref` supplied to `React.Fragment`."), bu(null));
      }
    }
    var gn = {};
    function vn(y, P, Z, Q, ce, Fe) {
      {
        var ae = L(y);
        if (!ae) {
          var se = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (se += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ke = tl();
          ke ? se += ke : se += Cn();
          var Ae;
          y === null ? Ae = "null" : Zu(y) ? Ae = "array" : y !== void 0 && y.$$typeof === t ? (Ae = "<" + (I(y.type) || "Unknown") + " />", se = " Did you accidentally export a JSX literal instead of a component?") : Ae = typeof y, d("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ae, se);
        }
        var ge = ul(y, P, Z, ce, Fe);
        if (ge == null)
          return ge;
        if (ae) {
          var Ie = P.children;
          if (Ie !== void 0)
            if (Q)
              if (Zu(Ie)) {
                for (var wu = 0; wu < Ie.length; wu++)
                  An(Ie[wu], y);
                Object.freeze && Object.freeze(Ie);
              } else
                d("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              An(Ie, y);
        }
        if (eu.call(P, "key")) {
          var ou = I(y), Se = Object.keys(P).filter(function(Dl) {
            return Dl !== "key";
          }), js = Se.length > 0 ? "{key: someKey, " + Se.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!gn[ou + js]) {
            var cl = Se.length > 0 ? "{" + Se.join(": ..., ") + ": ...}" : "{}";
            d(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, js, ou, cl, ou), gn[ou + js] = !0;
          }
        }
        return y === r ? nl(ge) : rl(ge), ge;
      }
    }
    function il(y, P, Z) {
      return vn(y, P, Z, !0);
    }
    function al(y, P, Z) {
      return vn(y, P, Z, !1);
    }
    var ol = al, ll = il;
    Xu.Fragment = r, Xu.jsx = ol, Xu.jsxs = ll;
  })()), Xu;
}
var bn;
function Vr() {
  return bn || (bn = 1, process.env.NODE_ENV === "production" ? jt.exports = Fl() : jt.exports = ml()), jt.exports;
}
var u = Vr();
function Cl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(s) {
    return t[s] === void 0 && (t[s] = e(s)), t[s];
  };
}
var El = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, xl = /* @__PURE__ */ Cl(
  function(e) {
    return El.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ce = "-ms-", at = "-moz-", oe = "-webkit-", Ca = "comm", cs = "rule", Wr = "decl", Al = "@import", gl = "@namespace", Ea = "@keyframes", vl = "@layer", xa = Math.abs, Gr = String.fromCharCode, vr = Object.assign;
function yl(e, t) {
  return ye(e, 0) ^ 45 ? (((t << 2 ^ ye(e, 0)) << 2 ^ ye(e, 1)) << 2 ^ ye(e, 2)) << 2 ^ ye(e, 3) : 0;
}
function Aa(e) {
  return e.trim();
}
function Ke(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ue(e, t, s) {
  return e.replace(t, s);
}
function Wt(e, t, s) {
  return e.indexOf(t, s);
}
function ye(e, t) {
  return e.charCodeAt(t) | 0;
}
function Fu(e, t, s) {
  return e.slice(t, s);
}
function Re(e) {
  return e.length;
}
function ga(e) {
  return e.length;
}
function tt(e, t) {
  return t.push(e), e;
}
function Bl(e, t) {
  return e.map(t).join("");
}
function wn(e, t) {
  return e.filter(function(s) {
    return !Ke(s, t);
  });
}
var Ds = 1, Iu = 1, va = 0, Le = 0, ve = 0, zu = "";
function ps(e, t, s, r, n, i, a, l) {
  return { value: e, root: t, parent: s, type: r, props: n, children: i, line: Ds, column: Iu, length: a, return: "", siblings: l };
}
function tu(e, t) {
  return vr(ps("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function ju(e) {
  for (; e.root; )
    e = tu(e.root, { children: [e] });
  tt(e, e.siblings);
}
function bl() {
  return ve;
}
function wl() {
  return ve = Le > 0 ? ye(zu, --Le) : 0, Iu--, ve === 10 && (Iu = 1, Ds--), ve;
}
function $e() {
  return ve = Le < va ? ye(zu, Le++) : 0, Iu++, ve === 10 && (Iu = 1, Ds++), ve;
}
function su() {
  return ye(zu, Le);
}
function Gt() {
  return Le;
}
function ds(e, t) {
  return Fu(zu, e, t);
}
function pt(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function jl(e) {
  return Ds = Iu = 1, va = Re(zu = e), Le = 0, [];
}
function _l(e) {
  return zu = "", e;
}
function ks(e) {
  return Aa(ds(Le - 1, yr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function kl(e) {
  for (; (ve = su()) && ve < 33; )
    $e();
  return pt(e) > 2 || pt(ve) > 3 ? "" : " ";
}
function Nl(e, t) {
  for (; --t && $e() && !(ve < 48 || ve > 102 || ve > 57 && ve < 65 || ve > 70 && ve < 97); )
    ;
  return ds(e, Gt() + (t < 6 && su() == 32 && $e() == 32));
}
function yr(e) {
  for (; $e(); )
    switch (ve) {
      // ] ) " '
      case e:
        return Le;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && yr(ve);
        break;
      // (
      case 40:
        e === 41 && yr(e);
        break;
      // \
      case 92:
        $e();
        break;
    }
  return Le;
}
function Tl(e, t) {
  for (; $e() && e + ve !== 57; )
    if (e + ve === 84 && su() === 47)
      break;
  return "/*" + ds(t, Le - 1) + "*" + Gr(e === 47 ? e : $e());
}
function Sl(e) {
  for (; !pt(su()); )
    $e();
  return ds(e, Le);
}
function Pl(e) {
  return _l(qt("", null, null, null, [""], e = jl(e), 0, [0], e));
}
function qt(e, t, s, r, n, i, a, l, o) {
  for (var D = 0, E = 0, p = a, m = 0, c = 0, f = 0, C = 1, g = 1, x = 1, d = 0, h = "", F = n, A = i, B = r, w = h; g; )
    switch (f = d, d = $e()) {
      // (
      case 40:
        if (f != 108 && ye(w, p - 1) == 58) {
          Wt(w += ue(ks(d), "&", "&\f"), "&\f", xa(D ? l[D - 1] : 0)) != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        w += ks(d);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        w += kl(f);
        break;
      // \
      case 92:
        w += Nl(Gt() - 1, 7);
        continue;
      // /
      case 47:
        switch (su()) {
          case 42:
          case 47:
            tt(Il(Tl($e(), Gt()), t, s, o), o), (pt(f || 1) == 5 || pt(su() || 1) == 5) && Re(w) && Fu(w, -1, void 0) !== " " && (w += " ");
            break;
          default:
            w += "/";
        }
        break;
      // {
      case 123 * C:
        l[D++] = Re(w) * x;
      // } ; \0
      case 125 * C:
      case 59:
      case 0:
        switch (d) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + E:
            x == -1 && (w = ue(w, /\f/g, "")), c > 0 && (Re(w) - p || C === 0 && f === 47) && tt(c > 32 ? _n(w + ";", r, s, p - 1, o) : _n(ue(w, " ", "") + ";", r, s, p - 2, o), o);
            break;
          // @ ;
          case 59:
            w += ";";
          // { rule/at-rule
          default:
            if (tt(B = jn(w, t, s, D, E, n, l, h, F = [], A = [], p, i), i), d === 123)
              if (E === 0)
                qt(w, t, B, B, F, i, p, l, A);
              else {
                switch (m) {
                  // c(ontainer)
                  case 99:
                    if (ye(w, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (ye(w, 2) === 97) break;
                  default:
                    E = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                E ? qt(e, B, B, r && tt(jn(e, B, B, 0, 0, n, l, h, n, F = [], p, A), A), n, A, p, l, r ? F : A) : qt(w, B, B, B, [""], A, 0, l, A);
              }
        }
        D = E = c = 0, C = x = 1, h = w = "", p = a;
        break;
      // :
      case 58:
        p = 1 + Re(w), c = f;
      default:
        if (C < 1) {
          if (d == 123)
            --C;
          else if (d == 125 && C++ == 0 && wl() == 125)
            continue;
        }
        switch (w += Gr(d), d * C) {
          // &
          case 38:
            x = E > 0 ? 1 : (w += "\f", -1);
            break;
          // ,
          case 44:
            l[D++] = (Re(w) - 1) * x, x = 1;
            break;
          // @
          case 64:
            su() === 45 && (w += ks($e())), m = su(), E = p = Re(h = w += Sl(Gt())), d++;
            break;
          // -
          case 45:
            f === 45 && Re(w) == 2 && (C = 0);
        }
    }
  return i;
}
function jn(e, t, s, r, n, i, a, l, o, D, E, p) {
  for (var m = n - 1, c = n === 0 ? i : [""], f = ga(c), C = 0, g = 0, x = 0; C < r; ++C)
    for (var d = 0, h = Fu(e, m + 1, m = xa(g = a[C])), F = e; d < f; ++d)
      (F = Aa(g > 0 ? c[d] + " " + h : ue(h, /&\f/g, c[d]))) && (o[x++] = F);
  return ps(e, t, s, n === 0 ? cs : l, o, D, E, p);
}
function Il(e, t, s, r) {
  return ps(e, t, s, Ca, Gr(bl()), Fu(e, 2, -2), 0, r);
}
function _n(e, t, s, r, n) {
  return ps(e, t, s, Wr, Fu(e, 0, r), Fu(e, r + 1, -1), r, n);
}
function ya(e, t, s) {
  switch (yl(e, t)) {
    // color-adjust
    case 5103:
      return oe + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return oe + e + e;
    // mask-composite
    case 4855:
      return oe + e.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + e;
    // tab-size
    case 4789:
      return at + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return oe + e + at + e + Ce + e + e;
    // writing-mode
    case 5936:
      switch (ye(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return oe + e + Ce + ue(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return oe + e + Ce + ue(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return oe + e + Ce + ue(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return oe + e + Ce + e + e;
    // order
    case 6165:
      return oe + e + Ce + "flex-" + e + e;
    // align-items
    case 5187:
      return oe + e + ue(e, /(\w+).+(:[^]+)/, oe + "box-$1$2" + Ce + "flex-$1$2") + e;
    // align-self
    case 5443:
      return oe + e + Ce + "flex-item-" + ue(e, /flex-|-self/g, "") + (Ke(e, /flex-|baseline/) ? "" : Ce + "grid-row-" + ue(e, /flex-|-self/g, "")) + e;
    // align-content
    case 4675:
      return oe + e + Ce + "flex-line-pack" + ue(e, /align-content|flex-|-self/g, "") + e;
    // flex-shrink
    case 5548:
      return oe + e + Ce + ue(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return oe + e + Ce + ue(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return oe + "box-" + ue(e, "-grow", "") + oe + e + Ce + ue(e, "grow", "positive") + e;
    // transition
    case 4554:
      return oe + ue(e, /([^-])(transform)/g, "$1" + oe + "$2") + e;
    // cursor
    case 6187:
      return ue(ue(ue(e, /(zoom-|grab)/, oe + "$1"), /(image-set)/, oe + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return ue(e, /(image-set\([^]*)/, oe + "$1$`$1");
    // justify-content
    case 4968:
      return ue(ue(e, /(.+:)(flex-)?(.*)/, oe + "box-pack:$3" + Ce + "flex-pack:$3"), /space-between/, "justify") + oe + e + e;
    // justify-self
    case 4200:
      if (!Ke(e, /flex-|baseline/)) return Ce + "grid-column-align" + Fu(e, t) + e;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return Ce + ue(e, "template-", "") + e;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return s && s.some(function(r, n) {
        return t = n, Ke(r.props, /grid-\w+-end/);
      }) ? ~Wt(e + (s = s[t].value), "span", 0) ? e : Ce + ue(e, "-start", "") + e + Ce + "grid-row-span:" + (~Wt(s, "span", 0) ? Ke(s, /\d+/) : +Ke(s, /\d+/) - +Ke(e, /\d+/)) + ";" : Ce + ue(e, "-start", "") + e;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return s && s.some(function(r) {
        return Ke(r.props, /grid-\w+-start/);
      }) ? e : Ce + ue(ue(e, "-end", "-span"), "span ", "") + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ue(e, /(.+)-inline(.+)/, oe + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Re(e) - 1 - t > 6)
        switch (ye(e, t + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (ye(e, t + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return ue(e, /(.+:)(.+)-([^]+)/, "$1" + oe + "$2-$3$1" + at + (ye(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          // (s)tretch
          case 115:
            return ~Wt(e, "stretch", 0) ? ya(ue(e, "stretch", "fill-available"), t, s) + e : e;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return ue(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, n, i, a, l, o, D) {
        return Ce + n + ":" + i + D + (a ? Ce + n + "-span:" + (l ? o : +o - +i) + D : "") + e;
      });
    // position: sticky
    case 4949:
      if (ye(e, t + 6) === 121)
        return ue(e, ":", ":" + oe) + e;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (ye(e, ye(e, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return ue(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + oe + (ye(e, 14) === 45 ? "inline-" : "") + "box$3$1" + oe + "$2$3$1" + Ce + "$2box$3") + e;
        // (inline-)?gri(d)
        case 100:
          return ue(e, ":", ":" + Ce) + e;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return ue(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function Qt(e, t) {
  for (var s = "", r = 0; r < e.length; r++)
    s += t(e[r], r, e, t) || "";
  return s;
}
function Ol(e, t, s, r) {
  switch (e.type) {
    case vl:
      if (e.children.length) break;
    case Al:
    case gl:
    case Wr:
      return e.return = e.return || e.value;
    case Ca:
      return "";
    case Ea:
      return e.return = e.value + "{" + Qt(e.children, r) + "}";
    case cs:
      if (!Re(e.value = e.props.join(","))) return "";
  }
  return Re(s = Qt(e.children, r)) ? e.return = e.value + "{" + s + "}" : "";
}
function Ll(e) {
  var t = ga(e);
  return function(s, r, n, i) {
    for (var a = "", l = 0; l < t; l++)
      a += e[l](s, r, n, i) || "";
    return a;
  };
}
function Rl(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function $l(e, t, s, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Wr:
        e.return = ya(e.value, e.length, s);
        return;
      case Ea:
        return Qt([tu(e, { value: ue(e.value, "@", "@" + oe) })], r);
      case cs:
        if (e.length)
          return Bl(s = e.props, function(n) {
            switch (Ke(n, r = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                ju(tu(e, { props: [ue(n, /:(read-\w+)/, ":" + at + "$1")] })), ju(tu(e, { props: [n] })), vr(e, { props: wn(s, r) });
                break;
              // :placeholder
              case "::placeholder":
                ju(tu(e, { props: [ue(n, /:(plac\w+)/, ":" + oe + "input-$1")] })), ju(tu(e, { props: [ue(n, /:(plac\w+)/, ":" + at + "$1")] })), ju(tu(e, { props: [ue(n, /:(plac\w+)/, Ce + "input-$1")] })), ju(tu(e, { props: [n] })), vr(e, { props: wn(s, r) });
                break;
            }
            return "";
          });
    }
}
var Ns, Ts;
const mu = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Ba = "active", ba = "data-styled-version", fs = "6.4.1", qr = `/*!sc*/
`, ot = typeof window < "u" && typeof document < "u";
function kn(e) {
  if (typeof process < "u" && process.env !== void 0) {
    const t = process.env[e];
    if (t !== void 0 && t !== "") return t !== "false";
  }
}
const Ml = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Ts = (Ns = kn("REACT_APP_SC_DISABLE_SPEEDY")) !== null && Ns !== void 0 ? Ns : kn("SC_DISABLE_SPEEDY")) !== null && Ts !== void 0 ? Ts : typeof process > "u" || process.env === void 0 || process.env.NODE_ENV !== "production"), Ul = "sc-keyframes-", Hl = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function mt(e, ...t) {
  return process.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`) : new Error((function(...s) {
    let r = s[0];
    const n = [];
    for (let i = 1, a = s.length; i < a; i += 1) n.push(s[i]);
    return n.forEach((i) => {
      r = r.replace(/%[a-z]/, i);
    }), r;
  })(Hl[e], ...t).trim());
}
const zl = 1 << 30;
let Zt = /* @__PURE__ */ new Map(), es = /* @__PURE__ */ new Map(), Kt = 1;
const _t = (e) => {
  if (Zt.has(e)) return Zt.get(e);
  for (; es.has(Kt); ) Kt++;
  const t = Kt++;
  if (process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > zl)) throw mt(16, `${t}`);
  return Zt.set(e, t), es.set(t, e), t;
}, Vl = (e) => es.get(e), Wl = (e, t) => {
  Kt = t + 1, Zt.set(e, t), es.set(t, e);
}, Nn = /invalid hook call/i, kt = /* @__PURE__ */ new Set(), Gl = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const s = `The component ${e}${t ? ` with the id of "${t}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, r = console.error;
    try {
      let n = !0;
      console.error = (i, ...a) => {
        Nn.test(i) ? (n = !1, kt.delete(s)) : r(i, ...a);
      }, typeof ee.useState == "function" && ee.useState(null), n && !kt.has(s) && (console.warn(s), kt.add(s));
    } catch (n) {
      Nn.test(n.message) && kt.delete(s);
    } finally {
      console.error = r;
    }
  }
}, Zr = Object.freeze([]), Ou = Object.freeze({});
function ql(e, t, s = Ou) {
  return e.theme !== s.theme && e.theme || t || s.theme;
}
const Zl = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Kl = /(^-|-$)/g;
function wa(e) {
  return e.replace(Zl, "-").replace(Kl, "");
}
const Yl = /(a)(d)/gi, Tn = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97));
function ja(e) {
  let t, s = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) s = Tn(t % 52) + s;
  return (Tn(t % 52) + s).replace(Yl, "$1-$2");
}
const Br = 5381, pu = (e, t) => {
  let s = t.length;
  for (; s; ) e = 33 * e ^ t.charCodeAt(--s);
  return e;
}, _a = (e) => pu(Br, e);
function Xl(e) {
  return ja(_a(e) >>> 0);
}
function Kr(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Yt(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
function Jl(e) {
  return Yt(e) ? `styled.${e}` : `Styled(${Kr(e)})`;
}
const ka = Symbol.for("react.memo"), Ql = Symbol.for("react.forward_ref"), ec = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, uc = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Na = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, tc = { [Ql]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [ka]: Na };
function Sn(e) {
  return ("type" in (t = e) && t.type.$$typeof) === ka ? Na : "$$typeof" in e ? tc[e.$$typeof] : ec;
  var t;
}
const sc = Object.defineProperty, rc = Object.getOwnPropertyNames, nc = Object.getOwnPropertySymbols, ic = Object.getOwnPropertyDescriptor, ac = Object.getPrototypeOf, oc = Object.prototype;
function Ta(e, t, s) {
  if (typeof t != "string") {
    const r = ac(t);
    r && r !== oc && Ta(e, r, s);
    const n = rc(t).concat(nc(t)), i = Sn(e), a = Sn(t);
    for (let l = 0; l < n.length; ++l) {
      const o = n[l];
      if (!(o in uc || s && s[o] || a && o in a || i && o in i)) {
        const D = ic(t, o);
        try {
          sc(e, o, D);
        } catch {
        }
      }
    }
  }
  return e;
}
function hs(e) {
  return typeof e == "function";
}
function Sa(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function st(e, t) {
  return e && t ? e + " " + t : e || t || "";
}
function Pn(e, t) {
  return e.join("");
}
function Cu(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function br(e, t, s = !1) {
  if (!s && !Cu(e) && !Array.isArray(e)) return t;
  if (Array.isArray(t)) for (let r = 0; r < t.length; r++) e[r] = br(e[r], t[r]);
  else if (Cu(t)) for (const r in t) e[r] = br(e[r], t[r]);
  return e;
}
function Pa(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
const lc = class {
  constructor(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(e) {
    if (e === this._cGroup) return this._cIndex;
    let t = this._cIndex;
    if (e > this._cGroup) for (let s = this._cGroup; s < e; s++) t += this.groupSizes[s];
    else for (let s = this._cGroup - 1; s >= e; s--) t -= this.groupSizes[s];
    return this._cGroup = e, this._cIndex = t, t;
  }
  insertRules(e, t) {
    if (e >= this.groupSizes.length) {
      const n = this.groupSizes, i = n.length;
      let a = i;
      for (; e >= a; ) if (a <<= 1, a < 0) throw mt(16, `${e}`);
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(n), this.length = a;
      for (let l = i; l < a; l++) this.groupSizes[l] = 0;
    }
    let s = this.indexOfGroup(e + 1), r = 0;
    for (let n = 0, i = t.length; n < i; n++) this.tag.insertRule(s, t[n]) && (this.groupSizes[e]++, s++, r++);
    r > 0 && this._cGroup > e && (this._cIndex += r);
  }
  clearGroup(e) {
    if (e < this.length) {
      const t = this.groupSizes[e], s = this.indexOfGroup(e), r = s + t;
      this.groupSizes[e] = 0;
      for (let n = s; n < r; n++) this.tag.deleteRule(s);
      t > 0 && this._cGroup > e && (this._cIndex -= t);
    }
  }
  getGroup(e) {
    let t = "";
    if (e >= this.length || this.groupSizes[e] === 0) return t;
    const s = this.groupSizes[e], r = this.indexOfGroup(e), n = r + s;
    for (let i = r; i < n; i++) t += this.tag.getRule(i) + qr;
    return t;
  }
}, cc = `style[${mu}][${ba}="${fs}"]`, Dc = new RegExp(`^${mu}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), In = (e) => typeof ShadowRoot < "u" && e instanceof ShadowRoot || "host" in e && e.nodeType === 11, wr = (e) => {
  if (!e) return document;
  if (In(e)) return e;
  if ("getRootNode" in e) {
    const t = e.getRootNode();
    if (In(t)) return t;
  }
  return document;
}, pc = (e, t, s) => {
  const r = s.split(",");
  let n;
  for (let i = 0, a = r.length; i < a; i++) (n = r[i]) && e.registerName(t, n);
}, dc = (e, t) => {
  var s;
  const r = ((s = t.textContent) !== null && s !== void 0 ? s : "").split(qr), n = [];
  for (let i = 0, a = r.length; i < a; i++) {
    const l = r[i].trim();
    if (!l) continue;
    const o = l.match(Dc);
    if (o) {
      const D = 0 | parseInt(o[1], 10), E = o[2];
      D !== 0 && (Wl(E, D), pc(e, E, o[3]), e.getTag().insertRules(D, n)), n.length = 0;
    } else n.push(l);
  }
}, Ss = (e) => {
  const t = wr(e.options.target).querySelectorAll(cc);
  for (let s = 0, r = t.length; s < r; s++) {
    const n = t[s];
    n && n.getAttribute(mu) !== Ba && (dc(e, n), n.parentNode && n.parentNode.removeChild(n));
  }
};
let Ju = !1;
function fc() {
  if (Ju !== !1) return Ju;
  if (typeof document < "u") {
    const e = document.head.querySelector('meta[property="csp-nonce"]');
    if (e) return Ju = e.nonce || e.getAttribute("content") || void 0;
    const t = document.head.querySelector('meta[name="sc-nonce"]');
    if (t) return Ju = t.getAttribute("content") || void 0;
  }
  return Ju = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const Ia = (e, t) => {
  const s = document.head, r = e || s, n = document.createElement("style"), i = ((o) => {
    const D = Array.from(o.querySelectorAll(`style[${mu}]`));
    return D[D.length - 1];
  })(r), a = i !== void 0 ? i.nextSibling : null;
  n.setAttribute(mu, Ba), n.setAttribute(ba, fs);
  const l = t || fc();
  return l && n.setAttribute("nonce", l), r.insertBefore(n, a), n;
}, hc = class {
  constructor(e, t) {
    this.element = Ia(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((s) => {
      var r;
      if (s.sheet) return s.sheet;
      const n = (r = s.getRootNode().styleSheets) !== null && r !== void 0 ? r : document.styleSheets;
      for (let i = 0, a = n.length; i < a; i++) {
        const l = n[i];
        if (l.ownerNode === s) return l;
      }
      throw mt(17);
    })(this.element), this.length = 0;
  }
  insertRule(e, t) {
    try {
      return this.sheet.insertRule(t, e), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(e) {
    this.sheet.deleteRule(e), this.length--;
  }
  getRule(e) {
    const t = this.sheet.cssRules[e];
    return t && t.cssText ? t.cssText : "";
  }
}, Fc = class {
  constructor(e, t) {
    this.element = Ia(e, t), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(e, t) {
    if (e <= this.length && e >= 0) {
      const s = document.createTextNode(t);
      return this.element.insertBefore(s, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }
  getRule(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }
};
let On = ot;
const mc = { isServer: !ot, useCSSOMInjection: !Ml };
class Fs {
  static registerId(t) {
    return _t(t);
  }
  constructor(t = Ou, s = {}, r) {
    this.options = Object.assign(Object.assign({}, mc), t), this.gs = s, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(r), this.server = !!t.isServer, !this.server && ot && On && (On = !1, Ss(this)), Pa(this, () => ((n) => {
      const i = n.getTag(), { length: a } = i;
      let l = "";
      for (let o = 0; o < a; o++) {
        const D = Vl(o);
        if (D === void 0) continue;
        const E = n.names.get(D);
        if (E === void 0 || !E.size) continue;
        const p = i.getGroup(o);
        if (p.length === 0) continue;
        const m = mu + ".g" + o + '[id="' + D + '"]';
        let c = "";
        for (const f of E) f.length > 0 && (c += f + ",");
        l += p + m + '{content:"' + c + '"}' + qr;
      }
      return l;
    })(this));
  }
  rehydrate() {
    !this.server && ot && Ss(this);
  }
  reconstructWithOptions(t, s = !0) {
    const r = new Fs(Object.assign(Object.assign({}, this.options), t), this.gs, s && this.names || void 0);
    return r.keyframeIds = new Set(this.keyframeIds), !this.server && ot && t.target !== this.options.target && wr(this.options.target) !== wr(t.target) && Ss(r), r;
  }
  allocateGSInstance(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (t = (({ useCSSOMInjection: s, target: r, nonce: n }) => s ? new hc(r, n) : new Fc(r, n))(this.options), new lc(t)));
    var t;
  }
  hasNameForId(t, s) {
    var r, n;
    return (n = (r = this.names.get(t)) === null || r === void 0 ? void 0 : r.has(s)) !== null && n !== void 0 && n;
  }
  registerName(t, s) {
    _t(t), t.startsWith(Ul) && this.keyframeIds.add(t);
    const r = this.names.get(t);
    r ? r.add(s) : this.names.set(t, /* @__PURE__ */ new Set([s]));
  }
  insertRules(t, s, r) {
    this.registerName(t, s), this.getTag().insertRules(_t(t), r);
  }
  clearNames(t) {
    this.names.has(t) && this.names.get(t).clear();
  }
  clearRules(t) {
    this.getTag().clearGroup(_t(t)), this.clearNames(t);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const Oa = /* @__PURE__ */ new WeakSet(), Cc = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function Ec(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t != "number" || t === 0 || e in Cc || e.startsWith("--") ? String(t).trim() : t + "px";
}
const Du = 47;
function Ln(e) {
  if (e.charCodeAt(0) === 45 && e.charCodeAt(1) === 45) return e;
  let t = "";
  for (let s = 0; s < e.length; s++) {
    const r = e.charCodeAt(s);
    t += r >= 65 && r <= 90 ? "-" + String.fromCharCode(r + 32) : e[s];
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
const xc = Symbol.for("sc-keyframes");
function jr(e) {
  return typeof e == "object" && e !== null && xc in e;
}
function La(e) {
  return hs(e) && !(e.prototype && e.prototype.isReactComponent);
}
const Ra = (e) => e == null || e === !1 || e === "", Ac = Symbol.for("react.client.reference");
function Rn(e) {
  return e.$$typeof === Ac;
}
function $n(e) {
  const t = e.$$id, s = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
  console.warn(`Interpolating a client component (${s}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $a(e, t) {
  for (const s in e) {
    const r = e[s];
    e.hasOwnProperty(s) && !Ra(r) && (Array.isArray(r) && Oa.has(r) || hs(r) ? t.push(Ln(s) + ":", r, ";") : Cu(r) ? (t.push(s + " {"), $a(r, t), t.push("}")) : t.push(Ln(s) + ": " + Ec(s, r) + ";"));
  }
}
function du(e, t, s, r, n = []) {
  if (Ra(e)) return n;
  const i = typeof e;
  if (i === "string") return n.push(e), n;
  if (i === "function") {
    if (Rn(e)) return process.env.NODE_ENV !== "production" && $n(e), n;
    if (La(e) && t) {
      const a = e(t);
      return process.env.NODE_ENV === "production" || typeof a != "object" || Array.isArray(a) || jr(a) || Cu(a) || a === null || console.error(`${Kr(e)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), du(a, t, s, r, n);
    }
    return n.push(e), n;
  }
  if (Array.isArray(e)) {
    for (let a = 0; a < e.length; a++) du(e[a], t, s, r, n);
    return n;
  }
  return Sa(e) ? (n.push(`.${e.styledComponentId}`), n) : jr(e) ? (s ? (e.inject(s, r), n.push(e.getName(r))) : n.push(e), n) : Rn(e) ? (process.env.NODE_ENV !== "production" && $n(e), n) : Cu(e) ? ($a(e, n), n) : (n.push(e.toString()), n);
}
const gc = _a(fs);
class vc {
  constructor(t, s, r) {
    this.rules = t, this.componentId = s, this.baseHash = pu(gc, s), this.baseStyle = r, Fs.registerId(s);
  }
  generateAndInjectStyles(t, s, r) {
    let n = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, s, r) : "";
    {
      let i = "";
      for (let a = 0; a < this.rules.length; a++) {
        const l = this.rules[a];
        if (typeof l == "string") i += l;
        else if (l) if (La(l)) {
          const o = l(t);
          typeof o == "string" ? i += o : o != null && o !== !1 && (process.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || jr(o) || Cu(o) || console.error(`${Kr(l)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), i += Pn(du(o, t, s, r)));
        } else i += Pn(du(l, t, s, r));
      }
      if (i) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const a = r.hash ? r.hash + i : i;
        let l = this.dynamicNameCache.get(a);
        if (!l) {
          if (l = ja(pu(pu(this.baseHash, r.hash), i) >>> 0), this.dynamicNameCache.size >= 200) {
            const o = this.dynamicNameCache.keys().next().value;
            o !== void 0 && this.dynamicNameCache.delete(o);
          }
          this.dynamicNameCache.set(a, l);
        }
        if (!s.hasNameForId(this.componentId, l)) {
          const o = r(i, "." + l, void 0, this.componentId);
          s.insertRules(this.componentId, l, o);
        }
        n = st(n, l);
      }
    }
    return n;
  }
}
const yc = /&/g;
function Ma(e, t) {
  let s = 0;
  for (; --t >= 0 && e.charCodeAt(t) === 92; ) s++;
  return !(1 & ~s);
}
function Ps(e) {
  const t = e.length;
  let s = "", r = 0, n = 0, i = 0, a = !1, l = !1;
  for (let o = 0; o < t; o++) {
    const D = e.charCodeAt(o);
    if (i !== 0 || a || D !== Du || e.charCodeAt(o + 1) !== 42) if (a) D === 42 && e.charCodeAt(o + 1) === Du && (a = !1, o++);
    else if (D !== 34 && D !== 39 || Ma(e, o)) {
      if (i === 0) if (D === 123) n++;
      else if (D === 125) {
        if (n--, n < 0) {
          l = !0;
          let E = o + 1;
          for (; E < t; ) {
            const p = e.charCodeAt(E);
            if (p === 59 || p === 10) break;
            E++;
          }
          E < t && e.charCodeAt(E) === 59 && E++, n = 0, o = E - 1, r = E;
          continue;
        }
        n === 0 && (s += e.substring(r, o + 1), r = o + 1);
      } else D === 59 && n === 0 && (s += e.substring(r, o + 1), r = o + 1);
    } else i === 0 ? i = D : i === D && (i = 0);
    else a = !0, o++;
  }
  return l || n !== 0 || i !== 0 ? (r < t && n === 0 && i === 0 && (s += e.substring(r)), s) : e;
}
function Ua(e, t) {
  const s = t + " ", r = "," + s;
  for (let n = 0; n < e.length; n++) {
    const i = e[n];
    if (i.type === "rule") {
      i.value = (s + i.value).replaceAll(",", r);
      const a = i.props, l = [];
      for (let o = 0; o < a.length; o++) l[o] = s + a[o];
      i.props = l;
    }
    Array.isArray(i.children) && i.type !== "@keyframes" && Ua(i.children, t);
  }
  return e;
}
function Bc({ options: e = Ou, plugins: t = Zr } = Ou) {
  let s, r, n;
  const i = (m, c, f) => f.startsWith(r) && f.endsWith(r) && f.replaceAll(r, "").length > 0 ? `.${s}` : m, a = t.slice();
  a.push((m) => {
    m.type === cs && m.value.includes("&") && (n || (n = new RegExp(`\\${r}\\b`, "g")), m.props[0] = m.props[0].replace(yc, r).replace(n, i));
  }), e.prefix && a.push($l), a.push(Ol);
  let l = [];
  const o = Ll(a.concat(Rl((m) => l.push(m)))), D = (m, c = "", f = "", C = "&") => {
    s = C, r = c, n = void 0;
    const g = (function(d) {
      const h = d.indexOf("//") !== -1, F = d.indexOf("}") !== -1;
      if (!h && !F) return d;
      if (!h) return Ps(d);
      const A = d.length;
      let B = "", w = 0, k = 0, U = 0, L = 0, T = 0, S = !1;
      for (; k < A; ) {
        const I = d.charCodeAt(k);
        if (I !== 34 && I !== 39 || Ma(d, k)) if (U === 0) if (I === Du && k + 1 < A && d.charCodeAt(k + 1) === 42) {
          for (k += 2; k + 1 < A && (d.charCodeAt(k) !== 42 || d.charCodeAt(k + 1) !== Du); ) k++;
          k += 2;
        } else if (I !== 40) if (I !== 41) if (L > 0) k++;
        else if (I === 42 && k + 1 < A && d.charCodeAt(k + 1) === Du) B += d.substring(w, k), k += 2, w = k, S = !0;
        else if (I === Du && k + 1 < A && d.charCodeAt(k + 1) === Du) {
          for (B += d.substring(w, k); k < A && d.charCodeAt(k) !== 10; ) k++;
          w = k, S = !0;
        } else I === 123 ? T++ : I === 125 && T--, k++;
        else L > 0 && L--, k++;
        else L++, k++;
        else k++;
        else U === 0 ? U = I : U === I && (U = 0), k++;
      }
      return S ? (w < A && (B += d.substring(w)), T === 0 ? B : Ps(B)) : T === 0 ? d : Ps(d);
    })(m);
    let x = Pl(f || c ? f + " " + c + " { " + g + " }" : g);
    return e.namespace && (x = Ua(x, e.namespace)), l = [], Qt(x, o), l;
  }, E = e;
  let p = Br;
  for (let m = 0; m < t.length; m++) t[m].name || mt(15), p = pu(p, t[m].name);
  return E?.namespace && (p = pu(p, E.namespace)), E?.prefix && (p = pu(p, "p")), D.hash = p !== Br ? p.toString() : "", D;
}
const bc = new Fs(), wc = Bc(), Ha = ee.createContext({ shouldForwardProp: void 0, styleSheet: bc, stylis: wc, stylisPlugins: void 0 });
Ha.Consumer;
function jc() {
  return ee.useContext(Ha);
}
const za = ee.createContext(void 0);
za.Consumer;
const Mn = Object.prototype.hasOwnProperty, Is = {};
function _c(e, t) {
  const s = typeof e != "string" ? "sc" : wa(e);
  Is[s] = (Is[s] || 0) + 1;
  const r = s + "-" + Xl(fs + s + Is[s]);
  return t ? t + "-" + r : r;
}
let Os;
function kc(e, t, s) {
  const r = Sa(e), n = e, i = !Yt(e), { attrs: a = Zr, componentId: l = _c(t.displayName, t.parentComponentId), displayName: o = Jl(e) } = t, D = t.displayName && t.componentId ? wa(t.displayName) + "-" + t.componentId : t.componentId || l, E = r && n.attrs ? n.attrs.concat(a).filter(Boolean) : a;
  let { shouldForwardProp: p } = t;
  if (r && n.shouldForwardProp) {
    const C = n.shouldForwardProp;
    if (t.shouldForwardProp) {
      const g = t.shouldForwardProp;
      p = (x, d) => C(x, d) && g(x, d);
    } else p = C;
  }
  const m = new vc(s, D, r ? n.componentStyle : void 0);
  function c(C, g) {
    return (function(x, d, h) {
      const { attrs: F, componentStyle: A, defaultProps: B, foldedComponentIds: w, styledComponentId: k, target: U } = x, L = ee.useContext(za), T = jc(), S = x.shouldForwardProp || T.shouldForwardProp;
      process.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(k);
      const I = ql(d, L, B) || Ou;
      let j, R;
      {
        const O = ee.useRef(null), b = O.current;
        if (b !== null && b[1] === I && b[2] === T.styleSheet && b[3] === T.stylis && b[7] === A && (function(N, M, W) {
          const z = N, Y = M;
          let K = 0;
          for (const X in Y) if (Mn.call(Y, X) && (K++, z[X] !== Y[X])) return !1;
          return K === W;
        })(b[0], d, b[4])) j = b[5], R = b[6];
        else {
          j = (function(M, W, z) {
            const Y = Object.assign(Object.assign({}, W), { className: void 0, theme: z }), K = M.length > 1;
            for (let X = 0; X < M.length; X++) {
              const J = M[X], H = hs(J) ? J(K ? Object.assign({}, Y) : Y) : J;
              for (const G in H) G === "className" ? Y.className = st(Y.className, H[G]) : G === "style" ? Y.style = Object.assign(Object.assign({}, Y.style), H[G]) : G in W && W[G] === void 0 || (Y[G] = H[G]);
            }
            return "className" in W && typeof W.className == "string" && (Y.className = st(Y.className, W.className)), Y;
          })(F, d, I), R = (function(M, W, z, Y) {
            const K = M.generateAndInjectStyles(W, z, Y);
            return process.env.NODE_ENV !== "production" && ee.useDebugValue && ee.useDebugValue(K), K;
          })(A, j, T.styleSheet, T.stylis);
          let N = 0;
          for (const M in d) Mn.call(d, M) && N++;
          O.current = [d, I, T.styleSheet, T.stylis, N, j, R, A];
        }
      }
      process.env.NODE_ENV !== "production" && x.warnTooManyClasses && x.warnTooManyClasses(R);
      const q = j.as || U, ie = (function(O, b, N, M) {
        const W = {};
        for (const z in O) O[z] === void 0 || z[0] === "$" || z === "as" || z === "theme" && O.theme === N || (z === "forwardedAs" ? W.as = O.forwardedAs : M && !M(z, b) || (W[z] = O[z], M || process.env.NODE_ENV !== "development" || xl(z) || (Os || (Os = /* @__PURE__ */ new Set())).has(z) || !Yt(b) || b.includes("-") || (Os.add(z), console.warn(`styled-components: it looks like an unknown prop "${z}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return W;
      })(j, q, I, S);
      let ne = st(w, k);
      return R && (ne += " " + R), j.className && (ne += " " + j.className), ie[Yt(q) && q.includes("-") ? "class" : "className"] = ne, h && (ie.ref = h), pl(q, ie);
    })(f, C, g);
  }
  c.displayName = o;
  let f = ee.forwardRef(c);
  return f.attrs = E, f.componentStyle = m, f.displayName = o, f.shouldForwardProp = p, f.foldedComponentIds = r ? st(n.foldedComponentIds, n.styledComponentId) : "", f.styledComponentId = D, f.target = r ? n.target : e, Object.defineProperty(f, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(C) {
    this._foldedDefaultProps = r ? (function(g, ...x) {
      for (const d of x) br(g, d, !0);
      return g;
    })({}, n.defaultProps, C) : C;
  } }), process.env.NODE_ENV !== "production" && (Gl(o, D), f.warnTooManyClasses = /* @__PURE__ */ ((C, g) => {
    let x = {}, d = !1;
    return (h) => {
      !d && (x[h] = !0, Object.keys(x).length >= 200) && (console.warn(`Over 200 classes were generated for component ${C}${g ? ` with the id of "${g}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), d = !0, x = {});
    };
  })(o, D)), Pa(f, () => `.${f.styledComponentId}`), i && Ta(f, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), f;
}
var Nc = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function Un(e, t) {
  const s = [e[0]];
  for (let r = 0, n = t.length; r < n; r += 1) s.push(t[r], e[r + 1]);
  return s;
}
const Hn = (e) => (Oa.add(e), e);
function Va(e, ...t) {
  if (hs(e) || Cu(e)) return Hn(du(Un(Zr, [e, ...t])));
  const s = e;
  return t.length === 0 && s.length === 1 && typeof s[0] == "string" ? du(s) : Hn(du(Un(s, t)));
}
function _r(e, t, s = Ou) {
  if (!t) throw mt(1, t);
  const r = (n, ...i) => e(t, s, Va(n, ...i));
  return r.attrs = (n) => _r(e, t, Object.assign(Object.assign({}, s), { attrs: Array.prototype.concat(s.attrs, n).filter(Boolean) })), r.withConfig = (n) => _r(e, t, Object.assign(Object.assign({}, s), n)), r;
}
const Wa = (e) => _r(kc, e), us = Wa;
Nc.forEach((e) => {
  us[e] = Wa(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Nt = `__sc-${mu}__`;
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[Nt] || (window[Nt] = 0), window[Nt] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Nt] += 1);
let Ga = us;
!typeof us.div === "function" && (Ga = us.default);
const _ = Ga, Eu = _.div`
  font-family: Helvetica Neue;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.025em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;
          letter-spacing: -0.04em;
          `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          white-space: pre-line;
        `;
  }
}};
`;
function Tc(e, t = []) {
  let s = [];
  function r(i, a) {
    const l = v.createContext(a);
    l.displayName = i + "Context";
    const o = s.length;
    s = [...s, a];
    const D = (p) => {
      const { scope: m, children: c, ...f } = p, C = m?.[e]?.[o] || l, g = v.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ u.jsx(C.Provider, { value: g, children: c });
    };
    D.displayName = i + "Provider";
    function E(p, m) {
      const c = m?.[e]?.[o] || l, f = v.useContext(c);
      if (f) return f;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${i}\``);
    }
    return [D, E];
  }
  const n = () => {
    const i = s.map((a) => v.createContext(a));
    return function(l) {
      const o = l?.[e] || i;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: o } }),
        [l, o]
      );
    };
  };
  return n.scopeName = e, [r, Sc(n, ...t)];
}
function Sc(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const s = () => {
    const r = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(i) {
      const a = r.reduce((l, { useScope: o, scopeName: D }) => {
        const p = o(i)[`__scope${D}`];
        return { ...l, ...p };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return s.scopeName = t.scopeName, s;
}
function Pc(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...s) => t.current?.(...s), []);
}
var kr = globalThis?.document ? v.useLayoutEffect : () => {
};
function zn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ic(...e) {
  return (t) => {
    let s = !1;
    const r = e.map((n) => {
      const i = zn(n, t);
      return !s && typeof i == "function" && (s = !0), i;
    });
    if (s)
      return () => {
        for (let n = 0; n < r.length; n++) {
          const i = r[n];
          typeof i == "function" ? i() : zn(e[n], null);
        }
      };
  };
}
var Oc = Symbol.for("react.lazy"), ts = v[" use ".trim().toString()];
function Lc(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function qa(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Oc && "_payload" in e && Lc(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Rc(e) {
  const t = /* @__PURE__ */ $c(e), s = v.forwardRef((r, n) => {
    let { children: i, ...a } = r;
    qa(i) && typeof ts == "function" && (i = ts(i._payload));
    const l = v.Children.toArray(i), o = l.find(Uc);
    if (o) {
      const D = o.props.children, E = l.map((p) => p === o ? v.Children.count(D) > 1 ? v.Children.only(null) : v.isValidElement(D) ? D.props.children : null : p);
      return /* @__PURE__ */ u.jsx(t, { ...a, ref: n, children: v.isValidElement(D) ? v.cloneElement(D, void 0, E) : null });
    }
    return /* @__PURE__ */ u.jsx(t, { ...a, ref: n, children: i });
  });
  return s.displayName = `${e}.Slot`, s;
}
// @__NO_SIDE_EFFECTS__
function $c(e) {
  const t = v.forwardRef((s, r) => {
    let { children: n, ...i } = s;
    if (qa(n) && typeof ts == "function" && (n = ts(n._payload)), v.isValidElement(n)) {
      const a = zc(n), l = Hc(i, n.props);
      return n.type !== v.Fragment && (l.ref = r ? Ic(r, a) : a), v.cloneElement(n, l);
    }
    return v.Children.count(n) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Mc = Symbol("radix.slottable");
function Uc(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Mc;
}
function Hc(e, t) {
  const s = { ...t };
  for (const r in t) {
    const n = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? n && i ? s[r] = (...l) => {
      const o = i(...l);
      return n(...l), o;
    } : n && (s[r] = n) : r === "style" ? s[r] = { ...n, ...i } : r === "className" && (s[r] = [n, i].filter(Boolean).join(" "));
  }
  return { ...e, ...s };
}
function zc(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, s = t && "isReactWarning" in t && t.isReactWarning;
  return s ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, s = t && "isReactWarning" in t && t.isReactWarning, s ? e.props.ref : e.props.ref || e.ref);
}
var Vc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Yr = Vc.reduce((e, t) => {
  const s = /* @__PURE__ */ Rc(`Primitive.${t}`), r = v.forwardRef((n, i) => {
    const { asChild: a, ...l } = n, o = a ? s : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u.jsx(o, { ...l, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Tt = { exports: {} }, Ls = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vn;
function Wc() {
  if (Vn) return Ls;
  Vn = 1;
  var e = ee;
  function t(p, m) {
    return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
  }
  var s = typeof Object.is == "function" ? Object.is : t, r = e.useState, n = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function l(p, m) {
    var c = m(), f = r({ inst: { value: c, getSnapshot: m } }), C = f[0].inst, g = f[1];
    return i(
      function() {
        C.value = c, C.getSnapshot = m, o(C) && g({ inst: C });
      },
      [p, c, m]
    ), n(
      function() {
        return o(C) && g({ inst: C }), p(function() {
          o(C) && g({ inst: C });
        });
      },
      [p]
    ), a(c), c;
  }
  function o(p) {
    var m = p.getSnapshot;
    p = p.value;
    try {
      var c = m();
      return !s(p, c);
    } catch {
      return !0;
    }
  }
  function D(p, m) {
    return m();
  }
  var E = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? D : l;
  return Ls.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : E, Ls;
}
var Rs = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wn;
function Gc() {
  return Wn || (Wn = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(c, f) {
      return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
    }
    function t(c, f) {
      E || n.startTransition === void 0 || (E = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var C = f();
      if (!p) {
        var g = f();
        i(C, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), p = !0);
      }
      g = a({
        inst: { value: C, getSnapshot: f }
      });
      var x = g[0].inst, d = g[1];
      return o(
        function() {
          x.value = C, x.getSnapshot = f, s(x) && d({ inst: x });
        },
        [c, C, f]
      ), l(
        function() {
          return s(x) && d({ inst: x }), c(function() {
            s(x) && d({ inst: x });
          });
        },
        [c]
      ), D(C), C;
    }
    function s(c) {
      var f = c.getSnapshot;
      c = c.value;
      try {
        var C = f();
        return !i(c, C);
      } catch {
        return !0;
      }
    }
    function r(c, f) {
      return f();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = ee, i = typeof Object.is == "function" ? Object.is : e, a = n.useState, l = n.useEffect, o = n.useLayoutEffect, D = n.useDebugValue, E = !1, p = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Rs.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Rs;
}
var Gn;
function qc() {
  return Gn || (Gn = 1, process.env.NODE_ENV === "production" ? Tt.exports = Wc() : Tt.exports = Gc()), Tt.exports;
}
var Zc = qc();
function Kc() {
  return Zc.useSyncExternalStore(
    Yc,
    () => !0,
    () => !1
  );
}
function Yc() {
  return () => {
  };
}
var Xr = "Avatar", [Xc] = Tc(Xr), [Jc, Za] = Xc(Xr), Ka = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: s, ...r } = e, [n, i] = v.useState("idle");
    return /* @__PURE__ */ u.jsx(
      Jc,
      {
        scope: s,
        imageLoadingStatus: n,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ u.jsx(Yr.span, { ...r, ref: t })
      }
    );
  }
);
Ka.displayName = Xr;
var Ya = "AvatarImage", Xa = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: s, src: r, onLoadingStatusChange: n = () => {
    }, ...i } = e, a = Za(Ya, s), l = Qc(r, i), o = Pc((D) => {
      n(D), a.onImageLoadingStatusChange(D);
    });
    return kr(() => {
      l !== "idle" && o(l);
    }, [l, o]), l === "loaded" ? /* @__PURE__ */ u.jsx(Yr.img, { ...i, ref: t, src: r }) : null;
  }
);
Xa.displayName = Ya;
var Ja = "AvatarFallback", Qa = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: s, delayMs: r, ...n } = e, i = Za(Ja, s), [a, l] = v.useState(r === void 0);
    return v.useEffect(() => {
      if (r !== void 0) {
        const o = window.setTimeout(() => l(!0), r);
        return () => window.clearTimeout(o);
      }
    }, [r]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ u.jsx(Yr.span, { ...n, ref: t }) : null;
  }
);
Qa.displayName = Ja;
function qn(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function Qc(e, { referrerPolicy: t, crossOrigin: s }) {
  const r = Kc(), n = v.useRef(null), i = r ? (n.current || (n.current = new window.Image()), n.current) : null, [a, l] = v.useState(
    () => qn(i, e)
  );
  return kr(() => {
    l(qn(i, e));
  }, [i, e]), kr(() => {
    const o = (p) => () => {
      l(p);
    };
    if (!i) return;
    const D = o("loaded"), E = o("error");
    return i.addEventListener("load", D), i.addEventListener("error", E), t && (i.referrerPolicy = t), typeof s == "string" && (i.crossOrigin = s), () => {
      i.removeEventListener("load", D), i.removeEventListener("error", E);
    };
  }, [i, s, t]), a;
}
var eD = Ka, uD = Xa, tD = Qa;
const sD = _(eD)`
  display: grid;
  place-content: center;
  height: 100%;

  img {
    width: 100%;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
  }
`, We = ({
  src: e,
  alt: t,
  ...s
}) => {
  const r = t.substring(0, 2).toUpperCase();
  return /* @__PURE__ */ u.jsxs(sD, { ...s, children: [
    /* @__PURE__ */ u.jsx(uD, { src: e, alt: t }),
    /* @__PURE__ */ u.jsx(tD, { children: r })
  ] });
}, eo = ({
  username: e,
  profilePicture: t,
  locationName: s,
  small: r,
  collabs: n
}) => {
  if (Array.isArray(n) && n.length > 1) {
    let a = oD(n);
    return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center", children: /* @__PURE__ */ u.jsxs(aD, { children: [
      /* @__PURE__ */ u.jsxs(rD, { children: [
        /* @__PURE__ */ u.jsx(nD, { src: n[1].profilePictureUrl, alt: e }),
        /* @__PURE__ */ u.jsx(iD, { src: n[0].profilePictureUrl, alt: e })
      ] }),
      " ",
      a
    ] }) });
  }
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
      width: "35px",
      height: "35px"
    }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
    /* @__PURE__ */ u.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`, children: [
      /* @__PURE__ */ u.jsx(Eu, { $variant: "heading", children: e }),
      s && /* @__PURE__ */ u.jsx(Eu, { $variant: "subheading", children: s })
    ] })
  ] });
}, rD = _.div`
  overflow: hidden;
  margin-left: 10px;
  margin-right: 4px;
  width: 38px;
  height: 38px;
`, uo = _(We)`
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
`, nD = _(uo)`
  left: 12px;

  > img {
    max-width: 24px;
    max-height: 24px;
  }
`, iD = _(uo)`
  top: -14px;
  > img {
    max-width: 24px;
    max-height: 24px;
    border: 1px solid white;
  }
`, aD = _.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
`, Zn = _.span`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
function oD(e) {
  return e.length < 2 ? null : e.length === 2 ? /* @__PURE__ */ u.jsx(Zn, { children: `${e[0].username} and ${e[1].username}` }) : /* @__PURE__ */ u.jsx(Zn, { children: `${e[0].username} and ${e.length - 1} others` });
}
const lD = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 20, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M15.2622 5.61017C15.2411 5.20965 14.9038 4.87236 14.4822 4.87236H11.9526V4.15563C11.9526 1.96327 10.2451 0.0871172 8.0527 0.0027957C5.75494 -0.0815258 3.85771 1.75247 3.85771 4.02915V4.87236H1.30698C1.11726 4.87236 0.927536 4.95668 0.779974 5.08316C0.611331 5.23073 0.527009 5.44153 0.527009 5.63125L0 18.6589C0 18.8697 0.0843216 19.0594 0.231884 19.207C0.379447 19.3546 0.56917 19.4389 0.779974 19.4389H15.22C15.4308 19.4389 15.6206 19.3546 15.7681 19.207C15.9157 19.0594 16 18.8486 16 18.6168L15.2622 5.61017ZM8.11594 1.56274C9.40184 1.68922 10.3505 2.80648 10.3505 4.11347V4.85128H5.43874V4.02915C5.41765 2.5746 6.6614 1.41518 8.11594 1.56274Z", fill: "white" })), cD = (e) => /* @__PURE__ */ v.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 108.56 122.88", style: {
  enableBackground: "new 0 0 108.56 122.88"
}, xmlSpace: "preserve", fill: "#fff", ...e }, /* @__PURE__ */ v.createElement("g", null, /* @__PURE__ */ v.createElement("path", { d: "M30.47,16.05h12.47l-6.35-7.16c-1.96-2.21-1.75-5.59,0.46-7.55c2.21-1.96,5.59-1.75,7.55,0.46l9.11,10.27L62.81,1.8 c1.96-2.21,5.34-2.42,7.55-0.46c2.21,1.96,2.42,5.34,0.46,7.55l-6.35,7.16h13.62c8.4,0,16.04,3.43,21.57,8.96 c5.49,5.49,8.9,13.05,8.9,21.35v46.21c0,8.3-3.41,15.86-8.9,21.35c-5.53,5.53-13.16,8.96-21.57,8.96H30.47 c-8.4,0-16.04-3.43-21.57-8.96C3.41,108.43,0,100.87,0,92.57V46.36c0-8.3,3.41-15.86,8.9-21.35 C14.43,19.48,22.07,16.05,30.47,16.05L30.47,16.05z M27.88,75.18c-2.86,0.74-5.78-0.98-6.52-3.84c-0.74-2.86,0.98-5.78,3.84-6.52 l28.8-7.45c2.86-0.74,5.78,0.98,6.52,3.84c0.14,0.53,0.19,1.07,0.17,1.59l-0.32,6.38l19.17-5.52c2.84-0.81,5.79,0.83,6.61,3.67 c0.81,2.84-0.83,5.79-3.67,6.61l-26.02,7.5c-0.64,0.23-1.34,0.34-2.06,0.31c-2.95-0.14-5.23-2.65-5.1-5.6l0.33-6.58L27.88,75.18 L27.88,75.18z M78.09,26.48H30.47c-5.4,0-10.31,2.22-13.88,5.78c-3.6,3.6-5.84,8.59-5.84,14.1v46.21c0,5.51,2.24,10.5,5.84,14.1 c3.57,3.57,8.48,5.78,13.88,5.78h47.61c5.4,0,10.31-2.22,13.88-5.78c3.6-3.6,5.84-8.59,5.84-14.1V46.36c0-5.51-2.24-10.5-5.84-14.1 C88.4,28.69,83.49,26.48,78.09,26.48L78.09,26.48z" }))), DD = (e) => /* @__PURE__ */ v.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 122.14 122.88", style: {
  enableBackground: "new 0 0 122.14 122.88"
}, xmlSpace: "preserve", fill: "#fff", ...e }, /* @__PURE__ */ v.createElement("g", null, /* @__PURE__ */ v.createElement("path", { d: "M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" }))), pD = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M0.003125 15.4988C0.04375 15.1957 0.075 14.8895 0.128125 14.5895C0.5375 12.3863 1.6875 10.6645 3.5125 9.36758C4.775 10.5645 6.2625 11.1957 8 11.1926C9.73125 11.1926 11.2156 10.5676 12.4906 9.36133C12.7438 9.56133 13.0094 9.75195 13.2531 9.96758C14.7906 11.3332 15.6969 13.0363 15.9438 15.0832C15.9594 15.2207 15.9812 15.3613 16 15.4988C16 15.6645 16 15.8332 16 15.9988C10.6656 15.9988 5.33437 15.9988 0 15.9988C0.003125 15.8332 0.003125 15.6645 0.003125 15.4988Z", fill: "white" }), /* @__PURE__ */ v.createElement("path", { d: "M8.37828 -0.000976562C8.69391 0.0615234 9.01578 0.102148 9.32203 0.189648C11.197 0.711523 12.5845 2.3709 12.7783 4.31152C13.047 7.00215 11.072 9.36465 8.36891 9.58652C5.93453 9.78965 3.69391 8.05527 3.28141 5.6459C2.83766 3.0709 4.44703 0.670898 7.00015 0.105273C7.2064 0.0583984 7.41891 0.0333984 7.62828 -0.000976562C7.87828 -0.000976563 8.12828 -0.000976562 8.37828 -0.000976562Z", fill: "white" }));
function Qu(e, t, s) {
  return t in e ? Object.defineProperty(e, t, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = s, e;
}
const de = 1, to = 2, so = 4, je = 8, Nr = 16, St = 32, ze = 64, Tr = {
  a: {
    content: de | je,
    self: !1,
    type: de | je | St | ze
  },
  address: {
    invalid: ["h1", "h2", "h3", "h4", "h5", "h6", "address", "article", "aside", "section", "div", "header", "footer"],
    self: !1
  },
  audio: {
    children: ["track", "source"]
  },
  br: {
    type: de | je,
    void: !0
  },
  body: {
    content: de | to | so | je | Nr | St | ze
  },
  button: {
    content: je,
    type: de | je | St | ze
  },
  caption: {
    content: de,
    parent: ["table"]
  },
  col: {
    parent: ["colgroup"],
    void: !0
  },
  colgroup: {
    children: ["col"],
    parent: ["table"]
  },
  details: {
    children: ["summary"],
    type: de | St | ze
  },
  dd: {
    content: de,
    parent: ["dl"]
  },
  dl: {
    children: ["dt", "dd"],
    type: de
  },
  dt: {
    content: de,
    invalid: ["footer", "header"],
    parent: ["dl"]
  },
  figcaption: {
    content: de,
    parent: ["figure"]
  },
  footer: {
    invalid: ["footer", "header"]
  },
  header: {
    invalid: ["footer", "header"]
  },
  hr: {
    type: de,
    void: !0
  },
  img: {
    void: !0
  },
  li: {
    content: de,
    parent: ["ul", "ol", "menu"]
  },
  main: {
    self: !1
  },
  ol: {
    children: ["li"],
    type: de
  },
  picture: {
    children: ["source", "img"],
    type: de | je | Nr
  },
  rb: {
    parent: ["ruby", "rtc"]
  },
  rp: {
    parent: ["ruby", "rtc"]
  },
  rt: {
    content: je,
    parent: ["ruby", "rtc"]
  },
  rtc: {
    content: je,
    parent: ["ruby"]
  },
  ruby: {
    children: ["rb", "rp", "rt", "rtc"]
  },
  source: {
    parent: ["audio", "video", "picture"],
    void: !0
  },
  summary: {
    content: je,
    parent: ["details"]
  },
  table: {
    children: ["caption", "colgroup", "thead", "tbody", "tfoot", "tr"],
    type: de
  },
  tbody: {
    parent: ["table"],
    children: ["tr"]
  },
  td: {
    content: de,
    parent: ["tr"]
  },
  tfoot: {
    parent: ["table"],
    children: ["tr"]
  },
  th: {
    content: de,
    parent: ["tr"]
  },
  thead: {
    parent: ["table"],
    children: ["tr"]
  },
  tr: {
    parent: ["table", "tbody", "thead", "tfoot"],
    children: ["th", "td"]
  },
  track: {
    parent: ["audio", "video"],
    void: !0
  },
  ul: {
    children: ["li"],
    type: de
  },
  video: {
    children: ["track", "source"]
  },
  wbr: {
    type: de | je,
    void: !0
  }
};
function gu(e) {
  return (t) => {
    Tr[t] = {
      ...e,
      ...Tr[t]
    };
  };
}
["address", "main", "div", "figure", "p", "pre"].forEach(gu({
  content: de,
  type: de | ze
}));
["abbr", "b", "bdi", "bdo", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "ruby", "samp", "strong", "sub", "sup", "time", "u", "var"].forEach(gu({
  content: je,
  type: de | je | ze
}));
["p", "pre"].forEach(gu({
  content: je,
  type: de | ze
}));
["s", "small", "span", "del", "ins"].forEach(gu({
  content: je,
  type: de | je
}));
["article", "aside", "footer", "header", "nav", "section", "blockquote"].forEach(gu({
  content: de,
  type: de | to | ze
}));
["h1", "h2", "h3", "h4", "h5", "h6"].forEach(gu({
  content: je,
  type: de | so | ze
}));
["audio", "canvas", "iframe", "img", "video"].forEach(gu({
  type: de | je | Nr | ze
}));
const Sr = Object.freeze(Tr), dD = ["applet", "base", "body", "command", "embed", "frame", "frameset", "head", "html", "link", "meta", "noscript", "object", "script", "style", "title"], fD = Object.keys(Sr).filter((e) => e !== "canvas" && e !== "iframe"), me = 1, hD = 2, rt = 3, ku = 4, ro = 5, Kn = Object.freeze({
  alt: me,
  cite: me,
  class: me,
  colspan: rt,
  controls: ku,
  datetime: me,
  default: ku,
  disabled: ku,
  dir: me,
  height: me,
  href: me,
  id: me,
  kind: me,
  label: me,
  lang: me,
  loading: me,
  loop: ku,
  media: me,
  muted: ku,
  poster: me,
  rel: me,
  role: me,
  rowspan: rt,
  scope: me,
  sizes: me,
  span: rt,
  start: rt,
  style: ro,
  src: me,
  srclang: me,
  srcset: me,
  tabindex: me,
  target: me,
  title: me,
  type: me,
  width: me
}), FD = Object.freeze({
  class: "className",
  colspan: "colSpan",
  datetime: "dateTime",
  rowspan: "rowSpan",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex"
});
function ss() {
  return ss = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var r in s)
        Object.prototype.hasOwnProperty.call(s, r) && (e[r] = s[r]);
    }
    return e;
  }, ss.apply(this, arguments);
}
function no({
  attributes: e = {},
  className: t,
  children: s = null,
  selfClose: r = !1,
  tagName: n
}) {
  const i = n;
  return r ? /* @__PURE__ */ ee.createElement(i, ss({
    className: t
  }, e)) : /* @__PURE__ */ ee.createElement(i, ss({
    className: t
  }, e), s);
}
class mD {
  /**
   * Filter and clean an HTML attribute value.
   */
  attribute(t, s) {
    return s;
  }
  /**
   * Filter and clean an HTML node.
   */
  node(t, s) {
    return s;
  }
}
function CD(e, t, s, r = !1) {
  const n = e.match(t instanceof RegExp ? t : new RegExp(t, "i"));
  return n ? {
    match: n[0],
    void: r,
    ...s(n),
    index: n.index,
    length: n[0].length,
    valid: !0
  } : null;
}
class Ct {
  constructor(t, s, r) {
    if (Qu(this, "greedy", !1), Qu(this, "options", void 0), Qu(this, "propName", void 0), Qu(this, "inverseName", void 0), Qu(this, "factory", void 0), process.env.NODE_ENV !== "production" && (!t || t.toLowerCase() === "html"))
      throw new Error(`The matcher name "${t}" is not allowed.`);
    this.options = {
      ...s
    }, this.propName = t, this.inverseName = `no${t.charAt(0).toUpperCase() + t.slice(1)}`, this.factory = r ?? null;
  }
  /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */
  createElement(t, s) {
    const r = this.factory ? /* @__PURE__ */ ee.createElement(this.factory, s, t) : this.replaceWith(t, s);
    if (process.env.NODE_ENV !== "production" && typeof r != "string" && !/* @__PURE__ */ ee.isValidElement(r))
      throw new Error(`Invalid React element created from ${this.constructor.name}.`);
    return r;
  }
  /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */
  doMatch(t, s, r, n = !1) {
    return CD(t, s, r, n);
  }
  /**
   * Callback triggered before parsing.
   */
  onBeforeParse(t, s) {
    return t;
  }
  /**
   * Callback triggered after parsing.
   */
  onAfterParse(t, s) {
    return t;
  }
  /**
   * Replace the match with a React element based on the matched token and optional props.
   */
}
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */
var $s, Yn;
function ED() {
  if (Yn) return $s;
  Yn = 1;
  var e = /["'&<>]/;
  $s = t;
  function t(s) {
    var r = "" + s, n = e.exec(r);
    if (!n)
      return r;
    var i, a = "", l = 0, o = 0;
    for (l = n.index; l < r.length; l++) {
      switch (r.charCodeAt(l)) {
        case 34:
          i = "&quot;";
          break;
        case 38:
          i = "&amp;";
          break;
        case 39:
          i = "&#39;";
          break;
        case 60:
          i = "&lt;";
          break;
        case 62:
          i = "&gt;";
          break;
        default:
          continue;
      }
      o !== l && (a += r.substring(o, l)), o = l + 1, a += i;
    }
    return o !== l ? a + r.substring(o, l) : a;
  }
  return $s;
}
var xD = ED();
const AD = /* @__PURE__ */ Au(xD);
function qe(e, t, s) {
  return t in e ? Object.defineProperty(e, t, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = s, e;
}
const gD = /(url|image|image-set)\(/i;
class vD extends mD {
  attribute(t, s) {
    return t === "style" && Object.keys(s).forEach((r) => {
      String(s[r]).match(gD) && delete s[r];
    }), s;
  }
}
const Xn = 1, yD = 3, BD = /^<(!doctype|(html|head|body)(\s|>))/i, bD = /^(aria-|data-|\w+:)/iu, wD = /{{{(\w+)\/?}}}/;
function jD() {
  if (!(typeof window > "u" || typeof document > "u"))
    return document.implementation.createHTMLDocument("Interweave");
}
class io {
  constructor(t, s = {}, r = [], n = []) {
    var i;
    if (qe(this, "allowed", void 0), qe(this, "banned", void 0), qe(this, "blocked", void 0), qe(this, "container", void 0), qe(this, "content", []), qe(this, "props", void 0), qe(this, "matchers", void 0), qe(this, "filters", void 0), qe(this, "keyIndex", void 0), process.env.NODE_ENV !== "production" && t && typeof t != "string")
      throw new TypeError("Interweave parser requires a valid string.");
    this.props = s, this.matchers = r, this.filters = [...n, new vD()], this.keyIndex = -1, this.container = this.createContainer(t || ""), this.allowed = new Set((i = s.allowList) !== null && i !== void 0 ? i : fD), this.banned = new Set(dD), this.blocked = new Set(s.blockList);
  }
  /**
   * Loop through and apply all registered attribute filters.
   */
  applyAttributeFilters(t, s) {
    return this.filters.reduce((r, n) => r !== null && typeof n.attribute == "function" ? n.attribute(t, r) : r, s);
  }
  /**
   * Loop through and apply all registered node filters.
   */
  applyNodeFilters(t, s) {
    return this.filters.reduce((r, n) => r !== null && typeof n.node == "function" ? n.node(t, r) : r, s);
  }
  /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */
  applyMatchers(t, s) {
    const r = {}, {
      props: n
    } = this;
    let i = t, a = 0, l = null;
    return this.matchers.forEach((o) => {
      const D = o.asTag().toLowerCase(), E = this.getTagConfig(D);
      if (n[o.inverseName] || !this.isTagAllowed(D) || !this.canRenderChild(s, E))
        return;
      let p = "";
      for (; i && (l = o.match(i)); ) {
        const {
          index: m,
          length: c,
          match: f,
          valid: C,
          void: g,
          ...x
        } = l, d = o.propName + String(a);
        m > 0 && (p += i.slice(0, m)), C ? (p += g ? `{{{${d}/}}}` : `{{{${d}}}}${f}{{{/${d}}}}`, this.keyIndex += 1, a += 1, r[d] = {
          children: f,
          matcher: o,
          props: {
            ...n,
            ...x,
            key: this.keyIndex
          }
        }) : p += f, o.greedy ? (i = p + i.slice(m + c), p = "") : i = i.slice(m + (c || f.length));
      }
      o.greedy || (i = p + i);
    }), a === 0 ? t : this.replaceTokens(i, r);
  }
  /**
   * Determine whether the child can be rendered within the parent.
   */
  canRenderChild(t, s) {
    return !t.tagName || !s.tagName || t.void ? !1 : t.children.length > 0 ? t.children.includes(s.tagName) : t.invalid.length > 0 && t.invalid.includes(s.tagName) ? !1 : s.parent.length > 0 ? s.parent.includes(t.tagName) : !t.self && t.tagName === s.tagName ? !1 : !!(t && t.content & s.type);
  }
  /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */
  convertLineBreaks(t) {
    const {
      noHtml: s,
      disableLineBreaks: r
    } = this.props;
    if (s || r || t.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi))
      return t;
    let n = t.replace(/\r\n/g, `
`);
    return n = n.replace(/\n{3,}/g, `


`), n = n.replace(/\n/g, "<br/>"), n;
  }
  /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */
  createContainer(t) {
    var s;
    const n = (typeof global < "u" && global.INTERWEAVE_SSR_POLYFILL || jD)();
    if (!n)
      return;
    const i = (s = this.props.containerTagName) !== null && s !== void 0 ? s : "body", a = i === "body" || i === "fragment" ? n.body : n.createElement(i);
    if (t.match(BD)) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("HTML documents as Interweave content are not supported.");
    } else
      a.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? AD(t) : t);
    return a;
  }
  /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */
  extractAttributes(t) {
    const {
      allowAttributes: s
    } = this.props, r = {};
    let n = 0;
    return t.nodeType !== Xn || !t.attributes || ([...t.attributes].forEach((i) => {
      const {
        name: a,
        value: l
      } = i, o = a.toLowerCase(), D = Kn[o] || Kn[a];
      if (!this.isSafe(t) || !o.match(bD) && (!s && (!D || D === hD) || o.startsWith("on") || l.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i)))
        return;
      let E = o === "style" ? this.extractStyleAttribute(t) : l;
      D === ku ? E = !0 : D === rt ? E = Number.parseFloat(String(E)) : D !== ro && (E = String(E)), r[FD[o] || o] = this.applyAttributeFilters(o, E), n += 1;
    }), n === 0) ? null : r;
  }
  /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */
  extractStyleAttribute(t) {
    const s = {};
    return Array.from(t.style).forEach((r) => {
      const n = t.style[r];
      (typeof n == "string" || typeof n == "number") && (s[r.replace(/-([a-z])/g, (i, a) => String(a).toUpperCase())] = n);
    }), s;
  }
  /**
   * Return configuration for a specific tag.
   */
  getTagConfig(t) {
    const s = {
      children: [],
      content: 0,
      invalid: [],
      parent: [],
      self: !0,
      tagName: "",
      type: 0,
      void: !1
    };
    return Sr[t] ? {
      ...s,
      ...Sr[t],
      tagName: t
    } : s;
  }
  /**
   * Verify that a node is safe from XSS and injection attacks.
   */
  isSafe(t) {
    if (typeof HTMLAnchorElement < "u" && t instanceof HTMLAnchorElement) {
      const s = t.getAttribute("href");
      if (s != null && s.startsWith("#"))
        return !0;
      const r = t.protocol.toLowerCase();
      return r === ":" || r === "http:" || r === "https:" || r === "mailto:" || r === "tel:";
    }
    return !0;
  }
  /**
   * Verify that an HTML tag is allowed to render.
   */
  isTagAllowed(t) {
    return this.banned.has(t) || this.blocked.has(t) ? !1 : this.props.allowElements || this.allowed.has(t);
  }
  /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */
  parse() {
    return this.container ? this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase())) : [];
  }
  /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */
  parseNode(t, s) {
    const {
      noHtml: r,
      noHtmlExceptMatchers: n,
      allowElements: i,
      transform: a,
      transformOnlyAllowList: l
    } = this.props;
    let o = [], D = "";
    return [...t.childNodes].forEach((E) => {
      if (E.nodeType === Xn) {
        const m = E.nodeName.toLowerCase(), c = this.getTagConfig(m);
        D && (o.push(D), D = "");
        const f = this.applyNodeFilters(m, E);
        if (!f)
          return;
        let C;
        if (a && !(l && !this.isTagAllowed(m))) {
          this.keyIndex += 1;
          const g = this.keyIndex;
          C = this.parseNode(f, c);
          const x = a(f, C, c);
          if (x === null)
            return;
          if (typeof x < "u") {
            o.push(/* @__PURE__ */ ee.cloneElement(x, {
              key: g
            }));
            return;
          }
          this.keyIndex = g - 1;
        }
        if (this.banned.has(m))
          return;
        if (!(r || n && m !== "br") && this.isTagAllowed(m) && (i || this.canRenderChild(s, c))) {
          var p;
          this.keyIndex += 1;
          const g = this.extractAttributes(f), x = {
            tagName: m
          };
          g && (x.attributes = g), c.void && (x.selfClose = c.void), o.push(/* @__PURE__ */ ee.createElement(no, {
            ...x,
            key: this.keyIndex
          }, (p = C) !== null && p !== void 0 ? p : this.parseNode(f, c)));
        } else
          o = [...o, ...this.parseNode(f, c.tagName ? c : s)];
      } else if (E.nodeType === yD) {
        const m = r && !n ? E.textContent : (
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          this.applyMatchers(E.textContent || "", s)
        );
        Array.isArray(m) ? o = [...o, ...m] : D += m;
      }
    }), D && o.push(D), o;
  }
  /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */
  replaceTokens(t, s) {
    if (!t.includes("{{{"))
      return t;
    const r = [];
    let n = t, i = null;
    for (; i = n.match(wD); ) {
      const [a, l] = i, o = i.index, D = a.includes("/");
      if (process.env.NODE_ENV !== "production" && !s[l])
        throw new Error(`Token "${l}" found but no matching element to replace with.`);
      o > 0 && (r.push(n.slice(0, o)), n = n.slice(o));
      const {
        children: E,
        matcher: p,
        props: m
      } = s[l];
      let c;
      if (D)
        c = a.length, r.push(p.createElement(E, m));
      else {
        const f = n.match(new RegExp(`{{{/${l}}}}`));
        if (process.env.NODE_ENV !== "production" && !f)
          throw new Error(`Closing token missing for interpolated element "${l}".`);
        c = f.index + f[0].length, r.push(p.createElement(this.replaceTokens(n.slice(a.length, f.index), s), m));
      }
      n = n.slice(c);
    }
    return n.length > 0 && r.push(n), r.length === 0 ? "" : r.length === 1 && typeof r[0] == "string" ? r[0] : r;
  }
}
function _D(e) {
  var t;
  const {
    attributes: s,
    className: r,
    containerTagName: n,
    content: i,
    emptyContent: a,
    parsedContent: l,
    tagName: o,
    noWrap: D
  } = e, E = (t = n ?? o) !== null && t !== void 0 ? t : "span", p = E === "fragment" ? !0 : D;
  let m;
  if (l)
    m = l;
  else {
    const c = new io(i ?? "", e).parse();
    c.length > 0 && (m = c);
  }
  return m || (m = a), p ? /* @__PURE__ */ ee.createElement(ee.Fragment, null, m) : /* @__PURE__ */ ee.createElement(no, {
    attributes: s,
    className: r,
    tagName: E
  }, m);
}
function kD(e) {
  const {
    attributes: t,
    className: s,
    content: r = "",
    disableFilters: n = !1,
    disableMatchers: i = !1,
    emptyContent: a = null,
    filters: l = [],
    matchers: o = [],
    onAfterParse: D = null,
    onBeforeParse: E = null,
    tagName: p = "span",
    noWrap: m = !1,
    ...c
  } = e, f = i ? [] : o, C = n ? [] : l, g = E ? [E] : [], x = D ? [D] : [];
  f.forEach((A) => {
    A.onBeforeParse && g.push(A.onBeforeParse.bind(A)), A.onAfterParse && x.push(A.onAfterParse.bind(A));
  });
  const d = g.reduce((A, B) => {
    const w = B(A, e);
    if (process.env.NODE_ENV !== "production" && typeof w != "string")
      throw new TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
    return w;
  }, r ?? ""), h = new io(d, c, f, C), F = x.reduce((A, B) => {
    const w = B(A, e);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(w))
      throw new TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
    return w;
  }, h.parse());
  return /* @__PURE__ */ ee.createElement(_D, {
    attributes: t,
    className: s,
    containerTagName: e.containerTagName,
    emptyContent: a,
    noWrap: m,
    parsedContent: F.length === 0 ? void 0 : F,
    tagName: p
  });
}
function Ne(e, t = {}) {
  var s, r;
  let n = e.map((i) => i.source).join((s = t.join) !== null && s !== void 0 ? s : "");
  return t.capture ? n = `(${n})` : t.nonCapture && (n = `(?:${n})`), t.match && (n += t.match), new RegExp(n, (r = t.flags) !== null && r !== void 0 ? r : "");
}
const Jn = /[a-z0-9]/, ao = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/, oo = /(https?:\/\/)?/, lo = Ne([
  /[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/,
  // Includes colon
  /@/
], {
  capture: !0,
  match: "?"
}), co = Ne([
  /(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/,
  // Subdomain
  /(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/,
  // Domain
  /(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/
  // TLD
], {
  capture: !0
}), Do = /(?::(\d{1,5}))?/, po = Ne([/\//, Ne([
  /[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/,
  /[-+a-z0-9/]/
  // Valid ending chars
], {
  match: "*",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), fo = Ne([/\?/, Ne([
  ao,
  /[a-z0-9_&=]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), ho = Ne([/#/, Ne([
  ao,
  /[a-z0-9]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), ND = Ne([oo, lo, co, Do, po, fo, ho], {
  flags: "i"
}), Pt = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/, TD = Ne([Pt, Pt, Pt, Pt], {
  capture: !0,
  join: "\\."
});
Ne([oo, lo, TD, Do, po, fo, ho], {
  flags: "i"
});
const SD = [
  // Chinese
  /[\d_\u4E00-\u9FFF-]+/,
  // Japanese
  /[\d_\u3000-\u30FF-]+/,
  // Korean
  /[\d_\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7FF-]+/,
  // Thai
  /[\d_\u0E00-\u0E7F-]+/,
  // Russian, Ukrainian
  // eslint-disable-next-line no-misleading-character-class
  /[\d_a-z\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F-]+/,
  // Latin based
  /[\d_a-z\u0080-\u00FF\u0100-\u017F\u0180-\u024F-]+/
];
Ne([/#/, Ne(SD, {
  capture: !0,
  join: "|"
})], {
  flags: "i"
});
const PD = /[.a-z0-9!#$%&?*+=_{|}~-]*/, ID = Ne([Jn, PD, Jn], {
  capture: !0
}), Qn = Ne([ID, co], {
  flags: "i",
  join: "@"
}), OD = new RegExp(`^${Qn.source}$`, Qn.flags), LD = [
  // Original
  "com",
  "org",
  "net",
  "int",
  "edu",
  "gov",
  "mil",
  // Sponsored
  "aero",
  "asia",
  "biz",
  "cat",
  "coop",
  "jobs",
  "mobi",
  "museum",
  "post",
  "tel",
  "travel",
  "xxx",
  // Misc
  "app",
  "arpa",
  "test",
  // Countries
  "ac",
  // Ascension Island
  "ad",
  // Andorra
  "ae",
  // United Arab Emirates
  "af",
  // Afghanistan
  "ag",
  // Antigua and Barbuda
  "ai",
  // Anguilla
  "al",
  // Albania
  "am",
  // Armenia
  "an",
  // Netherlands Antilles
  "ao",
  // Angola
  "aq",
  // Antarctica
  "ar",
  // Argentina
  "as",
  // American Samoa
  "at",
  // Austria
  "au",
  // Australia
  "aw",
  // Aruba
  "ax",
  // Aland Islands
  "az",
  // Azerbaijan
  "ba",
  // Bosnia and Herzegovina
  "bb",
  // Barbados
  "bd",
  // Bangladesh
  "be",
  // Belgium
  "bf",
  // Burkina Faso
  "bg",
  // Bulgaria
  "bh",
  // Bahrain
  "bi",
  // Burundi
  "bj",
  // Benin
  "bl",
  // Saint Barthelemy
  "bm",
  // Bermuda
  "bn",
  // Brunei Darussalam
  "bo",
  // Bolivia
  "bq",
  // Bonaire, Sint Eustatius and Saba
  "br",
  // Brazil
  "bs",
  // Bahamas
  "bt",
  // Bhutan
  "bv",
  // Bouvet Island
  "bw",
  // Botswana
  "by",
  // Belarus
  "bz",
  // Belize
  "ca",
  // Canada
  "cc",
  // Cocos (Keeling) Islands
  "cd",
  // Congo, The Democratic Republic of the
  "cf",
  // Central African Republic
  "cg",
  // Congo
  "ch",
  // Switzerland
  "ci",
  // Cote d'Ivoire
  "ck",
  // Cook Islands
  "cl",
  // Chile
  "cm",
  // Cameroon
  "cn",
  // China
  "co",
  // Colombia
  "cr",
  // Costa Rica
  "cu",
  // Cuba
  "cv",
  // Cape Verde
  "cw",
  // Curaçao
  "cx",
  // Christmas Island
  "cy",
  // Cyprus
  "cz",
  // Czech Republic
  "de",
  // Germany
  "dj",
  // Djibouti
  "dk",
  // Denmark
  "dm",
  // Dominica
  "do",
  // Dominican Republic
  "dz",
  // Algeria
  "ec",
  // Ecuador
  "ee",
  // Estonia
  "eg",
  // Egypt
  "eh",
  // Western Sahara
  "er",
  // Eritrea
  "es",
  // Spain
  "et",
  // Ethiopia
  "eu",
  // European Union
  "fi",
  // Finland
  "fj",
  // Fiji
  "fk",
  // Falkland Islands (Malvinas)
  "fm",
  // Micronesia, Federated States of
  "fo",
  // Faroe Islands
  "fr",
  // France
  "ga",
  // Gabon
  "gb",
  // United Kingdom
  "gd",
  // Grenada
  "ge",
  // Georgia
  "gf",
  // French Guiana
  "gg",
  // Guernsey
  "gh",
  // Ghana
  "gi",
  // Gibraltar
  "gl",
  // Greenland
  "gm",
  // Gambia
  "gn",
  // Guinea
  "gp",
  // Guadeloupe
  "gq",
  // Equatorial Guinea
  "gr",
  // Greece
  "gs",
  // South Georgia and the South Sandwich Islands
  "gt",
  // Guatemala
  "gu",
  // Guam
  "gw",
  // Guinea-Bissau
  "gy",
  // Guyana
  "hk",
  // Hong Kong
  "hm",
  // Heard Island and McDonald Islands
  "hn",
  // Honduras
  "hr",
  // Croatia
  "ht",
  // Haiti
  "hu",
  // Hungary
  "id",
  // Indonesia
  "ie",
  // Ireland
  "il",
  // Israel
  "im",
  // Isle of Man
  "in",
  // India
  "io",
  // British Indian Ocean Territory
  "iq",
  // Iraq
  "ir",
  // Iran, Islamic Republic of
  "is",
  // Iceland
  "it",
  // Italy
  "je",
  // Jersey
  "jm",
  // Jamaica
  "jo",
  // Jordan
  "jp",
  // Japan
  "ke",
  // Kenya
  "kg",
  // Kyrgyzstan
  "kh",
  // Cambodia
  "ki",
  // Kiribati
  "km",
  // Comoros
  "kn",
  // Saint Kitts and Nevis
  "kp",
  // Korea, Democratic People's Republic of
  "kr",
  // Korea, Republic of
  "kw",
  // Kuwait
  "ky",
  // Cayman Islands
  "kz",
  // Kazakhstan
  "la",
  // Lao People's Democratic Republic
  "lb",
  // Lebanon
  "lc",
  // Saint Lucia
  "li",
  // Liechtenstein
  "lk",
  // Sri Lanka
  "lr",
  // Liberia
  "ls",
  // Lesotho
  "lt",
  // Lithuania
  "lu",
  // Luxembourg
  "lv",
  // Latvia
  "ly",
  // Libyan Arab Jamahiriya
  "ma",
  // Morocco
  "mc",
  // Monaco
  "md",
  // Moldova, Republic of
  "me",
  // Montenegro
  "mf",
  // Saint Martin (French part)
  "mg",
  // Madagascar
  "mh",
  // Marshall Islands
  "mk",
  // Macedonia, The Former Yugoslav Republic of
  "ml",
  // Mali
  "mm",
  // Myanmar
  "mn",
  // Mongolia
  "mo",
  // Macao
  "mp",
  // Northern Mariana Islands
  "mq",
  // Martinique
  "mr",
  // Mauritania
  "ms",
  // Montserrat
  "mt",
  // Malta
  "mu",
  // Mauritius
  "mv",
  // Maldives
  "mw",
  // Malawi
  "mx",
  // Mexico
  "my",
  // Malaysia
  "mz",
  // Mozambique
  "na",
  // Namibia
  "nc",
  // New Caledonia
  "ne",
  // Niger
  "nf",
  // Norfolk Island
  "ng",
  // Nigeria
  "ni",
  // Nicaragua
  "nl",
  // Netherlands
  "no",
  // Norway
  "np",
  // Nepal
  "nr",
  // Nauru
  "nu",
  // Niue
  "nz",
  // New Zealand
  "om",
  // Oman
  "pa",
  // Panama
  "pe",
  // Peru
  "pf",
  // French Polynesia
  "pg",
  // Papua New Guinea
  "ph",
  // Philippines
  "pk",
  // Pakistan
  "pl",
  // Poland
  "pm",
  // Saint Pierre and Miquelon
  "pn",
  // Pitcairn
  "pr",
  // Puerto Rico
  "ps",
  // Palestinian Territory, Occupied
  "pt",
  // Portugal
  "pw",
  // Palau
  "py",
  // Paraguay
  "qa",
  // Qatar
  "re",
  // Reunion
  "ro",
  // Romania
  "rs",
  // Serbia
  "ru",
  // Russian Federation
  "rw",
  // Rwanda
  "sa",
  // Saudi Arabia
  "sb",
  // Solomon Islands
  "sc",
  // Seychelles
  "sd",
  // Sudan
  "se",
  // Sweden
  "sg",
  // Singapore
  "sh",
  // Saint Helena
  "si",
  // Slovenia
  "sj",
  // Svalbard and Jan Mayen
  "sk",
  // Slovakia
  "sl",
  // Sierra Leone
  "sm",
  // San Marino
  "sn",
  // Senegal
  "so",
  // Somalia
  "sr",
  // Suriname
  "st",
  // Sao Tome and Principe
  "su",
  // Soviet Union (being phased out)
  "sv",
  // El Salvador
  "sx",
  // Sint Maarten (Dutch part)
  "sy",
  // Syrian Arab Republic
  "sz",
  // Swaziland
  "tc",
  // Turks and Caicos Islands
  "td",
  // Chad
  "tf",
  // French Southern Territories
  "tg",
  // Togo
  "th",
  // Thailand
  "tj",
  // Tajikistan
  "tk",
  // Tokelau
  "tl",
  // Timor-Leste
  "tm",
  // Turkmenistan
  "tn",
  // Tunisia
  "to",
  // Tonga
  "tp",
  // Portuguese Timor (being phased out)
  "tr",
  // Turkey
  "tt",
  // Trinidad and Tobago
  "tv",
  // Tuvalu
  "tw",
  // Taiwan, Province of China
  "tz",
  // Tanzania, United Republic of
  "ua",
  // Ukraine
  "ug",
  // Uganda
  "uk",
  // United Kingdom
  "um",
  // United States Minor Outlying Islands
  "us",
  // United States
  "uy",
  // Uruguay
  "uz",
  // Uzbekistan
  "va",
  // Holy See (Vatican City State)
  "vc",
  // Saint Vincent and the Grenadines
  "ve",
  // Venezuela, Bolivarian Republic of
  "vg",
  // Virgin Islands, British
  "vi",
  // Virgin Islands, U.S.
  "vn",
  // Viet Nam
  "vu",
  // Vanuatu
  "wf",
  // Wallis and Futuna
  "ws",
  // Samoa
  "ye",
  // Yemen
  "yt",
  // Mayotte
  "za",
  // South Africa
  "zm",
  // Zambia
  "zw"
  // Zimbabwe
];
function Pr() {
  return Pr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var r in s)
        Object.prototype.hasOwnProperty.call(s, r) && (e[r] = s[r]);
    }
    return e;
  }, Pr.apply(this, arguments);
}
function RD({
  children: e,
  href: t,
  onClick: s,
  newWindow: r
}) {
  return /* @__PURE__ */ ee.createElement("a", {
    href: t,
    rel: "noopener noreferrer",
    target: r ? "_blank" : void 0,
    onClick: s
  }, e);
}
function $D({
  children: e,
  url: t,
  urlParts: s,
  ...r
}) {
  let n = t;
  return n.match(/^https?:\/\//) || (n = `http://${n}`), /* @__PURE__ */ ee.createElement(RD, Pr({}, r, {
    href: n
  }), e);
}
class MD extends Ct {
  constructor(t, s, r) {
    super(t, {
      customTLDs: [],
      validateTLD: !0,
      ...s
    }, r);
  }
  replaceWith(t, s) {
    return /* @__PURE__ */ ee.createElement($D, s, t);
  }
  asTag() {
    return "a";
  }
  match(t) {
    const s = this.doMatch(t, ND, this.handleMatches);
    if (s != null && s.match.match(OD) && (s.valid = !1), s != null && s.valid && this.options.validateTLD) {
      var r;
      const {
        host: n
      } = s.urlParts, i = [...LD, ...(r = this.options.customTLDs) !== null && r !== void 0 ? r : []], a = n.slice(n.lastIndexOf(".") + 1).toLowerCase();
      if (!i.includes(a))
        return null;
    }
    return s;
  }
  /**
   * Package the matched response.
   */
  handleMatches(t) {
    return {
      url: t[0],
      urlParts: {
        auth: t[2] ? t[2].slice(0, -1) : "",
        fragment: t[7] || "",
        host: t[3],
        path: t[5] || "",
        port: t[4] ? t[4] : "",
        query: t[6] || "",
        scheme: t[1] ? t[1].replace("://", "") : "http"
      }
    };
  }
}
/*!
 * XRegExp 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */
const Ee = "xregexp", xu = {
  astral: !1,
  namespacing: !0
}, Ve = {};
let nt = /* @__PURE__ */ Object.create(null), Nu = /* @__PURE__ */ Object.create(null);
const Ir = [], Pu = "default", ei = "class", UD = {
  // Any native multicharacter token in default scope, or any single character
  default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
  // Any native multicharacter token in character class scope, or any single character
  class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
}, HD = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, zD = /()??/.exec("")[1] === void 0, VD = /x/.flags !== void 0;
function Et(e) {
  let t = !0;
  try {
    if (new RegExp("", e), e === "y") {
      const s = "gy";
      ".a".replace(new RegExp("a", s), ".") === ".." && (t = !1);
    }
  } catch {
    t = !1;
  }
  return t;
}
const WD = Et("d"), Jr = Et("s"), Fo = Et("u"), Qr = Et("y"), mo = {
  d: WD,
  g: !0,
  i: !0,
  m: !0,
  s: Jr,
  u: Fo,
  y: Qr
}, GD = Jr ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
function Co(e, t, s, r, n) {
  if (e[Ee] = {
    captureNames: t
  }, n)
    return e;
  if (e.__proto__)
    e.__proto__ = V.prototype;
  else
    for (const i in V.prototype)
      e[i] = V.prototype[i];
  return e[Ee].source = s, e[Ee].flags = r && r.split("").sort().join(""), e;
}
function dt(e) {
  return e.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
}
function vu(e, t) {
  if (!V.isRegExp(e))
    throw new TypeError("Type RegExp expected");
  const s = e[Ee] || {};
  let r = qD(e), n = "", i = "", a = null, l = null;
  return t = t || {}, t.removeG && (i += "g"), t.removeY && (i += "y"), i && (r = r.replace(new RegExp(`[${i}]+`, "g"), "")), t.addG && (n += "g"), t.addY && (n += "y"), n && (r = dt(r + n)), t.isInternalOnly || (s.source !== void 0 && (a = s.source), s.flags != null && (l = n ? dt(s.flags + n) : s.flags)), e = Co(
    new RegExp(t.source || e.source, r),
    ZD(e) ? s.captureNames.slice(0) : null,
    a,
    l,
    t.isInternalOnly
  ), e;
}
function Eo(e) {
  return parseInt(e, 16);
}
function xo(e, t, s) {
  const r = e.index + e[0].length, n = e.input[e.index - 1], i = e.input[r];
  return (
    // No need to separate tokens if at the beginning or end of a group, before or after a
    // group, or before or after a `|`
    /^[()|]$/.test(n) || /^[()|]$/.test(i) || // No need to separate tokens if at the beginning or end of the pattern
    e.index === 0 || r === e.input.length || // No need to separate tokens if at the beginning of a noncapturing group or lookaround.
    // Looks only at the last 4 chars (at most) for perf when constructing long regexes.
    /\(\?(?:[:=!]|<[=!])$/.test(e.input.substring(e.index - 4, e.index)) || // Avoid separating tokens when the following token is a quantifier
    KD(e.input, r, s) ? "" : "(?:)"
  );
}
function qD(e) {
  return VD ? e.flags : (
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(e))[1]
  );
}
function ZD(e) {
  return !!(e[Ee] && e[Ee].captureNames);
}
function en(e) {
  return parseInt(e, 10).toString(16);
}
function KD(e, t, s) {
  const r = "\\(\\?#[^)]*\\)", n = "#[^#\\n]*", i = "[?*+]|{\\d+(?:,\\d*)?}";
  return (s.includes("x") ? (
    // Ignore any leading whitespace, line comments, and inline comments
    new RegExp(`^(?:\\s|${n}|${r})*(?:${i})`)
  ) : (
    // Ignore any leading inline comments
    new RegExp(`^(?:${r})*(?:${i})`)
  )).test(e.slice(t));
}
function rs(e, t) {
  return Object.prototype.toString.call(e) === `[object ${t}]`;
}
function Vu(e) {
  if (e == null)
    throw new TypeError("Cannot convert null or undefined to object");
  return e;
}
function un(e) {
  for (; e.length < 4; )
    e = `0${e}`;
  return e;
}
function YD(e, t) {
  if (dt(t) !== t)
    throw new SyntaxError(`Invalid duplicate regex flag ${t}`);
  e = e.replace(/^\(\?([\w$]+)\)/, (s, r) => {
    if (/[dgy]/.test(r))
      throw new SyntaxError(`Cannot use flags dgy in mode modifier ${s}`);
    return t = dt(t + r), "";
  });
  for (const s of t)
    if (!mo[s])
      throw new SyntaxError(`Unknown regex flag ${s}`);
  return {
    pattern: e,
    flags: t
  };
}
function Ao(e) {
  const t = {};
  return rs(e, "String") ? (V.forEach(e, /[^\s,]+/, (s) => {
    t[s] = !0;
  }), t) : e;
}
function ui(e) {
  if (!/^[\w$]$/.test(e))
    throw new Error("Flag must be a single character A-Za-z0-9_$");
  mo[e] = !0;
}
function XD(e, t, s, r, n) {
  let i = Ir.length;
  const a = e[s];
  let l = null, o, D;
  for (; i--; )
    if (D = Ir[i], !(D.leadChar && D.leadChar !== a || D.scope !== r && D.scope !== "all" || D.flag && !t.includes(D.flag)) && (o = V.exec(e, D.regex, s, "sticky"), o)) {
      l = {
        matchLength: o[0].length,
        output: D.handler.call(n, o, r, t),
        reparse: D.reparse
      };
      break;
    }
  return l;
}
function go(e) {
  xu.astral = e;
}
function vo(e) {
  xu.namespacing = e;
}
function V(e, t) {
  if (V.isRegExp(e)) {
    if (t !== void 0)
      throw new TypeError("Cannot supply flags when copying a RegExp");
    return vu(e);
  }
  if (e = e === void 0 ? "" : String(e), t = t === void 0 ? "" : String(t), V.isInstalled("astral") && !t.includes("A") && (t += "A"), Nu[e] || (Nu[e] = {}), !Nu[e][t]) {
    const r = {
      hasNamedCapture: !1,
      captureNames: []
    };
    let n = Pu, i = "", a = 0, l;
    const o = YD(e, t);
    let D = o.pattern;
    const E = o.flags;
    for (; a < D.length; ) {
      do
        l = XD(D, E, a, n, r), l && l.reparse && (D = D.slice(0, a) + l.output + D.slice(a + l.matchLength));
      while (l && l.reparse);
      if (l)
        i += l.output, a += l.matchLength || 1;
      else {
        const [p] = V.exec(D, UD[n], a, "sticky");
        i += p, a += p.length, p === "[" && n === Pu ? n = ei : p === "]" && n === ei && (n = Pu);
      }
    }
    Nu[e][t] = {
      // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
      // groups are sometimes inserted during regex transpilation in order to keep tokens
      // separated. However, more than one empty group in a row is never needed.
      pattern: i.replace(/(?:\(\?:\))+/g, "(?:)"),
      // Strip all but native flags
      flags: E.replace(GD, ""),
      // `context.captureNames` has an item for each capturing group, even if unnamed
      captures: r.hasNamedCapture ? r.captureNames : null
    };
  }
  const s = Nu[e][t];
  return Co(
    new RegExp(s.pattern, s.flags),
    s.captures,
    e,
    t
  );
}
V.prototype = new RegExp();
V.version = "5.1.2";
V._clipDuplicates = dt;
V._hasNativeFlag = Et;
V._dec = Eo;
V._hex = en;
V._pad4 = un;
V.addToken = (e, t, s) => {
  s = s || {};
  let { optionalFlags: r } = s;
  if (s.flag && ui(s.flag), r) {
    r = r.split("");
    for (const n of r)
      ui(n);
  }
  Ir.push({
    regex: vu(e, {
      addG: !0,
      addY: Qr,
      isInternalOnly: !0
    }),
    handler: t,
    scope: s.scope || Pu,
    flag: s.flag,
    reparse: s.reparse,
    leadChar: s.leadChar
  }), V.cache.flush("patterns");
};
V.cache = (e, t) => (nt[e] || (nt[e] = {}), nt[e][t] || (nt[e][t] = V(e, t)));
V.cache.flush = (e) => {
  e === "patterns" ? Nu = /* @__PURE__ */ Object.create(null) : nt = /* @__PURE__ */ Object.create(null);
};
V.escape = (e) => String(Vu(e)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, (t) => `\\u${un(en(t.charCodeAt(0)))}`);
V.exec = (e, t, s, r) => {
  let n = "g", i = !1, a = !1, l;
  i = Qr && !!(r || t.sticky && r !== !1), i ? n += "y" : r && (a = !0, n += "FakeY"), t[Ee] = t[Ee] || {};
  const o = t[Ee][n] || (t[Ee][n] = vu(t, {
    addG: !0,
    addY: i,
    source: a ? `${t.source}|()` : void 0,
    removeY: r === !1,
    isInternalOnly: !0
  }));
  return s = s || 0, o.lastIndex = s, l = Ve.exec.call(o, e), a && l && l.pop() === "" && (l = null), t.global && (t.lastIndex = l ? o.lastIndex : 0), l;
};
V.forEach = (e, t, s) => {
  let r = 0, n = -1, i;
  for (; i = V.exec(e, t, r); )
    s(i, ++n, e, t), r = i.index + (i[0].length || 1);
};
V.globalize = (e) => vu(e, { addG: !0 });
V.install = (e) => {
  e = Ao(e), !xu.astral && e.astral && go(!0), !xu.namespacing && e.namespacing && vo(!0);
};
V.isInstalled = (e) => !!xu[e];
V.isRegExp = (e) => Object.prototype.toString.call(e) === "[object RegExp]";
V.match = (e, t, s) => {
  const r = t.global && s !== "one" || s === "all", n = (r ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
  t[Ee] = t[Ee] || {};
  const i = t[Ee][n] || (t[Ee][n] = vu(t, {
    addG: !!r,
    removeG: s === "one",
    isInternalOnly: !0
  })), a = String(Vu(e)).match(i);
  return t.global && (t.lastIndex = s === "one" && a ? (
    // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    a.index + a[0].length
  ) : 0), r ? a || [] : a && a[0];
};
V.matchChain = (e, t) => (function s(r, n) {
  const i = t[n].regex ? t[n] : { regex: t[n] }, a = [];
  function l(o) {
    if (i.backref) {
      const D = `Backreference to undefined group: ${i.backref}`, E = isNaN(i.backref);
      if (E && V.isInstalled("namespacing")) {
        if (!(o.groups && i.backref in o.groups))
          throw new ReferenceError(D);
      } else if (!o.hasOwnProperty(i.backref))
        throw new ReferenceError(D);
      const p = E && V.isInstalled("namespacing") ? o.groups[i.backref] : o[i.backref];
      a.push(p || "");
    } else
      a.push(o[0]);
  }
  for (const o of r)
    V.forEach(o, i.regex, l);
  return n === t.length - 1 || !a.length ? a : s(a, n + 1);
})([e], 0);
V.replace = (e, t, s, r) => {
  const n = V.isRegExp(t), i = t.global && r !== "one" || r === "all", a = (i ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
  let l = t;
  n ? (t[Ee] = t[Ee] || {}, l = t[Ee][a] || (t[Ee][a] = vu(t, {
    addG: !!i,
    removeG: r === "one",
    isInternalOnly: !0
  }))) : i && (l = new RegExp(V.escape(String(t)), "g"));
  const o = Ve.replace.call(Vu(e), l, s);
  return n && t.global && (t.lastIndex = 0), o;
};
V.replaceEach = (e, t) => {
  for (const s of t)
    e = V.replace(e, s[0], s[1], s[2]);
  return e;
};
V.split = (e, t, s) => Ve.split.call(Vu(e), t, s);
V.test = (e, t, s, r) => !!V.exec(e, t, s, r);
V.uninstall = (e) => {
  e = Ao(e), xu.astral && e.astral && go(!1), xu.namespacing && e.namespacing && vo(!1);
};
V.union = (e, t, s) => {
  s = s || {};
  const r = s.conjunction || "or";
  let n = 0, i, a;
  function l(p, m, c) {
    const f = a[n - i];
    if (m) {
      if (++n, f)
        return `(?<${f}>`;
    } else if (c)
      return `\\${+c + i}`;
    return p;
  }
  if (!(rs(e, "Array") && e.length))
    throw new TypeError("Must provide a nonempty array of patterns to merge");
  const o = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, D = [];
  for (const p of e)
    V.isRegExp(p) ? (i = n, a = p[Ee] && p[Ee].captureNames || [], D.push(V(p.source).source.replace(o, l))) : D.push(V.escape(p));
  const E = r === "none" ? "" : "|";
  return V(D.join(E), t);
};
Ve.exec = function(e) {
  const t = this.lastIndex, s = RegExp.prototype.exec.apply(this, arguments);
  if (s) {
    if (!zD && s.length > 1 && s.includes("")) {
      const r = vu(this, {
        removeG: !0,
        isInternalOnly: !0
      });
      String(e).slice(s.index).replace(r, (...n) => {
        const i = n.length;
        for (let a = 1; a < i - 2; ++a)
          n[a] === void 0 && (s[a] = void 0);
      });
    }
    if (this[Ee] && this[Ee].captureNames) {
      let r = s;
      V.isInstalled("namespacing") && (s.groups = /* @__PURE__ */ Object.create(null), r = s.groups);
      for (let n = 1; n < s.length; ++n) {
        const i = this[Ee].captureNames[n - 1];
        i && (r[i] = s[n]);
      }
    } else !s.groups && V.isInstalled("namespacing") && (s.groups = void 0);
    this.global && !s[0].length && this.lastIndex > s.index && (this.lastIndex = s.index);
  }
  return this.global || (this.lastIndex = t), s;
};
Ve.test = function(e) {
  return !!Ve.exec.call(this, e);
};
Ve.match = function(e) {
  if (!V.isRegExp(e))
    e = new RegExp(e);
  else if (e.global) {
    const t = String.prototype.match.apply(this, arguments);
    return e.lastIndex = 0, t;
  }
  return Ve.exec.call(e, Vu(this));
};
Ve.replace = function(e, t) {
  const s = V.isRegExp(e);
  let r, n, i;
  return s ? (e[Ee] && ({ captureNames: n } = e[Ee]), r = e.lastIndex) : e += "", rs(t, "Function") ? i = String(this).replace(e, (...a) => {
    if (n) {
      let l;
      V.isInstalled("namespacing") ? (l = /* @__PURE__ */ Object.create(null), a.push(l)) : (a[0] = new String(a[0]), [l] = a);
      for (let o = 0; o < n.length; ++o)
        n[o] && (l[n[o]] = a[o + 1]);
    }
    return t(...a);
  }) : i = String(Vu(this)).replace(e, (...a) => {
    return String(t).replace(HD, l);
    function l(o, D, E, p) {
      D = D || E;
      const m = rs(a[a.length - 1], "Object") ? 4 : 3, c = a.length - m;
      if (D) {
        if (/^\d+$/.test(D)) {
          const C = +D;
          if (C <= c)
            return a[C] || "";
        }
        const f = n ? n.indexOf(D) : -1;
        if (f < 0)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return a[f + 1] || "";
      }
      if (p === "" || p === " ")
        throw new SyntaxError(`Invalid token ${o}`);
      if (p === "&" || +p == 0)
        return a[0];
      if (p === "$")
        return "$";
      if (p === "`")
        return a[a.length - 1].slice(0, a[a.length - 2]);
      if (p === "'")
        return a[a.length - 1].slice(a[a.length - 2] + a[0].length);
      if (p = +p, !isNaN(p)) {
        if (p > c)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return a[p] || "";
      }
      throw new SyntaxError(`Invalid token ${o}`);
    }
  }), s && (e.global ? e.lastIndex = 0 : e.lastIndex = r), i;
};
Ve.split = function(e, t) {
  if (!V.isRegExp(e))
    return String.prototype.split.apply(this, arguments);
  const s = String(this), r = [], n = e.lastIndex;
  let i = 0, a;
  return t = (t === void 0 ? -1 : t) >>> 0, V.forEach(s, e, (l) => {
    l.index + l[0].length > i && (r.push(s.slice(i, l.index)), l.length > 1 && l.index < s.length && Array.prototype.push.apply(r, l.slice(1)), a = l[0].length, i = l.index + a);
  }), i === s.length ? (!e.test("") || a) && r.push("") : r.push(s.slice(i)), e.lastIndex = n, r.length > t ? r.slice(0, t) : r;
};
V.addToken(
  /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
  (e, t) => {
    if (e[1] === "B" && t === Pu)
      return e[0];
    throw new SyntaxError(`Invalid escape ${e[0]}`);
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
V.addToken(
  /\\u{([\dA-Fa-f]+)}/,
  (e, t, s) => {
    const r = Eo(e[1]);
    if (r > 1114111)
      throw new SyntaxError(`Invalid Unicode code point ${e[0]}`);
    if (r <= 65535)
      return `\\u${un(en(r))}`;
    if (Fo && s.includes("u"))
      return e[0];
    throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
V.addToken(
  /\(\?#[^)]*\)/,
  xo,
  { leadChar: "(" }
);
V.addToken(
  /\s+|#[^\n]*\n?/,
  xo,
  { flag: "x" }
);
Jr || V.addToken(
  /\./,
  () => "[\\s\\S]",
  {
    flag: "s",
    leadChar: "."
  }
);
V.addToken(
  /\\k<([^>]+)>/,
  function(e) {
    const t = isNaN(e[1]) ? this.captureNames.indexOf(e[1]) + 1 : +e[1], s = e.index + e[0].length;
    if (!t || t > this.captureNames.length)
      throw new SyntaxError(`Backreference to undefined group ${e[0]}`);
    return `\\${t}${s === e.input.length || isNaN(e.input[s]) ? "" : "(?:)"}`;
  },
  { leadChar: "\\" }
);
V.addToken(
  /\\(\d+)/,
  function(e, t) {
    if (!(t === Pu && /^[1-9]/.test(e[1]) && +e[1] <= this.captureNames.length) && e[1] !== "0")
      throw new SyntaxError(`Cannot use octal escape or backreference to undefined group ${e[0]}`);
    return e[0];
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
V.addToken(
  /\(\?P?<([\p{ID_Start}$_][\p{ID_Continue}$_\u200C\u200D]*)>/u,
  function(e) {
    if (!V.isInstalled("namespacing") && (e[1] === "length" || e[1] === "__proto__"))
      throw new SyntaxError(`Cannot use reserved word as capture name ${e[0]}`);
    if (this.captureNames.includes(e[1]))
      throw new SyntaxError(`Cannot use same name for multiple groups ${e[0]}`);
    return this.captureNames.push(e[1]), this.hasNamedCapture = !0, "(";
  },
  { leadChar: "(" }
);
V.addToken(
  /\((?!\?)/,
  function(e, t, s) {
    return s.includes("n") ? "(?:" : (this.captureNames.push(null), "(");
  },
  {
    optionalFlags: "n",
    leadChar: "("
  }
);
/*!
 * XRegExp.build 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */
const JD = (e) => {
  const t = "xregexp", s = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, r = e.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, s], "g", {
    conjunction: "or"
  });
  function n(D) {
    const E = /^(?:\(\?:\))*\^/, p = /\$(?:\(\?:\))*$/;
    return E.test(D) && p.test(D) && // Ensure that the trailing `$` isn't escaped
    p.test(D.replace(/\\[\s\S]/g, "")) ? D.replace(E, "").replace(p, "") : D;
  }
  function i(D, E) {
    const p = E ? "x" : "";
    return e.isRegExp(D) ? D[t] && D[t].captureNames ? (
      // Don't recompile, to preserve capture names
      D
    ) : (
      // Recompile as XRegExp
      e(D.source, p)
    ) : (
      // Compile string as XRegExp
      e(D, p)
    );
  }
  function a(D) {
    return D instanceof RegExp ? D : e.escape(D);
  }
  function l(D, E, p) {
    return D[`subpattern${p}`] = E, D;
  }
  function o(D, E, p) {
    const m = E < p.length - 1;
    return D + (m ? `{{subpattern${E}}}` : "");
  }
  e.tag = (D) => (E, ...p) => {
    const m = p.map(a).reduce(l, {}), c = E.raw.map(o).join("");
    return e.build(c, m, D);
  }, e.build = (D, E, p) => {
    p = p || "";
    const m = p.includes("x"), c = /^\(\?([\w$]+)\)/.exec(D);
    c && (p = e._clipDuplicates(p + c[1]));
    const f = {};
    for (const B in E)
      if (E.hasOwnProperty(B)) {
        const w = i(E[B], m);
        f[B] = {
          // Deanchoring allows embedding independently useful anchored regexes. If you
          // really need to keep your anchors, double them (i.e., `^^...$$`).
          pattern: n(w.source),
          names: w[t].captureNames || []
        };
      }
    const C = i(D, m);
    let g = 0, x, d = 0;
    const h = [0], F = C[t].captureNames || [], A = C.source.replace(r, (B, w, k, U, L) => {
      const T = w || k;
      let S, I, j;
      if (T) {
        if (!f.hasOwnProperty(T))
          throw new ReferenceError(`Undefined property ${B}`);
        w ? (S = F[d], h[++d] = ++g, I = `(?<${S || T}>`) : I = "(?:", x = g;
        const R = f[T].pattern.replace(s, (q, ie, ne) => {
          if (ie) {
            if (S = f[T].names[g - x], ++g, S)
              return `(?<${S}>`;
          } else if (ne)
            return j = +ne - 1, f[T].names[j] ? (
              // Need to preserve the backreference name in case using flag `n`
              `\\k<${f[T].names[j]}>`
            ) : `\\${+ne + x}`;
          return q;
        });
        return `${I}${R})`;
      }
      if (U) {
        if (S = F[d], h[++d] = ++g, S)
          return `(?<${S}>`;
      } else if (L)
        return j = +L - 1, F[j] ? (
          // Need to preserve the backreference name in case using flag `n`
          `\\k<${F[j]}>`
        ) : `\\${h[+L]}`;
      return B;
    });
    return e(A, p);
  };
};
/*!
 * XRegExp.matchRecursive 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */
const QD = (e) => {
  function t(s, r, n, i) {
    return {
      name: s,
      value: r,
      start: n,
      end: i
    };
  }
  e.matchRecursive = (s, r, n, i, a) => {
    i = i || "", a = a || {};
    const l = i.includes("g"), o = i.includes("y"), D = i.replace(/y/g, "");
    r = e(r, D), n = e(n, D);
    let E, { escapeChar: p } = a;
    if (p) {
      if (p.length > 1)
        throw new Error("Cannot use more than one escape character");
      p = e.escape(p), E = new RegExp(
        `(?:${p}[\\S\\s]|(?:(?!${// Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
        // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
        // transformation resulting from those flags was already applied to `left` and
        // `right` when they were passed through the XRegExp constructor above.
        e.union([r, n], "", { conjunction: "or" }).source})[^${p}])+)+`,
        // Flags `dgy` not needed here
        i.replace(e._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, "")
      );
    }
    let m = 0, c = 0, f = 0, C = 0, g, x, d, h;
    const F = a.valueNames, A = [];
    for (; ; ) {
      if (p && (f += (e.exec(s, E, f, "sticky") || [""])[0].length), d = e.exec(s, r, f), h = e.exec(s, n, f), d && h && (d.index <= h.index ? h = null : d = null), d || h)
        c = (d || h).index, f = c + (d || h)[0].length;
      else if (!m)
        break;
      if (o && !m && c > C)
        break;
      if (d)
        m || (g = c, x = f), m += 1;
      else if (h && m) {
        if (m -= 1, !m && (F ? (F[0] && g > C && A.push(t(F[0], s.slice(C, g), C, g)), F[1] && A.push(t(F[1], s.slice(g, x), g, x)), F[2] && A.push(t(F[2], s.slice(x, c), x, c)), F[3] && A.push(t(F[3], s.slice(c, f), c, f))) : A.push(s.slice(x, c)), C = f, !l))
          break;
      } else {
        const B = a.unbalanced || "error";
        if (B === "skip" || B === "skip-lazy")
          if (h)
            h = null;
          else {
            if (B === "skip") {
              const w = e.exec(s, r, g, "sticky")[0].length;
              f = g + (w || 1);
            } else
              f = g + 1;
            m = 0;
          }
        else if (B === "error") {
          const w = h ? "right" : "left", k = h ? c : g;
          throw new Error(`Unbalanced ${w} delimiter found in string at position ${k}`);
        } else
          throw new Error(`Unsupported value for unbalanced: ${B}`);
      }
      c === f && (f += 1);
    }
    return l && A.length > 0 && !o && F && F[0] && s.length > C && A.push(t(F[0], s.slice(C), C, s.length)), A;
  };
};
/*!
 * XRegExp Unicode Base 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */
const e1 = (e) => {
  const t = {}, s = {}, r = e._dec, n = e._hex, i = e._pad4;
  function a(m) {
    return m.replace(/[- _]+/g, "").toLowerCase();
  }
  function l(m) {
    const c = /^\\[xu](.+)/.exec(m);
    return c ? r(c[1]) : m.charCodeAt(m[0] === "\\" ? 1 : 0);
  }
  function o(m) {
    let c = "", f = -1;
    return e.forEach(
      m,
      /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,
      (C) => {
        const g = l(C[1]);
        g > f + 1 && (c += `\\u${i(n(f + 1))}`, g > f + 2 && (c += `-\\u${i(n(g - 1))}`)), f = l(C[2] || C[1]);
      }
    ), f < 65535 && (c += `\\u${i(n(f + 1))}`, f < 65534 && (c += "-\\uFFFF")), c;
  }
  function D(m) {
    return t[m]["b!"] || (t[m]["b!"] = o(t[m].bmp));
  }
  function E(m, c) {
    const f = t[m];
    let C = "";
    return f.bmp && !f.isBmpLast && (C = `[${f.bmp}]${f.astral ? "|" : ""}`), f.astral && (C += f.astral), f.isBmpLast && f.bmp && (C += `${f.astral ? "|" : ""}[${f.bmp}]`), c ? `(?:(?!${C})(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-￿]))` : `(?:${C})`;
  }
  function p(m, c) {
    const f = c ? "a!" : "a=";
    return t[m][f] || (t[m][f] = E(m, c));
  }
  e.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/,
    (m, c, f) => {
      const C = "Invalid double negation ", g = "Unknown Unicode token ", x = "Unicode token missing data ", d = "Astral mode required for Unicode token ", h = "Astral mode does not support Unicode tokens within character classes", [
        F,
        A,
        B,
        w,
        k,
        U
      ] = m;
      let L = A === "P" || !!B;
      const T = f.includes("A");
      let S = a(U || k), I = t[S];
      if (A === "P" && B)
        throw new SyntaxError(C + F);
      if (!t.hasOwnProperty(S))
        throw new SyntaxError(g + F);
      if (w && !(s[w] && s[w][S]))
        throw new SyntaxError(g + F);
      if (I.inverseOf) {
        if (S = a(I.inverseOf), !t.hasOwnProperty(S))
          throw new ReferenceError(`${x + F} -> ${I.inverseOf}`);
        I = t[S], L = !L;
      }
      if (!(I.bmp || T))
        throw new SyntaxError(d + F);
      if (T) {
        if (c === "class")
          throw new SyntaxError(h);
        return p(S, L);
      }
      return c === "class" ? L ? D(S) : I.bmp : `${(L ? "[^" : "[") + I.bmp}]`;
    },
    {
      scope: "all",
      optionalFlags: "A",
      leadChar: "\\"
    }
  ), e.addUnicodeData = (m, c) => {
    const f = "Unicode token requires name", C = "Unicode token has no character data ";
    c && (s[c] = {});
    for (const g of m) {
      if (!g.name)
        throw new Error(f);
      if (!(g.inverseOf || g.bmp || g.astral))
        throw new Error(C + g.name);
      const x = a(g.name);
      if (t[x] = g, c && (s[c][x] = !0), g.alias) {
        const d = a(g.alias);
        t[d] = g, c && (s[c][d] = !0);
      }
    }
    e.cache.flush("patterns");
  }, e._getUnicodeProperty = (m) => {
    const c = a(m);
    return t[c];
  };
};
var Ms, ti;
function u1() {
  return ti || (ti = 1, Ms = [
    {
      name: "C",
      alias: "Other",
      isBmpLast: !0,
      bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
      astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCBD\uDCC3-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]"
    },
    {
      name: "Cc",
      alias: "Control",
      bmp: "\0--"
    },
    {
      name: "Cf",
      alias: "Format",
      bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯\uFEFF￹-￻",
      astral: "\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]"
    },
    {
      name: "Cn",
      alias: "Unassigned",
      bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
      astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCC3-\uDCCC\uDCCE\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F\uDC39-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]"
    },
    {
      name: "Co",
      alias: "Private_Use",
      bmp: "-",
      astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]"
    },
    {
      name: "Cs",
      alias: "Surrogate",
      bmp: "\uD800-\uDFFF"
    },
    {
      name: "L",
      alias: "Letter",
      bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "LC",
      alias: "Cased_Letter",
      bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
      astral: "\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD81B[\uDE40-\uDE7F]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD00-\uDD43]"
    },
    {
      name: "Ll",
      alias: "Lowercase_Letter",
      bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
      astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
    },
    {
      name: "Lm",
      alias: "Modifier_Letter",
      bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
      astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD838[\uDD37-\uDD3D]|𞥋"
    },
    {
      name: "Lo",
      alias: "Other_Letter",
      bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF4A\uDF50]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|𝼊|\uD838[\uDD00-\uDD2C\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Lt",
      alias: "Titlecase_Letter",
      bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
    },
    {
      name: "Lu",
      alias: "Uppercase_Letter",
      bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
      astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]"
    },
    {
      name: "M",
      alias: "Mark",
      bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
      astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "Mc",
      alias: "Spacing_Mark",
      bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
      astral: "\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD30-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]"
    },
    {
      name: "Me",
      alias: "Enclosing_Mark",
      bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
    },
    {
      name: "Mn",
      alias: "Nonspacing_Mark",
      bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
      astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "N",
      alias: "Number",
      bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
      astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]"
    },
    {
      name: "Nd",
      alias: "Decimal_Number",
      bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
      astral: "\uD801[\uDCA0-\uDCA9]|\uD803[\uDD30-\uDD39]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9\uDD50-\uDD59]|\uD807[\uDC50-\uDC59\uDD50-\uDD59\uDDA0-\uDDA9]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDD50-\uDD59]|\uD83E[\uDFF0-\uDFF9]"
    },
    {
      name: "Nl",
      alias: "Letter_Number",
      bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
      astral: "\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]"
    },
    {
      name: "No",
      alias: "Other_Number",
      bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
      astral: "\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C\uDFC0-\uDFD4]|\uD81A[\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD83A[\uDCC7-\uDCCF]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]"
    },
    {
      name: "P",
      alias: "Punctuation",
      bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
      astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
    },
    {
      name: "Pc",
      alias: "Connector_Punctuation",
      bmp: "_‿⁀⁔︳︴﹍-﹏＿"
    },
    {
      name: "Pd",
      alias: "Dash_Punctuation",
      bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
      astral: "𐺭"
    },
    {
      name: "Pe",
      alias: "Close_Punctuation",
      bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
    },
    {
      name: "Pf",
      alias: "Final_Punctuation",
      bmp: "»’”›⸃⸅⸊⸍⸝⸡"
    },
    {
      name: "Pi",
      alias: "Initial_Punctuation",
      bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
    },
    {
      name: "Po",
      alias: "Other_Punctuation",
      bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
      astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
    },
    {
      name: "Ps",
      alias: "Open_Punctuation",
      bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
    },
    {
      name: "S",
      alias: "Symbol",
      bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
      astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
    },
    {
      name: "Sc",
      alias: "Currency_Symbol",
      bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
      astral: "\uD807[\uDFDD-\uDFE0]|𞋿|𞲰"
    },
    {
      name: "Sk",
      alias: "Modifier_Symbol",
      bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
      astral: "\uD83C[\uDFFB-\uDFFF]"
    },
    {
      name: "Sm",
      alias: "Math_Symbol",
      bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
      astral: "\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]"
    },
    {
      name: "So",
      alias: "Other_Symbol",
      bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
      astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|𞅏|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
    },
    {
      name: "Z",
      alias: "Separator",
      bmp: "    - \u2028\u2029  　"
    },
    {
      name: "Zl",
      alias: "Line_Separator",
      bmp: "\u2028"
    },
    {
      name: "Zp",
      alias: "Paragraph_Separator",
      bmp: "\u2029"
    },
    {
      name: "Zs",
      alias: "Space_Separator",
      bmp: "    -   　"
    }
  ]), Ms;
}
var t1 = u1();
const s1 = /* @__PURE__ */ Au(t1);
/*!
 * XRegExp Unicode Categories 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const r1 = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
  e.addUnicodeData(s1);
};
var Us, si;
function n1() {
  return si || (si = 1, Us = [
    {
      name: "ASCII",
      bmp: "\0-"
    },
    {
      name: "Alphabetic",
      bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC45\uDC71-\uDC75\uDC82-\uDCB8\uDCC2\uDCD0-\uDCE8\uDD00-\uDD32\uDD44-\uDD47\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDCE\uDDCF\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2A\uDF40-\uDF46]|\uD806[\uDC00-\uDC38\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B\uDD3C\uDD3F-\uDD42\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDDF\uDDE1\uDDE3\uDDE4\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE97\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD96\uDD98\uDEE0-\uDEF6\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Any",
      isBmpLast: !0,
      bmp: "\0-￿",
      astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]"
    },
    {
      name: "Default_Ignorable_Code_Point",
      bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️\uFEFFﾠ￰-￸",
      astral: "\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]"
    },
    {
      name: "Lowercase",
      bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
      astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDF80\uDF83-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
    },
    {
      name: "Noncharacter_Code_Point",
      bmp: "﷐-﷯￾￿",
      astral: "[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]"
    },
    {
      name: "Uppercase",
      bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
      astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]"
    },
    {
      name: "White_Space",
      bmp: "	-\r    - \u2028\u2029  　"
    }
  ]), Us;
}
var i1 = n1();
const a1 = /* @__PURE__ */ Au(i1);
/*!
 * XRegExp Unicode Properties 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const o1 = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
  const t = a1;
  t.push({
    name: "Assigned",
    // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
    // Categories addon is required to use this property
    inverseOf: "Cn"
  }), e.addUnicodeData(t);
};
var Hs, ri;
function l1() {
  return ri || (ri = 1, Hs = [
    {
      name: "Adlam",
      astral: "\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]"
    },
    {
      name: "Ahom",
      astral: "\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF46]"
    },
    {
      name: "Anatolian_Hieroglyphs",
      astral: "\uD811[\uDC00-\uDE46]"
    },
    {
      name: "Arabic",
      bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
      astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]"
    },
    {
      name: "Armenian",
      bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
    },
    {
      name: "Avestan",
      astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]"
    },
    {
      name: "Balinese",
      bmp: "ᬀ-ᭌ᭐-᭾"
    },
    {
      name: "Bamum",
      bmp: "ꚠ-꛷",
      astral: "\uD81A[\uDC00-\uDE38]"
    },
    {
      name: "Bassa_Vah",
      astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]"
    },
    {
      name: "Batak",
      bmp: "ᯀ-᯳᯼-᯿"
    },
    {
      name: "Bengali",
      bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
    },
    {
      name: "Bhaiksuki",
      astral: "\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]"
    },
    {
      name: "Bopomofo",
      bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
    },
    {
      name: "Brahmi",
      astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC75\uDC7F]"
    },
    {
      name: "Braille",
      bmp: "⠀-⣿"
    },
    {
      name: "Buginese",
      bmp: "ᨀ-ᨛ᨞᨟"
    },
    {
      name: "Buhid",
      bmp: "ᝀ-ᝓ"
    },
    {
      name: "Canadian_Aboriginal",
      bmp: "᐀-ᙿᢰ-ᣵ",
      astral: "\uD806[\uDEB0-\uDEBF]"
    },
    {
      name: "Carian",
      astral: "\uD800[\uDEA0-\uDED0]"
    },
    {
      name: "Caucasian_Albanian",
      astral: "\uD801[\uDD30-\uDD63\uDD6F]"
    },
    {
      name: "Chakma",
      astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD47]"
    },
    {
      name: "Cham",
      bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
    },
    {
      name: "Cherokee",
      bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
    },
    {
      name: "Chorasmian",
      astral: "\uD803[\uDFB0-\uDFCB]"
    },
    {
      name: "Common",
      bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫\uFEFF！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
      astral: "\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9C\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDEE0-\uDEF3\uDF00-\uDF56\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83B[\uDC71-\uDCB4\uDD01-\uDD3D]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDDAD\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA\uDFF0-\uDFF9]|\uDB40[\uDC01\uDC20-\uDC7F]"
    },
    {
      name: "Coptic",
      bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
    },
    {
      name: "Cuneiform",
      astral: "\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]"
    },
    {
      name: "Cypriot",
      astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]"
    },
    {
      name: "Cypro_Minoan",
      astral: "\uD80B[\uDF90-\uDFF2]"
    },
    {
      name: "Cyrillic",
      bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
    },
    {
      name: "Deseret",
      astral: "\uD801[\uDC00-\uDC4F]"
    },
    {
      name: "Devanagari",
      bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
    },
    {
      name: "Dives_Akuru",
      astral: "\uD806[\uDD00-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDD50-\uDD59]"
    },
    {
      name: "Dogra",
      astral: "\uD806[\uDC00-\uDC3B]"
    },
    {
      name: "Duployan",
      astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]"
    },
    {
      name: "Egyptian_Hieroglyphs",
      astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E\uDC30-\uDC38]"
    },
    {
      name: "Elbasan",
      astral: "\uD801[\uDD00-\uDD27]"
    },
    {
      name: "Elymaic",
      astral: "\uD803[\uDFE0-\uDFF6]"
    },
    {
      name: "Ethiopic",
      bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
      astral: "\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]"
    },
    {
      name: "Georgian",
      bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
    },
    {
      name: "Glagolitic",
      bmp: "Ⰰ-ⱟ",
      astral: "\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]"
    },
    {
      name: "Gothic",
      astral: "\uD800[\uDF30-\uDF4A]"
    },
    {
      name: "Grantha",
      astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]"
    },
    {
      name: "Greek",
      bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
      astral: "\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]"
    },
    {
      name: "Gujarati",
      bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
    },
    {
      name: "Gunjala_Gondi",
      astral: "\uD807[\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9]"
    },
    {
      name: "Gurmukhi",
      bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
    },
    {
      name: "Han",
      bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
      astral: "\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Hangul",
      bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
    },
    {
      name: "Hanifi_Rohingya",
      astral: "\uD803[\uDD00-\uDD27\uDD30-\uDD39]"
    },
    {
      name: "Hanunoo",
      bmp: "ᜠ-᜴"
    },
    {
      name: "Hatran",
      astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]"
    },
    {
      name: "Hebrew",
      bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
    },
    {
      name: "Hiragana",
      bmp: "ぁ-ゖゝ-ゟ",
      astral: "\uD82C[\uDC01-\uDD1F\uDD50-\uDD52]|🈀"
    },
    {
      name: "Imperial_Aramaic",
      astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]"
    },
    {
      name: "Inherited",
      bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
      astral: "\uD800[\uDDFD\uDEE0]|𑌻|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "Inscriptional_Pahlavi",
      astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]"
    },
    {
      name: "Inscriptional_Parthian",
      astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]"
    },
    {
      name: "Javanese",
      bmp: "ꦀ-꧍꧐-꧙꧞꧟"
    },
    {
      name: "Kaithi",
      astral: "\uD804[\uDC80-\uDCC2\uDCCD]"
    },
    {
      name: "Kannada",
      bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
    },
    {
      name: "Katakana",
      bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
      astral: "\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00\uDD20-\uDD22\uDD64-\uDD67]"
    },
    {
      name: "Kayah_Li",
      bmp: "꤀-꤭꤯"
    },
    {
      name: "Kharoshthi",
      astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58]"
    },
    {
      name: "Khitan_Small_Script",
      astral: "𖿤|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDCD5]"
    },
    {
      name: "Khmer",
      bmp: "ក-៝០-៩៰-៹᧠-᧿"
    },
    {
      name: "Khojki",
      astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3E]"
    },
    {
      name: "Khudawadi",
      astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]"
    },
    {
      name: "Lao",
      bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
    },
    {
      name: "Latin",
      bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
      astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD837[\uDF00-\uDF1E]"
    },
    {
      name: "Lepcha",
      bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
    },
    {
      name: "Limbu",
      bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
    },
    {
      name: "Linear_A",
      astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]"
    },
    {
      name: "Linear_B",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]"
    },
    {
      name: "Lisu",
      bmp: "ꓐ-꓿",
      astral: "𑾰"
    },
    {
      name: "Lycian",
      astral: "\uD800[\uDE80-\uDE9C]"
    },
    {
      name: "Lydian",
      astral: "\uD802[\uDD20-\uDD39\uDD3F]"
    },
    {
      name: "Mahajani",
      astral: "\uD804[\uDD50-\uDD76]"
    },
    {
      name: "Makasar",
      astral: "\uD807[\uDEE0-\uDEF8]"
    },
    {
      name: "Malayalam",
      bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
    },
    {
      name: "Mandaic",
      bmp: "ࡀ-࡛࡞"
    },
    {
      name: "Manichaean",
      astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]"
    },
    {
      name: "Marchen",
      astral: "\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]"
    },
    {
      name: "Masaram_Gondi",
      astral: "\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]"
    },
    {
      name: "Medefaidrin",
      astral: "\uD81B[\uDE40-\uDE9A]"
    },
    {
      name: "Meetei_Mayek",
      bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
    },
    {
      name: "Mende_Kikakui",
      astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]"
    },
    {
      name: "Meroitic_Cursive",
      astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]"
    },
    {
      name: "Meroitic_Hieroglyphs",
      astral: "\uD802[\uDD80-\uDD9F]"
    },
    {
      name: "Miao",
      astral: "\uD81B[\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F]"
    },
    {
      name: "Modi",
      astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]"
    },
    {
      name: "Mongolian",
      bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
      astral: "\uD805[\uDE60-\uDE6C]"
    },
    {
      name: "Mro",
      astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]"
    },
    {
      name: "Multani",
      astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]"
    },
    {
      name: "Myanmar",
      bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
    },
    {
      name: "Nabataean",
      astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]"
    },
    {
      name: "Nandinagari",
      astral: "\uD806[\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4]"
    },
    {
      name: "New_Tai_Lue",
      bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
    },
    {
      name: "Newa",
      astral: "\uD805[\uDC00-\uDC5B\uDC5D-\uDC61]"
    },
    {
      name: "Nko",
      bmp: "߀-ߺ߽-߿"
    },
    {
      name: "Nushu",
      astral: "𖿡|\uD82C[\uDD70-\uDEFB]"
    },
    {
      name: "Nyiakeng_Puachue_Hmong",
      astral: "\uD838[\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDD4F]"
    },
    {
      name: "Ogham",
      bmp: " -᚜"
    },
    {
      name: "Ol_Chiki",
      bmp: "᱐-᱿"
    },
    {
      name: "Old_Hungarian",
      astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]"
    },
    {
      name: "Old_Italic",
      astral: "\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]"
    },
    {
      name: "Old_North_Arabian",
      astral: "\uD802[\uDE80-\uDE9F]"
    },
    {
      name: "Old_Permic",
      astral: "\uD800[\uDF50-\uDF7A]"
    },
    {
      name: "Old_Persian",
      astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]"
    },
    {
      name: "Old_Sogdian",
      astral: "\uD803[\uDF00-\uDF27]"
    },
    {
      name: "Old_South_Arabian",
      astral: "\uD802[\uDE60-\uDE7F]"
    },
    {
      name: "Old_Turkic",
      astral: "\uD803[\uDC00-\uDC48]"
    },
    {
      name: "Old_Uyghur",
      astral: "\uD803[\uDF70-\uDF89]"
    },
    {
      name: "Oriya",
      bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
    },
    {
      name: "Osage",
      astral: "\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]"
    },
    {
      name: "Osmanya",
      astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]"
    },
    {
      name: "Pahawh_Hmong",
      astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]"
    },
    {
      name: "Palmyrene",
      astral: "\uD802[\uDC60-\uDC7F]"
    },
    {
      name: "Pau_Cin_Hau",
      astral: "\uD806[\uDEC0-\uDEF8]"
    },
    {
      name: "Phags_Pa",
      bmp: "ꡀ-꡷"
    },
    {
      name: "Phoenician",
      astral: "\uD802[\uDD00-\uDD1B\uDD1F]"
    },
    {
      name: "Psalter_Pahlavi",
      astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]"
    },
    {
      name: "Rejang",
      bmp: "ꤰ-꥓꥟"
    },
    {
      name: "Runic",
      bmp: "ᚠ-ᛪᛮ-ᛸ"
    },
    {
      name: "Samaritan",
      bmp: "ࠀ-࠭࠰-࠾"
    },
    {
      name: "Saurashtra",
      bmp: "ꢀ-ꣅ꣎-꣙"
    },
    {
      name: "Sharada",
      astral: "\uD804[\uDD80-\uDDDF]"
    },
    {
      name: "Shavian",
      astral: "\uD801[\uDC50-\uDC7F]"
    },
    {
      name: "Siddham",
      astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]"
    },
    {
      name: "SignWriting",
      astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]"
    },
    {
      name: "Sinhala",
      bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
      astral: "\uD804[\uDDE1-\uDDF4]"
    },
    {
      name: "Sogdian",
      astral: "\uD803[\uDF30-\uDF59]"
    },
    {
      name: "Sora_Sompeng",
      astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]"
    },
    {
      name: "Soyombo",
      astral: "\uD806[\uDE50-\uDEA2]"
    },
    {
      name: "Sundanese",
      bmp: "ᮀ-ᮿ᳀-᳇"
    },
    {
      name: "Syloti_Nagri",
      bmp: "ꠀ-꠬"
    },
    {
      name: "Syriac",
      bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
    },
    {
      name: "Tagalog",
      bmp: "ᜀ-᜕ᜟ"
    },
    {
      name: "Tagbanwa",
      bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
    },
    {
      name: "Tai_Le",
      bmp: "ᥐ-ᥭᥰ-ᥴ"
    },
    {
      name: "Tai_Tham",
      bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
    },
    {
      name: "Tai_Viet",
      bmp: "ꪀ-ꫂꫛ-꫟"
    },
    {
      name: "Takri",
      astral: "\uD805[\uDE80-\uDEB9\uDEC0-\uDEC9]"
    },
    {
      name: "Tamil",
      bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
      astral: "\uD807[\uDFC0-\uDFF1\uDFFF]"
    },
    {
      name: "Tangsa",
      astral: "\uD81A[\uDE70-\uDEBE\uDEC0-\uDEC9]"
    },
    {
      name: "Tangut",
      astral: "𖿠|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEFF]|\uD823[\uDD00-\uDD08]"
    },
    {
      name: "Telugu",
      bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
    },
    {
      name: "Thaana",
      bmp: "ހ-ޱ"
    },
    {
      name: "Thai",
      bmp: "ก-ฺเ-๛"
    },
    {
      name: "Tibetan",
      bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
    },
    {
      name: "Tifinagh",
      bmp: "ⴰ-ⵧⵯ⵰⵿"
    },
    {
      name: "Tirhuta",
      astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]"
    },
    {
      name: "Toto",
      astral: "\uD838[\uDE90-\uDEAE]"
    },
    {
      name: "Ugaritic",
      astral: "\uD800[\uDF80-\uDF9D\uDF9F]"
    },
    {
      name: "Vai",
      bmp: "ꔀ-ꘫ"
    },
    {
      name: "Vithkuqi",
      astral: "\uD801[\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]"
    },
    {
      name: "Wancho",
      astral: "\uD838[\uDEC0-\uDEF9\uDEFF]"
    },
    {
      name: "Warang_Citi",
      astral: "\uD806[\uDCA0-\uDCF2\uDCFF]"
    },
    {
      name: "Yezidi",
      astral: "\uD803[\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1]"
    },
    {
      name: "Yi",
      bmp: "ꀀ-ꒌ꒐-꓆"
    },
    {
      name: "Zanabazar_Square",
      astral: "\uD806[\uDE00-\uDE47]"
    }
  ]), Hs;
}
var c1 = l1();
const D1 = /* @__PURE__ */ Au(c1);
/*!
 * XRegExp Unicode Scripts 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const p1 = (e) => {
  if (!e.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
  e.addUnicodeData(D1, "Script");
};
JD(V);
QD(V);
e1(V);
r1(V);
o1(V);
p1(V);
const d1 = V(
  // prettier-ignore
  /@\[(\d+)\]\(([^)]+)\)+/i
), f1 = V(
  // prettier-ignore
  // eslint-disable-next-line no-useless-escape
  /@\[(urn:li:(organization|person):[A-Za-z0-9\_\-]+)\]\(([^)]+)\)+/i
), h1 = V(
  // prettier-ignore
  /(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i
), F1 = V(
  // prettier-ignore
  /(?:@)([A-Za-z0-9_](?:[A-Za-z0-9_.]{0,28}(?:[A-Za-z0-9_]))?)/i
), m1 = V(
  // prettier-ignore
  /(#+[a-zA-Z0-9(_)]{1,})/i
);
function C1({
  host: e,
  tag: t,
  label: s
}) {
  return /* @__PURE__ */ u.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${e}${t}`, children: s });
}
function E1({
  label: e
}) {
  return /* @__PURE__ */ u.jsx("span", { children: e }, `unknown-${e}`);
}
class x1 extends Ct {
  constructor(t, s) {
    super(t), this.targetPlatform = s;
  }
  match(t) {
    const s = t.match(m1);
    return !s || s.index === void 0 ? null : {
      index: s.index,
      length: s[0].length,
      match: s[0],
      urn: s[0],
      label: s[0],
      valid: !0
    };
  }
  replaceWith(t, s) {
    let {
      label: r
    } = s;
    const n = r.replace("#", "");
    let i;
    switch (this.targetPlatform) {
      case "IG":
        i = "https://www.instagram.com/explore/tags/";
        break;
      case "TW":
        i = "https://twitter.com/hashtag/";
        break;
      case "TH":
        i = "https://threads.net/search?q=", r = r.replace("#", "");
        break;
      case "LI":
        i = "https://www.linkedin.com/feed/hashtag/";
        break;
      case "TT":
        i = "https://www.tiktok.com/tag/";
        break;
      case "FB":
        i = "https://www.facebook.com/hashtag/";
        break;
      default:
        i = null;
    }
    return i ? ee.createElement(C1, {
      key: s.key,
      tag: n,
      host: i,
      label: r
    }, t) : ee.createElement(E1, {
      key: s.key,
      label: r
    }, t);
  }
  asTag() {
    return "a";
  }
}
function A1({
  host: e,
  username: t,
  label: s
}) {
  return /* @__PURE__ */ u.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${e}/${t}`, children: s }, s);
}
class g1 extends Ct {
  constructor(t, s) {
    if (super(t), this.targetPlatform = s, this.platformHosts = {
      IG: "https://instagram.com",
      TW: "https://twitter.com",
      TH: "https://threads.net",
      TT: "https://tiktok.com",
      PI: "https://pinterest.com"
    }, !this.platformHosts[s])
      throw new Error(`Unsupported "targetPlatform": ${s}`);
  }
  match(t) {
    const s = this.targetPlatform === "TT" ? F1 : h1, r = t.match(s);
    if (!r || r.index === void 0)
      return null;
    const n = this.targetPlatform === "IG" ? r[0].replace("@", "") : r[0];
    return {
      index: r.index,
      length: r[0].length,
      match: r[0],
      urn: n,
      label: r[0],
      valid: !0
    };
  }
  replaceWith(t, s) {
    const {
      label: r
    } = s;
    if (!r)
      throw new Error("Username is required.");
    const n = this.platformHosts[this.targetPlatform], i = this.targetPlatform === "IG" ? r.replace(/^@/, "") : r;
    return ee.createElement(A1, {
      ...s,
      key: s.key,
      host: n,
      username: i
    }, t);
  }
  asTag() {
    return "a";
  }
}
function v1({
  urn: e,
  label: t,
  orgId: s,
  trackEvent: r
}) {
  return /* @__PURE__ */ u.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `LinkedIn organization: ${e}`, onClick: () => {
    r && r("link-preview-clicked"), window.open(`https://www.linkedin.com/company/${s}`, "_blank");
  }, children: t }, e);
}
function y1({
  label: e,
  urn: t
}) {
  return /* @__PURE__ */ u.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `Person mention for ${e}. Sked currently can't link you directly to the person's profile.`, children: e }, `unknown-${t}${e}`);
}
class B1 extends Ct {
  constructor(t, s, r) {
    super(t), this.targetPlatform = s, this.trackEvent = r;
  }
  match(t) {
    const s = t.match(f1);
    return !s || s.index === void 0 ? null : {
      index: s.index,
      length: s[0].length,
      match: s[0],
      urn: s[1],
      label: s[3],
      valid: !0
    };
  }
  replaceWith(t, s) {
    const {
      urn: r,
      label: n
    } = s;
    if (this.targetPlatform === "LI" && r.includes("organization")) {
      const i = r.split(":").pop();
      return ee.createElement(v1, {
        key: s.key,
        urn: r,
        label: n,
        orgId: i,
        trackEvent: this.trackEvent
      }, t);
    } else
      return ee.createElement(y1, {
        key: s.key,
        urn: r,
        label: n,
        trackEvent: this.trackEvent
      }, t);
  }
  asTag() {
    return "span";
  }
}
function ni({
  id: e,
  label: t
}) {
  return /* @__PURE__ */ u.jsx("a", { className: "sked-mention sked-mention-link sked-mention-facebook", target: "_blank", rel: "noreferrer", href: `https://www.facebook.com/${e}`, children: t }, t);
}
class b1 extends Ct {
  constructor(t, s) {
    super(t), this.targetPlatform = s;
  }
  match(t) {
    const s = t.match(d1);
    return !s || s.index === void 0 ? null : {
      index: s.index,
      length: s[0].length,
      match: s[0],
      id: s[1],
      label: s[2],
      valid: !0
    };
  }
  replaceWith(t, s) {
    return this.targetPlatform === "FB" ? ee.createElement(ni, {
      ...s,
      key: s.key
    }, t) : ee.createElement(ni, {
      ...s,
      key: s.key
    }, t);
  }
  asTag() {
    return "a";
  }
}
function w1(e, t) {
  e === void 0 && (e = "");
  const s = [new MD("url"), new x1("hashtag", e)];
  switch (e) {
    case "IG":
    case "TW":
    case "TT":
    case "TH":
    case "PI":
      return [new g1("socialLink", e), ...s];
    default:
      return [new b1("fb", e), new B1("li", e, t), ...s];
  }
}
function le({
  caption: e,
  targetPlatform: t,
  trackEvent: s
}) {
  const r = e, n = w1(t, s);
  return /* @__PURE__ */ u.jsx(kD, { content: r, matchers: n, newWindow: !0 });
}
function k3({
  caption: e,
  targetPlatform: t
}) {
  return /* @__PURE__ */ u.jsx(j1, { children: /* @__PURE__ */ u.jsx(le, { caption: e, targetPlatform: t }) });
}
const j1 = _.div`
  .sked-mention {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`;
var zs, ii;
function _1() {
  if (ii) return zs;
  ii = 1, zs = function(n, i, a) {
    var l = document.head || document.getElementsByTagName("head")[0], o = document.createElement("script");
    typeof i == "function" && (a = i, i = {}), i = i || {}, a = a || function() {
    }, o.type = i.type || "text/javascript", o.charset = i.charset || "utf8", o.async = "async" in i ? !!i.async : !0, o.src = n, i.attrs && e(o, i.attrs), i.text && (o.text = "" + i.text);
    var D = "onload" in o ? t : s;
    D(o, a), o.onload || t(o, a), l.appendChild(o);
  };
  function e(r, n) {
    for (var i in n)
      r.setAttribute(i, n[i]);
  }
  function t(r, n) {
    r.onload = function() {
      this.onerror = this.onload = null, n(null, r);
    }, r.onerror = function() {
      this.onerror = this.onload = null, n(new Error("Failed to load " + this.src), r);
    };
  }
  function s(r, n) {
    r.onreadystatechange = function() {
      this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, n(null, r));
    };
  }
  return zs;
}
var Vs, ai;
function yo() {
  if (ai) return Vs;
  ai = 1;
  var e = function(d) {
    return t(d) && !s(d);
  };
  function t(x) {
    return !!x && typeof x == "object";
  }
  function s(x) {
    var d = Object.prototype.toString.call(x);
    return d === "[object RegExp]" || d === "[object Date]" || i(x);
  }
  var r = typeof Symbol == "function" && Symbol.for, n = r ? Symbol.for("react.element") : 60103;
  function i(x) {
    return x.$$typeof === n;
  }
  function a(x) {
    return Array.isArray(x) ? [] : {};
  }
  function l(x, d) {
    return d.clone !== !1 && d.isMergeableObject(x) ? C(a(x), x, d) : x;
  }
  function o(x, d, h) {
    return x.concat(d).map(function(F) {
      return l(F, h);
    });
  }
  function D(x, d) {
    if (!d.customMerge)
      return C;
    var h = d.customMerge(x);
    return typeof h == "function" ? h : C;
  }
  function E(x) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(x).filter(function(d) {
      return Object.propertyIsEnumerable.call(x, d);
    }) : [];
  }
  function p(x) {
    return Object.keys(x).concat(E(x));
  }
  function m(x, d) {
    try {
      return d in x;
    } catch {
      return !1;
    }
  }
  function c(x, d) {
    return m(x, d) && !(Object.hasOwnProperty.call(x, d) && Object.propertyIsEnumerable.call(x, d));
  }
  function f(x, d, h) {
    var F = {};
    return h.isMergeableObject(x) && p(x).forEach(function(A) {
      F[A] = l(x[A], h);
    }), p(d).forEach(function(A) {
      c(x, A) || (m(x, A) && h.isMergeableObject(d[A]) ? F[A] = D(A, h)(x[A], d[A], h) : F[A] = l(d[A], h));
    }), F;
  }
  function C(x, d, h) {
    h = h || {}, h.arrayMerge = h.arrayMerge || o, h.isMergeableObject = h.isMergeableObject || e, h.cloneUnlessOtherwiseSpecified = l;
    var F = Array.isArray(d), A = Array.isArray(x), B = F === A;
    return B ? F ? h.arrayMerge(x, d, h) : f(x, d, h) : l(d, h);
  }
  C.all = function(d, h) {
    if (!Array.isArray(d))
      throw new Error("first argument should be an array");
    return d.reduce(function(F, A) {
      return C(F, A, h);
    }, {});
  };
  var g = C;
  return Vs = g, Vs;
}
var Ws, oi;
function ms() {
  if (oi) return Ws;
  oi = 1;
  var e = Object.create, t = Object.defineProperty, s = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, n = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (O, b) => {
    for (var N in b)
      t(O, N, { get: b[N], enumerable: !0 });
  }, l = (O, b, N, M) => {
    if (b && typeof b == "object" || typeof b == "function")
      for (let W of r(b))
        !i.call(O, W) && W !== N && t(O, W, { get: () => b[W], enumerable: !(M = s(b, W)) || M.enumerable });
    return O;
  }, o = (O, b, N) => (N = O != null ? e(n(O)) : {}, l(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !O || !O.__esModule ? t(N, "default", { value: O, enumerable: !0 }) : N,
    O
  )), D = (O) => l(t({}, "__esModule", { value: !0 }), O), E = {};
  a(E, {
    callPlayer: () => j,
    getConfig: () => S,
    getSDK: () => T,
    isBlobUrl: () => q,
    isMediaStream: () => R,
    lazy: () => f,
    omit: () => I,
    parseEndTime: () => B,
    parseStartTime: () => A,
    queryString: () => k,
    randomString: () => w,
    supportsWebKitPresentationMode: () => ie
  }), Ws = D(E);
  var p = o(ee), m = o(_1()), c = o(yo());
  const f = (O) => p.default.lazy(async () => {
    const b = await O();
    return typeof b.default == "function" ? b : b.default;
  }), C = /[?&#](?:start|t)=([0-9hms]+)/, g = /[?&#]end=([0-9hms]+)/, x = /(\d+)(h|m|s)/g, d = /^\d+$/;
  function h(O, b) {
    if (O instanceof Array)
      return;
    const N = O.match(b);
    if (N) {
      const M = N[1];
      if (M.match(x))
        return F(M);
      if (d.test(M))
        return parseInt(M);
    }
  }
  function F(O) {
    let b = 0, N = x.exec(O);
    for (; N !== null; ) {
      const [, M, W] = N;
      W === "h" && (b += parseInt(M, 10) * 60 * 60), W === "m" && (b += parseInt(M, 10) * 60), W === "s" && (b += parseInt(M, 10)), N = x.exec(O);
    }
    return b;
  }
  function A(O) {
    return h(O, C);
  }
  function B(O) {
    return h(O, g);
  }
  function w() {
    return Math.random().toString(36).substr(2, 5);
  }
  function k(O) {
    return Object.keys(O).map((b) => `${b}=${O[b]}`).join("&");
  }
  function U(O) {
    return window[O] ? window[O] : window.exports && window.exports[O] ? window.exports[O] : window.module && window.module.exports && window.module.exports[O] ? window.module.exports[O] : null;
  }
  const L = {}, T = function(b, N, M = null, W = () => !0, z = m.default) {
    const Y = U(N);
    return Y && W(Y) ? Promise.resolve(Y) : new Promise((K, X) => {
      if (L[b]) {
        L[b].push({ resolve: K, reject: X });
        return;
      }
      L[b] = [{ resolve: K, reject: X }];
      const J = (H) => {
        L[b].forEach((G) => G.resolve(H));
      };
      if (M) {
        const H = window[M];
        window[M] = function() {
          H && H(), J(U(N));
        };
      }
      z(b, (H) => {
        H ? (L[b].forEach((G) => G.reject(H)), L[b] = null) : M || J(U(N));
      });
    });
  };
  function S(O, b) {
    return (0, c.default)(b.config, O.config);
  }
  function I(O, ...b) {
    const N = [].concat(...b), M = {}, W = Object.keys(O);
    for (const z of W)
      N.indexOf(z) === -1 && (M[z] = O[z]);
    return M;
  }
  function j(O, ...b) {
    if (!this.player || !this.player[O]) {
      let N = `ReactPlayer: ${this.constructor.displayName} player could not call %c${O}%c – `;
      return this.player ? this.player[O] || (N += "The method was not available") : N += "The player was not available", console.warn(N, "font-weight: bold", ""), null;
    }
    return this.player[O](...b);
  }
  function R(O) {
    return typeof window < "u" && typeof window.MediaStream < "u" && O instanceof window.MediaStream;
  }
  function q(O) {
    return /^blob:/.test(O);
  }
  function ie(O = document.createElement("video")) {
    const b = /iPhone|iPod/.test(navigator.userAgent) === !1;
    return O.webkitSupportsPresentationMode && typeof O.webkitSetPresentationMode == "function" && b;
  }
  function ne(O) {
    return O;
  }
  return Ws;
}
var Gs, li;
function k1() {
  if (li) return Gs;
  li = 1;
  var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, n = (j, R) => {
    for (var q in R)
      e(j, q, { get: R[q], enumerable: !0 });
  }, i = (j, R, q, ie) => {
    if (R && typeof R == "object" || typeof R == "function")
      for (let ne of s(R))
        !r.call(j, ne) && ne !== q && e(j, ne, { get: () => R[ne], enumerable: !(ie = t(R, ne)) || ie.enumerable });
    return j;
  }, a = (j) => i(e({}, "__esModule", { value: !0 }), j), l = {};
  n(l, {
    AUDIO_EXTENSIONS: () => w,
    DASH_EXTENSIONS: () => L,
    FLV_EXTENSIONS: () => T,
    HLS_EXTENSIONS: () => U,
    MATCH_URL_DAILYMOTION: () => h,
    MATCH_URL_FACEBOOK: () => c,
    MATCH_URL_FACEBOOK_WATCH: () => f,
    MATCH_URL_KALTURA: () => B,
    MATCH_URL_MIXCLOUD: () => F,
    MATCH_URL_MUX: () => m,
    MATCH_URL_SOUNDCLOUD: () => E,
    MATCH_URL_STREAMABLE: () => C,
    MATCH_URL_TWITCH_CHANNEL: () => d,
    MATCH_URL_TWITCH_VIDEO: () => x,
    MATCH_URL_VIDYARD: () => A,
    MATCH_URL_VIMEO: () => p,
    MATCH_URL_WISTIA: () => g,
    MATCH_URL_YOUTUBE: () => D,
    VIDEO_EXTENSIONS: () => k,
    canPlay: () => I
  }), Gs = a(l);
  var o = /* @__PURE__ */ ms();
  const D = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, E = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, p = /vimeo\.com\/(?!progressive_redirect).+/, m = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, c = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, f = /^https?:\/\/fb\.watch\/.+$/, C = /streamable\.com\/([a-z0-9]+)$/, g = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, x = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, d = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, h = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, F = /mixcloud\.com\/([^/]+\/[^/]+)/, A = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, B = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, w = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, k = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, U = /\.(m3u8)($|\?)/i, L = /\.(mpd)($|\?)/i, T = /\.(flv)($|\?)/i, S = (j) => {
    if (j instanceof Array) {
      for (const R of j)
        if (typeof R == "string" && S(R) || S(R.src))
          return !0;
      return !1;
    }
    return (0, o.isMediaStream)(j) || (0, o.isBlobUrl)(j) ? !0 : w.test(j) || k.test(j) || U.test(j) || L.test(j) || T.test(j);
  }, I = {
    youtube: (j) => j instanceof Array ? j.every((R) => D.test(R)) : D.test(j),
    soundcloud: (j) => E.test(j) && !w.test(j),
    vimeo: (j) => p.test(j) && !k.test(j) && !U.test(j),
    mux: (j) => m.test(j),
    facebook: (j) => c.test(j) || f.test(j),
    streamable: (j) => C.test(j),
    wistia: (j) => g.test(j),
    twitch: (j) => x.test(j) || d.test(j),
    dailymotion: (j) => h.test(j),
    mixcloud: (j) => F.test(j),
    vidyard: (j) => A.test(j),
    kaltura: (j) => B.test(j),
    file: S
  };
  return Gs;
}
var qs, ci;
function N1() {
  if (ci) return qs;
  ci = 1;
  var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, n = (p, m) => {
    for (var c in m)
      e(p, c, { get: m[c], enumerable: !0 });
  }, i = (p, m, c, f) => {
    if (m && typeof m == "object" || typeof m == "function")
      for (let C of s(m))
        !r.call(p, C) && C !== c && e(p, C, { get: () => m[C], enumerable: !(f = t(m, C)) || f.enumerable });
    return p;
  }, a = (p) => i(e({}, "__esModule", { value: !0 }), p), l = {};
  n(l, {
    default: () => E
  }), qs = a(l);
  var o = /* @__PURE__ */ ms(), D = /* @__PURE__ */ k1(), E = [
    {
      key: "youtube",
      name: "YouTube",
      canPlay: D.canPlay.youtube,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerYouTube' */
        "./YouTube-BxYM5UCh.js"
      ).then((p) => p.Y))
    },
    {
      key: "soundcloud",
      name: "SoundCloud",
      canPlay: D.canPlay.soundcloud,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerSoundCloud' */
        "./SoundCloud-Cd4UABLK.js"
      ).then((p) => p.S))
    },
    {
      key: "vimeo",
      name: "Vimeo",
      canPlay: D.canPlay.vimeo,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVimeo' */
        "./Vimeo-z0x9tuF6.js"
      ).then((p) => p.V))
    },
    {
      key: "mux",
      name: "Mux",
      canPlay: D.canPlay.mux,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMux' */
        "./Mux-CB5cS_Y7.js"
      ).then((p) => p.M))
    },
    {
      key: "facebook",
      name: "Facebook",
      canPlay: D.canPlay.facebook,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFacebook' */
        "./Facebook-BvL5BUob.js"
      ).then((p) => p.F))
    },
    {
      key: "streamable",
      name: "Streamable",
      canPlay: D.canPlay.streamable,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerStreamable' */
        "./Streamable-BiNEZean.js"
      ).then((p) => p.S))
    },
    {
      key: "wistia",
      name: "Wistia",
      canPlay: D.canPlay.wistia,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerWistia' */
        "./Wistia-KESB5ol3.js"
      ).then((p) => p.W))
    },
    {
      key: "twitch",
      name: "Twitch",
      canPlay: D.canPlay.twitch,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerTwitch' */
        "./Twitch-DcaSxPbR.js"
      ).then((p) => p.T))
    },
    {
      key: "dailymotion",
      name: "DailyMotion",
      canPlay: D.canPlay.dailymotion,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerDailyMotion' */
        "./DailyMotion-Cy3kRrFL.js"
      ).then((p) => p.D))
    },
    {
      key: "mixcloud",
      name: "Mixcloud",
      canPlay: D.canPlay.mixcloud,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMixcloud' */
        "./Mixcloud-fR_sUcqy.js"
      ).then((p) => p.M))
    },
    {
      key: "vidyard",
      name: "Vidyard",
      canPlay: D.canPlay.vidyard,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVidyard' */
        "./Vidyard-CEYxm8fu.js"
      ).then((p) => p.V))
    },
    {
      key: "kaltura",
      name: "Kaltura",
      canPlay: D.canPlay.kaltura,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerKaltura' */
        "./Kaltura-_F2FNsP_.js"
      ).then((p) => p.K))
    },
    {
      key: "file",
      name: "FilePlayer",
      canPlay: D.canPlay.file,
      canEnablePIP: (p) => D.canPlay.file(p) && (document.pictureInPictureEnabled || (0, o.supportsWebKitPresentationMode)()) && !D.AUDIO_EXTENSIONS.test(p),
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFilePlayer' */
        "./FilePlayer-jMUjqsPV.js"
      ).then((p) => p.F))
    }
  ];
  return qs;
}
var Di = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function T1(e, t) {
  return !!(e === t || Di(e) && Di(t));
}
function S1(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var s = 0; s < e.length; s++)
    if (!T1(e[s], t[s]))
      return !1;
  return !0;
}
function P1(e, t) {
  t === void 0 && (t = S1);
  var s, r = [], n, i = !1;
  function a() {
    for (var l = [], o = 0; o < arguments.length; o++)
      l[o] = arguments[o];
    return i && s === this && t(l, r) || (n = e.apply(this, l), i = !0, s = this, r = l), n;
  }
  return a;
}
const I1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P1
}, Symbol.toStringTag, { value: "Module" })), O1 = /* @__PURE__ */ hl(I1);
var Zs, pi;
function Bo() {
  if (pi) return Zs;
  pi = 1;
  var e = typeof Element < "u", t = typeof Map == "function", s = typeof Set == "function", r = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function n(i, a) {
    if (i === a) return !0;
    if (i && a && typeof i == "object" && typeof a == "object") {
      if (i.constructor !== a.constructor) return !1;
      var l, o, D;
      if (Array.isArray(i)) {
        if (l = i.length, l != a.length) return !1;
        for (o = l; o-- !== 0; )
          if (!n(i[o], a[o])) return !1;
        return !0;
      }
      var E;
      if (t && i instanceof Map && a instanceof Map) {
        if (i.size !== a.size) return !1;
        for (E = i.entries(); !(o = E.next()).done; )
          if (!a.has(o.value[0])) return !1;
        for (E = i.entries(); !(o = E.next()).done; )
          if (!n(o.value[1], a.get(o.value[0]))) return !1;
        return !0;
      }
      if (s && i instanceof Set && a instanceof Set) {
        if (i.size !== a.size) return !1;
        for (E = i.entries(); !(o = E.next()).done; )
          if (!a.has(o.value[0])) return !1;
        return !0;
      }
      if (r && ArrayBuffer.isView(i) && ArrayBuffer.isView(a)) {
        if (l = i.length, l != a.length) return !1;
        for (o = l; o-- !== 0; )
          if (i[o] !== a[o]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === a.source && i.flags === a.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof a.valueOf == "function") return i.valueOf() === a.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof a.toString == "function") return i.toString() === a.toString();
      if (D = Object.keys(i), l = D.length, l !== Object.keys(a).length) return !1;
      for (o = l; o-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, D[o])) return !1;
      if (e && i instanceof Element) return !1;
      for (o = l; o-- !== 0; )
        if (!((D[o] === "_owner" || D[o] === "__v" || D[o] === "__o") && i.$$typeof) && !n(i[D[o]], a[D[o]]))
          return !1;
      return !0;
    }
    return i !== i && a !== a;
  }
  return Zs = function(a, l) {
    try {
      return n(a, l);
    } catch (o) {
      if ((o.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw o;
    }
  }, Zs;
}
var It = { exports: {} }, Ot = { exports: {} }, De = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var di;
function L1() {
  if (di) return De;
  di = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, D = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, c = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, d = e ? Symbol.for("react.scope") : 60119;
  function h(A) {
    if (typeof A == "object" && A !== null) {
      var B = A.$$typeof;
      switch (B) {
        case t:
          switch (A = A.type, A) {
            case o:
            case D:
            case r:
            case i:
            case n:
            case p:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case l:
                case E:
                case f:
                case c:
                case a:
                  return A;
                default:
                  return B;
              }
          }
        case s:
          return B;
      }
    }
  }
  function F(A) {
    return h(A) === D;
  }
  return De.AsyncMode = o, De.ConcurrentMode = D, De.ContextConsumer = l, De.ContextProvider = a, De.Element = t, De.ForwardRef = E, De.Fragment = r, De.Lazy = f, De.Memo = c, De.Portal = s, De.Profiler = i, De.StrictMode = n, De.Suspense = p, De.isAsyncMode = function(A) {
    return F(A) || h(A) === o;
  }, De.isConcurrentMode = F, De.isContextConsumer = function(A) {
    return h(A) === l;
  }, De.isContextProvider = function(A) {
    return h(A) === a;
  }, De.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }, De.isForwardRef = function(A) {
    return h(A) === E;
  }, De.isFragment = function(A) {
    return h(A) === r;
  }, De.isLazy = function(A) {
    return h(A) === f;
  }, De.isMemo = function(A) {
    return h(A) === c;
  }, De.isPortal = function(A) {
    return h(A) === s;
  }, De.isProfiler = function(A) {
    return h(A) === i;
  }, De.isStrictMode = function(A) {
    return h(A) === n;
  }, De.isSuspense = function(A) {
    return h(A) === p;
  }, De.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === D || A === i || A === n || A === p || A === m || typeof A == "object" && A !== null && (A.$$typeof === f || A.$$typeof === c || A.$$typeof === a || A.$$typeof === l || A.$$typeof === E || A.$$typeof === g || A.$$typeof === x || A.$$typeof === d || A.$$typeof === C);
  }, De.typeOf = h, De;
}
var pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fi;
function R1() {
  return fi || (fi = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, D = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, c = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, d = e ? Symbol.for("react.scope") : 60119;
    function h($) {
      return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === r || $ === D || $ === i || $ === n || $ === p || $ === m || typeof $ == "object" && $ !== null && ($.$$typeof === f || $.$$typeof === c || $.$$typeof === a || $.$$typeof === l || $.$$typeof === E || $.$$typeof === g || $.$$typeof === x || $.$$typeof === d || $.$$typeof === C);
    }
    function F($) {
      if (typeof $ == "object" && $ !== null) {
        var he = $.$$typeof;
        switch (he) {
          case t:
            var we = $.type;
            switch (we) {
              case o:
              case D:
              case r:
              case i:
              case n:
              case p:
                return we;
              default:
                var fe = we && we.$$typeof;
                switch (fe) {
                  case l:
                  case E:
                  case f:
                  case c:
                  case a:
                    return fe;
                  default:
                    return he;
                }
            }
          case s:
            return he;
        }
      }
    }
    var A = o, B = D, w = l, k = a, U = t, L = E, T = r, S = f, I = c, j = s, R = i, q = n, ie = p, ne = !1;
    function O($) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), b($) || F($) === o;
    }
    function b($) {
      return F($) === D;
    }
    function N($) {
      return F($) === l;
    }
    function M($) {
      return F($) === a;
    }
    function W($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function z($) {
      return F($) === E;
    }
    function Y($) {
      return F($) === r;
    }
    function K($) {
      return F($) === f;
    }
    function X($) {
      return F($) === c;
    }
    function J($) {
      return F($) === s;
    }
    function H($) {
      return F($) === i;
    }
    function G($) {
      return F($) === n;
    }
    function te($) {
      return F($) === p;
    }
    pe.AsyncMode = A, pe.ConcurrentMode = B, pe.ContextConsumer = w, pe.ContextProvider = k, pe.Element = U, pe.ForwardRef = L, pe.Fragment = T, pe.Lazy = S, pe.Memo = I, pe.Portal = j, pe.Profiler = R, pe.StrictMode = q, pe.Suspense = ie, pe.isAsyncMode = O, pe.isConcurrentMode = b, pe.isContextConsumer = N, pe.isContextProvider = M, pe.isElement = W, pe.isForwardRef = z, pe.isFragment = Y, pe.isLazy = K, pe.isMemo = X, pe.isPortal = J, pe.isProfiler = H, pe.isStrictMode = G, pe.isSuspense = te, pe.isValidElementType = h, pe.typeOf = F;
  })()), pe;
}
var hi;
function bo() {
  return hi || (hi = 1, process.env.NODE_ENV === "production" ? Ot.exports = L1() : Ot.exports = R1()), Ot.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ks, Fi;
function $1() {
  if (Fi) return Ks;
  Fi = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var o = Object.getOwnPropertyNames(a).map(function(E) {
        return a[E];
      });
      if (o.join("") !== "0123456789")
        return !1;
      var D = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(E) {
        D[E] = E;
      }), Object.keys(Object.assign({}, D)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ks = n() ? Object.assign : function(i, a) {
    for (var l, o = r(i), D, E = 1; E < arguments.length; E++) {
      l = Object(arguments[E]);
      for (var p in l)
        t.call(l, p) && (o[p] = l[p]);
      if (e) {
        D = e(l);
        for (var m = 0; m < D.length; m++)
          s.call(l, D[m]) && (o[D[m]] = l[D[m]]);
      }
    }
    return o;
  }, Ks;
}
var Ys, mi;
function tn() {
  if (mi) return Ys;
  mi = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ys = e, Ys;
}
var Xs, Ci;
function wo() {
  return Ci || (Ci = 1, Xs = Function.call.bind(Object.prototype.hasOwnProperty)), Xs;
}
var Js, Ei;
function M1() {
  if (Ei) return Js;
  Ei = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ tn(), s = {}, r = /* @__PURE__ */ wo();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function n(i, a, l, o, D) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in i)
        if (r(i, E)) {
          var p;
          try {
            if (typeof i[E] != "function") {
              var m = Error(
                (o || "React class") + ": " + l + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            p = i[E](a, E, o, l, null, t);
          } catch (f) {
            p = f;
          }
          if (p && !(p instanceof Error) && e(
            (o || "React class") + ": type specification of " + l + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in s)) {
            s[p.message] = !0;
            var c = D ? D() : "";
            e(
              "Failed " + l + " type: " + p.message + (c ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (s = {});
  }, Js = n, Js;
}
var Qs, xi;
function U1() {
  if (xi) return Qs;
  xi = 1;
  var e = bo(), t = $1(), s = /* @__PURE__ */ tn(), r = /* @__PURE__ */ wo(), n = /* @__PURE__ */ M1(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var o = "Warning: " + l;
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Qs = function(l, o) {
    var D = typeof Symbol == "function" && Symbol.iterator, E = "@@iterator";
    function p(b) {
      var N = b && (D && b[D] || b[E]);
      if (typeof N == "function")
        return N;
    }
    var m = "<<anonymous>>", c = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: d(),
      arrayOf: h,
      element: F(),
      elementType: A(),
      instanceOf: B,
      node: L(),
      objectOf: k,
      oneOf: w,
      oneOfType: U,
      shape: S,
      exact: I
    };
    function f(b, N) {
      return b === N ? b !== 0 || 1 / b === 1 / N : b !== b && N !== N;
    }
    function C(b, N) {
      this.message = b, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function g(b) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, M = 0;
      function W(Y, K, X, J, H, G, te) {
        if (J = J || m, G = G || X, te !== s) {
          if (o) {
            var $ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw $.name = "Invariant Violation", $;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = J + ":" + X;
            !N[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            M < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[he] = !0, M++);
          }
        }
        return K[X] == null ? Y ? K[X] === null ? new C("The " + H + " `" + G + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new C("The " + H + " `" + G + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : b(K, X, J, H, G);
      }
      var z = W.bind(null, !1);
      return z.isRequired = W.bind(null, !0), z;
    }
    function x(b) {
      function N(M, W, z, Y, K, X) {
        var J = M[W], H = q(J);
        if (H !== b) {
          var G = ie(J);
          return new C(
            "Invalid " + Y + " `" + K + "` of type " + ("`" + G + "` supplied to `" + z + "`, expected ") + ("`" + b + "`."),
            { expectedType: b }
          );
        }
        return null;
      }
      return g(N);
    }
    function d() {
      return g(a);
    }
    function h(b) {
      function N(M, W, z, Y, K) {
        if (typeof b != "function")
          return new C("Property `" + K + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
        var X = M[W];
        if (!Array.isArray(X)) {
          var J = q(X);
          return new C("Invalid " + Y + " `" + K + "` of type " + ("`" + J + "` supplied to `" + z + "`, expected an array."));
        }
        for (var H = 0; H < X.length; H++) {
          var G = b(X, H, z, Y, K + "[" + H + "]", s);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return g(N);
    }
    function F() {
      function b(N, M, W, z, Y) {
        var K = N[M];
        if (!l(K)) {
          var X = q(K);
          return new C("Invalid " + z + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(b);
    }
    function A() {
      function b(N, M, W, z, Y) {
        var K = N[M];
        if (!e.isValidElementType(K)) {
          var X = q(K);
          return new C("Invalid " + z + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(b);
    }
    function B(b) {
      function N(M, W, z, Y, K) {
        if (!(M[W] instanceof b)) {
          var X = b.name || m, J = O(M[W]);
          return new C("Invalid " + Y + " `" + K + "` of type " + ("`" + J + "` supplied to `" + z + "`, expected ") + ("instance of `" + X + "`."));
        }
        return null;
      }
      return g(N);
    }
    function w(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function N(M, W, z, Y, K) {
        for (var X = M[W], J = 0; J < b.length; J++)
          if (f(X, b[J]))
            return null;
        var H = JSON.stringify(b, function(te, $) {
          var he = ie($);
          return he === "symbol" ? String($) : $;
        });
        return new C("Invalid " + Y + " `" + K + "` of value `" + String(X) + "` " + ("supplied to `" + z + "`, expected one of " + H + "."));
      }
      return g(N);
    }
    function k(b) {
      function N(M, W, z, Y, K) {
        if (typeof b != "function")
          return new C("Property `" + K + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
        var X = M[W], J = q(X);
        if (J !== "object")
          return new C("Invalid " + Y + " `" + K + "` of type " + ("`" + J + "` supplied to `" + z + "`, expected an object."));
        for (var H in X)
          if (r(X, H)) {
            var G = b(X, H, z, Y, K + "." + H, s);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return g(N);
    }
    function U(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var N = 0; N < b.length; N++) {
        var M = b[N];
        if (typeof M != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(M) + " at index " + N + "."
          ), a;
      }
      function W(z, Y, K, X, J) {
        for (var H = [], G = 0; G < b.length; G++) {
          var te = b[G], $ = te(z, Y, K, X, J, s);
          if ($ == null)
            return null;
          $.data && r($.data, "expectedType") && H.push($.data.expectedType);
        }
        var he = H.length > 0 ? ", expected one of type [" + H.join(", ") + "]" : "";
        return new C("Invalid " + X + " `" + J + "` supplied to " + ("`" + K + "`" + he + "."));
      }
      return g(W);
    }
    function L() {
      function b(N, M, W, z, Y) {
        return j(N[M]) ? null : new C("Invalid " + z + " `" + Y + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return g(b);
    }
    function T(b, N, M, W, z) {
      return new C(
        (b || "React class") + ": " + N + " type `" + M + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
      );
    }
    function S(b) {
      function N(M, W, z, Y, K) {
        var X = M[W], J = q(X);
        if (J !== "object")
          return new C("Invalid " + Y + " `" + K + "` of type `" + J + "` " + ("supplied to `" + z + "`, expected `object`."));
        for (var H in b) {
          var G = b[H];
          if (typeof G != "function")
            return T(z, Y, K, H, ie(G));
          var te = G(X, H, z, Y, K + "." + H, s);
          if (te)
            return te;
        }
        return null;
      }
      return g(N);
    }
    function I(b) {
      function N(M, W, z, Y, K) {
        var X = M[W], J = q(X);
        if (J !== "object")
          return new C("Invalid " + Y + " `" + K + "` of type `" + J + "` " + ("supplied to `" + z + "`, expected `object`."));
        var H = t({}, M[W], b);
        for (var G in H) {
          var te = b[G];
          if (r(b, G) && typeof te != "function")
            return T(z, Y, K, G, ie(te));
          if (!te)
            return new C(
              "Invalid " + Y + " `" + K + "` key `" + G + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(M[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(b), null, "  ")
            );
          var $ = te(X, G, z, Y, K + "." + G, s);
          if ($)
            return $;
        }
        return null;
      }
      return g(N);
    }
    function j(b) {
      switch (typeof b) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !b;
        case "object":
          if (Array.isArray(b))
            return b.every(j);
          if (b === null || l(b))
            return !0;
          var N = p(b);
          if (N) {
            var M = N.call(b), W;
            if (N !== b.entries) {
              for (; !(W = M.next()).done; )
                if (!j(W.value))
                  return !1;
            } else
              for (; !(W = M.next()).done; ) {
                var z = W.value;
                if (z && !j(z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function R(b, N) {
      return b === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function q(b) {
      var N = typeof b;
      return Array.isArray(b) ? "array" : b instanceof RegExp ? "object" : R(N, b) ? "symbol" : N;
    }
    function ie(b) {
      if (typeof b > "u" || b === null)
        return "" + b;
      var N = q(b);
      if (N === "object") {
        if (b instanceof Date)
          return "date";
        if (b instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function ne(b) {
      var N = ie(b);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function O(b) {
      return !b.constructor || !b.constructor.name ? m : b.constructor.name;
    }
    return c.checkPropTypes = n, c.resetWarningCache = n.resetWarningCache, c.PropTypes = c, c;
  }, Qs;
}
var er, Ai;
function H1() {
  if (Ai) return er;
  Ai = 1;
  var e = /* @__PURE__ */ tn();
  function t() {
  }
  function s() {
  }
  return s.resetWarningCache = t, er = function() {
    function r(a, l, o, D, E, p) {
      if (p !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: s,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, er;
}
var gi;
function z1() {
  if (gi) return It.exports;
  if (gi = 1, process.env.NODE_ENV !== "production") {
    var e = bo(), t = !0;
    It.exports = /* @__PURE__ */ U1()(e.isElement, t);
  } else
    It.exports = /* @__PURE__ */ H1()();
  return It.exports;
}
var ur, vi;
function jo() {
  if (vi) return ur;
  vi = 1;
  var e = Object.create, t = Object.defineProperty, s = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, n = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (k, U) => {
    for (var L in U)
      t(k, L, { get: U[L], enumerable: !0 });
  }, l = (k, U, L, T) => {
    if (U && typeof U == "object" || typeof U == "function")
      for (let S of r(U))
        !i.call(k, S) && S !== L && t(k, S, { get: () => U[S], enumerable: !(T = s(U, S)) || T.enumerable });
    return k;
  }, o = (k, U, L) => (L = k != null ? e(n(k)) : {}, l(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !k || !k.__esModule ? t(L, "default", { value: k, enumerable: !0 }) : L,
    k
  )), D = (k) => l(t({}, "__esModule", { value: !0 }), k), E = {};
  a(E, {
    defaultProps: () => w,
    propTypes: () => A
  }), ur = D(E);
  var p = o(/* @__PURE__ */ z1());
  const { string: m, bool: c, number: f, array: C, oneOfType: g, shape: x, object: d, func: h, node: F } = p.default, A = {
    url: g([m, C, d]),
    playing: c,
    loop: c,
    controls: c,
    volume: f,
    muted: c,
    playbackRate: f,
    width: g([m, f]),
    height: g([m, f]),
    style: d,
    progressInterval: f,
    playsinline: c,
    pip: c,
    stopOnUnmount: c,
    light: g([c, m, d]),
    playIcon: F,
    previewTabIndex: f,
    previewAriaLabel: m,
    fallback: F,
    oEmbedUrl: m,
    wrapper: g([
      m,
      h,
      x({ render: h.isRequired })
    ]),
    config: x({
      soundcloud: x({
        options: d
      }),
      youtube: x({
        playerVars: d,
        embedOptions: d,
        onUnstarted: h
      }),
      facebook: x({
        appId: m,
        version: m,
        playerId: m,
        attributes: d
      }),
      dailymotion: x({
        params: d
      }),
      vimeo: x({
        playerOptions: d,
        title: m
      }),
      mux: x({
        attributes: d,
        version: m
      }),
      file: x({
        attributes: d,
        tracks: C,
        forceVideo: c,
        forceAudio: c,
        forceHLS: c,
        forceSafariHLS: c,
        forceDisableHls: c,
        forceDASH: c,
        forceFLV: c,
        hlsOptions: d,
        hlsVersion: m,
        dashVersion: m,
        flvVersion: m
      }),
      wistia: x({
        options: d,
        playerId: m,
        customControls: C
      }),
      mixcloud: x({
        options: d
      }),
      twitch: x({
        options: d,
        playerId: m
      }),
      vidyard: x({
        options: d
      })
    }),
    onReady: h,
    onStart: h,
    onPlay: h,
    onPause: h,
    onBuffer: h,
    onBufferEnd: h,
    onEnded: h,
    onError: h,
    onDuration: h,
    onSeek: h,
    onPlaybackRateChange: h,
    onPlaybackQualityChange: h,
    onProgress: h,
    onClickPreview: h,
    onEnablePIP: h,
    onDisablePIP: h
  }, B = () => {
  }, w = {
    playing: !1,
    loop: !1,
    controls: !1,
    volume: null,
    muted: !1,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: !1,
    pip: !1,
    stopOnUnmount: !0,
    light: !1,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
      soundcloud: {
        options: {
          visual: !0,
          // Undocumented, but makes player fill container and look better
          buying: !1,
          liking: !1,
          download: !1,
          sharing: !1,
          show_comments: !1,
          show_playcount: !1
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: B
      },
      facebook: {
        appId: "1309697205772819",
        version: "v3.3",
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          "endscreen-enable": !1
        }
      },
      vimeo: {
        playerOptions: {
          autopause: !1,
          byline: !1,
          portrait: !1,
          title: !1
        },
        title: null
      },
      mux: {
        attributes: {},
        version: "2"
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: !1,
        forceAudio: !1,
        forceHLS: !1,
        forceDASH: !1,
        forceFLV: !1,
        hlsOptions: {},
        hlsVersion: "1.1.4",
        dashVersion: "3.1.3",
        flvVersion: "1.5.0",
        forceDisableHls: !1
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: B,
    onStart: B,
    onPlay: B,
    onPause: B,
    onBuffer: B,
    onBufferEnd: B,
    onEnded: B,
    onError: B,
    onDuration: B,
    onSeek: B,
    onPlaybackRateChange: B,
    onPlaybackQualityChange: B,
    onProgress: B,
    onClickPreview: B,
    onEnablePIP: B,
    onDisablePIP: B
  };
  return ur;
}
var tr, yi;
function V1() {
  if (yi) return tr;
  yi = 1;
  var e = Object.create, t = Object.defineProperty, s = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, n = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (h, F, A) => F in h ? t(h, F, { enumerable: !0, configurable: !0, writable: !0, value: A }) : h[F] = A, l = (h, F) => {
    for (var A in F)
      t(h, A, { get: F[A], enumerable: !0 });
  }, o = (h, F, A, B) => {
    if (F && typeof F == "object" || typeof F == "function")
      for (let w of r(F))
        !i.call(h, w) && w !== A && t(h, w, { get: () => F[w], enumerable: !(B = s(F, w)) || B.enumerable });
    return h;
  }, D = (h, F, A) => (A = h != null ? e(n(h)) : {}, o(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !h || !h.__esModule ? t(A, "default", { value: h, enumerable: !0 }) : A,
    h
  )), E = (h) => o(t({}, "__esModule", { value: !0 }), h), p = (h, F, A) => (a(h, typeof F != "symbol" ? F + "" : F, A), A), m = {};
  l(m, {
    default: () => d
  }), tr = E(m);
  var c = D(ee), f = D(Bo()), C = /* @__PURE__ */ jo(), g = /* @__PURE__ */ ms();
  const x = 5e3;
  class d extends c.Component {
    constructor() {
      super(...arguments), p(this, "mounted", !1), p(this, "isReady", !1), p(this, "isPlaying", !1), p(this, "isLoading", !0), p(this, "loadOnReady", null), p(this, "startOnPlay", !0), p(this, "seekOnPlay", null), p(this, "onDurationCalled", !1), p(this, "handlePlayerMount", (F) => {
        if (this.player) {
          this.progress();
          return;
        }
        this.player = F, this.player.load(this.props.url), this.progress();
      }), p(this, "getInternalPlayer", (F) => this.player ? this.player[F] : null), p(this, "progress", () => {
        if (this.props.url && this.player && this.isReady) {
          const F = this.getCurrentTime() || 0, A = this.getSecondsLoaded(), B = this.getDuration();
          if (B) {
            const w = {
              playedSeconds: F,
              played: F / B
            };
            A !== null && (w.loadedSeconds = A, w.loaded = A / B), (w.playedSeconds !== this.prevPlayed || w.loadedSeconds !== this.prevLoaded) && this.props.onProgress(w), this.prevPlayed = w.playedSeconds, this.prevLoaded = w.loadedSeconds;
          }
        }
        this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
      }), p(this, "handleReady", () => {
        if (!this.mounted)
          return;
        this.isReady = !0, this.isLoading = !1;
        const { onReady: F, playing: A, volume: B, muted: w } = this.props;
        F(), !w && B !== null && this.player.setVolume(B), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : A && this.player.play(), this.handleDurationCheck();
      }), p(this, "handlePlay", () => {
        this.isPlaying = !0, this.isLoading = !1;
        const { onStart: F, onPlay: A, playbackRate: B } = this.props;
        this.startOnPlay && (this.player.setPlaybackRate && B !== 1 && this.player.setPlaybackRate(B), F(), this.startOnPlay = !1), A(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
      }), p(this, "handlePause", (F) => {
        this.isPlaying = !1, this.isLoading || this.props.onPause(F);
      }), p(this, "handleEnded", () => {
        const { activePlayer: F, loop: A, onEnded: B } = this.props;
        F.loopOnEnded && A && this.seekTo(0), A || (this.isPlaying = !1, B());
      }), p(this, "handleError", (...F) => {
        this.isLoading = !1, this.props.onError(...F);
      }), p(this, "handleDurationCheck", () => {
        clearTimeout(this.durationCheckTimeout);
        const F = this.getDuration();
        F ? this.onDurationCalled || (this.props.onDuration(F), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }), p(this, "handleLoaded", () => {
        this.isLoading = !1;
      });
    }
    componentDidMount() {
      this.mounted = !0;
    }
    componentWillUnmount() {
      clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
    }
    componentDidUpdate(F) {
      if (!this.player)
        return;
      const { url: A, playing: B, volume: w, muted: k, playbackRate: U, pip: L, loop: T, activePlayer: S, disableDeferredLoading: I } = this.props;
      if (!(0, f.default)(F.url, A)) {
        if (this.isLoading && !S.forceLoad && !I && !(0, g.isMediaStream)(A)) {
          console.warn(`ReactPlayer: the attempt to load ${A} is being deferred until the player has loaded`), this.loadOnReady = A;
          return;
        }
        this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(A, this.isReady);
      }
      !F.playing && B && !this.isPlaying && this.player.play(), F.playing && !B && this.isPlaying && this.player.pause(), !F.pip && L && this.player.enablePIP && this.player.enablePIP(), F.pip && !L && this.player.disablePIP && this.player.disablePIP(), F.volume !== w && w !== null && this.player.setVolume(w), F.muted !== k && (k ? this.player.mute() : (this.player.unmute(), w !== null && setTimeout(() => this.player.setVolume(w)))), F.playbackRate !== U && this.player.setPlaybackRate && this.player.setPlaybackRate(U), F.loop !== T && this.player.setLoop && this.player.setLoop(T);
    }
    getDuration() {
      return this.isReady ? this.player.getDuration() : null;
    }
    getCurrentTime() {
      return this.isReady ? this.player.getCurrentTime() : null;
    }
    getSecondsLoaded() {
      return this.isReady ? this.player.getSecondsLoaded() : null;
    }
    seekTo(F, A, B) {
      if (!this.isReady) {
        F !== 0 && (this.seekOnPlay = F, setTimeout(() => {
          this.seekOnPlay = null;
        }, x));
        return;
      }
      if (A ? A === "fraction" : F > 0 && F < 1) {
        const k = this.player.getDuration();
        if (!k) {
          console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
          return;
        }
        this.player.seekTo(k * F, B);
        return;
      }
      this.player.seekTo(F, B);
    }
    render() {
      const F = this.props.activePlayer;
      return F ? /* @__PURE__ */ c.default.createElement(
        F,
        {
          ...this.props,
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        }
      ) : null;
    }
  }
  return p(d, "displayName", "Player"), p(d, "propTypes", C.propTypes), p(d, "defaultProps", C.defaultProps), tr;
}
var sr, Bi;
function W1() {
  if (Bi) return sr;
  Bi = 1;
  var e = Object.create, t = Object.defineProperty, s = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, n = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (T, S, I) => S in T ? t(T, S, { enumerable: !0, configurable: !0, writable: !0, value: I }) : T[S] = I, l = (T, S) => {
    for (var I in S)
      t(T, I, { get: S[I], enumerable: !0 });
  }, o = (T, S, I, j) => {
    if (S && typeof S == "object" || typeof S == "function")
      for (let R of r(S))
        !i.call(T, R) && R !== I && t(T, R, { get: () => S[R], enumerable: !(j = s(S, R)) || j.enumerable });
    return T;
  }, D = (T, S, I) => (I = T != null ? e(n(T)) : {}, o(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !T || !T.__esModule ? t(I, "default", { value: T, enumerable: !0 }) : I,
    T
  )), E = (T) => o(t({}, "__esModule", { value: !0 }), T), p = (T, S, I) => (a(T, typeof S != "symbol" ? S + "" : S, I), I), m = {};
  l(m, {
    createReactPlayer: () => L
  }), sr = E(m);
  var c = D(ee), f = D(yo()), C = D(O1), g = D(Bo()), x = /* @__PURE__ */ jo(), d = /* @__PURE__ */ ms(), h = D(/* @__PURE__ */ V1());
  const F = (0, d.lazy)(() => import(
    /* webpackChunkName: 'reactPlayerPreview' */
    "./Preview-Os33eut3.js"
  ).then((T) => T.P)), A = typeof window < "u" && window.document && typeof document < "u", B = typeof _s < "u" && _s.window && _s.window.document, w = Object.keys(x.propTypes), k = A || B ? c.Suspense : () => null, U = [], L = (T, S) => {
    var I;
    return I = class extends c.Component {
      constructor() {
        super(...arguments), p(this, "state", {
          showPreview: !!this.props.light
        }), p(this, "references", {
          wrapper: (j) => {
            this.wrapper = j;
          },
          player: (j) => {
            this.player = j;
          }
        }), p(this, "handleClickPreview", (j) => {
          this.setState({ showPreview: !1 }), this.props.onClickPreview(j);
        }), p(this, "showPreview", () => {
          this.setState({ showPreview: !0 });
        }), p(this, "getDuration", () => this.player ? this.player.getDuration() : null), p(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), p(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), p(this, "getInternalPlayer", (j = "player") => this.player ? this.player.getInternalPlayer(j) : null), p(this, "seekTo", (j, R, q) => {
          if (!this.player)
            return null;
          this.player.seekTo(j, R, q);
        }), p(this, "handleReady", () => {
          this.props.onReady(this);
        }), p(this, "getActivePlayer", (0, C.default)((j) => {
          for (const R of [...U, ...T])
            if (R.canPlay(j))
              return R;
          return S || null;
        })), p(this, "getConfig", (0, C.default)((j, R) => {
          const { config: q } = this.props;
          return f.default.all([
            x.defaultProps.config,
            x.defaultProps.config[R] || {},
            q,
            q[R] || {}
          ]);
        })), p(this, "getAttributes", (0, C.default)((j) => (0, d.omit)(this.props, w))), p(this, "renderActivePlayer", (j) => {
          if (!j)
            return null;
          const R = this.getActivePlayer(j);
          if (!R)
            return null;
          const q = this.getConfig(j, R.key);
          return /* @__PURE__ */ c.default.createElement(
            h.default,
            {
              ...this.props,
              key: R.key,
              ref: this.references.player,
              config: q,
              activePlayer: R.lazyPlayer || R,
              onReady: this.handleReady
            }
          );
        });
      }
      shouldComponentUpdate(j, R) {
        return !(0, g.default)(this.props, j) || !(0, g.default)(this.state, R);
      }
      componentDidUpdate(j) {
        const { light: R } = this.props;
        !j.light && R && this.setState({ showPreview: !0 }), j.light && !R && this.setState({ showPreview: !1 });
      }
      renderPreview(j) {
        if (!j)
          return null;
        const { light: R, playIcon: q, previewTabIndex: ie, oEmbedUrl: ne, previewAriaLabel: O } = this.props;
        return /* @__PURE__ */ c.default.createElement(
          F,
          {
            url: j,
            light: R,
            playIcon: q,
            previewTabIndex: ie,
            previewAriaLabel: O,
            oEmbedUrl: ne,
            onClick: this.handleClickPreview
          }
        );
      }
      render() {
        const { url: j, style: R, width: q, height: ie, fallback: ne, wrapper: O } = this.props, { showPreview: b } = this.state, N = this.getAttributes(j), M = typeof O == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ c.default.createElement(O, { ref: M, style: { ...R, width: q, height: ie }, ...N }, /* @__PURE__ */ c.default.createElement(k, { fallback: ne }, b ? this.renderPreview(j) : this.renderActivePlayer(j)));
      }
    }, p(I, "displayName", "ReactPlayer"), p(I, "propTypes", x.propTypes), p(I, "defaultProps", x.defaultProps), p(I, "addCustomPlayer", (j) => {
      U.push(j);
    }), p(I, "removeCustomPlayers", () => {
      U.length = 0;
    }), p(I, "canPlay", (j) => {
      for (const R of [...U, ...T])
        if (R.canPlay(j))
          return !0;
      return !1;
    }), p(I, "canEnablePIP", (j) => {
      for (const R of [...U, ...T])
        if (R.canEnablePIP && R.canEnablePIP(j))
          return !0;
      return !1;
    }), I;
  };
  return sr;
}
var rr, bi;
function G1() {
  if (bi) return rr;
  bi = 1;
  var e = Object.create, t = Object.defineProperty, s = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, n = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (C, g) => {
    for (var x in g)
      t(C, x, { get: g[x], enumerable: !0 });
  }, l = (C, g, x, d) => {
    if (g && typeof g == "object" || typeof g == "function")
      for (let h of r(g))
        !i.call(C, h) && h !== x && t(C, h, { get: () => g[h], enumerable: !(d = s(g, h)) || d.enumerable });
    return C;
  }, o = (C, g, x) => (x = C != null ? e(n(C)) : {}, l(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !C || !C.__esModule ? t(x, "default", { value: C, enumerable: !0 }) : x,
    C
  )), D = (C) => l(t({}, "__esModule", { value: !0 }), C), E = {};
  a(E, {
    default: () => f
  }), rr = D(E);
  var p = o(/* @__PURE__ */ N1()), m = /* @__PURE__ */ W1();
  const c = p.default[p.default.length - 1];
  var f = (0, m.createReactPlayer)(p.default, c);
  return rr;
}
var q1 = /* @__PURE__ */ G1();
const Me = /* @__PURE__ */ Au(q1), _o = _.a`
  display: ${(e) => e.$isFlex ? "flex" : "inline-flex"};
  width: 100%;
  margin: auto;
`, sn = dl({
  post: null
}), wi = (e) => e || void 0, Z1 = ({
  contextVideoCoverPreview: e,
  videoCoverPreviewOverride: t,
  fallbackToContext: s = !0
}) => {
  const r = wi(t), n = wi(e);
  return s ? r ?? n : r;
}, rn = (e = {}) => {
  const [t, s] = re(!1), [r, n] = re(!1), [i, a] = re(0), {
    videoCoverPreview: l,
    post: o
  } = Fa(sn), {
    usePostTypeCheck: D = !0,
    videoCoverPreviewOverride: E,
    fallbackToContext: p = !0
  } = e, m = Z1({
    contextVideoCoverPreview: l,
    videoCoverPreviewOverride: E,
    fallbackToContext: p
  });
  hu(() => {
    m && (s(!1), n(!1), a((x) => x + 1));
  }, [m]);
  const c = D ? m !== void 0 && (o?.type === "reel" || o?.storyType === "reel") : m !== void 0;
  return {
    isPlaying: t,
    hasPlayed: r,
    vid: i,
    videoCoverPreview: m,
    showVideoCover: c,
    resetVideo: () => {
      s(!1), n(!1), a((x) => x + 1);
    },
    handlePlay: () => {
      s(!0), n(!0);
    },
    handlePause: () => {
      s(!1);
    },
    showResetButton: c && !t && r
  };
}, ko = (e) => /* @__PURE__ */ v.createElement("svg", { width: 36, height: 34, viewBox: "0 0 36 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M2.33301 13.6667C2.33301 13.6667 5.67464 9.1137 8.3894 6.39707C11.1042 3.68045 14.8557 2 18.9997 2C27.2839 2 33.9997 8.71573 33.9997 17C33.9997 25.2843 27.2839 32 18.9997 32C12.1612 32 6.39153 27.4238 4.58595 21.1667M2.33301 13.6667V3.66667M2.33301 13.6667H12.333", stroke: "white", strokeWidth: 3.33333, strokeLinecap: "round", strokeLinejoin: "round" })), K1 = _.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, No = _.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100% !important;

  .react-player video {
    object-fit: ${(e) => e.$videoObjectFit || "contain"};
  }

  ${(e) => e.$showVideoCover && Va([".react-player__preview{width:100%;height:100%;background-size:cover !important;background-position:center !important;background-repeat:no-repeat !important;}"])}
`, To = _.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  pointer-events: none;
`, Y1 = _.div`
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 711px;
  width: 100%;
  height: 100%;
  background: grey;
  display: flex;
`, So = ({
  onClick: e
}) => /* @__PURE__ */ u.jsx(K1, { onClick: e, children: /* @__PURE__ */ u.jsx(ko, {}) }), X1 = _.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`, J1 = _.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(e) => e.$visible ? 1 : 0};
  transition: opacity 0.2s ease;
  pointer-events: none;
`, Q1 = () => /* @__PURE__ */ u.jsx("svg", { width: "24", height: "28", viewBox: "0 0 24 28", fill: "none", children: /* @__PURE__ */ u.jsx("path", { d: "M22 14L2 26V2L22 14Z", fill: "white" }) }), ep = () => /* @__PURE__ */ u.jsxs("svg", { width: "20", height: "24", viewBox: "0 0 20 24", fill: "none", children: [
  /* @__PURE__ */ u.jsx("rect", { x: "1", y: "1", width: "6", height: "22", rx: "1", fill: "white" }),
  /* @__PURE__ */ u.jsx("rect", { x: "13", y: "1", width: "6", height: "22", rx: "1", fill: "white" })
] }), Po = ({
  playing: e,
  onToggle: t
}) => /* @__PURE__ */ u.jsx(X1, { onClick: t, children: /* @__PURE__ */ u.jsx(J1, { $visible: !e, children: e ? /* @__PURE__ */ u.jsx(ep, {}) : /* @__PURE__ */ u.jsx(Q1, {}) }) }), up = ({
  src: e,
  imageObjectFit: t,
  fillContainer: s = !1
}) => /* @__PURE__ */ u.jsx(sp, { $isFlex: !0, $fillContainer: s, href: e, children: /* @__PURE__ */ u.jsx(rp, { src: e, $imageObjectFit: t, $fillContainer: s }) }), tp = ({
  url: e,
  thumbnailUrl: t,
  isActiveSlide: s = !0,
  videoRef: r,
  containerStyles: n,
  controls: i = !0,
  videoObjectFit: a
}) => {
  const {
    vid: l,
    videoCoverPreview: o,
    showVideoCover: D,
    resetVideo: E,
    handlePlay: p,
    handlePause: m,
    showResetButton: c
  } = rn({
    usePostTypeCheck: !0,
    videoCoverPreviewOverride: t,
    fallbackToContext: !t
  }), [f, C] = re(!1), g = !i, x = g && D && !f, d = () => {
    C(!1), E();
  };
  if (!s)
    return null;
  const h = {
    playsInline: !0,
    preload: "metadata",
    ...t ? {
      poster: t
    } : {}
  }, F = /* @__PURE__ */ u.jsxs(No, { ref: r, style: n, $showVideoCover: D, $videoObjectFit: a, children: [
    c && /* @__PURE__ */ u.jsx(So, { onClick: d }),
    x && o && /* @__PURE__ */ u.jsx(To, { src: o, alt: "" }),
    g && /* @__PURE__ */ u.jsx(Po, { playing: f, onToggle: () => C((A) => !A) }),
    /* @__PURE__ */ u.jsx(Me, { playing: g ? f : !!o, onPlay: p, onPause: m, light: !g && D ? o : void 0, controls: i, url: e, config: {
      file: {
        attributes: h
      }
    }, className: "sp-relative sp-w-full react-player", width: "100%", height: "100%", style: D ? {
      minHeight: "500px",
      background: "grey",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    } : {
      display: "flex",
      position: "absolute",
      top: 0,
      left: 0
    } }, l)
  ] });
  return D ? /* @__PURE__ */ u.jsx(Y1, { children: F }) : F;
}, Lu = ({
  media: e,
  isActiveSlide: t = !0,
  videoRef: s,
  videoContainerStyles: r,
  controls: n,
  videoObjectFit: i,
  imageObjectFit: a,
  fillContainer: l = !1
}) => e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(tp, { videoRef: s, url: e.url, thumbnailUrl: e.thumbnailUrl, isActiveSlide: t, containerStyles: r, controls: n, videoObjectFit: i }) : /* @__PURE__ */ u.jsx(up, { src: e.url, imageObjectFit: a, fillContainer: l }), sp = _(_o)`
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
  align-items: center;
  justify-content: center;
`, rp = _.img`
  display: block;
  object-fit: ${(e) => e.$imageObjectFit || "cover"};
  position: relative;
  width: 100%;
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
`, np = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z" })), ip = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z" })), Ru = ({
  direction: e,
  onClick: t
}) => /* @__PURE__ */ u.jsx(ap, { direction: e, role: "button", "aria-label": e === "left" ? "Previous slide" : "Next slide", onClick: t, children: e === "left" ? /* @__PURE__ */ u.jsx(np, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" }) : /* @__PURE__ */ u.jsx(ip, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" }) }), ap = _.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(e) => e.direction === "left" ? "left: 10px;" : "right: 10px;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.2);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, op = ({
  media: e,
  slideNo: t,
  isActiveSlide: s
}) => {
  const r = {
    order: t,
    flex: "1 0 100%"
  }, n = e.isVideo || e.url?.includes(".mp4");
  return /* @__PURE__ */ u.jsx("div", { style: r, children: n ? /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-w-full sp-aspect-[2/3] sp-bg-[#f2f2f2] [@supports_not_(aspect-ratio:1/1)]:sp-h-0 [@supports_not_(aspect-ratio:1/1)]:sp-pb-[150%]", children: /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-0", children: /* @__PURE__ */ u.jsx(Lu, { media: e, isActiveSlide: s, videoObjectFit: "cover" }) }) }) : /* @__PURE__ */ u.jsx(Lu, { media: e, isActiveSlide: s, videoObjectFit: "cover" }) });
}, lp = ({
  medias: e,
  currentSlide: t
}) => e.map((s, r) => /* @__PURE__ */ u.jsx(op, { media: s, slideNo: r + 1, isActiveSlide: t === r + 1 }, r)), cp = ({
  current: e
}) => /* @__PURE__ */ u.jsx("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), Dp = ({
  count: e,
  current: t
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4", style: {
  marginBottom: "-42px",
  height: "42px"
}, children: [...Array(e)].map((s, r) => /* @__PURE__ */ u.jsx(cp, { current: r + 1 === t }, r)) }), pp = ({
  medias: e,
  count: t,
  getIsFirstSlide: s
}) => {
  const [r, n] = re(1);
  hu(() => {
    r > e.length && n(e.length);
  }, [e.length]);
  const i = {
    left: "100%",
    transform: `translateX(${r * -100}%)`
  };
  return hu(() => {
    s && s(r === 1);
  }, [r]), /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      r !== 1 && /* @__PURE__ */ u.jsx(Ru, { direction: "left", onClick: () => n(r - 1) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-relative sp-items-center", style: i, children: /* @__PURE__ */ u.jsx(lp, { medias: e, currentSlide: r }) }),
      r !== e.length && /* @__PURE__ */ u.jsx(Ru, { direction: "right", onClick: () => n(r + 1) })
    ] }),
    /* @__PURE__ */ u.jsx(Dp, { count: t, current: r })
  ] });
}, dp = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-p-4 sp-text-gray-800", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-grow sp-items-center", children: [
    /* @__PURE__ */ u.jsx(Lt, { icon: "icon-instagram-heart", className: "sp-mr-6" }),
    /* @__PURE__ */ u.jsx(Lt, { icon: "icon-instagram-comment", className: "sp-mr-6" }),
    /* @__PURE__ */ u.jsx(Lt, { icon: "icon-instagram-share", className: "sp-mr-6" })
  ] }),
  /* @__PURE__ */ u.jsx(Lt, { icon: "icon-instagram-bookmark" })
] }), Lt = ({
  icon: e,
  className: t
}) => /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-items-center sp-justify-center ${t}`, children: /* @__PURE__ */ u.jsx("div", { className: `sp-text-2xl sp-font-normal ${e}` }) }), fp = _.button`
  border: none;
  display: flex;
  align-items: center;
  background: #504e4c;
  border-radius: 4px;
  padding: 9px 7px;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-width: 100px;
  justify-content: center;

  svg {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 500;
    color: white;
    font-size: 12px;
  }
`, hp = _.div`
  position: absolute;
  z-index: 2;
  top: ${(e) => e.top && e.top}%;
  left: ${(e) => e.left && e.left}%;
  font-family: Helvetica Neue;
  background: #504e4c;
  color: white;
  font-weight: 500;
  font-size: 14px;
  padding: 9px 13px;
  border-radius: 4px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #504e4c;
  }

  .sked-mention.sked-mention-link {
    color: white;
  }
`, Fp = ({
  medias: e,
  storyType: t,
  productTags: s,
  userTags: r
}) => {
  const n = e.collection, i = n.length, a = i > 1, [l, o] = re(!0);
  let D = s && s.length > 0 ? "productTags" : void 0;
  r && r.length > 0 && (D = "userTags");
  const E = D === "productTags" ? s : r, [p, m] = re(!1);
  return /* @__PURE__ */ u.jsxs("div", { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", children: [
      t && t === "reel" && /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ u.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ u.jsx(DD, {}) }),
        /* @__PURE__ */ u.jsxs(Eu, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " Reel"
        ] })
      ] }),
      t && t === "igtv" && /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ u.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ u.jsx(cD, {}) }),
        /* @__PURE__ */ u.jsxs(Eu, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " IGTV"
        ] })
      ] }),
      l && E.length > 0 && /* @__PURE__ */ u.jsxs(fp, { onClick: () => m((c) => !c), children: [
        D === "productTags" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx(lD, {}),
          /* @__PURE__ */ u.jsxs("p", { children: [
            p ? "Hide" : "Show",
            " product tags"
          ] })
        ] }),
        D === "userTags" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx(pD, {}),
          /* @__PURE__ */ u.jsxs("p", { children: [
            p ? "Hide" : "Show",
            " user tags"
          ] })
        ] })
      ] }),
      E.length > 0 && p && /* @__PURE__ */ u.jsx("div", { children: E.map(({
        top: c,
        left: f,
        value: C
      }) => /* @__PURE__ */ u.jsx(hp, { top: c, left: f, children: D === "userTags" ? /* @__PURE__ */ u.jsx(le, { caption: `@${C}`, targetPlatform: "IG" }) : C }, C)) }),
      /* @__PURE__ */ u.jsx("div", { onClick: () => m(!1), children: a ? /* @__PURE__ */ u.jsx(pp, { medias: n, count: i, getIsFirstSlide: (c) => {
        o(c);
      } }) : /* @__PURE__ */ u.jsx(Lu, { media: n[0] }) })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ u.jsx(dp, {}) })
  ] });
}, mp = ({
  post: e
}) => {
  const t = e.comment?.trim();
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-flex sp-flex-col", children: [
    /* @__PURE__ */ u.jsx(eo, { collabs: e.collaboratingIgUsers, username: e.username, profilePicture: e.profilePicture, locationName: e.locationName }),
    /* @__PURE__ */ u.jsx(Fp, { medias: e.medias, storyType: e.storyType || null, productTags: e.providedPost.productTags || [], userTags: e.providedPost.tags || [] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: [
      /* @__PURE__ */ u.jsxs(Eu, { $variant: "caption", className: "sp-whitespace-pre-line sp-mb-2 sp-break-words", children: [
        /* @__PURE__ */ u.jsx("span", { className: "sp-font-bold sp-mr-1", children: e.username }),
        /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "IG" })
      ] }),
      t && /* @__PURE__ */ u.jsxs(Eu, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
        /* @__PURE__ */ u.jsx("span", { className: "sp-font-bold sp-mr-1", children: e.username }),
        /* @__PURE__ */ u.jsx(le, { caption: t, targetPlatform: "IG" })
      ] })
    ] })
  ] });
}, Cp = (e) => /* @__PURE__ */ v.createElement("svg", { viewBox: "0 0 33 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M13 0.463379L9 4.36582H3.23171C1.71834 4.36582 0.5 5.58417 0.5 7.09753L0.500002 27C0.500002 28.5134 1.71834 29.7317 3.23171 29.7317H29.7683C31.2817 29.7317 32.5 28.5134 32.5 27L32.5 7.09753C32.5 5.58417 31.2817 4.36582 29.7683 4.36582H24L20 0.463379H13ZM16.5 8.30487C21.0122 8.30487 24.6951 11.9878 24.6951 16.5C24.6951 21.0122 21.0122 24.6951 16.5 24.6951C11.9878 24.6951 8.30488 21.0122 8.30488 16.5C8.30488 11.9878 11.9879 8.30487 16.5 8.30487ZM16.5 10.6463C13.2533 10.6463 10.6463 13.2533 10.6463 16.5C10.6463 19.7467 13.2533 22.3537 16.5 22.3537C19.7468 22.3537 22.3537 19.7467 22.3537 16.5C22.3537 13.2533 19.7468 10.6463 16.5 10.6463Z", fill: "white" })), Ep = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", fill: "#1a9bfb", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M 19.625 0.15625 C 17.996094 0.234375 16.429688 0.945313 15.21875 2.15625 L 10.46875 6.90625 C 11.214844 6.15625 13.984375 6.671875 14.65625 7.34375 L 17.53125 4.46875 C 18.167969 3.832031 18.964844 3.441406 19.78125 3.40625 C 20.335938 3.378906 21.121094 3.496094 21.8125 4.1875 C 22.457031 4.832031 22.59375 5.582031 22.59375 6.09375 C 22.59375 6.949219 22.203125 7.800781 21.53125 8.46875 L 16.53125 13.5 C 15.273438 14.757813 13.359375 14.859375 12.25 13.75 C 11.617188 13.117188 10.574219 13.113281 9.9375 13.75 C 9.300781 14.386719 9.300781 15.425781 9.9375 16.0625 C 11.078125 17.203125 12.578125 17.78125 14.125 17.78125 C 15.796875 17.78125 17.503906 17.097656 18.8125 15.78125 L 23.84375 10.78125 C 25.121094 9.507813 25.84375 7.804688 25.84375 6.09375 C 25.84375 4.503906 25.242188 2.992188 24.125 1.875 C 22.929688 0.679688 21.324219 0.078125 19.625 0.15625 Z M 11.875 8.21875 C 10.203125 8.21875 8.46875 8.90625 7.15625 10.21875 L 2.15625 15.21875 C 0.878906 16.492188 0.15625 18.195313 0.15625 19.90625 C 0.15625 21.496094 0.757813 23.007813 1.875 24.125 C 3.070313 25.320313 4.675781 25.921875 6.375 25.84375 C 8.003906 25.765625 9.570313 25.054688 10.78125 23.84375 L 15.53125 19.09375 C 14.78125 19.84375 12.015625 19.328125 11.34375 18.65625 L 8.46875 21.53125 C 7.832031 22.167969 7.035156 22.554688 6.21875 22.59375 C 5.664063 22.621094 4.878906 22.503906 4.1875 21.8125 C 3.542969 21.167969 3.40625 20.414063 3.40625 19.90625 C 3.40625 19.050781 3.796875 18.199219 4.46875 17.53125 L 9.46875 12.5 C 10.726563 11.242188 12.640625 11.144531 13.75 12.25 C 14.386719 12.886719 15.429688 12.886719 16.0625 12.25 C 16.699219 11.613281 16.699219 10.574219 16.0625 9.9375 C 14.921875 8.796875 13.417969 8.21875 11.875 8.21875 Z", fill: "#1a9bfb" })), xp = (e) => {
  try {
    const {
      hostname: t
    } = new URL(e);
    return t;
  } catch {
    return "Error";
  }
}, Ap = () => /* @__PURE__ */ u.jsx("div", { className: "sp-w-full sp-h-2 sp-overflow-hidden", style: {
  backgroundColor: "rgba(181, 180, 176, 0.4)"
}, children: /* @__PURE__ */ u.jsx("span", { className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75", style: {
  width: "33%"
}, children: " " }) }), gp = ({
  username: e,
  profilePicture: t,
  locationName: s
}) => /* @__PURE__ */ u.jsxs("section", { className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-my-3 sp-mx-2", children: /* @__PURE__ */ u.jsx(Ap, {}) }),
  /* @__PURE__ */ u.jsx(eo, { username: e, profilePicture: t, locationName: s, small: !0 })
] }), vp = () => /* @__PURE__ */ u.jsx($p, { className: "sp-text-white", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-w-full", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2", style: {
      backgroundColor: "rgba(74, 85, 104, 0.7)"
    }, children: /* @__PURE__ */ u.jsx(Cp, { className: "sp-h-20px sp-w-20px" }) }),
    /* @__PURE__ */ u.jsx(Eu, { $variant: "caption", className: "sp-font-bold sp-pl-4", children: "Send message" })
  ] }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-mx-8", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-fill-current sp-mr-3 icon-instagram-share sp-flex sp-text-4xl sp-mr-8" }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex sp-mr-3 sp-mr-4", children: [...Array(3)].map((e, t) => /* @__PURE__ */ u.jsx(Op, {}, t)) })
  ] })
] }) }), yp = ({
  url: e,
  label: t,
  height: s
}) => /* @__PURE__ */ u.jsx(Np, { className: "sp-bg-white sp-rounded-lg sp-absolute sp-z-10", height: s * 100, children: /* @__PURE__ */ u.jsx(Tp, { href: e, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ u.jsxs(Sp, { children: [
  /* @__PURE__ */ u.jsx(Ip, { children: /* @__PURE__ */ u.jsx(Ep, {}) }),
  /* @__PURE__ */ u.jsx(Pp, { children: t || xp(e) })
] }) }) }), Io = 6.5, Bp = _.div`
  top: calc(
    ${(e) => e.height ? `${e.height + Io}% - ${e.height > 60 ? "140px" : "110px"}` : "0"}
  );
  position: absolute;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: ${(e) => e.height > 60 ? "column-reverse" : "column"};
`, bp = _.div`
  width: 100%;
  height: 145px;
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
  display: flex;
  border-top: 1px dashed rgba(255, 255, 255, 0.2);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  div {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  }
`, wp = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  margin: 10px 0;
`, jp = _.p`
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  margin: 0;
`, _p = _.div`
  width: 18px;
  height: 18px;
  background: #333;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  margin-left: 8px;
  position: relative;
  :hover {
    cursor: pointer;
    div {
      visibility: visible;
    }
  }
`, kp = _.div`
  visibility: hidden;
  width: 340px;
  background-color: rgba(51, 51, 51, 1);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: ${(e) => e.height > 60 ? "-38px" : "28px"};
  right: -62px;
  &::after {
    content: "";
    position: absolute;
    bottom: ${(e) => e.height > 60 ? "-10px" : "29px"};
    right: 66px;
    rotate: ${(e) => e.height > 60 ? "180deg" : "0"};
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 1) transparent;
  }
`, Np = _.div`
  top: calc(${(e) => e.height && e.height + Io}% - 60px);
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  max-width: 95%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
`, Tp = _.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  &:hover {
    text-decoration: none;
  }
`, Sp = _.div`
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`, Pp = _.div`
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  color: #1a9bfb;
  font-size: clamp(20px, 2.4vw, 28px);
  line-height: 1.1;
  font-family: Aveny, "Apple Color Emoji", "Segoe UI Emoji", Arial, sans-serif;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translateY(4px);
`, Ip = _.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
`, Op = _.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 2px;
`, Oo = ({
  post: e,
  media: t,
  isActiveSlide: s,
  env: r,
  showNote: n = !0
}) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center", children: /* @__PURE__ */ u.jsxs(Lp, { children: [
    /* @__PURE__ */ u.jsx(gp, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName }),
    /* @__PURE__ */ u.jsxs(Rp, { children: [
      e.storyUrl && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        r === "schedugram-client" && /* @__PURE__ */ u.jsxs(Bp, { height: (e.storyStickerHeight || 0.8) * 100, children: [
          /* @__PURE__ */ u.jsx(bp, { children: /* @__PURE__ */ u.jsx("div", {}) }),
          /* @__PURE__ */ u.jsxs(wp, { children: [
            /* @__PURE__ */ u.jsx(jp, { children: "Approx. Sticker placement area" }),
            /* @__PURE__ */ u.jsxs(_p, { children: [
              "?",
              /* @__PURE__ */ u.jsx(kp, { height: (e.storyStickerHeight || 0.8) * 100, children: "Sticker position is approximate, to be used as a guide only." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ u.jsx(yp, { url: e.storyUrl, label: e.storyLabel, height: e.storyStickerHeight || 0.8 })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-full sp-w-full sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ u.jsx(Lu, { media: t, isActiveSlide: s, imageObjectFit: "contain", fillContainer: !0, videoObjectFit: "contain" }) })
    ] }),
    /* @__PURE__ */ u.jsx(vp, {})
  ] }) }),
  n && e.caption && /* @__PURE__ */ u.jsxs(Lo, { children: [
    /* @__PURE__ */ u.jsx("strong", { children: "Notes for manual Publishing: " }),
    e.caption
  ] })
] }), Lo = _.p`
  max-width: 358px;
  margin: 14px auto 0;
  font-size: 14px;
`, Lp = _.div`
  position: relative;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  background: #000;
  overflow: hidden;
`, Rp = _.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #000;
`, $p = _.section`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 24px;
  z-index: 50;
`, Mp = ({
  post: e,
  media: t,
  slideNo: s,
  isActiveSlide: r,
  env: n
}) => {
  const i = {
    order: s,
    flex: "0 0 100%",
    minWidth: 0,
    overflow: "hidden",
    width: "100%"
  };
  return /* @__PURE__ */ u.jsx("div", { "data-ig-story-carousel-slide": s, style: i, children: /* @__PURE__ */ u.jsx(Oo, { post: e, media: t, isActiveSlide: r, env: n, showNote: !1 }) });
}, Up = ({
  post: e,
  stories: t,
  currentSlide: s,
  env: r
}) => t.map((n, i) => /* @__PURE__ */ u.jsx(Mp, { post: e, media: n, slideNo: i + 1, isActiveSlide: s === i + 1, env: r }, i)), Hp = ({
  post: e,
  stories: t,
  count: s,
  env: r
}) => {
  const [n, i] = re(1), a = 1, l = s;
  hu(() => {
    i(1);
  }, [e]);
  const o = {
    transform: `translateX(-${(n - 1) * 100}%)`,
    width: "100%"
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", "data-ig-story-carousel": !0, children: [
      a === n || /* @__PURE__ */ u.jsx(Ru, { direction: "left", onClick: () => i(n - 1) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-relative", "data-ig-story-carousel-track": !0, style: o, children: /* @__PURE__ */ u.jsx(Up, { post: e, stories: t, currentSlide: n, env: r }) }),
      l === n || /* @__PURE__ */ u.jsx(Ru, { direction: "right", onClick: () => i(n + 1) })
    ] }),
    e.caption && /* @__PURE__ */ u.jsxs(Lo, { children: [
      /* @__PURE__ */ u.jsx("strong", { children: "Notes for manual Publishing: " }),
      e.caption
    ] })
  ] });
}, zp = ({
  post: e,
  env: t
}) => {
  const s = e.medias.collection, r = s.length;
  return /* @__PURE__ */ u.jsx("div", { className: "sp-pb-8", children: r > 1 ? /* @__PURE__ */ u.jsx(Hp, { post: e, stories: s, count: r, env: t }) : /* @__PURE__ */ u.jsx(Oo, { post: e, media: s[0], env: t }) });
}, Vp = _.div`
  display: flex;
  flex-direction: ${({
  $direction: e = "row"
}) => e};
  justify-content: ${({
  $justify: e = "flex-start"
}) => e};
  align-items: ${({
  $align: e = "flex-start"
}) => e};
  gap: ${({
  $gap: e = 7
}) => `${e}px`};
  margin-top: ${({
  $marginTop: e = 0
}) => e === "auto" ? "auto" : `${e}px`};
  margin-bottom: ${({
  $marginBottom: e = 0
}) => e === "auto" ? "auto" : `${e}px`};
  margin-left: ${({
  $marginLeft: e = 0
}) => e === "auto" ? "auto" : `${e}px`};
  margin-right: ${({
  $marginRight: e = 0
}) => e === "auto" ? "auto" : `${e}px`};
  width: ${({
  $width: e = "auto"
}) => e};
`, Wp = ({
  media: e,
  slideNo: t,
  isActiveSlide: s
}) => {
  const r = {
    order: t,
    flex: "1 0 100%"
  };
  return /* @__PURE__ */ u.jsx("div", { style: r, className: "sp-h-full", children: /* @__PURE__ */ u.jsx(Lu, { media: e, isActiveSlide: s, videoContainerStyles: {
    position: "relative"
  }, videoObjectFit: "cover", imageObjectFit: "contain", fillContainer: !0 }) });
}, Gp = ({
  medias: e,
  currentSlide: t
}) => {
  const s = e.map((r, n) => /* @__PURE__ */ u.jsx(Wp, { media: r, slideNo: n + 1, isActiveSlide: t === n + 1 }, `slide-${n}`));
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: s });
}, qp = ({
  current: e
}) => /* @__PURE__ */ u.jsx("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), Zp = ({
  count: e,
  current: t
}) => /* @__PURE__ */ u.jsx(Yp, { className: "sp-flex sp-items-center sp-justify-center", children: [...Array(e)].map((s, r) => /* @__PURE__ */ u.jsx(qp, { current: r + 1 === t }, `dot-${r}`)) }), Kp = ({
  medias: e,
  count: t
}) => {
  const [s, r] = re(1);
  hu(() => {
    s > e.length && r(e.length);
  }, [e.length, s]);
  const n = {
    left: "100%",
    transform: `translateX(${s * -100}%)`
  };
  return /* @__PURE__ */ u.jsxs(Vp, { $width: "100%", $direction: "column", $justify: "center", $align: "stretch", $gap: "0", className: "sp-relative", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-flex-1 sp-relative sp-overflow-hidden", children: [
      s !== 1 && /* @__PURE__ */ u.jsx(Ru, { direction: "left", onClick: () => r(s - 1) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-relative sp-items-stretch sp-h-full", style: n, children: /* @__PURE__ */ u.jsx(Gp, { medias: e, currentSlide: s }) }),
      s !== e.length && /* @__PURE__ */ u.jsx(Ru, { direction: "right", onClick: () => r(s + 1) })
    ] }),
    /* @__PURE__ */ u.jsx(Zp, { count: t, current: s })
  ] });
}, Yp = _.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
`, Ro = ({
  medias: e
}) => {
  const t = e.collection, s = t.length, r = s > 1;
  if (s === 0)
    return null;
  const n = t[0], i = !!n?.isVideo || n?.url?.includes(".mp4");
  return r ? /* @__PURE__ */ u.jsx(Kp, { medias: t, count: s }) : /* @__PURE__ */ u.jsx(Lu, { media: n, controls: i, videoObjectFit: "cover", imageObjectFit: "contain", fillContainer: !0 });
}, ns = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, Xp = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 14", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M0.285317 6.39974C0.194867 6.47853 0.123111 6.5721 0.0741546 6.6751C0.0251977 6.7781 6.52568e-07 6.8885 6.47695e-07 7C6.42821e-07 7.1115 0.0251977 7.2219 0.0741545 7.3249C0.123111 7.42789 0.194867 7.52146 0.285317 7.60026L7.33835 13.7514C7.52089 13.9106 7.76847 14 8.02663 14C8.28478 14 8.53236 13.9106 8.71491 13.7514C8.89745 13.5922 9 13.3762 9 13.1511C9 12.926 8.89745 12.71 8.71491 12.5508L2.35015 7L8.71491 1.44916C8.80529 1.37033 8.87699 1.27675 8.92591 1.17376C8.97482 1.07077 9 0.960378 9 0.848899C9 0.73742 8.97482 0.627033 8.92591 0.52404C8.87699 0.421046 8.80529 0.327465 8.71491 0.248637C8.62452 0.169809 8.51722 0.10728 8.39912 0.0646186C8.28103 0.0219574 8.15445 -3.86212e-08 8.02663 -4.25475e-08C7.8988 -4.64737e-08 7.77223 0.0219574 7.65413 0.0646186C7.53604 0.10728 7.42873 0.169809 7.33835 0.248637L0.285317 6.39974Z", fill: "white" })), Jp = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 21 17", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_85)" }, /* @__PURE__ */ v.createElement("path", { d: "M13.2308 23C11.4549 23 10 21.6081 10 19.9091V11.6667C10 9.96768 11.4549 8.57576 13.2308 8.57576H15.9567L17.0841 6.42661C17.1514 6.2982 17.2547 6.19026 17.3825 6.11491C17.5103 6.03955 17.6576 5.99976 17.8077 6H23.1923C23.3424 5.99976 23.4897 6.03955 23.6175 6.11491C23.7453 6.19026 23.8486 6.2982 23.9159 6.42661L25.0433 8.57576H27.7692C29.5451 8.57576 31 9.96768 31 11.6667V19.9091C31 21.6081 29.5451 23 27.7692 23H13.2308ZM13.2308 21.4545H27.7692C28.6781 21.4545 29.3846 20.7786 29.3846 19.9091V11.6667C29.3846 10.7972 28.6781 10.1212 27.7692 10.1212H24.5385C24.3883 10.1215 24.2411 10.0817 24.1133 10.0063C23.9855 9.93097 23.8822 9.82303 23.8149 9.69462L22.6875 7.54545H18.3125L17.1851 9.69462C17.1178 9.82303 17.0145 9.93097 16.8867 10.0063C16.7589 10.0817 16.6117 10.1215 16.4615 10.1212H13.2308C12.3219 10.1212 11.6154 10.7972 11.6154 11.6667V19.9091C11.6154 20.7786 12.3219 21.4545 13.2308 21.4545ZM20.5 20.1667C17.9818 20.1667 15.9231 18.1971 15.9231 15.7879C15.9231 13.3787 17.9818 11.4091 20.5 11.4091C23.0182 11.4091 25.0769 13.3787 25.0769 15.7879C25.0769 18.1971 23.0182 20.1667 20.5 20.1667ZM20.5 18.6212C22.1452 18.6212 23.4615 17.3618 23.4615 15.7879C23.4615 14.2139 22.1452 12.9546 20.5 12.9546C18.8549 12.9546 17.5385 14.2139 17.5385 15.7879C17.5385 17.3618 18.8549 18.6212 20.5 18.6212Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_85", x: 0, y: 0, width: 41, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_85" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_85", result: "shape" })))), Qp = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 8 8", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_80)" }, /* @__PURE__ */ v.createElement("rect", { x: 10, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ v.createElement("rect", { x: 16, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ v.createElement("rect", { x: 13, y: 6, width: 2, height: 8, rx: 1, fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_80", x: 0, y: 0, width: 28, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_80" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_80", result: "shape" })))), ed = _.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`, ud = _.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 6px;
`, $o = ({
  profilePicture: e,
  username: t
}) => /* @__PURE__ */ u.jsxs(ed, { children: [
  /* @__PURE__ */ u.jsx(ud, { $profilePicture: e }),
  /* @__PURE__ */ u.jsxs(ns, { className: "sp-font-bold", children: [
    t,
    " • Follow"
  ] })
] }), td = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 18", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_66)" }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.383 6C21.3618 6 20.0001 8.32683 20.0001 8.32683C20.0001 8.32683 18.6384 6 15.6171 6C12.5107 6 10.0001 8.80976 10.0001 12.278C10.0001 15.7463 12.5958 17.722 15.1916 20.0927C19.1064 23.6927 19.3618 24 20.0001 24C20.6384 24 20.8937 23.6927 24.8086 20.0927C27.4469 17.678 30.0001 15.7024 30.0001 12.278C30.0001 8.80976 27.4894 6 24.383 6ZM23.9575 19.0829C21.6596 21.1902 20.4256 22.3756 20.0001 22.639C19.5745 22.3317 18.0426 20.9268 16.0426 19.0829C13.7022 16.9317 11.2767 15.1317 11.2767 12.2341C11.2767 9.5122 13.2341 7.27317 15.6171 7.27317C17.3618 7.27317 18.2979 8.15122 18.9788 9.11707C20.5107 11.3561 19.4894 11.3561 21.0213 9.11707C21.7022 8.15122 22.6384 7.27317 24.383 7.27317C26.766 7.27317 28.7235 9.5122 28.7235 12.2341C28.7235 15.1756 26.2979 16.9756 23.9575 19.0829Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_66", x: 610352e-10, y: 0, width: 40, height: 38, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_66" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_66", result: "shape" })))), sd = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 20", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_65)" }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.9868 25.3914L28.7961 20.7137C29.5615 19.3103 29.9868 17.6944 29.9868 15.9934C29.9868 10.4651 25.5216 6 19.9934 6C14.4651 6 10 10.4651 10 15.9934C10 21.5216 14.4651 25.9868 19.9934 25.9868C21.6944 25.9868 23.3103 25.5615 24.7137 24.7961L29.3914 25.9868C29.7316 26.0718 30.0718 25.7316 29.9868 25.3914ZM28.711 15.9934C28.711 17.6944 28.2858 18.9701 27.6054 20.2459C27.5203 20.416 27.4778 20.6286 27.5203 20.8412L28.4134 24.4134L24.8838 23.5203C24.6711 23.4778 24.4585 23.4778 24.2884 23.6054C23.523 24.0306 22.0771 24.711 20.0359 24.711C15.1881 24.711 11.2758 20.7987 11.2758 15.9934C11.2758 11.1881 15.1881 7.27575 19.9934 7.27575C24.7987 7.27575 28.711 11.1881 28.711 15.9934Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_65", x: 0, y: 0, width: 40, height: 40, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_65" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_65", result: "shape" })))), rd = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 17", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_64)" }, /* @__PURE__ */ v.createElement("path", { d: "M29.5574 6H10.419C10.0363 6 9.86616 6.45544 10.1213 6.70386L16.9261 13.2456L19.2652 22.6856C19.3503 23.0582 19.8606 23.0996 20.0307 22.8098L29.9401 6.62105C30.1102 6.33123 29.8976 6 29.5574 6ZM12.503 7.2421H26.7504L17.9043 12.0035C17.7341 12.0863 17.5215 12.0449 17.3939 11.9207L12.503 7.2421ZM20.0307 20.4084L18.3295 13.5354C18.287 13.3698 18.3721 13.1628 18.5422 13.08L27.4309 8.27719L20.0307 20.4084Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_64", x: 0, y: 0, width: 40, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_64" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_64", result: "shape" })))), nd = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ v.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ v.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), id = _.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 4;

  svg {
    width: 20px;

    &.more {
      position: relative;
      ${({
  $vertical: e
}) => e && "top: -10px;"};
    }
  }

  ${({
  $vertical: e
}) => e ? `
      flex-direction: column;
      right: 14px;
      bottom: 145px;
      gap: 40px;
      ` : `
      flex-direction: row;
      gap: 14px;
      left: 14px;
      bottom: 80px;
      `}
`, Mo = ({
  vertical: e
}) => /* @__PURE__ */ u.jsxs(id, { $vertical: e, children: [
  /* @__PURE__ */ u.jsx(td, {}),
  /* @__PURE__ */ u.jsx(sd, {}),
  /* @__PURE__ */ u.jsx(rd, {}),
  /* @__PURE__ */ u.jsx(nd, { className: "more" })
] }), ad = ({
  post: e,
  className: t
}) => {
  const s = e?.medias?.collection?.length > 1, r = e.comment?.trim(), [n, i] = re(!1);
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs(od, { className: t, children: [
      /* @__PURE__ */ u.jsxs(Dd, { children: [
        /* @__PURE__ */ u.jsx(Xp, { className: "arrow-back" }),
        /* @__PURE__ */ u.jsx(ns, { children: "Reels" }),
        /* @__PURE__ */ u.jsx(Jp, { className: "camera" })
      ] }),
      /* @__PURE__ */ u.jsx(Mo, { vertical: !0 }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[1]" }),
      /* @__PURE__ */ u.jsxs(ld, { $isMultipleMedia: s, $expanded: n, children: [
        /* @__PURE__ */ u.jsx($o, { profilePicture: e.profilePicture, username: e.username }),
        /* @__PURE__ */ u.jsx("div", { className: n ? "sp-max-h-[300px] sp-overflow-y-auto" : "sp-line-clamp-2 sp-overflow-hidden", style: n ? {
          scrollbarWidth: "none"
        } : void 0, children: /* @__PURE__ */ u.jsx(ns, { children: /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "IG" }) }) }),
        e.caption && /* @__PURE__ */ u.jsx("button", { onClick: (a) => {
          a.stopPropagation(), i(!n);
        }, className: "sp-text-white/70 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: n ? "less" : "more" }),
        /* @__PURE__ */ u.jsxs(pd, { children: [
          /* @__PURE__ */ u.jsx(Qp, {}),
          /* @__PURE__ */ u.jsx("span", { children: "Audio will be auto-matched after publishing" })
        ] })
      ] }),
      /* @__PURE__ */ u.jsx(Ro, { medias: e.medias })
    ] }),
    r && /* @__PURE__ */ u.jsxs(cd, { id: "post-preview-notes", children: [
      /* @__PURE__ */ u.jsxs("strong", { children: [
        e.username,
        " "
      ] }),
      /* @__PURE__ */ u.jsx(le, { caption: r, targetPlatform: "IG" })
    ] })
  ] });
}, od = _.div`
  box-shadow: 0 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  height: 711px;
  background: #333;
  display: flex;
  overflow: hidden;
`, ld = _.div`
  position: absolute;
  bottom: ${(e) => e.$isMultipleMedia ? "85px" : "55px"};
  z-index: 4;
  padding: ${(e) => e.$expanded ? "12px" : "0 0 0 12px"};
  right: 60px;
  overflow-wrap: break-word;
  word-break: break-word;
  border-radius: ${(e) => e.$expanded ? "12px" : "0"};
  background: ${(e) => e.$expanded ? "rgba(0, 0, 0, 0.5)" : "transparent"};
  transition:
    background 0.2s ease,
    padding 0.2s ease;

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }
`, cd = _.div`
  margin: 14px 5px;
  font-size: 14px;
  line-height: 17px;
`, Dd = _.div`
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 4;
  justify-content: space-between;
  width: 100%;

  p {
    font-weight: 700;
  }

  .arrow-back {
    width: 14px;
    margin-left: 12px;
  }

  .camera {
    width: 21px;
    margin-right: 12px;
  }
`, pd = _.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    width: 8px;
    flex-shrink: 0;
  }
`, dd = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, fd = _.div`
  position: absolute;
  top: 20px;
  z-index: 2;
  width: 100%;

  .section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;

    p {
      width: 280px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 16px;
    }

    svg.close {
      width: 17px;
    }
  }
`, hd = ({
  post: e
}) => /* @__PURE__ */ u.jsxs(dd, { children: [
  /* @__PURE__ */ u.jsxs(fd, { children: [
    e.caption && /* @__PURE__ */ u.jsx("div", { className: "section", children: /* @__PURE__ */ u.jsx(ns, { children: e.caption }) }),
    /* @__PURE__ */ u.jsx("div", { className: "section", children: /* @__PURE__ */ u.jsx($o, { profilePicture: e.profilePicture, username: e.username }) })
  ] }),
  /* @__PURE__ */ u.jsx(Mo, {}),
  /* @__PURE__ */ u.jsx(Ro, { medias: e.medias })
] }), Fd = ({
  post: e,
  className: t,
  env: s
}) => {
  let r = e.type;
  switch (r === "story" && e.storyType && e.storyType !== "story" && (e.storyType === "reel" ? (r = "reel", e.locationName = "Reel") : e.storyType === "igtv" && (r = "igtv", e.locationName = "IGTV")), r) {
    case "image":
    case "multiMedia":
      return /* @__PURE__ */ u.jsx(mp, { post: e });
    // videos now get previewed as reels
    case "video":
    case "reel":
      return /* @__PURE__ */ u.jsx(ad, { post: e, className: t });
    case "igtv":
      return /* @__PURE__ */ u.jsx(hd, { post: e });
    case "story":
      return /* @__PURE__ */ u.jsx(zp, { post: e, env: s });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, $u = _.div`
  font-family: Helvetica;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};

  .sked-mention.sked-mention-facebook {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, md = ({
  username: e,
  profilePicture: t,
  small: s,
  scheduled: r
}) => {
  let n = new Ze(r).format("MMM D [at] HH:mm");
  return n === "Invalid date" && (n = null), /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
    /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsxs("div", { className: "", children: [
      /* @__PURE__ */ u.jsx($u, { $variant: "heading", className: "sp-mb-1", children: e }),
      n && /* @__PURE__ */ u.jsx($u, { $variant: "subheading", children: n })
    ] }) })
  ] });
}, Xe = ({
  children: e,
  href: t,
  target: s = "_blank",
  $isFlex: r = !1
}) => /* @__PURE__ */ u.jsx(_o, { $isFlex: r, href: t, target: s, rel: "noreferrer", children: e });
function Uo(e) {
  var t, s, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (s = Uo(e[t])) && (r && (r += " "), r += s);
  } else for (s in e) e[s] && (r && (r += " "), r += s);
  return r;
}
function Cd() {
  for (var e, t, s = 0, r = "", n = arguments.length; s < n; s++) (e = arguments[s]) && (t = Uo(e)) && (r && (r += " "), r += t);
  return r;
}
const Ed = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, xd = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Ad = ({
  src: e,
  forCarousel: t,
  showOverlay: s,
  showAll: r,
  setShowAll: n,
  mediaCount: i
}) => t ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsx(Xe, { href: e, $isFlex: !0, children: /* @__PURE__ */ u.jsx(xd, { src: e, className: "" }) }),
  !r && s && /* @__PURE__ */ u.jsxs("div", { className: "sp-cursor-pointer", onClick: () => n(!0), children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ u.jsx(Xe, { href: e, children: /* @__PURE__ */ u.jsx(Ed, { src: e }) }), gd = ({
  url: e,
  isActiveSlide: t,
  isCarouselPost: s,
  controls: r = !0
}) => {
  const {
    vid: n,
    videoCoverPreview: i,
    showVideoCover: a,
    resetVideo: l,
    handlePlay: o,
    handlePause: D,
    showResetButton: E
  } = rn({
    usePostTypeCheck: !1
  }), [p, m] = re(!1), c = !r, f = c && a && !p, C = () => {
    m(!1), l();
  };
  return t ? /* @__PURE__ */ u.jsx("div", { className: Cd("sp-w-full sp-h-full", {
    "sp-relative": !s
  }, {
    "sp-absolute": s
  }), children: /* @__PURE__ */ u.jsxs(No, { $showVideoCover: a, children: [
    E && /* @__PURE__ */ u.jsx(So, { onClick: C }),
    f && i && /* @__PURE__ */ u.jsx(To, { src: i, alt: "" }),
    c && /* @__PURE__ */ u.jsx(Po, { playing: p, onToggle: () => m((g) => !g) }),
    /* @__PURE__ */ u.jsx(Me, { url: e, controls: r, playing: c ? p : !!i, onPlay: o, onPause: D, light: !c && a ? i : void 0, className: "sp-overflow-hidden sp-my-auto", width: "100%", height: "100%", config: {
      facebook: {
        version: "v25.0"
      }
    } }, n)
  ] }) }) : null;
}, nn = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showOverlay: r,
  showAll: n,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: l = !0,
  controls: o
}) => t && n === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(gd, { url: e.url, isActiveSlide: l, isCarouselPost: s, controls: o }) : /* @__PURE__ */ u.jsx(Ad, { src: e.url, forCarousel: s, showOverlay: r, showAll: n, setShowAll: i, mediaCount: a }), vd = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, yd = ({
  medias: e
}) => {
  const [t, s] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: e.map((r, n) => !t && n > 3 ? null : /* @__PURE__ */ u.jsx(vd, { className: "sp-relative", children: /* @__PURE__ */ u.jsx(nn, { media: r, forCarousel: !0, hidden: n > 3, isActiveSlide: n === 0, mediaCount: e.length, showOverlay: n === 3 && e.length > 4, showAll: t, setShowAll: s }) }, `fb-media-key-${n}`)) });
}, Bd = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-py-2 sp-text-gray-700", children: [
  /* @__PURE__ */ u.jsx(nr, { icon: "icon-facebook-like", text: "Like" }),
  /* @__PURE__ */ u.jsx(nr, { icon: "icon-facebook-comment", text: "Comment" }),
  /* @__PURE__ */ u.jsx(nr, { icon: "icon-facebook-share", text: "Share" })
] }), nr = ({
  icon: e,
  text: t
}) => /* @__PURE__ */ u.jsxs($u, { $variant: "icons", className: "sp-flex sp-items-center sp-justify-center sp-w-1/3 ", children: [
  /* @__PURE__ */ u.jsx("div", { className: `sp-mr-2 sp-text-xl ${e}` }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-text-gray-700", children: t })
] }), bd = ({
  medias: e
}) => {
  const t = e.collection, s = t.length, r = s > 1;
  return /* @__PURE__ */ u.jsxs("div", { children: [
    s > 0 && /* @__PURE__ */ u.jsx(u.Fragment, { children: r ? /* @__PURE__ */ u.jsx(yd, { medias: t }) : /* @__PURE__ */ u.jsx(nn, { media: t[0], showOverlay: !1, showAll: !0, setShowAll: () => {
    }, isActiveSlide: !0, mediaCount: s }) }),
    /* @__PURE__ */ u.jsx(Bd, {})
  ] });
}, wd = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", Cs = ({
  url: e
}) => /* @__PURE__ */ u.jsx(ma, { url: e, apiKey: wd, size: "large", className: "sp-shadow-lg" }), jd = ({
  post: e
}) => {
  let t = e.caption;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ u.jsx(md, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName, scheduled: e.scheduledFor }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-mx-4 sp-pb-4", style: e.type === "text" && e.redirectUrl === "" ? {
      borderBottom: "1px solid #BFBEBE"
    } : {}, children: /* @__PURE__ */ u.jsxs($u, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ u.jsx(le, { caption: t, targetPlatform: "FB" }),
      e.redirectUrl && e.type !== "text" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        " ",
        /* @__PURE__ */ u.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: e.redirectUrl, target: "_blank", children: e.redirectUrl })
      ] })
    ] }) }),
    e.type === "text" && e.redirectUrl && /* @__PURE__ */ u.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ u.jsx(Cs, { url: e.redirectUrl }) }),
    /* @__PURE__ */ u.jsx(bd, { medias: e.medias }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ u.jsxs($u, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ u.jsx("span", { className: "sp-font-bold sp-mr-1", children: e.username }),
      /* @__PURE__ */ u.jsx(le, { caption: e.comment, targetPlatform: "FB" })
    ] }) })
  ] });
}, _d = ({
  post: e,
  media: t
}) => {
  const [s, r] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center sp-h-full", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ u.jsx(nn, { media: t, controls: !1 }) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-top-8 sp-flex sp-items-center sp-justify-between sp-w-full  sp-text-white sp-text-24px", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-mx-16px sp-w-full sp-flex sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-xmark" }) }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-16px", children: [
        /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-magnifying-glass" }) }),
        /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-circle-user" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-bottom-[50px] sp-right-[16px] sp-flex sp-flex-col sp-gap-[40px] sp-items-center sp-text-white sp-text-24px sp-z-10", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-thumbs-up" }) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-message" }) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-share" }) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-comment-lines" }) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-ellipsis" }) })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[5]" }),
    /* @__PURE__ */ u.jsxs("div", { className: `sp-absolute sp-bottom-[50px] sp-flex sp-flex-col sp-gap-3 sp-z-10 sp-transition-all sp-duration-200 ${s ? "sp-left-0 sp-right-0 sp-px-5 sp-bg-black/50 sp-p-3" : "sp-left-5 sp-max-w-[320px]"}`, children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-[8px]", children: [
          /* @__PURE__ */ u.jsx("div", { className: "sp-w-[40px] sp-h-[40px] sp-rounded-full sp-overflow-hidden sp-bg-[#333] sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx("img", { src: e.profilePicture, className: "sp-w-full sp-h-full sp-object-cover" }) }),
          /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-gap-1", children: /* @__PURE__ */ u.jsx("span", { className: "sp-text-white sp-font-semibold sp-text-[16px] sp-max-w-[180px] sp-overflow-hidden sp-whitespace-nowrap sp-text-ellipsis sp-inline-block", children: e.username }) }),
          /* @__PURE__ */ u.jsx("div", { className: "sp-w-3 sp-h-3 sp-text-white sp-text-12px", children: /* @__PURE__ */ u.jsx("i", { className: "fa-regular fa-earth-americas" }) })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "sp-flex-shrink-0 sp-ml-[12px]", children: /* @__PURE__ */ u.jsx("button", { className: "sp-bg-transparent  sp-border-[1px] sp-border-white/30 sp-border-solid sp-rounded-[9px] sp-text-white sp-text-[15px] sp-px-[12px] sp-py-[4px]", children: "Follow" }) })
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-text-white sp-text-[16px] sp-leading-6", children: [
        /* @__PURE__ */ u.jsx("div", { className: s ? "sp-max-h-[300px] sp-overflow-y-auto sp-break-words" : "sp-line-clamp-2 sp-overflow-hidden sp-break-words", style: s ? {
          scrollbarWidth: "none"
        } : void 0, children: /* @__PURE__ */ u.jsx("span", { children: e.caption }) }),
        e.caption && /* @__PURE__ */ u.jsx("button", { onClick: (n) => {
          n.stopPropagation(), r(!s);
        }, className: "sp-text-gray-400 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: s ? "less" : "more" })
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1.5 sp-text-white/70 sp-text-[11px] sp-mt-2", children: [
        /* @__PURE__ */ u.jsx("i", { className: "fa-solid fa-music sp-text-[10px]" }),
        /* @__PURE__ */ u.jsx("span", { className: "sp-truncate", children: "Audio will be auto-matched after publishing" })
      ] })
    ] })
  ] }) });
}, ji = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-pb-8", children: [
  /* @__PURE__ */ u.jsx(_d, { post: e, media: e.medias.collection[0] }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-py-8", children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ u.jsxs($u, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
    /* @__PURE__ */ u.jsx("span", { className: "sp-font-bold sp-mr-1", children: e.username }),
    /* @__PURE__ */ u.jsx(le, { caption: e.comment, targetPlatform: "FB" })
  ] }) })
] }), kd = ({
  post: e
}) => {
  const t = e.type, s = e.providedPost?.videoPostType;
  if (t === "video" && s === "reel")
    return /* @__PURE__ */ u.jsx(ji, { post: e });
  switch (t) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ u.jsx(jd, { post: e });
    case "story":
    case "fb-reel":
      return /* @__PURE__ */ u.jsx(ji, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Or = _.div`
  font-family: Helvetica;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, Nd = ({
  username: e,
  profilePicture: t,
  small: s
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
  /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsxs("div", { className: "sp-font-sans", children: [
    /* @__PURE__ */ u.jsx(Or, { $variant: "heading", className: "sp-mb-1", children: e }),
    /* @__PURE__ */ u.jsxs(Or, { $variant: "subheading", className: "sp-text-gray-600", children: [
      "@",
      e
    ] })
  ] }) }),
  /* @__PURE__ */ u.jsx("div", { className: "icon-twitter-down sp-mr-4 sp-text-2xl sp-text-gray-600", children: " " })
] }), Td = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Sd = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Pd = ({
  src: e,
  forCarousel: t,
  showOverlay: s,
  showAll: r,
  setShowAll: n,
  mediaCount: i
}) => t ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsx(Xe, { href: e, $isFlex: !0, children: /* @__PURE__ */ u.jsx(Sd, { src: e, className: "" }) }),
  !r && s && /* @__PURE__ */ u.jsxs("div", { className: "sp-cursor-pointer", onClick: () => n(!0), children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ u.jsx(Xe, { href: e, children: /* @__PURE__ */ u.jsx(Td, { src: e }) }), Id = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, playing: !1, className: "sp-relative", width: "100%", height: "auto" }) }) : null, Ho = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showOverlay: r,
  showAll: n,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: l = !0
}) => t && n === !1 ? null : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(Id, { url: e.url, forCarousel: s, isActiveSlide: l }),
  !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(Pd, { src: e.url, forCarousel: s, showOverlay: r, showAll: n, setShowAll: i, mediaCount: a })
] }), Od = () => /* @__PURE__ */ u.jsx("div", { className: "sp-py-4 sp-px-2 sp-w-full", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-text-gray-600 sp-py-2", style: {
  borderTop: "0.5px solid #ebebe4",
  borderBottom: "0.5px solid #ebebe4"
}, children: [
  /* @__PURE__ */ u.jsx(Rt, { icon: "icon-twitter-reply" }),
  /* @__PURE__ */ u.jsx(Rt, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ u.jsx(Rt, { icon: "icon-twitter-heart" }),
  /* @__PURE__ */ u.jsx(Rt, { icon: "icon-twitter-share" })
] }) }), Rt = ({
  icon: e
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-w-1/4 ", children: /* @__PURE__ */ u.jsx("div", { className: `sp-text-xl ${e}` }) }), Ld = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Rd = ({
  medias: e
}) => {
  const [t, s] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: e.map((r, n) => !t && n > 3 ? null : /* @__PURE__ */ u.jsx(Ld, { className: "sp-relative", children: /* @__PURE__ */ u.jsx(Ho, { media: r, forCarousel: !0, hidden: n > 3, mediaCount: e.length, showOverlay: n === 3 && e.length > 4, showAll: t, setShowAll: s }) }, `fb-media-key-${n}`)) });
}, $d = ({
  medias: e
}) => {
  const t = e.collection, s = t.length, r = s > 1;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-px-4", children: [
    s > 0 && /* @__PURE__ */ u.jsx(u.Fragment, { children: r ? /* @__PURE__ */ u.jsx(Rd, { medias: t, count: s }) : /* @__PURE__ */ u.jsx(Ho, { media: t[0] }) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ u.jsx(Od, {}) })
  ] });
}, Md = ({
  post: e
}) => {
  let t = e.caption;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ u.jsx(Nd, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ u.jsxs(Or, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ u.jsx(le, { caption: t, targetPlatform: "TW" }),
      e.redirectUrl && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        " ",
        /* @__PURE__ */ u.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: e.redirectUrl, target: "_blank", children: e.redirectUrl })
      ] })
    ] }) }),
    e.type === "text" && e.redirectUrl && /* @__PURE__ */ u.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ u.jsx(Cs, { url: e.redirectUrl }) }),
    /* @__PURE__ */ u.jsx($d, { medias: e.medias })
  ] });
}, Ud = ({
  post: e
}) => {
  switch (e.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ u.jsx(Md, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, ft = _.div`
  font-family: Helvetica;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.045em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
  }
}};

  .sked-mention.sked-mention-linkedin {
    color: #0a66c2; // copied from LI home feed - in caption creator they're black but feed are #0a66c2
    cursor: pointer;
    font-weight: bold; // LI mentions are bold

    &:hover {
      text-decoration: underline;
    }
  }
`, Hd = ({
  username: e,
  profilePicture: t,
  locationName: s,
  small: r
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "48px",
    height: "48px"
  }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
  /* @__PURE__ */ u.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`, children: [
    /* @__PURE__ */ u.jsx(ft, { $variant: "heading", children: e }),
    s && /* @__PURE__ */ u.jsx(ft, { $variant: "subheading", className: "sp-text-gray-600", children: s })
  ] })
] }), zd = _.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${(e) => e.backgroundColor || "var(--white)"};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -4px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -4px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -4px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -4px;
  }
`, Vd = _.div`
  width: ${(e) => e.width || "auto"};
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(e) => e.backgroundColor || "var(--white)"};
  color: white;
  position: relative;
  z-index: 998;
  box-sizing: border-box;
  font-family: Helvetica;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`, Wd = ({
  backgroundColor: e,
  arrowPosition: t,
  children: s,
  width: r,
  ...n
}) => /* @__PURE__ */ u.jsx(zd, { backgroundColor: e, className: `arrow-${t}`, children: /* @__PURE__ */ u.jsx(Vd, { backgroundColor: e, width: r, ...n, children: s }) }), Gd = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("g", { clipPath: "url(#clip0_4697_272)" }, /* @__PURE__ */ v.createElement("path", { d: "M7.99967 10.6666V7.99992M7.99967 5.33325H8.00634M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z", stroke: "white", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("clipPath", { id: "clip0_4697_272" }, /* @__PURE__ */ v.createElement("rect", { width: 16, height: 16, fill: "white" }))));
function qd(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Xt = { exports: {} }, Zd = Xt.exports, _i;
function Kd() {
  return _i || (_i = 1, (function(e, t) {
    (function(s, r) {
      typeof qd == "function" ? e.exports = r() : s.pluralize = r();
    })(Zd, function() {
      var s = [], r = [], n = {}, i = {}, a = {};
      function l(C) {
        return typeof C == "string" ? new RegExp("^" + C + "$", "i") : C;
      }
      function o(C, g) {
        return C === g ? g : C === C.toLowerCase() ? g.toLowerCase() : C === C.toUpperCase() ? g.toUpperCase() : C[0] === C[0].toUpperCase() ? g.charAt(0).toUpperCase() + g.substr(1).toLowerCase() : g.toLowerCase();
      }
      function D(C, g) {
        return C.replace(/\$(\d{1,2})/g, function(x, d) {
          return g[d] || "";
        });
      }
      function E(C, g) {
        return C.replace(g[0], function(x, d) {
          var h = D(g[1], arguments);
          return o(x === "" ? C[d - 1] : x, h);
        });
      }
      function p(C, g, x) {
        if (!C.length || n.hasOwnProperty(C))
          return g;
        for (var d = x.length; d--; ) {
          var h = x[d];
          if (h[0].test(g)) return E(g, h);
        }
        return g;
      }
      function m(C, g, x) {
        return function(d) {
          var h = d.toLowerCase();
          return g.hasOwnProperty(h) ? o(d, h) : C.hasOwnProperty(h) ? o(d, C[h]) : p(h, d, x);
        };
      }
      function c(C, g, x, d) {
        return function(h) {
          var F = h.toLowerCase();
          return g.hasOwnProperty(F) ? !0 : C.hasOwnProperty(F) ? !1 : p(F, F, x) === F;
        };
      }
      function f(C, g, x) {
        var d = g === 1 ? f.singular(C) : f.plural(C);
        return (x ? g + " " : "") + d;
      }
      return f.plural = m(
        a,
        i,
        s
      ), f.isPlural = c(
        a,
        i,
        s
      ), f.singular = m(
        i,
        a,
        r
      ), f.isSingular = c(
        i,
        a,
        r
      ), f.addPluralRule = function(C, g) {
        s.push([l(C), g]);
      }, f.addSingularRule = function(C, g) {
        r.push([l(C), g]);
      }, f.addUncountableRule = function(C) {
        if (typeof C == "string") {
          n[C.toLowerCase()] = !0;
          return;
        }
        f.addPluralRule(C, "$0"), f.addSingularRule(C, "$0");
      }, f.addIrregularRule = function(C, g) {
        g = g.toLowerCase(), C = C.toLowerCase(), a[C] = g, i[g] = C;
      }, [
        // Pronouns.
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        // Words ending in with a consonant and `o`.
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        // Ends with `us`.
        ["genus", "genera"],
        ["viscus", "viscera"],
        // Ends with `ma`.
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        // Other irregular rules.
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(C) {
        return f.addIrregularRule(C[0], C[1]);
      }), [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(C) {
        return f.addPluralRule(C[0], C[1]);
      }), [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(C) {
        return f.addSingularRule(C[0], C[1]);
      }), [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        // "chinese", "japanese"
        /deer$/i,
        // "deer", "reindeer"
        /fish$/i,
        // "fish", "blowfish", "angelfish"
        /measles$/i,
        /o[iu]s$/i,
        // "carnivorous"
        /pox$/i,
        // "chickpox", "smallpox"
        /sheep$/i
      ].forEach(f.addUncountableRule), f;
    });
  })(Xt)), Xt.exports;
}
var Yd = Kd();
const Xd = /* @__PURE__ */ Au(Yd), Jd = ({
  preferVideoCoverPreviewOverride: e,
  thumbnailUrl: t,
  contextVideoCoverPreview: s
}) => e && s ? s : t, Qd = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, e2 = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, ki = ({
  src: e,
  forCarousel: t,
  showOverlay: s,
  showAll: r,
  setShowAll: n,
  mediaCount: i,
  url: a
  // override for the url we link to
}) => t ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsx(Xe, { href: a || e, $isFlex: !0, children: /* @__PURE__ */ u.jsx(e2, { src: e, className: "" }) }),
  !r && s && /* @__PURE__ */ u.jsxs("div", { className: "sp-cursor-pointer", onClick: () => n(!0), children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ u.jsx(Xe, { href: a || e, children: /* @__PURE__ */ u.jsx(Qd, { src: e, title: "Click to see the full file in a new window." }) }), u2 = ({
  url: e,
  thumbnailUrl: t,
  isActiveSlide: s,
  shouldUseVideoCoverPreviewOverride: r,
  width: n,
  height: i
}) => {
  const [a, l] = re(!1), {
    videoCoverPreview: o,
    preferVideoCoverPreviewOverride: D
  } = Fa(sn), E = Jd({
    preferVideoCoverPreviewOverride: D && r,
    thumbnailUrl: t,
    contextVideoCoverPreview: o
  }), {
    videoCoverPreview: p,
    showVideoCover: m
  } = rn({
    usePostTypeCheck: !1,
    videoCoverPreviewOverride: E
  }), c = n && i && n > 0 && i > 0 ? `${n} / ${i}` : null;
  if (!s)
    return null;
  const f = (g) => {
    console.error("Error loading video", g), l(!0);
  };
  return /* @__PURE__ */ u.jsxs(s2, { className: "sp-flex sp-items-center sp-h-full", style: c ? {
    aspectRatio: c
  } : void 0, children: [
    a && /* @__PURE__ */ u.jsx("div", { className: "sp-text-xl sp-text-red-500 sp-mx-auto", children: "Failed to load this video." }),
    !a && /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, light: m ? p : void 0, playing: !!p, onError: (g) => f(g), className: "sp-relative react-player", width: "100%", height: "100%" })
  ] });
}, zo = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showOverlay: r,
  showAll: n,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: l = !0,
  shouldUseVideoCoverPreviewOverride: o = !1
}) => t && n === !1 ? null : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(u2, { url: e.url, thumbnailUrl: e.thumbnailUrl, isActiveSlide: l, shouldUseVideoCoverPreviewOverride: o, width: e.width, height: e.height }),
  !(e.isVideo || e.url.includes(".mp4") || e.url.includes(".pdf")) && /* @__PURE__ */ u.jsx(ki, { src: e.url, forCarousel: s, showOverlay: r ?? !1, showAll: n ?? !1, setShowAll: i, mediaCount: a }),
  e.url.includes(".pdf") && /* @__PURE__ */ u.jsxs("div", { children: [
    /* @__PURE__ */ u.jsxs(r2, { children: [
      /* @__PURE__ */ u.jsx("span", { className: "filename", title: e.fileName, children: e.fileName }),
      /* @__PURE__ */ u.jsx("span", { className: "dot", children: "●" }),
      /* @__PURE__ */ u.jsx("span", { className: "pages", children: Xd("page", e.pages, !0) }),
      /* @__PURE__ */ u.jsxs(n2, { children: [
        /* @__PURE__ */ u.jsx(Gd, {}),
        /* @__PURE__ */ u.jsx(i2, { id: "tooltip", children: /* @__PURE__ */ u.jsxs(Wd, { arrowPosition: "bottom", backgroundColor: "#1A1A1A", width: "250px", children: [
          "Previewing Page 1 of ",
          e.pages,
          ". The complete document will be posted to LinkedIn."
        ] }) })
      ] })
    ] }),
    e.thumbnailUrl !== void 0 && /* @__PURE__ */ u.jsx(ki, { src: e.thumbnailUrl, url: e.url, forCarousel: !1, mediaCount: a, showAll: n ?? !1, setShowAll: i, showOverlay: r ?? !1 }),
    /* @__PURE__ */ u.jsx(t2, { children: /* @__PURE__ */ u.jsx("a", { href: e.url, target: "_blank", rel: "noreferrer", children: "Click to download and view the full document in a new tab." }) })
  ] })
] }), t2 = _.span`
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: flex;
`, s2 = _.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #000;

  .react-player {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player > div {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player__preview {
    width: 100%;
    height: 100%;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
`, r2 = _.div`
  background: rgba(0, 0, 0, 0.4);
  padding: 4px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  .filename {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }

  .dot {
    padding: 0 4px 0 6px;
    font-size: 6px;
    position: relative;
    top: 1px;
    line-height: 16px;
  }

  .pages {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }

  svg {
    position: relative;
    top: 2px;
    margin-left: 4px;
  }
`, n2 = _.div`
  position: relative;
  display: inline-block;
  line-height: normal;

  svg {
    &:hover + #tooltip {
      display: block;
    }
  }
`, i2 = _.div`
  display: none;
  position: absolute;
  top: -60px;
  left: calc(-250px / 2 + 12px);
`, a2 = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, o2 = ({
  medias: e
}) => {
  const [t, s] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: e.map((r, n) => !t && n > 3 ? null : /* @__PURE__ */ u.jsx(a2, { className: "sp-relative", children: /* @__PURE__ */ u.jsx(zo, { media: r, forCarousel: !0, hidden: n > 3, mediaCount: e.length, shouldUseVideoCoverPreviewOverride: n === 0, showOverlay: n === 3 && e.length > 4, showAll: t, setShowAll: s }) }, `fb-media-key-${n}`)) });
}, l2 = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-w-full sp-items-center sp-justify-center sp-py-4 sp-text-gray-700 sp-font-bold", children: [
  /* @__PURE__ */ u.jsx(ir, { icon: "icon-linkedin-like", text: "Like", className: "sp-justify-start sp-ml-2" }, "ico-like"),
  /* @__PURE__ */ u.jsx(ir, { icon: "icon-linkedin-comment", text: "Comment", className: "sp-justify-center" }, "ico-comment"),
  /* @__PURE__ */ u.jsx(ir, { icon: "icon-linkedin-share", text: "Share", className: "sp-justify-end sp-mr-2" }, "ico-share")
] }), ir = ({
  icon: e,
  text: t,
  className: s = ""
}) => /* @__PURE__ */ u.jsxs(ft, { $variant: "icons", className: `sp-flex sp-items-center sp-w-1/3 ${s}`, children: [
  /* @__PURE__ */ u.jsx("div", { className: `sp-mr-1 sp-text-2xl ${e}` }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-text-gray-700 sp-text-xl", children: t })
] }), c2 = ({
  medias: e,
  postType: t
}) => {
  let s = e?.collection || [];
  if (t === "document")
    if (s.length === 0)
      s.push({});
    else {
      const i = e?.medias?.[0];
      i && (s[0].thumbnailUrl = i.thumbnailUrl, s[0].fileName = i.fileName, s[0].pages = i.meta?.pages, s[0].url = i.url);
    }
  t === "multiMedia" && s.length > 0 && (s = s.filter((i) => !i.url.includes(".pdf")));
  const r = s.length, n = r > 1;
  return /* @__PURE__ */ u.jsxs("div", { children: [
    r > 0 && /* @__PURE__ */ u.jsx(u.Fragment, { children: n ? /* @__PURE__ */ u.jsx(o2, { medias: s }) : /* @__PURE__ */ u.jsx(zo, { media: s[0], mediaCount: r, shouldUseVideoCoverPreviewOverride: !0, setShowAll: () => {
    }, forCarousel: !1, showAll: !1, hidden: !1, isActiveSlide: !0, showOverlay: !1 }) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ u.jsx(l2, {}) })
  ] });
}, D2 = ({
  post: e,
  trackEvent: t
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
  /* @__PURE__ */ u.jsx(Hd, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName }),
  e.caption && /* @__PURE__ */ u.jsxs(ft, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words sp-flex sp-flex-col sp-m-8", children: [
    /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "LI", trackEvent: t }),
    e.redirectUrl && e.type !== "text" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      " ",
      /* @__PURE__ */ u.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: e.redirectUrl, target: "_blank", children: e.redirectUrl })
    ] })
  ] }),
  e.type === "text" && e.redirectUrl && /* @__PURE__ */ u.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ u.jsx(Cs, { url: e.redirectUrl }) }),
  /* @__PURE__ */ u.jsx(c2, { medias: e.medias, postType: e.type }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: e.comment && /* @__PURE__ */ u.jsxs(ft, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
    /* @__PURE__ */ u.jsx("span", { className: "sp-font-bold sp-mr-1", children: e.username }),
    /* @__PURE__ */ u.jsx(le, { caption: e.comment, targetPlatform: "LI" })
  ] }) })
] }), p2 = ({
  post: e,
  trackEvent: t
}) => {
  switch (e.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "document":
      return /* @__PURE__ */ u.jsx(D2, { post: e, trackEvent: t });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, cu = _.span`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "buttonlabel":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
  }
}};
`, Su = _.div`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          color: rgba(0,0,0,.54);
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
    case "title":
      return `
          font-style: normal;
          font-weight: medium;
          font-size: 20px;
          line-height: 28px;
        `;
    case "subtitle":
      return `
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
        `;
  }
}};
`, d2 = _(We)`
  display: inherit;

  img {
    border-radius: 50%;
  }
`, f2 = ({
  username: e,
  profilePicture: t
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-pb-4", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-mr-1", style: {
    width: "38x",
    height: "38px"
  }, children: [
    /* @__PURE__ */ u.jsx(d2, { src: t, alt: e }),
    /* @__PURE__ */ u.jsx("div", { style: {
      position: "relative",
      top: "25px",
      right: "25%",
      marginLeft: "auto",
      fill: "#1a73e8",
      lineHeight: "18px",
      height: "18px"
    }, children: /* @__PURE__ */ u.jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", style: {
      height: "18px"
    }, children: /* @__PURE__ */ u.jsx("path", { stroke: "#fff", d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" }) }) })
  ] }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-justify-center sp-leading-tight ", style: {
    width: "auto",
    height: "36px"
  }, children: [
    /* @__PURE__ */ u.jsx(Su, { $variant: "heading", className: "", children: e }),
    /* @__PURE__ */ u.jsx(Su, { $variant: "subheading", className: "", children: "a minute ago" })
  ] })
] });
var ar = {}, or = { exports: {} }, lr = { exports: {} }, Ni;
function h2() {
  return Ni || (Ni = 1, (function(e) {
    function t(s) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(s);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(lr)), lr.exports;
}
var Ti;
function Lr() {
  return Ti || (Ti = 1, (function(e) {
    var t = h2().default;
    function s(r, n) {
      if (typeof WeakMap == "function") var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
      return (e.exports = s = function(o, D) {
        if (!D && o && o.__esModule) return o;
        var E, p, m = {
          __proto__: null,
          default: o
        };
        if (o === null || t(o) != "object" && typeof o != "function") return m;
        if (E = D ? a : i) {
          if (E.has(o)) return E.get(o);
          E.set(o, m);
        }
        for (var c in o) c !== "default" && {}.hasOwnProperty.call(o, c) && ((p = (E = Object.defineProperty) && Object.getOwnPropertyDescriptor(o, c)) && (p.get || p.set) ? E(m, c, p) : m[c] = o[c]);
        return m;
      }, e.exports.__esModule = !0, e.exports.default = e.exports)(r, n);
    }
    e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(or)), or.exports;
}
var cr = { exports: {} }, Si;
function Vo() {
  return Si || (Si = 1, (function(e) {
    function t(s) {
      return s && s.__esModule ? s : {
        default: s
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(cr)), cr.exports;
}
var Dr = { exports: {} }, Pi;
function Wo() {
  return Pi || (Pi = 1, (function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(s) {
        for (var r = 1; r < arguments.length; r++) {
          var n = arguments[r];
          for (var i in n) ({}).hasOwnProperty.call(n, i) && (s[i] = n[i]);
        }
        return s;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Dr)), Dr.exports;
}
var pr = {}, dr = {}, Ii;
function F2() {
  return Ii || (Ii = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.translate = a, e.infiniteIndex = l, e.clampNumber = o, e.default = m;
    var t = "linear", s = 50, r = "transitionend", n = Math.abs, i = {
      passive: !1
    };
    function a(c, f, C) {
      C === void 0 && (C = 100);
      var g = c * C * -1, x = f ? "calc(" + g + "% - " + f + "px)" : g + "%";
      return "translate3d(" + x + ", 0, 0)";
    }
    function l(c, f) {
      return c < 0 ? f - 1 : c >= f ? 0 : c;
    }
    function o(c, f, C) {
      return Math.min(Math.max(c, f), C);
    }
    function D(c) {
      return c.targetTouches ? c.targetTouches[0] : c.touches[0];
    }
    function E(c, f, C, g, x) {
      var d = f !== "" ? "transition-timing-function: " + f + ";" : "", h = c ? "transition-duration: " + c + "ms;" : "";
      return "" + d + h + "transform: " + a(C, g, x) + ";";
    }
    function p(c) {
      for (; c.childElementCount > 1; )
        c !== null && c.removeChild(c.lastChild);
      return !0;
    }
    function m(c, f) {
      var C = f.doAfterSlide, g = f.doBeforeSlide, x = f.ease, d = f.infiniteLoop, h = f.initialSlide, F = f.numOfSlides, A = f.onNext, B = f.onPrev, w = f.slidesDOMEl, k = f.slideSpeed, U = f.items;
      if (c === null) return;
      var L = h, T = !1, S = 0, I = 0, j = 0, R = 0;
      function q(H, G, te) {
        G === void 0 && (G = ""), te === void 0 && (te = 0);
        var $ = 100 / F;
        w.style.cssText = E(H, G, L, te, $);
      }
      function ie(H) {
        var G = H === !0 ? 1 : -1, te = L + 1 * G;
        d && (te = l(te, U)), te = o(te, 0, U - 1), z(te);
      }
      function ne() {
      }
      function O(H) {
        var G = D(H);
        T = void 0, j = G.pageX, R = G.pageY;
      }
      function b(H) {
        if (!(H.touches.length > 1 || H.scale && H.scale !== 1)) {
          var G = D(H);
          if (S = G.pageX - j, I = G.pageY - R, typeof T > "u") {
            T = n(S) < n(I), T || (document.ontouchmove = function(te) {
              return te.preventDefault();
            });
            return;
          }
          T || (H.preventDefault(), q(0, t, S * -1));
        }
      }
      function N() {
        if (document.ontouchmove = function() {
          return !0;
        }, !T) {
          var H = n(S) > s, G = S < 0, te = G === !1 && L === 0 || G === !0 && L === U - 1;
          H === !0 && te === !1 ? ie(G) : q(k, t);
        }
        S = I = j = R = 0;
      }
      function M() {
        w.addEventListener(r, ne), c.addEventListener("touchstart", O, i), c.addEventListener("touchmove", b, i), c.addEventListener("touchend", N, i), L !== 0 && q(0);
      }
      function W() {
        return p(w);
      }
      function z(H) {
        H !== L && (H <= U && (g({
          currentSlide: L,
          nextSlide: H
        }), H > L ? A(H) : B(H), L = H), q(k, x), w.addEventListener(r, function G(te) {
          C({
            currentSlide: L
          }), te.currentTarget.removeEventListener(te.type, G);
        }));
      }
      function Y(H) {
        H.preventDefault(), H.stopPropagation(), ie(!1);
      }
      function K(H) {
        H.preventDefault(), H.stopPropagation(), ie(!0);
      }
      function X(H) {
        U = H;
      }
      function J() {
        c.removeEventListener("touchstart", O, i), c.removeEventListener("touchmove", b, i), c.removeEventListener("touchend", N, i), w.removeEventListener(r, ne);
      }
      return M(), {
        clean: W,
        destroy: J,
        goTo: z,
        next: K,
        prev: Y,
        slide: ie,
        updateItems: X
      };
    }
  })(dr)), dr;
}
var Oi;
function m2() {
  return Oi || (Oi = 1, (function(e) {
    var t = Lr(), s = Vo();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = m;
    var r = s(Wo()), n = t(ee), i = s(F2()), a = Vr();
    n.default.createElement;
    function l(c) {
    }
    function o(c) {
      return Array.isArray(c) ? c : [c];
    }
    function D(c) {
      var f = c.index, C = c.maxIndex, g = c.items, x = c.itemsToPreload, d = c.numOfSlides, h = Math.max(x, d);
      if (f >= g.length - d) {
        var F = g.length > d ? g.slice(0, d - 1) : [];
        return [].concat(g.slice(0, C + h), F);
      } else
        return g.slice(0, C + h);
    }
    function E(c, f) {
      c && c.clean() && c.destroy(), f();
    }
    var p = function(f) {
      return function(C, g) {
        var x = f !== 1 ? {
          width: 100 / f + "%"
        } : {};
        return /* @__PURE__ */ (0, a.jsx)("li", {
          style: x,
          children: C
        }, g);
      };
    };
    function m(c) {
      var f = c.ArrowLeft, C = c.ArrowRight, g = c.children, x = c.classNameBase, d = c.doAfterDestroy, h = c.doAfterInit, F = c.doAfterSlide, A = c.doBeforeSlide, B = c.ease, w = c.infiniteLoop, k = c.initialSlide, U = c.itemsToPreload, L = c.keyboardNavigation, T = c.numOfSlides, S = c.showArrows, I = c.slide, j = c.slideSpeed, R = (0, n.useState)({
        goTo: l,
        next: l,
        prev: l,
        updateItems: l
      }), q = R[0], ie = R[1], ne = (0, n.useState)(k), O = ne[0], b = ne[1], N = (0, n.useState)(k), M = N[0], W = N[1], z = (0, n.useRef)(null), Y = (0, n.useRef)(null), K = o(g);
      (0, n.useEffect)(
        function() {
          I !== O && q.goTo(I);
        },
        [I]
        // eslint-disable-line
      ), (0, n.useEffect)(
        function() {
          var $, he = (0, i.default)(z.current, {
            ease: B,
            doAfterSlide: F,
            doBeforeSlide: A,
            numOfSlides: T,
            slideSpeed: j,
            infiniteLoop: w,
            slidesDOMEl: Y.current,
            initialSlide: O,
            items: K.length,
            onNext: function(fe) {
              return b(fe), fe > M && W(fe), fe;
            },
            onPrev: function(fe) {
              return b(fe), fe;
            }
          });
          return ie(he), h(), L && ($ = function(fe) {
            fe.keyCode === 39 ? he.next(fe) : fe.keyCode === 37 && he.prev(fe);
          }, document.addEventListener("keydown", $)), function() {
            E(he, d), L && document.removeEventListener("keydown", $);
          };
        },
        []
        // eslint-disable-line
      ), (0, n.useEffect)(function() {
        q && q.updateItems(K.length);
      });
      var X = D({
        index: O,
        maxIndex: M,
        items: K,
        itemsToPreload: U,
        numOfSlides: T
      }), J = function(he) {
        return q.prev(he);
      }, H = function(he) {
        return K.length > T && q.next(he);
      }, G = function() {
        var he = O === 0 && !w, we = {
          disabled: he,
          onClick: J
        }, fe = x + "-arrow " + x + "-arrowLeft";
        return f ? /* @__PURE__ */ (0, a.jsx)(f, (0, r.default)({}, we, {
          className: fe
        })) : /* @__PURE__ */ (0, a.jsx)("span", (0, r.default)({
          "aria-label": "Previous",
          className: fe + " " + x + "-prev",
          role: "button"
        }, we));
      }, te = function() {
        var he = (K.length <= T || O === K.length - 1) && !w, we = {
          disabled: he,
          onClick: H
        }, fe = x + "-arrow " + x + "-arrowRight";
        return C ? /* @__PURE__ */ (0, a.jsx)(C, (0, r.default)({}, we, {
          className: fe
        })) : /* @__PURE__ */ (0, a.jsx)("span", (0, r.default)({
          "aria-label": "Next",
          className: fe + " " + x + "-next",
          role: "button"
        }, we));
      };
      return /* @__PURE__ */ (0, a.jsxs)(a.Fragment, {
        children: [S && /* @__PURE__ */ (0, a.jsxs)(a.Fragment, {
          children: [G(), te()]
        }), /* @__PURE__ */ (0, a.jsx)("div", {
          ref: z,
          children: /* @__PURE__ */ (0, a.jsx)("ul", {
            ref: Y,
            children: X.map(p(T))
          })
        })]
      });
    }
  })(pr)), pr;
}
var Li = {}, Ri;
function C2() {
  return Ri || (Ri = 1, (function() {
    if (typeof window != "object")
      return;
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        "isIntersecting",
        {
          get: function() {
            return this.intersectionRatio > 0;
          }
        }
      );
      return;
    }
    var e = window.document, t = [], s = null, r = null;
    function n(d) {
      this.time = d.time, this.target = d.target, this.rootBounds = c(d.rootBounds), this.boundingClientRect = c(d.boundingClientRect), this.intersectionRect = c(d.intersectionRect || m()), this.isIntersecting = !!d.intersectionRect;
      var h = this.boundingClientRect, F = h.width * h.height, A = this.intersectionRect, B = A.width * A.height;
      F ? this.intersectionRatio = Number((B / F).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    function i(d, h) {
      var F = h || {};
      if (typeof d != "function")
        throw new Error("callback must be a function");
      if (F.root && F.root.nodeType != 1)
        throw new Error("root must be an Element");
      this._checkForIntersections = l(
        this._checkForIntersections.bind(this),
        this.THROTTLE_TIMEOUT
      ), this._callback = d, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(F.rootMargin), this.thresholds = this._initThresholds(F.threshold), this.root = F.root || null, this.rootMargin = this._rootMarginValues.map(function(A) {
        return A.value + A.unit;
      }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
    }
    i.prototype.THROTTLE_TIMEOUT = 100, i.prototype.POLL_INTERVAL = null, i.prototype.USE_MUTATION_OBSERVER = !0, i._setupCrossOriginUpdater = function() {
      return s || (s = function(d, h) {
        !d || !h ? r = m() : r = f(d, h), t.forEach(function(F) {
          F._checkForIntersections();
        });
      }), s;
    }, i._resetCrossOriginUpdater = function() {
      s = null, r = null;
    }, i.prototype.observe = function(d) {
      var h = this._observationTargets.some(function(F) {
        return F.element == d;
      });
      if (!h) {
        if (!(d && d.nodeType == 1))
          throw new Error("target must be an Element");
        this._registerInstance(), this._observationTargets.push({ element: d, entry: null }), this._monitorIntersections(d.ownerDocument), this._checkForIntersections();
      }
    }, i.prototype.unobserve = function(d) {
      this._observationTargets = this._observationTargets.filter(function(h) {
        return h.element != d;
      }), this._unmonitorIntersections(d.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
    }, i.prototype.disconnect = function() {
      this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
    }, i.prototype.takeRecords = function() {
      var d = this._queuedEntries.slice();
      return this._queuedEntries = [], d;
    }, i.prototype._initThresholds = function(d) {
      var h = d || [0];
      return Array.isArray(h) || (h = [h]), h.sort().filter(function(F, A, B) {
        if (typeof F != "number" || isNaN(F) || F < 0 || F > 1)
          throw new Error("threshold must be a number between 0 and 1 inclusively");
        return F !== B[A - 1];
      });
    }, i.prototype._parseRootMargin = function(d) {
      var h = d || "0px", F = h.split(/\s+/).map(function(A) {
        var B = /^(-?\d*\.?\d+)(px|%)$/.exec(A);
        if (!B)
          throw new Error("rootMargin must be specified in pixels or percent");
        return { value: parseFloat(B[1]), unit: B[2] };
      });
      return F[1] = F[1] || F[0], F[2] = F[2] || F[0], F[3] = F[3] || F[1], F;
    }, i.prototype._monitorIntersections = function(d) {
      var h = d.defaultView;
      if (h && this._monitoringDocuments.indexOf(d) == -1) {
        var F = this._checkForIntersections, A = null, B = null;
        if (this.POLL_INTERVAL ? A = h.setInterval(F, this.POLL_INTERVAL) : (o(h, "resize", F, !0), o(d, "scroll", F, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in h && (B = new h.MutationObserver(F), B.observe(d, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        }))), this._monitoringDocuments.push(d), this._monitoringUnsubscribes.push(function() {
          var k = d.defaultView;
          k && (A && k.clearInterval(A), D(k, "resize", F, !0)), D(d, "scroll", F, !0), B && B.disconnect();
        }), d != (this.root && this.root.ownerDocument || e)) {
          var w = x(d);
          w && this._monitorIntersections(w.ownerDocument);
        }
      }
    }, i.prototype._unmonitorIntersections = function(d) {
      var h = this._monitoringDocuments.indexOf(d);
      if (h != -1) {
        var F = this.root && this.root.ownerDocument || e, A = this._observationTargets.some(function(k) {
          var U = k.element.ownerDocument;
          if (U == d)
            return !0;
          for (; U && U != F; ) {
            var L = x(U);
            if (U = L && L.ownerDocument, U == d)
              return !0;
          }
          return !1;
        });
        if (!A) {
          var B = this._monitoringUnsubscribes[h];
          if (this._monitoringDocuments.splice(h, 1), this._monitoringUnsubscribes.splice(h, 1), B(), d != F) {
            var w = x(d);
            w && this._unmonitorIntersections(w.ownerDocument);
          }
        }
      }
    }, i.prototype._unmonitorAllIntersections = function() {
      var d = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
      for (var h = 0; h < d.length; h++)
        d[h]();
    }, i.prototype._checkForIntersections = function() {
      if (!(!this.root && s && !r)) {
        var d = this._rootIsInDom(), h = d ? this._getRootRect() : m();
        this._observationTargets.forEach(function(F) {
          var A = F.element, B = p(A), w = this._rootContainsTarget(A), k = F.entry, U = d && w && this._computeTargetAndRootIntersection(A, B, h), L = F.entry = new n({
            time: a(),
            target: A,
            boundingClientRect: B,
            rootBounds: s && !this.root ? null : h,
            intersectionRect: U
          });
          k ? d && w ? this._hasCrossedThreshold(k, L) && this._queuedEntries.push(L) : k && k.isIntersecting && this._queuedEntries.push(L) : this._queuedEntries.push(L);
        }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
      }
    }, i.prototype._computeTargetAndRootIntersection = function(d, h, F) {
      if (window.getComputedStyle(d).display != "none") {
        for (var A = h, B = g(d), w = !1; !w && B; ) {
          var k = null, U = B.nodeType == 1 ? window.getComputedStyle(B) : {};
          if (U.display == "none") return null;
          if (B == this.root || B.nodeType == /* DOCUMENT */
          9)
            if (w = !0, B == this.root || B == e)
              s && !this.root ? !r || r.width == 0 && r.height == 0 ? (B = null, k = null, A = null) : k = r : k = F;
            else {
              var L = g(B), T = L && p(L), S = L && this._computeTargetAndRootIntersection(L, T, F);
              T && S ? (B = L, k = f(T, S)) : (B = null, A = null);
            }
          else {
            var I = B.ownerDocument;
            B != I.body && B != I.documentElement && U.overflow != "visible" && (k = p(B));
          }
          if (k && (A = E(k, A)), !A) break;
          B = B && g(B);
        }
        return A;
      }
    }, i.prototype._getRootRect = function() {
      var d;
      if (this.root)
        d = p(this.root);
      else {
        var h = e.documentElement, F = e.body;
        d = {
          top: 0,
          left: 0,
          right: h.clientWidth || F.clientWidth,
          width: h.clientWidth || F.clientWidth,
          bottom: h.clientHeight || F.clientHeight,
          height: h.clientHeight || F.clientHeight
        };
      }
      return this._expandRectByRootMargin(d);
    }, i.prototype._expandRectByRootMargin = function(d) {
      var h = this._rootMarginValues.map(function(A, B) {
        return A.unit == "px" ? A.value : A.value * (B % 2 ? d.width : d.height) / 100;
      }), F = {
        top: d.top - h[0],
        right: d.right + h[1],
        bottom: d.bottom + h[2],
        left: d.left - h[3]
      };
      return F.width = F.right - F.left, F.height = F.bottom - F.top, F;
    }, i.prototype._hasCrossedThreshold = function(d, h) {
      var F = d && d.isIntersecting ? d.intersectionRatio || 0 : -1, A = h.isIntersecting ? h.intersectionRatio || 0 : -1;
      if (F !== A)
        for (var B = 0; B < this.thresholds.length; B++) {
          var w = this.thresholds[B];
          if (w == F || w == A || w < F != w < A)
            return !0;
        }
    }, i.prototype._rootIsInDom = function() {
      return !this.root || C(e, this.root);
    }, i.prototype._rootContainsTarget = function(d) {
      return C(this.root || e, d) && (!this.root || this.root.ownerDocument == d.ownerDocument);
    }, i.prototype._registerInstance = function() {
      t.indexOf(this) < 0 && t.push(this);
    }, i.prototype._unregisterInstance = function() {
      var d = t.indexOf(this);
      d != -1 && t.splice(d, 1);
    };
    function a() {
      return window.performance && performance.now && performance.now();
    }
    function l(d, h) {
      var F = null;
      return function() {
        F || (F = setTimeout(function() {
          d(), F = null;
        }, h));
      };
    }
    function o(d, h, F, A) {
      typeof d.addEventListener == "function" ? d.addEventListener(h, F, A) : typeof d.attachEvent == "function" && d.attachEvent("on" + h, F);
    }
    function D(d, h, F, A) {
      typeof d.removeEventListener == "function" ? d.removeEventListener(h, F, A) : typeof d.detatchEvent == "function" && d.detatchEvent("on" + h, F);
    }
    function E(d, h) {
      var F = Math.max(d.top, h.top), A = Math.min(d.bottom, h.bottom), B = Math.max(d.left, h.left), w = Math.min(d.right, h.right), k = w - B, U = A - F;
      return k >= 0 && U >= 0 && {
        top: F,
        bottom: A,
        left: B,
        right: w,
        width: k,
        height: U
      } || null;
    }
    function p(d) {
      var h;
      try {
        h = d.getBoundingClientRect();
      } catch {
      }
      return h ? (h.width && h.height || (h = {
        top: h.top,
        right: h.right,
        bottom: h.bottom,
        left: h.left,
        width: h.right - h.left,
        height: h.bottom - h.top
      }), h) : m();
    }
    function m() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    function c(d) {
      return !d || "x" in d ? d : {
        top: d.top,
        y: d.top,
        bottom: d.bottom,
        left: d.left,
        x: d.left,
        right: d.right,
        width: d.width,
        height: d.height
      };
    }
    function f(d, h) {
      var F = h.top - d.top, A = h.left - d.left;
      return {
        top: F,
        left: A,
        height: h.height,
        width: h.width,
        bottom: F + h.height,
        right: A + h.width
      };
    }
    function C(d, h) {
      for (var F = h; F; ) {
        if (F == d) return !0;
        F = g(F);
      }
      return !1;
    }
    function g(d) {
      var h = d.parentNode;
      return d.nodeType == /* DOCUMENT */
      9 && d != e ? x(d) : h && h.nodeType == 11 && h.host ? h.host : h && h.assignedSlot ? h.assignedSlot.parentNode : h;
    }
    function x(d) {
      try {
        return d.defaultView && d.defaultView.frameElement || null;
      } catch {
        return null;
      }
    }
    window.IntersectionObserver = i, window.IntersectionObserverEntry = n;
  })()), Li;
}
var $i;
function E2() {
  return $i || ($i = 1, (function(e) {
    var t = Lr(), s = Vo();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(Wo()), n = s(Lr()), i = t(ee), a = s(m2()), l = Vr();
    i.default.createElement;
    function o() {
    }
    var D = {
      contain: "react-Slidy--contain",
      cover: "react-Slidy--cover",
      fullHeight: "react-Slidy--fullHeight",
      fullWidth: "react-Slidy--fullWidth"
    }, E = function(c) {
      var f = c.ArrowLeft, C = c.ArrowRight, g = c.children, x = c.classNameBase, d = x === void 0 ? "react-Slidy" : x, h = c.doAfterDestroy, F = h === void 0 ? o : h, A = c.doAfterInit, B = A === void 0 ? o : A, w = c.doAfterSlide, k = w === void 0 ? o : w, U = c.doBeforeSlide, L = U === void 0 ? o : U, T = c.imageObjectFit, S = c.infiniteLoop, I = S === void 0 ? !1 : S, j = c.itemsToPreload, R = j === void 0 ? 1 : j, q = c.initialSlide, ie = q === void 0 ? 0 : q, ne = c.ease, O = ne === void 0 ? "ease" : ne, b = c.lazyLoadSlider, N = b === void 0 ? !0 : b, M = c.lazyLoadConfig, W = M === void 0 ? {
        offset: 150
      } : M, z = c.keyboardNavigation, Y = z === void 0 ? !1 : z, K = c.numOfSlides, X = K === void 0 ? 1 : K, J = c.sanitize, H = J === void 0 ? !0 : J, G = c.slide, te = G === void 0 ? 0 : G, $ = c.slideSpeed, he = $ === void 0 ? 500 : $, we = c.showArrows, fe = we === void 0 ? !0 : we, eu = c.useFullHeight, gt = eu === void 0 ? !1 : eu, qu = c.useFullWidth, Bu = qu === void 0 ? !0 : qu, vt = (0, i.useState)(!N), gs = vt[0], Zu = vt[1], yt = (0, i.useRef)(null);
      (0, i.useEffect)(
        function() {
          var iu;
          if (N) {
            var au = function() {
              var uu = W.offset, ys = uu === void 0 ? 0 : uu;
              iu = new window.IntersectionObserver(vs, {
                rootMargin: ys + "px 0px 0px"
              }), iu.observe(yt.current);
            };
            "IntersectionObserver" in window ? au() : Promise.resolve().then(function() {
              return (0, n.default)(C2());
            }).then(au);
          }
          return function() {
            return iu && iu.disconnect();
          };
        },
        []
        // eslint-disable-line
      );
      var vs = function(au, Ku) {
        var uu = au[0];
        (uu.isIntersecting || uu.intersectionRatio > 0) && (Ku.unobserve(uu.target), Zu(!0));
      }, Bt = Math.min(X, i.default.Children.count(g)), bt = [d, gt && D.fullHeight, Bu && D.fullWidth, T && D[T]].filter(Boolean).join(" "), wt = {
        ArrowLeft: f,
        ArrowRight: C,
        children: g,
        classNameBase: d,
        doAfterDestroy: F,
        doAfterInit: B,
        doAfterSlide: k,
        doBeforeSlide: L,
        ease: O,
        infiniteLoop: I,
        initialSlide: ie,
        itemsToPreload: R,
        keyboardNavigation: Y,
        numOfSlides: X,
        showArrows: fe,
        slide: te,
        slideSpeed: he
      };
      return /* @__PURE__ */ (0, l.jsx)("div", {
        className: bt,
        ref: yt,
        children: gs && /* @__PURE__ */ (0, l.jsx)(a.default, (0, r.default)({}, wt, {
          numOfSlides: H ? Bt : X,
          children: g
        }))
      });
    }, p = E;
    e.default = p;
  })(ar)), ar;
}
var x2 = E2();
const A2 = /* @__PURE__ */ Au(x2), g2 = _.img`
  object-fit: contain;
  position: relative;
  width: 100%;
  max-height: 290px;
`, Go = ({
  src: e
}) => /* @__PURE__ */ u.jsx(Xe, { href: e, children: /* @__PURE__ */ u.jsx(g2, { src: e }) }), qo = ({
  url: e
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-h-full", children: /* @__PURE__ */ u.jsx(Me, { url: e, playing: !1, loop: !0, controls: !0, className: "sp-w-full", width: "100%", height: "auto" }) }), v2 = ({
  media: e
}) => {
  const [t, s] = re(0), r = e.length, n = ({
    currentSlide: i
  }) => {
    s(i);
  };
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-text-white sp-bg-black sp-rounded-lg sp-p-2 sp-text-xl sp-w-auto sp-text-center", style: {
      opacity: 0.7,
      position: "absolute",
      right: "25px",
      zIndex: 100,
      top: "10px"
    }, children: /* @__PURE__ */ u.jsxs(cu, { children: [
      t + 1,
      " / ",
      r
    ] }) }),
    /* @__PURE__ */ u.jsx(A2, { imageObjectFit: "cover", useFullWidth: !0, numOfSlides: 1.1, itemsToPreload: 2, slideSpeed: 100, doAfterSlide: n, slide: t, children: e.map((i, a) => i.isVideo || i.url.includes(".mp4") ? /* @__PURE__ */ u.jsx("div", { className: "sp-p-2", children: /* @__PURE__ */ u.jsx(qo, { url: i.url }) }, `item-${a}`) : /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(Go, { src: i.url }, `item-${a}`) }, `item-${a}`)) })
  ] });
}, y2 = ({
  media: e
}) => e.length === 1 ? e[0].isVideo || e[0].url.includes(".mp4") ? /* @__PURE__ */ u.jsx(qo, { url: e[0].url }) : /* @__PURE__ */ u.jsx(Go, { src: e[0].url }) : /* @__PURE__ */ u.jsx(v2, { media: e }), B2 = ({
  medias: e
}) => {
  const t = e.collection, s = t.length;
  if (t && t.length > 0)
    return /* @__PURE__ */ u.jsx("div", { className: "sp-h-full sp-py-4", children: s && /* @__PURE__ */ u.jsx(y2, { media: t }) });
}, b2 = (e) => {
  switch (e) {
    case "BOOK":
      return "Book now";
    case "ORDER":
      return "Order online";
    case "SHOP":
      return "Buy";
    case "LEARN_MORE":
      return "Learn more";
    case "SIGN_UP":
      return "Sign up";
    case "CALL":
      return "Call now";
    default:
      return null;
  }
}, w2 = ({
  post: e
}) => {
  let t = null, s = null;
  e.event && e.event.startDate && (t = new Ze(e.event.startDate), s = new Ze(e.event.endDate));
  let r = e.caption;
  const n = b2(e.callToAction.actionType);
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pt-4 sp-pb-6 sp-px-6", children: [
    /* @__PURE__ */ u.jsx(f2, { username: e.username, profilePicture: e.profilePicture }),
    e.medias && e.medias.count > 0 && /* @__PURE__ */ u.jsx(B2, { medias: e.medias }),
    e.event && e.event.title && /* @__PURE__ */ u.jsxs(Su, { $variant: "title", children: [
      e.event.title,
      " ",
      e.topicType === "OFFER" && /* @__PURE__ */ u.jsx("span", { style: {
        display: "inline-block",
        height: "20px",
        width: "20px"
      }, children: /* @__PURE__ */ u.jsx("svg", { focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#f4b400", style: {
        height: "20px"
      }, children: /* @__PURE__ */ u.jsx("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" }) }) })
    ] }),
    t && e.topicType === "EVENT" && /* @__PURE__ */ u.jsx(Su, { $variant: "subtitle", className: "sp-text-googlegray-500 sp-font-light", children: `${Ze(t).format("MMM D, LT")} -  ${Ze(s).format("MMM D, LT")}` }),
    t && e.topicType === "OFFER" && /* @__PURE__ */ u.jsx(Su, { $variant: "subtitle", className: "", children: `Valid ${Ze(t).format("MMM D")} -  ${Ze(s).format("MMM D")}` }),
    r && /* @__PURE__ */ u.jsx(Su, { $variant: "caption", className: `sp-flex sp-flex-col sp-mt-6 sp-pb-6 ${t ? "sp-text-googlegray-500 sp-font-light" : null}`, style: {
      fontSize: t ? "13px" : ""
    }, children: /* @__PURE__ */ u.jsx(le, { caption: r }) }),
    e.topicType === "OFFER" && e.offer && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      e.offer.couponCode && /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-mb-6 sp-bg-googlegray-100 sp-border-dashed sp-border-googlegray-200 sp-p-6", children: [
        /* @__PURE__ */ u.jsx(cu, { className: "sp-text-googlegray-500 sp-text-xl sp-pb-2", children: "Show this code at the shop" }),
        /* @__PURE__ */ u.jsx(cu, { className: "sp-font-medium sp-text-5xl sp-pb-2", children: e.offer.couponCode }),
        /* @__PURE__ */ u.jsx(cu, { className: "sp-text-lg sp-font-bold", children: `Valid ${Ze(t).format("l, LT")} - ${Ze(s).format("l, LT")}` })
      ] }),
      e.offer.redeemOnlineUrl && /* @__PURE__ */ u.jsx("a", { href: e.offer.redeemOnlineUrl, className: "sp-text-blue-700 sp-no-underline sp-text-2xl", target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ u.jsx(cu, { children: "Redeem online" }) })
    ] }),
    e.callToAction && n && /* @__PURE__ */ u.jsx("div", { className: "sp-mb-2 sp-pt-4 sp-my-2", children: /* @__PURE__ */ u.jsx("a", { href: e.callToAction.url, target: "_blank", className: "sp-no-underline sp-inline", children: /* @__PURE__ */ u.jsx(cu, { $variant: "buttonlabel", style: {
      width: "auto"
    }, className: " sp-text-white sp-bg-googleblue-500 sp-py-4 sp-px-6 sp-text-xl sp-no-underline hover:sp-bg-googleblue-600 sp-rounded hover:sp-shadow-lg", children: n }) }) }),
    e.topicType === "OFFER" && e.offer && e.offer.termsConditions && /* @__PURE__ */ u.jsx("div", { className: "sp-border-googlegray-300 sp-border-solid sp-mt-4 sp-pt-4", style: {
      borderWidth: 0,
      borderTopWidth: "1px"
    }, children: /* @__PURE__ */ u.jsx(cu, { className: "sp-text-base sp-text-googlegray-400", children: e.offer.termsConditions }) })
  ] });
}, j2 = ({
  post: e
}) => {
  switch (e.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "gmb":
      return /* @__PURE__ */ u.jsx(w2, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Rr = _.div`
  font-family: Helvetica;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, _2 = ({
  username: e,
  profilePicture: t,
  small: s,
  description: r
}) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
    /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsx("div", { className: "", children: /* @__PURE__ */ u.jsx(Rr, { $variant: "subheading", className: "sp-mb-1", children: e }) }) })
  ] }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-ml-8 sp-mr-4", style: {
    paddingLeft: "40px"
  }, children: /* @__PURE__ */ u.jsx(Rr, { $variant: "caption", className: "sp-mb-1", children: /* @__PURE__ */ u.jsx(le, { caption: r }) }) })
] }), k2 = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-bg-black sp-relative", style: {}, children: /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, Zo = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showAll: r,
  isActiveSlide: n = !0
}) => t && r === !1 ? null : /* @__PURE__ */ u.jsx(u.Fragment, { children: (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(k2, { url: e.url, forCarousel: s, isActiveSlide: n }) }), N2 = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, T2 = ({
  medias: e
}) => {
  const [t, s] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: e.map((r, n) => !t && n > 3 ? null : /* @__PURE__ */ u.jsx(N2, { className: "sp-relative", children: /* @__PURE__ */ u.jsx(Zo, { media: r, forCarousel: !0, hidden: n > 3, mediaCount: e.length, showOverlay: n === 3 && e.length > 4, showAll: t, setShowAll: s }) }, `fb-media-key-${n}`)) });
}, S2 = ({
  medias: e
}) => {
  const t = e.collection, s = t.length, r = s > 1;
  return /* @__PURE__ */ u.jsx("div", { children: s > 0 && /* @__PURE__ */ u.jsx(u.Fragment, { children: r ? /* @__PURE__ */ u.jsx(T2, { medias: t, count: s }) : /* @__PURE__ */ u.jsx(Zo, { media: t[0] }) }) });
}, P2 = ({
  post: e
}) => {
  let t = e.ytTitle;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pb-4", children: [
    /* @__PURE__ */ u.jsx(S2, { medias: e.medias }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-mt-2 sp-mb-2 sp-flex sp-flex-col sp-border-0 sp-border-b sp-border-solid sp-border-gray-300", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-mt-4 sp-mb-6 sp-m-2", children: /* @__PURE__ */ u.jsx(Rr, { $variant: "heading", className: "sp-whitespace-pre-line sp-break-words", children: t }) }),
      /* @__PURE__ */ u.jsx("div", {})
    ] }),
    /* @__PURE__ */ u.jsx(_2, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName, description: e.caption })
  ] });
}, I2 = ({
  post: e
}) => {
  switch (e.type) {
    case "video":
      return /* @__PURE__ */ u.jsx(P2, { post: e });
    case "image":
    case "multiMedia":
    case "text":
    case "story":
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, fr = _.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 15px;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, et = _.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 13px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, O2 = ({
  username: e,
  boardTitle: t,
  boardSectionTitle: s,
  profilePicture: r,
  small: n,
  description: i,
  url: a,
  title: l
}) => {
  let o = null;
  if (a)
    try {
      const {
        hostname: D
      } = new URL(a);
      o = D;
    } catch {
    }
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-p-2 sp-px-4", children: [
      a && o && /* @__PURE__ */ u.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ u.jsxs(fr, { $variant: "caption", children: [
        "Article from",
        " ",
        /* @__PURE__ */ u.jsx("a", { href: a, target: "_blank", style: {
          color: "inherit",
          textDecoration: "none"
        }, rel: "noreferrer", children: /* @__PURE__ */ u.jsx(et, { $variant: "bold", children: o }) })
      ] }) }),
      l && /* @__PURE__ */ u.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ u.jsx(L2, { url: a, children: /* @__PURE__ */ u.jsx(fr, { $variant: "heading", children: l }) }) }),
      i && /* @__PURE__ */ u.jsx(fr, { $variant: "caption", children: /* @__PURE__ */ u.jsx(le, { caption: i, targetPlatform: "PI" }) })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-px-4", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-2", style: {
        width: "40px",
        height: "40px",
        minWidth: "40px",
        minHeight: "40px"
      }, children: /* @__PURE__ */ u.jsx(We, { src: r, alt: e }) }),
      /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsxs("div", { className: "", children: [
        /* @__PURE__ */ u.jsxs(et, { $variant: "bold", className: "sp-mb-1", children: [
          e,
          " "
        ] }),
        /* @__PURE__ */ u.jsx(et, { children: "saved to " }),
        s && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx(et, { $variant: "bold", className: "sp-mb-1", children: s }),
          " ",
          "in "
        ] }),
        /* @__PURE__ */ u.jsx(et, { $variant: "bold", className: "sp-mb-1", children: t })
      ] }) })
    ] })
  ] });
}, L2 = ({
  url: e,
  children: t
}) => e ? /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: t }) : /* @__PURE__ */ u.jsx("div", { children: t }), R2 = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
  border-radius: 20px;
`, $2 = ({
  src: e
}) => /* @__PURE__ */ u.jsx(R2, { src: e }), M2 = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-bg-black sp-relative", style: {
  borderRadius: "10px"
}, children: /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, U2 = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showAll: r,
  isActiveSlide: n = !0
}) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(M2, { url: e.url, forCarousel: s, isActiveSlide: n }) : /* @__PURE__ */ u.jsx($2, { src: e.url }), H2 = ({
  medias: e
}) => {
  const t = e.collection, s = t.length;
  return /* @__PURE__ */ u.jsx(z2, { children: s > 0 && /* @__PURE__ */ u.jsx(U2, { media: t[0] }) });
}, z2 = _.div`
  border-radius: 20px;
  overflow: hidden;
`, V2 = ({
  url: e,
  children: t
}) => e ? /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: t }) : /* @__PURE__ */ u.jsx("div", { children: t }), W2 = ({
  post: e
}) => /* @__PURE__ */ u.jsxs(G2, { className: "sp-bg-white md:sp-shadow-around sp-pb-4", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ u.jsx(V2, { url: e.redirectUrl, children: /* @__PURE__ */ u.jsx(H2, { medias: e.medias }) }) }),
  /* @__PURE__ */ u.jsx(O2, { username: e.username, small: !1, profilePicture: e.profilePicture, description: e.caption, title: e.piTitle, boardTitle: e.boardTitle, boardSectionTitle: e.boardSectionTitle, url: e.redirectUrl })
] }), G2 = _.div`
  padding: 35px 28px 28px;
`, q2 = ({
  post: e
}) => {
  switch (e.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ u.jsx(W2, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Z2 = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`, K2 = _.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, Y2 = ({
  src: e
}) => /* @__PURE__ */ u.jsx(K2, { src: e }), X2 = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-relative", children: /* @__PURE__ */ u.jsx(Me, { controls: !0, url: e, playing: !1, width: "100%", height: "auto", style: {
  display: "grid",
  placeContent: "center",
  minHeight: "600px",
  background: "grey"
} }) }) : null, J2 = ({
  media: e,
  hidden: t = !1,
  showAll: s,
  isActiveSlide: r = !0
}) => t && s === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(X2, { url: e.url, isActiveSlide: r }) : /* @__PURE__ */ u.jsx(Z2, { children: /* @__PURE__ */ u.jsx(Y2, { src: e.url }) }), Q2 = ({
  medias: e
}) => {
  const t = e.collection, s = t.length;
  return /* @__PURE__ */ u.jsx(ef, { children: s > 0 && /* @__PURE__ */ u.jsx(J2, { media: t[0] }) });
}, ef = _.div`
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: grey;
`, Ko = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, uf = (e) => /* @__PURE__ */ v.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "10 6 14 14", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_89)" }, /* @__PURE__ */ v.createElement("path", { d: "M23.6165 19.615C23.3689 19.8635 23.04 20 22.6891 20C22.3391 20 22.0093 19.8635 21.7617 19.615L19.4195 17.2735C18.4363 17.9069 17.2914 18.2435 16.1219 18.243C14.9112 18.2432 13.7277 17.8843 12.721 17.2118C11.7143 16.5392 10.9296 15.5832 10.4662 14.4647C10.0028 13.3462 9.88143 12.1153 10.1175 10.9278C10.3536 9.74027 10.9365 8.64946 11.7925 7.79325C12.6485 6.93706 13.7392 6.35396 14.9265 6.11769C16.1139 5.88142 17.3447 6.00259 18.4632 6.46589C19.5817 6.92919 20.5378 7.71379 21.2104 8.72049C21.883 9.72718 22.242 10.9107 22.242 12.1215C22.2426 13.2902 21.907 14.4344 21.2752 15.4176L23.6165 17.76C23.8621 18.0062 24 18.3398 24 18.6875C24 19.0352 23.8621 19.3688 23.6165 19.615ZM16.1219 8.625C15.6628 8.625 15.2081 8.71545 14.7839 8.89116C14.3598 9.06687 13.9743 9.32442 13.6497 9.6491C13.325 9.97378 13.0675 10.3592 12.8918 10.7834C12.7161 11.2077 12.6257 11.6623 12.6257 12.1215C12.6257 12.5807 12.7161 13.0353 12.8918 13.4595C13.0675 13.8838 13.325 14.2692 13.6497 14.5939C13.9743 14.9186 14.3598 15.1761 14.7839 15.3519C15.2081 15.5276 15.6628 15.618 16.1219 15.618C17.0493 15.618 17.9387 15.2496 18.5944 14.5938C19.2502 13.938 19.6186 13.0485 19.6186 12.1211C19.6186 11.1936 19.2502 10.3042 18.5944 9.64836C17.9387 8.99256 17.0493 8.62412 16.1219 8.62412V8.625Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_89", x: 0, y: 0, width: 34, height: 34, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_89" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_89", result: "shape" })))), tf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M14.0463 1.18364C13.2625 0.399877 12.2228 0 11.1831 0C10.1435 0 9.11978 0.399877 8.32003 1.18364L7.64823 1.85543L6.97644 1.18364C6.19268 0.399877 5.153 0 4.11332 0C2.46583 0 0.834332 0.991695 0.178533 2.95909C-0.253334 4.28668 0.114553 5.75823 1.10625 6.74992L7.15239 12.7961C7.4243 13.068 7.84018 13.068 8.11209 12.7961L14.0143 6.89388C15.6298 5.32636 15.6298 2.75115 14.0463 1.18364Z", fill: "white" })), sf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M1.68328 11.6584C0.823728 12.0881 -0.0881374 11.1763 0.34164 10.3167L1.5049 7.99021C2.12365 6.7527 2.05895 5.2833 1.33382 4.10496L0.201123 2.26433C-0.314794 1.42596 0.56357 0.425049 1.46184 0.827721L11.0744 5.13679C11.8442 5.48188 11.8671 6.56645 11.1125 6.94373L1.68328 11.6584Z", fill: "white" })), rf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ v.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ v.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), nf = (e) => /* @__PURE__ */ v.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 14 8", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_103)" }, /* @__PURE__ */ v.createElement("path", { d: "M21 7C20.7545 7 20.5556 7.19899 20.5556 7.44444V9.55555H18.4444C18.199 9.55555 18 9.75453 18 10C18 10.2455 18.199 10.4444 18.4444 10.4444H20.5556V12.5556C20.5556 12.801 20.7545 13 21 13C21.2455 13 21.4444 12.801 21.4444 12.5556V10.4444H23.5555C23.801 10.4444 24 10.2455 24 10C24 9.75453 23.801 9.55555 23.5555 9.55555H21.4444V7.44444C21.4444 7.19899 21.2455 7 21 7Z", fill: "white" }), /* @__PURE__ */ v.createElement("path", { d: "M10.8872 14C11.0037 14.0002 11.1191 13.9808 11.2267 13.9429C11.3343 13.9051 11.432 13.8495 11.5141 13.7794L13.5 12.0955L15.4782 13.7729C15.6019 13.8802 15.7606 13.9537 15.9339 13.984C16.1072 14.0143 16.2872 13.9999 16.4508 13.9427C16.6144 13.8856 16.7541 13.7883 16.852 13.6633C16.9498 13.5383 17.0014 13.3913 17 13.2413V7.16129C17 6.8533 16.8557 6.55792 16.5988 6.34013C16.342 6.12235 15.9936 6 15.6304 6H11.3696C11.0063 6 10.658 6.12235 10.4011 6.34013C10.1443 6.55792 10 6.8533 10 7.16129V13.2477C10.0004 13.4471 10.094 13.6383 10.2603 13.7793C10.4266 13.9203 10.652 13.9997 10.8872 14ZM10.913 7.16129C10.913 7.05863 10.9611 6.96017 11.0468 6.88757C11.1324 6.81498 11.2485 6.77419 11.3696 6.77419H15.6304C15.7515 6.77419 15.8676 6.81498 15.9532 6.88757C16.0388 6.96017 16.0869 7.05863 16.0869 7.16129V13.1948L13.5 11.0013L10.913 13.1948V7.16129Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_103", x: 0, y: 0, width: 34, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_103" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_103", result: "shape" })))), af = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, of = _(Ko)`
  position: absolute;
  top: 17px;
  z-index: 2;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
    font-size: 16px;
  }

  svg {
    position: relative;
    left: -50%;
    width: 14px;
  }
`, lf = _.div`
  position: absolute;
  right: 7px;
  bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 15px;
  }
`, hr = _.div`
  width: 32px;
  display: grid;
  place-content: center;
  height: 32px;
`, Fr = _.div`
  width: 32px;
  height: 32px;
  opacity: 0.2;
  border-radius: 50%;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: white;
  position: absolute;
`, cf = _.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 22px;
  height: 22px;
  border-radius: 50%;
`, Df = _.div`
  position: absolute;
  z-index: 2;
  padding: 7px;
  display: flex;
  align-items: center;
  height: 22px;
  gap: 4px;
  bottom: 45px;

  p {
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  }

  .bookmarkIconWrap {
    position: relative;
    top: -2px;
    left: 4px;
    height: 8px;

    svg {
      height: 8px;
    }
  }
`, pf = ({
  url: e,
  children: t
}) => e ? /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: t }) : /* @__PURE__ */ u.jsx("div", { children: t }), df = ({
  medias: e,
  profilePicture: t,
  username: s
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ u.jsxs(of, { children: [
    /* @__PURE__ */ u.jsx(uf, {}),
    /* @__PURE__ */ u.jsx("span", { children: "Spotlight You" })
  ] }) }),
  /* @__PURE__ */ u.jsx(Q2, { medias: e }),
  /* @__PURE__ */ u.jsxs(lf, { children: [
    /* @__PURE__ */ u.jsxs(hr, { children: [
      /* @__PURE__ */ u.jsx(Fr, {}),
      /* @__PURE__ */ u.jsx(tf, {})
    ] }),
    /* @__PURE__ */ u.jsxs(hr, { children: [
      /* @__PURE__ */ u.jsx(Fr, {}),
      /* @__PURE__ */ u.jsx(sf, {})
    ] }),
    /* @__PURE__ */ u.jsxs(hr, { children: [
      /* @__PURE__ */ u.jsx(Fr, {}),
      /* @__PURE__ */ u.jsx(rf, {})
    ] })
  ] }),
  /* @__PURE__ */ u.jsxs(Df, { children: [
    /* @__PURE__ */ u.jsx(cf, { $profilePicture: t }),
    /* @__PURE__ */ u.jsxs(Ko, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      s
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "bookmarkIconWrap", children: /* @__PURE__ */ u.jsx(nf, {}) })
  ] })
] }), ff = ({
  post: e
}) => /* @__PURE__ */ u.jsx(af, { children: /* @__PURE__ */ u.jsx(pf, { url: e.redirectUrl, children: /* @__PURE__ */ u.jsx(df, { medias: e.medias, username: e.username, profilePicture: e.profilePicture }) }) }), hf = ({
  post: e
}) => {
  switch (e.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ u.jsx(ff, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Ff = _.img`
  display: block;
  object-fit: contain;
  position: relative;
  width: 100%;
`, mf = ({
  url: e,
  isActiveSlide: t,
  videoCoverPreview: s
}) => {
  const [r, n] = re(!1), [i, a] = re(!1), [l, o] = re(0);
  return hu(() => {
    s && (n(!1), a(!1), o((D) => D + 1));
  }, [s]), t ? /* @__PURE__ */ u.jsxs(Cf, { className: "sp-relative", style: {
    minHeight: "500px",
    width: "100%"
  }, children: [
    !r && i && /* @__PURE__ */ u.jsx(Ef, { children: /* @__PURE__ */ u.jsx(ko, { onClick: () => {
      n(!1), a(!1), o((D) => D + 1);
    } }) }),
    /* @__PURE__ */ u.jsx(Me, { playing: !!s, onPlay: () => {
      n(!0), a(!0);
    }, onPause: () => n(!1), controls: !0, light: s, url: e, width: "100%", height: "auto", style: {
      display: s ? "flex" : "grid",
      placeContent: "center",
      minHeight: "500px",
      background: "grey"
    } }, l)
  ] }) : null;
}, Cf = _.div`
  min-height: 500px;
  width: 100%;

  .react-player__preview {
    height: calc(-280px + 100vh) !important;
    background-repeat: no-repeat !important;
  }
`, Ef = _.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, Yo = ({
  media: e,
  hidden: t = !1,
  showAll: s,
  isActiveSlide: r = !0,
  videoCoverPreview: n
}) => t && s === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(mf, { url: e.url, isActiveSlide: r, videoCoverPreview: n }) : /* @__PURE__ */ u.jsx(Ff, { src: e.url }), xf = ({
  current: e,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { style: {
  backgroundColor: `${e ? "#FFFFFF" : "#C4C4C4"}`
}, className: `
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out
    sp-cursor-pointer
    `, ...t }), Af = ({
  count: e,
  current: t,
  titleCaptionHeight: s,
  onChange: r,
  isMultipleLinesDetected: n
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-absolute", style: {
  bottom: s - 3,
  left: 0,
  right: 0,
  backgroundColor: n ? "black" : void 0,
  height: 40
}, children: /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4 sp-absolute", style: {
  left: "50%",
  transform: "translateX(-50%)",
  bottom: 0
}, id: "dottt", children: [...Array(e)].map((i, a) => /* @__PURE__ */ u.jsx(xf, { current: a + 1 === t, onClick: () => {
  r(a + 1);
} }, a)) }) }), gf = ({
  medias: e,
  count: t,
  titleCaptionHeight: s,
  isMultipleLinesDetected: r
}) => {
  const [n, i] = re(1);
  hu(() => {
    n > e.length && i(e.length);
  }, [e.length]);
  const a = t > 1 ? 35 : 10;
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-w-full sp-relative", style: {
      transform: r ? `translateY(-${(s + a) / 2}px)` : void 0
    }, children: /* @__PURE__ */ u.jsx(Yo, { media: e[n - 1] }) }),
    t > 1 && /* @__PURE__ */ u.jsx(Af, { count: t, current: n, titleCaptionHeight: s, onChange: (l) => i(l), isMultipleLinesDetected: r })
  ] });
}, vf = ({
  medias: e,
  videoCoverPreview: t,
  postType: s,
  titleCaptionHeight: r,
  isMultipleLinesDetected: n
}) => {
  const i = e.collection, a = i.length;
  return s === "multiMedia" || s?.toLowerCase() === "image" ? /* @__PURE__ */ u.jsx(Mi, { children: /* @__PURE__ */ u.jsx(gf, { medias: i, count: a, isMultipleLinesDetected: n, titleCaptionHeight: r }) }) : /* @__PURE__ */ u.jsx(Mi, { children: a > 0 && /* @__PURE__ */ u.jsx(Yo, { videoCoverPreview: t, media: i[0] }) });
}, Mi = _.div`
  overflow: hidden;
  border-radius: 15px;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: black;
  display: flex;
  overflow: hidden;
`, mr = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, yf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 52, height: 49, viewBox: "0 0 52 49", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("g", { filter: "url(#filter0_d_0_24)" }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1429 6C23.7143 6 26 9.01299 26 9.01299C26 9.01299 28.2857 6 32.8571 6C38.1905 6 42 10.1428 42 15.4156C42 21.4416 37.0188 26.8133 32.4762 30.8571C29.6716 33.3537 27.5238 35 26 35C24.4762 35 22.2674 33.3412 19.5238 30.8571C15.0583 26.814 10 21.4416 10 15.4156C10 10.1428 13.8095 6 19.1429 6Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_24", x: 0, y: 0, width: 52, height: 49, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_24" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_24", result: "shape" })))), Bf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 51, height: 50, viewBox: "0 0 51 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_25)" }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1286 29.6848C39.2029 26.6131 41 23.4136 41 19.6882C41 12.1283 34.0609 6 25.5 6C16.9391 6 10 12.1283 10 19.6884C10 27.2485 17.1636 32.4385 25.7246 32.4385V34.9456C25.7246 35.74 26.5504 36.2512 27.2507 35.8726C29.4385 34.6901 33.4926 32.3184 36.1286 29.6848ZM17.9706 17.8423C19.1941 17.8423 20.1859 18.8244 20.1859 20.0341C20.1859 21.2463 19.1941 22.2284 17.9706 22.2284C16.7492 22.2284 15.7573 21.2463 15.7573 20.0341C15.7573 18.8244 16.7492 17.8423 17.9706 17.8423ZM27.7144 20.0341C27.7144 18.8244 26.7229 17.8423 25.5 17.8423C24.2772 17.8423 23.2858 18.8244 23.2858 20.0341C23.2858 21.2463 24.2773 22.2284 25.5 22.2284C26.7229 22.2284 27.7144 21.2463 27.7144 20.0341ZM33.0291 17.8423C34.2524 17.8423 35.2428 18.8244 35.2428 20.0341C35.2428 21.2463 34.2524 22.2284 33.0291 22.2284C31.8058 22.2284 30.814 21.2463 30.8142 20.0341C30.8142 18.8244 31.8058 17.8423 33.0291 17.8423Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_25", x: 0, y: 0, width: 51, height: 50, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_25" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_25", result: "shape" })))), bf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 51, height: 44, viewBox: "0 0 51 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_23)" }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.2228 7.13786C27.2228 6.13946 28.4318 5.62698 29.1629 6.31551L40.2873 16.7934C41.2662 17.7155 41.2321 19.2704 40.2135 20.1494L29.1259 29.7178C28.3833 30.3588 27.2228 29.8372 27.2228 28.8623V24.5263C27.2228 24.5263 15.318 22.4052 11.4993 29.3377C11.1432 29.984 9.75548 30.2101 10.0376 26.9853C11.2172 21.05 13.628 11.7838 27.2228 11.7838V7.13786Z", fill: "white" })), /* @__PURE__ */ v.createElement("defs", null, /* @__PURE__ */ v.createElement("filter", { id: "filter0_d_0_23", x: 0, y: 0, width: 51, height: 44, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ v.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ v.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ v.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ v.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ v.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ v.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_23" }), /* @__PURE__ */ v.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_23", result: "shape" })))), wf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 14, height: 15, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1249 1.87579C12.1249 1.63512 11.9014 1.45676 11.6668 1.51012L5.6712 2.87348C5.5005 2.91229 5.37934 3.06409 5.37934 3.23914V12.0902H5.37897C5.3889 12.9029 4.5507 13.7484 3.35438 14.0689C2.01898 14.4267 0.743054 13.9951 0.504513 13.1048C0.265968 12.2146 1.15513 11.2028 2.49052 10.845C2.97713 10.7146 3.45585 10.6891 3.87934 10.7523V3.23914C3.87934 2.36382 4.48504 1.60493 5.33861 1.41083L11.3342 0.0474661C12.5075 -0.219354 13.6249 0.672475 13.6249 1.87579V10.2609C13.6564 11.0828 12.8123 11.9454 11.6011 12.2699C10.2657 12.6277 8.98976 12.1961 8.75123 11.3058C8.51269 10.4156 9.40185 9.4038 10.7372 9.04598C11.2234 8.91574 11.7017 8.89009 12.1249 8.95313V1.87579Z", fill: "white" })), jf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M27.4365 8.78874L27.2831 7.33075C27.1539 6.10359 26.1191 5.172 24.8852 5.172H5.11487C3.88093 5.172 2.84612 6.1036 2.71695 7.33075L2.56348 8.78874", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ v.createElement("path", { d: "M11.25 1L15.625 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ v.createElement("path", { d: "M19.375 1L15 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ v.createElement("path", { d: "M2.5 23.8585L2.71692 25.9193C2.8461 27.1465 3.88091 28.0781 5.11484 28.0781H24.8851C26.1191 28.0781 27.1539 27.1465 27.283 25.9193L27.5 23.8585", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ v.createElement("path", { d: "M1.28897 21.25V11.6692H3.3146V19.5799H7.42201V21.25H1.28897ZM10.7891 11.6692V21.25H8.76346V11.6692H10.7891ZM14.1866 11.6692L16.5023 18.9484H16.5912L18.9115 11.6692H21.157L17.8542 21.25H15.2438L11.9364 11.6692H14.1866ZM22.3102 21.25V11.6692H28.766V13.3393H24.3358V15.6222H28.4339V17.2923H24.3358V19.5799H28.7847V21.25H22.3102Z", fill: "white" })), _f = (e) => /* @__PURE__ */ v.createElement("svg", { width: 23, height: 23, viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("circle", { cx: 9.04035, cy: 9.04035, r: 8.04035, stroke: "white", strokeWidth: 2 }), /* @__PURE__ */ v.createElement("path", { d: "M21.2621 21.9124C21.6526 22.3029 22.2858 22.3029 22.6763 21.9124C23.0668 21.5219 23.0668 20.8887 22.6763 20.4982L21.2621 21.9124ZM14.1996 14.8499L21.2621 21.9124L22.6763 20.4982L15.6138 13.4357L14.1996 14.8499Z", fill: "white" })), kf = (e) => /* @__PURE__ */ v.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#FF0505" }), /* @__PURE__ */ v.createElement("rect", { x: 9, y: 5, width: 2, height: 9, rx: 1, fill: "white" }), /* @__PURE__ */ v.createElement("rect", { x: 5.5, y: 10.5, width: 2, height: 9, rx: 1, transform: "rotate(-90 5.5 10.5)", fill: "white" })), Nf = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  ${(e) => e.$env === "schedugram-client" && `
    margin: 0 50px;
    @media (max-width: 1279px) {
      margin: 0;
    }
  `}
`, Tf = _.div`
  position: absolute;
  top: 42px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`, Sf = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 600;
    color: white;
    font-family: "Inter";
  }
`, Pf = _.p`
  opacity: 0.6;
  margin: 0;
`, If = _.p`
  margin: 0 0 -2px 15px;
`, Of = _.span`
  display: block;
  height: 2px;
  width: 30px;
  background-color: white;
  margin: 0 auto;
`, Lf = _.div`
  z-index: 10;
  position: absolute;
  right: 10px;
  bottom: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 45px;
    height: 45px;
  }
`, Rf = _.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50%;
  position: relative;
  display: grid;
  place-items: center;
  margin-bottom: 20px;

  svg {
    position: absolute;
    bottom: -10px;
    height: auto;
  }
`, $f = _.div`
  position: absolute;
  bottom: 0px;
  z-index: 2;
  padding: 10px;
  left: 0px;
  right: 0px;
  padding-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  ${({
  $isTakingUpSpace: e
}) => e ? "background-color: black;" : ""}

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }

  .description {
    line-height: 20px;
    width: 210px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  svg.musicIcon {
    width: 14px;
    height: 15px;
    flex-shrink: 0;
  }
`, Mf = ({
  url: e,
  ContentItem: t
}) => e ? /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: t }) : /* @__PURE__ */ u.jsx("div", { children: t }), Uf = ({
  medias: e,
  profilePicture: t,
  username: s,
  description: r,
  videoCoverPreview: n,
  title: i,
  postType: a
}) => {
  const [l, o] = ee.useState(!1), [D, E] = ee.useState(0);
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ u.jsxs(Tf, { children: [
      /* @__PURE__ */ u.jsx(jf, {}),
      /* @__PURE__ */ u.jsxs(Sf, { children: [
        /* @__PURE__ */ u.jsx(Pf, { children: "Following" }),
        /* @__PURE__ */ u.jsxs(If, { children: [
          "For You ",
          /* @__PURE__ */ u.jsx(Of, {})
        ] })
      ] }),
      /* @__PURE__ */ u.jsx(_f, {})
    ] }) }),
    /* @__PURE__ */ u.jsx(vf, { medias: e, videoCoverPreview: n, postType: a, isMultipleLinesDetected: l, titleCaptionHeight: D }),
    /* @__PURE__ */ u.jsx(Wf, { profilePicture: t }),
    /* @__PURE__ */ u.jsx(Vf, { username: s, title: i, description: r, onMultipleLinesDetected: o, onHeightDetected: E, isTakingUpSpace: l && Hf(a) })
  ] });
}, Hf = (e) => e === "multiMedia" || e?.toLowerCase() === "image";
function zf(e, t = 50) {
  return e && e.clientHeight > t;
}
const Vf = ({
  username: e,
  title: t,
  description: s,
  onMultipleLinesDetected: r,
  onHeightDetected: n,
  isTakingUpSpace: i
}) => {
  const a = ee.useRef(null), [l, o] = ee.useState(!1);
  return r = r || (() => {
  }), n = n || (() => {
  }), ls(() => {
    if (a.current) {
      n(a.current.clientHeight);
      const D = a.current.querySelector(".title-caption");
      if (zf(D)) {
        r(!0);
        return;
      }
      r(!1);
    }
  }, [t, s, e]), /* @__PURE__ */ u.jsxs($f, { ref: a, $isTakingUpSpace: i, children: [
    /* @__PURE__ */ u.jsxs(mr, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      e
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "title-caption", children: [
      t && /* @__PURE__ */ u.jsx(mr, { className: "title sp-font-bold sp-mb-1 sp-mt-4 sp-text-2xl", children: t }),
      /* @__PURE__ */ u.jsx("div", { className: l ? "sp-max-h-[200px] sp-overflow-y-auto sp-leading-5" : "description", children: /* @__PURE__ */ u.jsx(mr, { children: /* @__PURE__ */ u.jsx(le, { caption: s, targetPlatform: "TT" }) }) }),
      s && /* @__PURE__ */ u.jsx("button", { onClick: (D) => {
        D.preventDefault(), D.stopPropagation(), o(!l);
      }, className: "sp-text-white/60 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: l ? "less" : "more" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1.5 sp-mt-3.5 sp-text-white/70 sp-text-[11px]", children: [
      /* @__PURE__ */ u.jsx(wf, { className: "musicIcon" }),
      /* @__PURE__ */ u.jsx("span", { className: "sp-truncate", children: "Audio will be auto-matched after publishing" })
    ] })
  ] });
}, Wf = ({
  profilePicture: e
}) => /* @__PURE__ */ u.jsxs(Lf, { children: [
  /* @__PURE__ */ u.jsx(Rf, { $profilePicture: e, children: /* @__PURE__ */ u.jsx(kf, { className: "sp-w-8" }) }),
  /* @__PURE__ */ u.jsx(yf, {}),
  /* @__PURE__ */ u.jsx(Bf, {}),
  /* @__PURE__ */ u.jsx(bf, {})
] }), Xo = ({
  post: e,
  env: t,
  videoCoverPreview: s
}) => /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsx(Nf, { $env: t, children: /* @__PURE__ */ u.jsx(Mf, { ContentItem: /* @__PURE__ */ u.jsx(Uf, { medias: e.medias, username: e.username, profilePicture: e.profilePicture, description: e.caption, videoCoverPreview: s, title: e.postOptions?.title, postType: e.type }), url: e.redirectUrl }) }) }), Gf = Xo, qf = ({
  post: e,
  env: t,
  videoCoverPreview: s
}) => {
  switch (e.type) {
    case "image":
    case "multiMedia":
      return /* @__PURE__ */ u.jsx(Gf, { post: e, env: t, videoCoverPreview: s });
    case "video":
    case "text":
    case "story":
      return /* @__PURE__ */ u.jsx(Xo, { post: e, env: t, videoCoverPreview: s });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Jo = _.div`
  font-family: Helvetica;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, Zf = ({
  username: e,
  profilePicture: t,
  small: s
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }),
  /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsx("div", { className: "sp-font-sans", children: /* @__PURE__ */ u.jsx(Jo, { $variant: "heading", className: "sp-mb-1", children: e }) }) })
] }), Kf = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Yf = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Xf = ({
  src: e,
  forCarousel: t,
  showOverlay: s,
  showAll: r,
  setShowAll: n,
  mediaCount: i
}) => t ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsx(Xe, { href: e, $isFlex: !0, children: /* @__PURE__ */ u.jsx(Yf, { src: e, className: "" }) }),
  !r && s && /* @__PURE__ */ u.jsxs("div", { className: "sp-cursor-pointer", onClick: () => n(!0), children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ u.jsx(Xe, { href: e, children: /* @__PURE__ */ u.jsx(Kf, { src: e }) }), Jf = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, playing: !1, className: "sp-relative", width: "100%", height: "auto" }) }) : null, Qo = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showOverlay: r,
  showAll: n,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: l = !0
}) => t && n === !1 ? null : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(Jf, { url: e.url, forCarousel: s, isActiveSlide: l }),
  !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ u.jsx(Xf, { src: e.url, forCarousel: s, showOverlay: r, showAll: n, setShowAll: i, mediaCount: a })
] }), Qf = () => /* @__PURE__ */ u.jsx("div", { className: "sp-py-2 sp-w-full", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-w-full sp-justify-start sp-text-black sp-py-4 sp-pl-0", children: [
  /* @__PURE__ */ u.jsx($t, { icon: "icon-instagram-heart" }),
  /* @__PURE__ */ u.jsx($t, { icon: "icon-instagram-comment" }),
  /* @__PURE__ */ u.jsx($t, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ u.jsx($t, { icon: "icon-instagram-share" })
] }) }), $t = ({
  icon: e
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-start sp-pr-4 ", children: /* @__PURE__ */ u.jsx("div", { className: `sp-text-xl ${e}` }) }), eh = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, uh = ({
  medias: e
}) => {
  const [t, s] = re(!1);
  return /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: e.map((r, n) => !t && n > 3 ? null : /* @__PURE__ */ u.jsx(eh, { className: "sp-relative", children: /* @__PURE__ */ u.jsx(Qo, { media: r, forCarousel: !0, hidden: n > 3, mediaCount: e.length, showOverlay: n === 3 && e.length > 4, showAll: t, setShowAll: s }) }, `fb-media-key-${n}`)) });
}, th = ({
  medias: e
}) => {
  const t = e.collection, s = t.length, r = s > 1;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-px-4", children: [
    s > 0 && /* @__PURE__ */ u.jsx(u.Fragment, { children: r ? /* @__PURE__ */ u.jsx(uh, { medias: t, count: s }) : /* @__PURE__ */ u.jsx(Qo, { media: t[0] }) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ u.jsx(Qf, {}) })
  ] });
}, sh = ({
  post: e
}) => {
  let t = e.caption;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ u.jsx(Zf, { username: e.username, profilePicture: e.profilePicture, locationName: e.locationName }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ u.jsxs(Jo, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ u.jsx(le, { caption: t, targetPlatform: "TH" }),
      e.redirectUrl && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        " ",
        /* @__PURE__ */ u.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: e.redirectUrl, target: "_blank", children: e.redirectUrl })
      ] })
    ] }) }),
    e.type === "text" && e.redirectUrl && /* @__PURE__ */ u.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ u.jsx(Cs, { url: e.redirectUrl }) }),
    /* @__PURE__ */ u.jsx(th, { medias: e.medias })
  ] });
}, rh = ({
  post: e
}) => {
  switch (e.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ u.jsx(sh, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
}, Ui = _.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 25px;
          line-height: 30px;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 18px;
          white-space: pre-line;
        `;
    case "link":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 18px;
          white-space: pre-line;
          font-weight: bold;
          color: black;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, nh = _.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: e
}) => {
  switch (e) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, ih = ({
  username: e,
  profilePicture: t,
  small: s,
  description: r,
  url: n
}) => /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsxs("div", { className: "sp-pt-4 sp-pb-2 sp-px-0 sp-flex sp-flex-row", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-px-1", children: /* @__PURE__ */ u.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-4", style: {
    width: "40px",
    height: "40px",
    minWidth: "40px",
    minHeight: "40px"
  }, children: /* @__PURE__ */ u.jsx(We, { src: t, alt: e }) }) }),
  /* @__PURE__ */ u.jsxs("div", { children: [
    /* @__PURE__ */ u.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ u.jsx("div", { className: "", children: /* @__PURE__ */ u.jsxs(nh, { $variant: "bold", className: "sp-mb-1", children: [
      e,
      " "
    ] }) }) }),
    r && /* @__PURE__ */ u.jsx(Ui, { $variant: "caption", children: /* @__PURE__ */ u.jsx(le, { caption: r }) }),
    n && /* @__PURE__ */ u.jsxs("div", { className: "sp-py-2", children: [
      " ",
      /* @__PURE__ */ u.jsx("a", { href: n, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ u.jsx(Ui, { $variant: "link", children: "URL for post" }) })
    ] })
  ] })
] }) }), ah = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, oh = ({
  src: e
}) => /* @__PURE__ */ u.jsx(ah, { src: e }), lh = ({
  url: e,
  isActiveSlide: t
}) => t ? /* @__PURE__ */ u.jsx("div", { className: "sp-relative", style: {}, children: /* @__PURE__ */ u.jsx(Me, { url: e, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, ch = ({
  media: e,
  hidden: t = !1,
  forCarousel: s = !1,
  showAll: r,
  isActiveSlide: n = !0
}) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ u.jsx(lh, { url: e.url, forCarousel: s, isActiveSlide: n }) : /* @__PURE__ */ u.jsx(oh, { src: e.url }), Dh = ({
  medias: e
}) => {
  const t = e.collection, s = t.length;
  return /* @__PURE__ */ u.jsx(ph, { children: s > 0 && /* @__PURE__ */ u.jsx(ch, { media: t[0] }) });
}, ph = _.div`
  overflow: hidden;
`, dh = ({
  url: e,
  children: t
}) => e ? /* @__PURE__ */ u.jsx("a", { href: e, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: t }) : /* @__PURE__ */ u.jsx("div", { children: t }), fh = ({
  post: e
}) => /* @__PURE__ */ u.jsxs(hh, { className: "sp-bg-white md:sp-shadow-around sp-pb-6", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ u.jsx(ih, { username: e.username, profilePicture: e.profilePicture, description: e.caption, small: !1, url: e.redirectUrl }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-pb-2", style: {
    paddingLeft: "47px"
  }, children: /* @__PURE__ */ u.jsx(dh, { url: e.redirectUrl, children: /* @__PURE__ */ u.jsx(Dh, { medias: e.medias }) }) })
] }), hh = _.div`
  padding: 1.1em;
`, Fh = ({
  post: e
}) => {
  switch (e.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ u.jsx(fh, { post: e });
    default:
      return /* @__PURE__ */ u.jsx(u.Fragment, {});
  }
};
class mh extends fl {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    }, this.post = t.post;
  }
  // @ts-expect-error not sure why this is here but it's not used
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(t) {
    return {
      hasError: !0
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(t, s) {
    console.log(t);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-w-full sp-border-2 sp-border-solid sp-border-gray-300 sp-rounded-lg sp-p-8 sp-h-500px sp-shadow-lg", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-4xl sp-mb-8 sp-text-red-500 sp-font-bold", children: "Failed to load preview" }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-3xl sp-text-red-500", children: "Please contact Sked support" })
    ] }) : this.props.children;
  }
}
const Ch = {
  FB: ["text", "image", "video", "multiMedia", "fb-reel"],
  GMB: ["text", "image", "video", "multiMedia", "story", "fb-reel", "gmb"],
  IG: ["image", "video", "multiMedia", "story", "fb-reel"],
  LI: ["text", "image", "multiMedia", "video", "document", "fb-reel"],
  OT: ["image", "video", "multiMedia", "story", "text", "fb-reel"],
  PI: ["image", "video", "fb-reel"],
  SC: ["image", "video", "multiMedia", "story", "text", "fb-reel"],
  TH: ["audio", "image", "video", "multiMedia", "text", "fb-reel"],
  TT: ["video", "image", "multiMedia", "fb-reel"],
  TW: ["text", "image", "video", "multiMedia", "fb-reel"],
  YT: ["video", "fb-reel"]
}, Eh = {
  FB: "Facebook",
  GMB: "Google Business Profile",
  IG: "Instagram",
  LI: "LinkedIn",
  OT: "Other",
  PI: "Pinterest",
  SC: "Snapchat",
  TH: "Threads",
  TT: "TikTok",
  TW: "X",
  YT: "YouTube"
}, e0 = (e) => {
  const t = t0(e), s = jh(t), r = gh(e), n = Hi(r), i = Ch[t];
  return i ? i.includes(r) ? r === "multiMedia" && vh(e) ? {
    platform: t,
    platformName: s,
    reason: "unsupported-document-media",
    supported: !1,
    type: "document",
    typeName: Hi("document")
  } : t === "TT" && r === "multiMedia" && Bh(e) ? {
    platform: t,
    platformName: s,
    reason: "unsupported-media-combination",
    supported: !1,
    type: "mixedMedia",
    typeName: "Mixed media posts"
  } : {
    platform: t,
    platformName: s,
    reason: "supported",
    supported: !0,
    type: r,
    typeName: n
  } : {
    platform: t,
    platformName: s,
    reason: "unsupported-post-type",
    supported: !1,
    type: r,
    typeName: n
  } : {
    platform: t,
    platformName: s,
    reason: "unknown-platform",
    supported: !1,
    type: r,
    typeName: n
  };
}, xh = (e) => e0(e).supported, Ah = (e) => {
  const t = e0(e);
  return t.supported ? null : {
    title: "Post preview not available",
    message: t.reason === "unsupported-media-combination" && t.platform === "TT" ? "Mixed photo and video posts aren't available on TikTok." : `${t.typeName} aren't available on ${t.platformName}.`
  };
}, gh = (e) => {
  const t = t0(e), s = e?.type || e?.providedPost?.type || "text";
  return (e?.videoPostType || e?.providedPost?.videoPostType || null) === "reel" ? t === "FB" || t === "IG" ? "fb-reel" : "reel" : s === "reel" && t === "IG" ? "fb-reel" : s === "fb-reel" ? t !== "FB" && t !== "IG" ? "video" : "fb-reel" : s;
}, vh = (e) => u0(e).some(yh), yh = (e) => {
  const t = e.type?.toLowerCase() || "", s = e.url?.toLowerCase().split(/[?#]/)[0] || "";
  return e.isDocument === !0 || t.includes("document") || t.includes("pdf") || s.endsWith(".pdf");
}, Bh = (e) => {
  const t = u0(e);
  return t.some(bh) && t.some(wh);
}, bh = (e) => {
  const t = e.type?.toLowerCase() || "", s = e.url?.toLowerCase().split(/[?#]/)[0] || "";
  return e.isVideo === !0 || t.startsWith("video/") || /\.(m4v|mov|mp4|mpeg|mpg|webm)$/.test(s);
}, wh = (e) => {
  const t = e.type?.toLowerCase() || "", s = e.url?.toLowerCase().split(/[?#]/)[0] || "";
  return e.isVideo === !1 || t.startsWith("image/") || /\.(avif|gif|heic|jpeg|jpg|png|webp)$/.test(s);
}, u0 = (e) => e ? e.medias?.collection || e.mediaFiles || e.providedPost?.mediaFiles || [] : [], t0 = (e) => e?.platform || e?.platformType || "IG", jh = (e) => Eh[e] || e, Hi = (e) => {
  switch (e) {
    case "fb-reel":
    case "reel":
      return "Reels";
    case "multiMedia":
      return "Carousel posts";
    case "story":
      return "Stories";
    case "text":
      return "Text posts";
    case "document":
      return "Document posts";
    case "video":
      return "Video posts";
    case "image":
    case "photo":
      return "Image posts";
    default:
      return `${_h(e)} posts`;
  }
}, _h = (e) => e.length > 0 ? `${e[0].toUpperCase()}${e.slice(1)}` : e, zi = ({
  className: e,
  copy: t,
  post: s
}) => {
  const r = t || Ah(s);
  return r ? /* @__PURE__ */ u.jsxs("div", { className: ["sp-box-border sp-flex sp-w-full sp-items-start sp-gap-3 sp-rounded-lg sp-bg-[#fffbeb] sp-p-2 sp-font-sans sp-antialiased", e].filter(Boolean).join(" "), "data-testid": "unsupported-post-preview-placeholder", "data-preview-placeholder": "unsupported", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-w-0.5 sp-self-stretch sp-rounded-[3px] sp-bg-[#d97706]" }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-1 sp-py-1", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-2", children: [
        /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-size-5 sp-shrink-0", fill: "none", viewBox: "0 0 20 20", children: /* @__PURE__ */ u.jsx("path", { d: "M9.999 7.5v3.333m0 2.5h.009M8.845 3.243 2.24 14.583A1.25 1.25 0 0 0 3.322 16.5h13.355a1.25 1.25 0 0 0 1.083-1.917L11.155 3.243a1.25 1.25 0 0 0-2.31 0Z", stroke: "#d97706", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }) }),
        /* @__PURE__ */ u.jsx("div", { className: "sp-min-w-0 sp-flex-1 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#333333]", children: r.title })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-sm sp-font-normal sp-leading-5 sp-text-[#808080]", children: r.message })
    ] })
  ] }) : null;
}, s0 = (e) => {
  if (e === null)
    return null;
  if (e.type !== "fb-reel")
    return e;
  switch (e.platform) {
    case "FB":
      return e;
    case "IG":
      return {
        ...e,
        type: "reel"
      };
    default:
      return {
        ...e,
        type: "video"
      };
  }
}, r0 = ({
  alignTriggerWithTextEnd: e = !1,
  buttonClassName: t,
  caption: s,
  charsPerLine: r,
  className: n,
  collapseTriggerLabel: i = "Show less",
  collapsedLines: a,
  contentClassName: l,
  expanded: o,
  expandOnContentClick: D = !1,
  hideTriggerWhenExpanded: E = !1,
  leadingText: p,
  measurementText: m,
  onExpandedChange: c,
  prefix: f,
  suffix: C,
  targetPlatform: g,
  triggerNode: x,
  triggerStyle: d,
  trackEvent: h,
  triggerLabel: F
}) => {
  const B = xt({
    charsPerLine: r,
    leadingText: p,
    text: m ?? s
  }) > a, w = o ? i : F, k = e && !o && B ? kh({
    charsPerLine: r,
    collapsedLines: a,
    leadingText: p,
    text: m ?? s,
    triggerLabel: F,
    triggerStyle: d
  }) : d, U = (L) => {
    const T = L.target;
    !D || !B || !(T instanceof HTMLElement) || T.closest("a, button") || c(!o);
  };
  return /* @__PURE__ */ u.jsxs("div", { className: ["sp-relative", n].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ u.jsxs("div", { "aria-expanded": B ? o : void 0, className: ["sp-break-words", D && B ? "sp-cursor-pointer" : void 0, !o && B ? Sh(a) : void 0, l].filter(Boolean).join(" "), onClick: U, children: [
      f,
      /* @__PURE__ */ u.jsx(le, { caption: s, targetPlatform: g, trackEvent: h }),
      C
    ] }),
    B && !(o && E) ? /* @__PURE__ */ u.jsx("button", { "aria-expanded": o, className: [o ? "sp-inline" : "sp-absolute sp-bottom-0 sp-right-0 sp-inline", "sp-border-0 sp-bg-transparent sp-p-0 sp-text-left sp-font-inherit sp-leading-inherit sp-text-inherit", t].filter(Boolean).join(" "), onClick: () => c(!o), style: k, type: "button", children: !o && x ? x : w }) : null
  ] });
}, an = ({
  charsPerLine: e,
  collapsedLines: t,
  expanded: s,
  leadingText: r,
  lineHeight: n,
  text: i
}) => {
  const a = xt({
    charsPerLine: e,
    leadingText: r,
    text: i
  });
  return Math.min(s ? a : t, a) * n;
}, xt = ({
  charsPerLine: e,
  leadingText: t,
  text: s
}) => {
  const r = s.trim();
  return r ? r.split(/\r?\n/).reduce((i, a, l) => {
    const o = l === 0 && t ? `${t} ${a}` : a;
    return i + Math.max(1, Math.ceil(o.length / e));
  }, 0) : 0;
}, kh = ({
  charsPerLine: e,
  collapsedLines: t,
  leadingText: s,
  text: r,
  triggerLabel: n,
  triggerStyle: i
}) => {
  const a = Nh({
    charsPerLine: e,
    collapsedLines: t,
    leadingText: s,
    text: r
  }), l = Math.max(2, n.length), o = Math.min(a + 0.5, Math.max(0, e - l));
  return {
    ...i,
    left: `${o}ch`,
    right: "auto"
  };
}, Nh = ({
  charsPerLine: e,
  collapsedLines: t,
  leadingText: s,
  text: r
}) => {
  const n = r.trim();
  if (!n)
    return 0;
  const i = n.split(/\r?\n/).flatMap((l, o) => Th(o === 0 && s ? `${s} ${l}` : l, e));
  return (i[Math.min(t, i.length) - 1] ?? "").trimEnd().length;
}, Th = (e, t) => {
  if (!e)
    return [""];
  const s = [];
  for (let r = 0; r < e.length; r += t)
    s.push(e.slice(r, r + t));
  return s;
}, Sh = (e) => e <= 1 ? "sp-line-clamp-1" : e === 2 ? "sp-line-clamp-2" : e === 3 ? "sp-line-clamp-3" : e === 4 ? "sp-line-clamp-4" : e === 5 ? "sp-line-clamp-5" : "sp-line-clamp-4", fu = (...e) => e.filter(Boolean).join(" "), Je = ({
  children: e,
  className: t,
  platform: s
}) => /* @__PURE__ */ u.jsx("div", { className: fu("sp-box-border sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-text-[16px] sp-leading-5 sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t), "data-preview-variant": "uplift", "data-preview-platform": s, style: {
  fontFamily: "Inter, Helvetica, Arial, sans-serif"
}, children: e }), Be = ({
  alt: e = "",
  className: t,
  onError: s,
  src: r,
  ...n
}) => {
  const [i, a] = re(!1), l = fu("sp-h-10 sp-w-10 sp-shrink-0 sp-rounded-full sp-bg-[#eef0f2] sp-object-cover", t);
  return !r || i ? /* @__PURE__ */ u.jsx("span", { "aria-label": e, className: fu(l, "sp-flex sp-items-center sp-justify-center sp-overflow-hidden sp-text-sm sp-font-semibold sp-leading-none sp-text-[#4b5563]"), role: "img", children: Ph(e) }) : /* @__PURE__ */ u.jsx("img", { alt: e, className: fu("sp-block", l), onError: (o) => {
    a(!0), s?.(o);
  }, src: r, ...n });
}, Ph = (e) => e.trim().charAt(0).toUpperCase() || "?", At = ({
  className: e,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { className: fu("sp-overflow-hidden sp-truncate sp-text-base sp-font-semibold sp-leading-none sp-text-black", e), ...t }), Ih = ({
  className: e,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { className: fu("sp-text-center sp-text-[24px] sp-leading-none sp-text-[#808080]", e), ...t }), Mu = ({
  className: e,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { className: fu("sp-box-border sp-min-h-0 sp-min-w-0 sp-overflow-hidden sp-bg-[#e4e6eb]", e), ...t }), Oh = ({
  autoPlay: e = !1,
  autoplayMode: t = "none",
  className: s,
  controls: r = !1,
  customControls: n = !1,
  fit: i,
  gateCover: a,
  intrinsicRatio: l,
  isActive: o = !0,
  loop: D = !1,
  muted: E = !1,
  onError: p,
  poster: m,
  publishedRatio: c,
  source: f,
  videoClassName: C
}) => {
  const g = Dt(null), x = `${f}:${m ?? ""}`, [d, h] = re({
    hasEnded: !1,
    hasPlayed: !1,
    identity: x,
    isPlaying: !1,
    resetKey: 0
  }), F = d.identity === x ? d : {
    hasEnded: !1,
    hasPlayed: !1,
    identity: x,
    isPlaying: !1,
    resetKey: 0
  }, {
    hasEnded: A,
    hasPlayed: B,
    isPlaying: w,
    resetKey: k
  } = F, L = a ?? (n && !!(m && m !== f)), T = L ? !1 : e, S = n && (!T || B) && !A && (!r || !B), I = n && B && A;
  if (!o)
    return null;
  const j = () => {
    const q = g.current;
    q && (q.paused ? q.play() : q.pause());
  }, R = () => {
    h((q) => ({
      hasEnded: !1,
      hasPlayed: !1,
      identity: x,
      isPlaying: !1,
      resetKey: q.identity === x ? q.resetKey + 1 : 1
    }));
  };
  return /* @__PURE__ */ u.jsxs("div", { className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", s].filter(Boolean).join(" "), "data-uplift-video-player": "true", "data-uplift-fit": i, "data-uplift-intrinsic-ratio": l, "data-uplift-video-autoplay": T ? "true" : "false", "data-uplift-video-autoplay-mode": t, "data-uplift-video-cover-gated": L ? "true" : "false", "data-uplift-media-kind": "video", "data-uplift-poster": m, "data-uplift-published-ratio": c, "data-uplift-video-playing": w ? "true" : "false", children: [
    /* @__PURE__ */ u.jsx("video", { className: ["sp-block sp-h-full sp-w-full sp-bg-[#111]", C || "sp-object-cover"].filter(Boolean).join(" "), controls: r, autoPlay: T, loop: D, muted: E, onEnded: () => {
      h((q) => ({
        ...F,
        resetKey: q.identity === x ? q.resetKey : F.resetKey,
        hasEnded: !0,
        isPlaying: !1
      }));
    }, onError: p, onPause: () => h((q) => ({
      ...F,
      resetKey: q.identity === x ? q.resetKey : F.resetKey,
      isPlaying: !1
    })), onPlay: () => {
      h((q) => ({
        ...F,
        resetKey: q.identity === x ? q.resetKey : F.resetKey,
        hasEnded: !1,
        hasPlayed: !0,
        isPlaying: !0
      }));
    }, playsInline: !0, poster: m, preload: "metadata", ref: g, src: f }, `${x}:${k}`),
    L && !B && m ? /* @__PURE__ */ u.jsx("img", { alt: "", className: ["sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full", C || "sp-object-cover"].filter(Boolean).join(" "), src: m }) : null,
    S ? /* @__PURE__ */ u.jsx("button", { "aria-label": w ? "Pause video" : "Play video", className: ["sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-border-0 sp-bg-transparent sp-p-0 sp-text-white", "sp-cursor-pointer"].join(" "), onClick: j, type: "button", children: /* @__PURE__ */ u.jsx("span", { className: ["sp-flex sp-h-[52px] sp-w-[52px] sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-transition-opacity", w || A ? "sp-opacity-0" : "sp-opacity-100"].join(" "), children: w ? /* @__PURE__ */ u.jsx(Rh, {}) : /* @__PURE__ */ u.jsx(Lh, {}) }) }) : null,
    I ? /* @__PURE__ */ u.jsx("button", { "aria-label": "Replay video", className: "sp-absolute sp-left-1/2 sp-top-1/2 sp-flex sp-h-14 sp-w-14 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/30 sp-p-0 sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", onClick: R, style: {
      transform: "translate(-50%, -50%)"
    }, type: "button", children: /* @__PURE__ */ u.jsx($h, {}) }) : null
  ] });
}, Lh = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", fill: "none", height: "26", viewBox: "0 0 24 28", width: "24", children: /* @__PURE__ */ u.jsx("path", { d: "M22 14L2 26V2L22 14Z", fill: "currentColor" }) }), Rh = () => /* @__PURE__ */ u.jsxs("svg", { "aria-hidden": "true", fill: "none", height: "24", viewBox: "0 0 20 24", width: "20", children: [
  /* @__PURE__ */ u.jsx("rect", { fill: "currentColor", height: "22", rx: "1", width: "6", x: "1", y: "1" }),
  /* @__PURE__ */ u.jsx("rect", { fill: "currentColor", height: "22", rx: "1", width: "6", x: "13", y: "1" })
] }), $h = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-block sp-translate-x-[1px]", fill: "none", height: "28", viewBox: "0 0 36 34", width: "28", children: /* @__PURE__ */ u.jsx("path", { d: "M2.333 13.667s3.342-4.553 6.056-7.27C11.104 3.68 14.856 2 19 2c8.284 0 15 6.716 15 15s-6.716 15-15 15c-6.839 0-12.608-4.576-14.414-10.833M2.333 13.667v-10m0 10h10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2.9" }) }), Mh = ["TT", "IG", "FB", "LI"], Uh = ["IG", "FB", "LI"], n0 = (e) => e ? typeof e == "string" ? e : e.platformType || e.TYPE || "" : "", is = (e) => Mh.includes(n0(e)), Hh = (e) => Uh.includes(n0(e)), N3 = (e = []) => e.filter((t) => is(t)), T3 = ({
  platforms: e = [],
  selectedPlatform: t
}) => t === "LINKED" ? e.some((s) => is(s)) : is(t), S3 = ({
  platforms: e = [],
  selectedPlatform: t
}) => {
  const r = (t === "LINKED" ? e : [t || ""]).filter((n) => is(n));
  return r.length > 0 && r.every((n) => Hh(n));
}, P3 = ({
  isStory: e,
  isVideoPost: t,
  mediaUrlCount: s,
  storyType: r
}) => s > 1 || s > 0 && !t || e && r !== "reel" ? !1 : t, zh = ({
  hasCoverPoster: e,
  platform: t,
  surface: s
}) => e ? !(t === "IG" && (s === "reel" || s === "story")) : !1, Vh = [".mp4", ".mov", ".webm", ".m4v"], on = (e) => e?.url || e?.thumbnailUrl || "", _e = (e) => {
  if (!e)
    return !1;
  if (e.isVideo || e.type?.toLowerCase().startsWith("video/"))
    return !0;
  const t = on(e).toLowerCase().split(/[?#]/)[0];
  return Vh.some((s) => t.endsWith(s));
}, Uu = (e, t) => _e(e[t]) ? e.slice(0, t).filter(_e).length : t, Wh = ({
  coverScope: e = "singlePostOnly",
  media: t,
  mediaCount: s = 1,
  mediaIndex: r = 0,
  preferVideoCoverPreviewOverride: n = !1,
  videoCoverPreview: i
}) => {
  const a = on(t), l = i || void 0, o = t?.thumbnailUrl || void 0;
  return (e === "allVideos" || e === "firstVideoOnly" && r === 0 || e === "singlePostOnly" && s === 1 || n && r === 0) && l ? l : o || a || void 0;
}, Wu = ({
  fit: e,
  media: t,
  platform: s,
  surface: r
}) => ({
  fit: e || Zh({
    platform: s,
    surface: r
  }),
  intrinsicRatio: qh(t),
  publishedRatio: Xh({
    media: t,
    platform: s,
    surface: r
  })
}), Es = ({
  fit: e,
  media: t,
  platform: s,
  surface: r,
  width: n
}) => {
  const i = Wu({
    fit: e,
    media: t,
    platform: s,
    surface: r
  }), a = Jh(i.publishedRatio);
  return {
    ...i,
    height: Qh(n / a),
    width: n
  };
}, Gh = ({
  isActive: e = !0,
  platform: t,
  surface: s
}) => {
  const r = Kh({
    platform: t,
    surface: s
  }), n = e && r !== "none";
  return {
    autoPlay: n,
    autoplayMode: r,
    loop: n && Yh({
      platform: t,
      surface: s
    }),
    muted: n
  };
}, qh = (e) => {
  const t = e?.width, s = e?.height;
  if (!(!t || !s || t <= 0 || s <= 0))
    return `${t} / ${s}`;
}, Zh = ({
  platform: e,
  surface: t
}) => (e === "LI" || e === "YT" || e === "OT") && t === "video" ? "contain" : "cover", Kh = ({
  platform: e,
  surface: t
}) => e === "GMB" ? "none" : t === "story" || t === "reel" || e === "SC" || e === "TT" ? "activeFullscreen" : "mutedWhenVisible", Yh = ({
  platform: e,
  surface: t
}) => t === "story" || t === "reel" || e === "SC" || e === "TT", Xh = ({
  media: e,
  platform: t,
  surface: s
}) => t === "IG" && (s === "feed" || s === "carousel") ? lu({
  fallbackRatio: "1 / 1",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 4 / 5,
  minRatioLabel: "4 / 5"
}) : t === "OT" ? s === "video" ? Vi({
  fallbackRatio: "16 / 9",
  media: e
}) : "1 / 1" : s === "story" || s === "reel" || t === "SC" || t === "TT" ? "9 / 16" : t === "PI" && s === "pin" ? _e(e) ? "9 / 16" : "2 / 3" : t === "TW" && s === "video" ? lu({
  fallbackRatio: "16 / 9",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 9 / 16,
  minRatioLabel: "9 / 16"
}) : t === "TW" && s === "grid" ? lu({
  fallbackRatio: "1 / 1",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 9 / 16,
  minRatioLabel: "9 / 16"
}) : t === "TH" && s === "video" ? lu({
  fallbackRatio: "4 / 5",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 9 / 16,
  minRatioLabel: "9 / 16"
}) : t === "TH" && s === "grid" ? lu({
  fallbackRatio: "1 / 1",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 4 / 5,
  minRatioLabel: "4 / 5"
}) : t === "FB" && s === "grid" ? lu({
  fallbackRatio: "1 / 1",
  maxRatio: 1.91,
  maxRatioLabel: "1.91 / 1",
  media: e,
  minRatio: 4 / 5,
  minRatioLabel: "4 / 5"
}) : t === "LI" && (s === "grid" || s === "video") ? lu({
  fallbackRatio: s === "video" ? "16 / 9" : "1 / 1",
  maxRatio: s === "video" ? 16 / 9 : 1.91,
  maxRatioLabel: s === "video" ? "16 / 9" : "1.91 / 1",
  media: e,
  minRatio: s === "video" ? 9 / 16 : 1 / 1.91,
  minRatioLabel: s === "video" ? "9 / 16" : "1 / 1.91"
}) : t === "GMB" ? s === "carousel" ? "1 / 1" : "400 / 264" : t === "YT" && s === "video" ? Vi({
  fallbackRatio: "16 / 9",
  media: e
}) : "1 / 1", Vi = ({
  fallbackRatio: e,
  media: t
}) => {
  const s = t?.width, r = t?.height;
  return !s || !r || s <= 0 || r <= 0 ? e : `${s} / ${r}`;
}, lu = ({
  fallbackRatio: e,
  maxRatio: t,
  maxRatioLabel: s,
  media: r,
  minRatio: n,
  minRatioLabel: i
}) => {
  const a = r?.width, l = r?.height;
  if (!a || !l || a <= 0 || l <= 0)
    return e;
  const o = a / l;
  return o < n ? i : o > t ? s : `${a} / ${l}`;
}, Jh = (e) => {
  const [t, s] = e.split("/").map((r) => Number(r.trim()));
  return !t || !s || t <= 0 || s <= 0 ? 1 : t / s;
}, Qh = (e) => Math.round(e * 1e3) / 1e3, xe = ({
  className: e,
  controls: t,
  coverScope: s,
  customVideoControls: r,
  fit: n,
  imageClassName: i,
  isActive: a = !0,
  media: l,
  mediaCount: o = 1,
  mediaIndex: D = 0,
  platform: E,
  preferVideoCoverPreviewOverride: p,
  surface: m,
  videoClassName: c,
  videoCoverPreview: f
}) => {
  const C = on(l), g = _e(l), x = Wu({
    fit: n,
    media: l,
    platform: E,
    surface: m
  }), d = x.fit === "contain" ? "sp-object-contain" : "sp-object-cover";
  if (!C)
    return /* @__PURE__ */ u.jsx("div", { className: ["sp-h-full sp-w-full sp-bg-[#e6e6e6]", e].filter(Boolean).join(" "), "data-uplift-fit": x.fit, "data-uplift-media-kind": "empty", "data-uplift-published-ratio": x.publishedRatio });
  if (g) {
    const h = Wh({
      coverScope: s,
      media: l,
      mediaCount: o,
      mediaIndex: D,
      preferVideoCoverPreviewOverride: p,
      videoCoverPreview: f
    }), F = Gh({
      isActive: a,
      platform: E,
      surface: m
    }), B = zh({
      hasCoverPoster: !!(h && h !== C),
      platform: E,
      surface: m
    }), w = m === "reel" || m === "story", k = r ?? (w || B), U = t ?? (!k || B && !w);
    return /* @__PURE__ */ u.jsx(Oh, { autoPlay: F.autoPlay, autoplayMode: F.autoplayMode, className: e, controls: U, customControls: k, fit: x.fit, gateCover: B, intrinsicRatio: x.intrinsicRatio, isActive: a, loop: F.loop, muted: F.muted, poster: h, publishedRatio: x.publishedRatio, source: C, videoClassName: [d, c].filter(Boolean).join(" ") });
  }
  return /* @__PURE__ */ u.jsx("img", { alt: "", className: ["sp-block sp-h-full sp-w-full", d, e, i].filter(Boolean).join(" "), "data-uplift-fit": x.fit, "data-uplift-intrinsic-ratio": x.intrinsicRatio, "data-uplift-media-kind": "image", "data-uplift-published-ratio": x.publishedRatio, src: C });
}, eF = {
  collection: [],
  count: 0
}, be = (e) => !!e?.trim(), i0 = (e) => {
  const t = e.medias?.collection ?? [], s = e;
  return {
    id: e.id,
    caption: e.caption || "",
    comment: e.comment || "",
    platform: e.platform,
    type: e.type,
    storyType: e.storyType || null,
    medias: e.medias ? {
      collection: t,
      count: e.medias.count ?? t.length
    } : eF,
    username: e.username || "",
    profilePicture: e.profilePicture || "",
    imageUrl: e.image_url || "",
    locationName: e.locationName || null,
    redirectUrl: e.redirectUrl || "",
    storyUrl: e.storyUrl || "",
    storyLabel: e.storyLabel || "",
    storyStickerHeight: e.storyStickerHeight || null,
    tags: Array.isArray(e.providedPost?.tags) ? e.providedPost.tags : [],
    productTags: Array.isArray(e.providedPost?.productTags) ? e.providedPost.productTags : [],
    callToAction: e.callToAction || "",
    event: e.event || "",
    topicType: e.topicType || null,
    ytTitle: e.ytTitle || null,
    piTitle: e.piTitle || null,
    boardTitle: e.boardTitle || null,
    collaboratingIgUsers: s.collaboratingIgUsers ?? s.providedPost?.collaboratingIgUsers,
    providedPost: e.providedPost,
    sourcePost: e
  };
}, uF = /* @__PURE__ */ new Set(["fb-reel", "image", "multiMedia", "story", "text", "video"]), $r = 58, Wi = 32, a0 = 5, Gi = 20, tF = 30, sF = 55, Oe = 46, rF = 36, nF = 1, o0 = 54, iF = 72, aF = 40, oF = 12, lF = 800 - o0 - iF - aF - oF, cF = (e) => e.platform === "FB" && (uF.has(e.type) || C0(e)), DF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = e.type === "fb-reel" || C0(e), i = e.type === "story";
  return n ? /* @__PURE__ */ u.jsx(gF, { post: e, className: t, trackEvent: s, videoCoverPreview: r }) : i ? /* @__PURE__ */ u.jsx(yF, { post: e, className: t, trackEvent: s, videoCoverPreview: r }) : /* @__PURE__ */ u.jsx(pF, { post: e, className: t, trackEvent: s, videoCoverPreview: r });
}, pF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = e.medias.collection, [i, a] = re(!1), l = D0(e, n), o = c0({
    caption: e.caption,
    charsPerLine: l.charsPerLine,
    expanded: i,
    lineHeight: l.lineHeight
  }), D = [e.caption, i ? "expanded" : "collapsed"].join("|"), [E, p] = re(null), m = Dt(null), c = E?.key === D ? E.height : void 0, f = mF(e, n, i, c), C = be(e.caption);
  return ls(() => {
    if (!i) {
      p(null);
      return;
    }
    const g = m.current;
    if (!g)
      return;
    const x = Math.ceil(g.scrollHeight);
    x > 0 && Math.abs(x - o) > 1 && p({
      height: x,
      key: D
    });
  }, [i, D, o]), /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-[#141414]", t].filter(Boolean).join(" "), platform: "FB", children: /* @__PURE__ */ u.jsxs("article", { className: "sp-relative sp-w-full", "data-uplift-renderer": "facebook", "data-uplift-layout": f.dataLayout, style: {
    height: f.height
  }, children: [
    /* @__PURE__ */ u.jsx(dF, { post: e }),
    C && /* @__PURE__ */ u.jsx("div", { ref: m, className: ["sp-absolute sp-left-4 sp-top-[68px] sp-w-[368px] sp-overflow-hidden sp-break-words sp-whitespace-pre-line sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline", f.captionClassName].join(" "), style: {
      height: f.captionHeight
    }, children: /* @__PURE__ */ u.jsx(r0, { caption: e.caption, charsPerLine: $r, collapsedLines: a0, contentClassName: "sp-whitespace-pre-line", expanded: i, expandOnContentClick: !0, onExpandedChange: a, targetPlatform: "FB", trackEvent: s, triggerLabel: "... See more", triggerNode: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx("span", { className: "sp-text-black", children: "... " }),
      /* @__PURE__ */ u.jsx("span", { className: "sp-text-[#808080]", children: "See more" })
    ] }), buttonClassName: "sp-bg-white sp-cursor-pointer" }) }),
    f.kind === "link" && /* @__PURE__ */ u.jsx(hF, { layout: f, post: e, videoCoverPreview: r }),
    f.kind === "video" && /* @__PURE__ */ u.jsx(fF, { layout: f, media: n[0], post: e, videoCoverPreview: r }),
    f.kind === "single-media" && /* @__PURE__ */ u.jsx(Cr, { media: n[0], mediaCount: n.length, mediaIndex: 0, rect: f.mediaRects[0], videoCoverPreview: r }),
    f.kind === "media-link" && f.mediaRects.map((g, x) => /* @__PURE__ */ u.jsx(Cr, { media: n[x], mediaCount: n.length, mediaIndex: Uu(n, x), rect: g, videoCoverPreview: r, children: g.overlayCount ? /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white", children: [
      "+",
      g.overlayCount
    ] }) : null }, qi(n[x], g))),
    f.kind === "media-link" && f.linkCardTop !== void 0 && /* @__PURE__ */ u.jsx(AF, { post: e, top: f.linkCardTop }),
    f.kind === "collage" && f.mediaRects.map((g, x) => /* @__PURE__ */ u.jsx(Cr, { media: n[x], mediaCount: n.length, mediaIndex: Uu(n, x), rect: g, videoCoverPreview: r, children: g.overlayCount ? /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white", children: [
      "+",
      g.overlayCount
    ] }) : null }, qi(n[x], g))),
    /* @__PURE__ */ u.jsx(FF, { top: f.actionsTop })
  ] }) });
}, qi = (e, t) => [e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media", t.left, t.top, t.width, t.height].join("-"), dF = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-justify-between", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-2", children: [
    /* @__PURE__ */ u.jsx(Be, { className: "sp-h-10 sp-w-10", src: e.profilePicture, alt: e.username }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-items-start sp-gap-1", children: [
      /* @__PURE__ */ u.jsx(At, { className: "sp-text-base sp-leading-none", children: e.username }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1 sp-text-sm sp-leading-none sp-text-[#808080]", children: [
        /* @__PURE__ */ u.jsx("span", { children: "Just now" }),
        /* @__PURE__ */ u.jsx("span", { "aria-hidden": "true", children: "." }),
        /* @__PURE__ */ u.jsx(BF, {})
      ] })
    ] })
  ] }),
  /* @__PURE__ */ u.jsx(Ih, { className: "sp-h-8 sp-w-8 sp-text-center sp-text-[24px] sp-leading-6 sp-text-[#65676b]", children: "..." })
] }), Cr = ({
  children: e,
  media: t,
  mediaCount: s,
  mediaIndex: r,
  rect: n,
  videoCoverPreview: i
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-overflow-hidden sp-bg-[#e4e6eb]", "data-uplift-media-frame-ratio": `${n.width} / ${n.height}`, style: {
  height: n.height,
  left: n.left,
  top: n.top,
  width: n.width
}, children: [
  t && /* @__PURE__ */ u.jsx(xe, { coverScope: "firstVideoOnly", media: t, mediaCount: s, mediaIndex: r, platform: "FB", surface: "grid", videoCoverPreview: i }),
  e
] }), fF = ({
  layout: e,
  media: t,
  post: s,
  videoCoverPreview: r
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-black", "data-uplift-media-frame-ratio": e.mediaRects[0] ? `${e.mediaRects[0].width} / ${e.mediaRects[0].height}` : void 0, style: {
  height: e.contentHeight,
  top: e.contentTop
}, children: [
  /* @__PURE__ */ u.jsx(xe, { coverScope: "singlePostOnly", media: t ?? {
    isVideo: !0,
    thumbnailUrl: s.imageUrl,
    url: s.imageUrl
  }, platform: "FB", surface: "grid", videoCoverPreview: r }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-4 sp-right-4 sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/50 sp-text-white", children: /* @__PURE__ */ u.jsx(bF, { size: 20 }) })
] }), hF = ({
  layout: e,
  post: t,
  videoCoverPreview: s
}) => {
  const r = t.medias.collection[0] ?? {
    thumbnailUrl: t.imageUrl || s,
    url: t.imageUrl || s
  };
  return /* @__PURE__ */ u.jsx("a", { className: "sp-absolute sp-left-0 sp-block sp-w-full sp-overflow-hidden sp-text-inherit sp-no-underline", href: t.redirectUrl, rel: "noreferrer", style: {
    height: e.contentHeight,
    top: e.contentTop
  }, target: "_blank", children: e.linkHasBody ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]", children: /* @__PURE__ */ u.jsx(xe, { media: r, platform: "FB", surface: "grid" }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-box-border sp-h-[55px] sp-w-full sp-bg-[#f2f2f2] sp-px-4 sp-py-2", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]", children: m0(t.redirectUrl) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]", children: t.redirectUrl })
    ] })
  ] }) : /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]", children: /* @__PURE__ */ u.jsx(xe, { media: r, platform: "FB", surface: "grid" }) }) });
}, FF = ({
  top: e
}) => /* @__PURE__ */ u.jsxs("footer", { className: "sp-absolute sp-left-0 sp-flex sp-h-10 sp-w-full sp-items-start sp-gap-8 sp-px-4 sp-text-sm sp-font-medium sp-leading-none sp-text-[#808080]", style: {
  top: e
}, children: [
  /* @__PURE__ */ u.jsx(Er, { icon: /* @__PURE__ */ u.jsx(p0, {}), count: 1 }),
  /* @__PURE__ */ u.jsx(Er, { icon: /* @__PURE__ */ u.jsx(Mr, {}), count: 1 }),
  /* @__PURE__ */ u.jsx(Er, { className: "sp-gap-1", icon: /* @__PURE__ */ u.jsx(d0, {}), count: 1 })
] }), mF = (e, t, s, r) => {
  const n = D0(e, t), i = r ?? c0({
    caption: e.caption,
    charsPerLine: n.charsPerLine,
    expanded: s,
    lineHeight: n.lineHeight
  }), a = n.className, l = i > 0, o = t.length;
  if (e.type === "video" || _e(t[0])) {
    const E = Jt(t[0], He(140, i)), p = E.top + E.height + 12;
    return {
      actionsTop: p,
      captionHeight: i,
      captionClassName: a,
      contentHeight: E.height,
      contentTop: E.top,
      dataLayout: "facebook-video",
      height: p + Oe,
      kind: "video",
      mediaRects: [E]
    };
  }
  if (e.redirectUrl && o > 0) {
    const E = Zi(t, i), p = Math.max(...E.mediaRects.map((f) => f.top + f.height)), m = p, c = m + sF + 12;
    return {
      actionsTop: c,
      captionHeight: i,
      captionClassName: a,
      contentHeight: p - E.contentTop,
      contentTop: E.contentTop,
      dataLayout: "facebook-media-link",
      height: c + Oe,
      kind: "media-link",
      linkCardTop: m,
      mediaRects: E.mediaRects
    };
  }
  if (e.redirectUrl) {
    const E = l && i >= 180, p = He(E ? 264 : 140, i), m = E ? 273 : 328, c = p + m + (E ? 16 : -1);
    return {
      actionsTop: c,
      captionHeight: i,
      captionClassName: a,
      contentHeight: m,
      contentTop: p,
      dataLayout: E ? "facebook-hashtag" : "facebook-link",
      height: c + Oe,
      kind: "link",
      linkHasBody: !E,
      mediaRects: []
    };
  }
  if (o === 0) {
    const E = He(138, i), p = i === 0 ? l0 : Math.max(E, i >= 180 ? 260 : i >= 100 ? 180 : 138);
    return {
      actionsTop: p,
      captionHeight: i,
      captionClassName: a,
      contentHeight: 0,
      contentTop: 0,
      dataLayout: "facebook-text",
      height: p + Oe,
      kind: "text",
      mediaRects: []
    };
  }
  return {
    ...Zi(t, i),
    captionHeight: i,
    captionClassName: a
  };
}, Zi = (e, t) => {
  const s = e.length;
  if (s === 1) {
    if (t >= 700) {
      const o = Jt(e[0], He(780, t)), D = o.top + o.height + 12;
      return {
        actionsTop: D,
        contentHeight: o.height,
        contentTop: o.top,
        dataLayout: "facebook-image-long",
        height: D + Oe,
        kind: "single-media",
        mediaRects: [o]
      };
    }
    if (t >= 180) {
      const o = Jt(e[0], He(264, t)), D = o.top + o.height + 12;
      return {
        actionsTop: D,
        contentHeight: o.height,
        contentTop: o.top,
        dataLayout: "facebook-image-hashtag",
        height: D + Oe,
        kind: "single-media",
        mediaRects: [o]
      };
    }
    const a = Jt(e[0], He(137, t)), l = a.top + a.height + 12;
    return {
      actionsTop: l,
      contentHeight: a.height,
      contentTop: a.top,
      dataLayout: "facebook-image",
      height: l + Oe,
      kind: "single-media",
      mediaRects: [a]
    };
  }
  if (s === 2) {
    const a = He(137, t), l = a + 196 + 10;
    return {
      actionsTop: l,
      contentHeight: 196,
      contentTop: a,
      dataLayout: "facebook-collage-2",
      height: l + Oe,
      kind: "collage",
      mediaRects: [{
        height: 196,
        left: 0,
        top: a,
        width: 196
      }, {
        height: 196,
        left: 204,
        top: a,
        width: 196
      }]
    };
  }
  if (s === 3) {
    const a = He(144, t);
    if (xF(e)) {
      const D = a + 400 + 16;
      return {
        actionsTop: D,
        contentHeight: 400,
        contentTop: a,
        dataLayout: "facebook-collage-3-portrait",
        height: D + Oe,
        kind: "collage",
        mediaRects: [{
          height: 400,
          left: 0,
          top: a,
          width: 196
        }, {
          height: 196,
          left: 204,
          top: a,
          width: 196
        }, {
          height: 196,
          left: 204,
          top: a + 204,
          width: 196
        }]
      };
    }
    const l = a + 204, o = a + 400 + 16;
    return {
      actionsTop: o,
      contentHeight: 400,
      contentTop: a,
      dataLayout: "facebook-collage-3",
      height: o + Oe,
      kind: "collage",
      mediaRects: [{
        height: 196,
        left: 0,
        top: a,
        width: 400
      }, {
        height: 196,
        left: 0,
        top: l,
        width: 196
      }, {
        height: 196,
        left: 204,
        top: l,
        width: 196
      }]
    };
  }
  if (s === 4) {
    const a = He(144, t), l = a + 204, o = a + 400 + 16;
    return {
      actionsTop: o,
      contentHeight: 400,
      contentTop: a,
      dataLayout: "facebook-collage-4",
      height: o + Oe,
      kind: "collage",
      mediaRects: [{
        height: 196,
        left: 0,
        top: a,
        width: 196
      }, {
        height: 196,
        left: 204,
        top: a,
        width: 196
      }, {
        height: 196,
        left: 0,
        top: l,
        width: 196
      }, {
        height: 196,
        left: 204,
        top: l,
        width: 196
      }]
    };
  }
  const r = He(144, t), n = r + 204, i = r + 332 + 16;
  return {
    actionsTop: i,
    contentHeight: 332,
    contentTop: r,
    dataLayout: s > 5 ? "facebook-collage-5-plus" : "facebook-collage-5",
    height: i + Oe,
    kind: "collage",
    mediaRects: [{
      height: 196,
      left: 0,
      top: r,
      width: 196
    }, {
      height: 196,
      left: 204,
      top: r,
      width: 196
    }, {
      height: 128,
      left: 0,
      top: n,
      width: 128
    }, {
      height: 128,
      left: 136,
      top: n,
      width: 128
    }, {
      height: 128,
      left: 272,
      overlayCount: s > 5 ? s - 4 : void 0,
      top: n,
      width: 128
    }]
  };
}, l0 = 68, CF = 68, EF = 12, He = (e, t) => t > 0 ? Math.max(e, CF + t + EF) : l0, Jt = (e, t) => {
  const s = Es({
    media: e,
    platform: "FB",
    surface: "grid",
    width: 400
  });
  return {
    height: s.height,
    left: 0,
    top: t,
    width: s.width
  };
}, c0 = ({
  caption: e,
  charsPerLine: t,
  expanded: s,
  lineHeight: r
}) => e.trim().length === 0 ? 0 : an({
  charsPerLine: t,
  collapsedLines: a0,
  expanded: s,
  lineHeight: r,
  text: e
}), D0 = (e, t) => t.length > 0 || e.redirectUrl ? {
  charsPerLine: $r,
  className: "sp-text-base",
  lineHeight: Gi
} : xt({
  charsPerLine: Wi,
  text: e.caption
}) <= 2 ? {
  charsPerLine: Wi,
  className: "sp-text-2xl sp-leading-[30px]",
  lineHeight: tF
} : {
  charsPerLine: $r,
  className: "sp-text-base",
  lineHeight: Gi
}, xF = (e) => e.length > 0 && e.every((t) => typeof t.width == "number" && typeof t.height == "number" && t.height > t.width), AF = ({
  post: e,
  top: t
}) => /* @__PURE__ */ u.jsxs("a", { className: "sp-absolute sp-left-0 sp-box-border sp-block sp-h-[55px] sp-w-full sp-border-0 sp-border-b sp-border-solid sp-border-[#c4c4c4] sp-bg-[#f2f2f2] sp-px-4 sp-py-2 sp-text-inherit sp-no-underline", href: e.redirectUrl, rel: "noreferrer", style: {
  top: t
}, target: "_blank", children: [
  /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]", children: m0(e.redirectUrl) }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]", children: e.redirectUrl })
] }), gF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = e.medias.collection[0], [i, a] = re(!1), l = r || n?.thumbnailUrl || e.imageUrl, o = n?.url || e.imageUrl, D = be(e.caption), E = {
    ...n || {},
    thumbnailUrl: l,
    url: o || l
  };
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-h-[800px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "), platform: "FB", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-full sp-w-full", "data-uplift-renderer": "facebook", "data-uplift-layout": "facebook-reel", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-0", "data-uplift-media-frame-ratio": "9 / 16", children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", customVideoControls: !0, media: {
      ...E,
      isVideo: _e(E)
    }, platform: "FB", surface: "reel", videoCoverPreview: r }) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-x-0 sp-top-[546px] sp-h-[254px] sp-bg-gradient-to-t sp-from-[rgba(0,0,0,0.6)] sp-to-transparent" }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-4 sp-top-8 sp-flex sp-h-6 sp-w-[368px] sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ u.jsx(F0, {}),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-4", children: [
        /* @__PURE__ */ u.jsx(f0, {}),
        /* @__PURE__ */ u.jsx(Be, { className: "sp-h-6 sp-w-6", src: e.profilePicture, alt: e.username })
      ] })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[352px] sp-top-[424px] sp-flex sp-w-8 sp-flex-col sp-gap-10 sp-text-white", children: [
      /* @__PURE__ */ u.jsx(p0, { size: 32 }),
      /* @__PURE__ */ u.jsx(Mr, { size: 32 }),
      /* @__PURE__ */ u.jsx(d0, { size: 32 }),
      /* @__PURE__ */ u.jsx(Mr, { size: 32 }),
      /* @__PURE__ */ u.jsx(h0, { size: 32 })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-5 sp-flex sp-w-[298px] sp-flex-col sp-gap-3", style: {
      bottom: o0
    }, children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ u.jsx(Be, { className: "sp-h-10 sp-w-10", src: e.profilePicture, alt: e.username }),
        /* @__PURE__ */ u.jsx(At, { className: "sp-text-white", children: e.username }),
        /* @__PURE__ */ u.jsx("button", { className: "sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white", type: "button", children: "Follow" })
      ] }),
      D && /* @__PURE__ */ u.jsx(vF, { caption: e.caption, expanded: i, onExpandedChange: a, trackEvent: s })
    ] })
  ] }) });
}, vF = ({
  caption: e,
  expanded: t,
  onExpandedChange: s,
  trackEvent: r
}) => xt({
  charsPerLine: rF,
  text: e
}) > nF ? /* @__PURE__ */ u.jsx("div", { "aria-expanded": t, className: ["sp-cursor-pointer sp-break-words sp-whitespace-pre-line sp-text-base sp-leading-5 sp-text-white [&_*]:sp-inline", t ? "sp-overflow-y-auto sp-pr-1" : "sp-line-clamp-1 sp-overflow-hidden"].filter(Boolean).join(" "), onClick: () => s(!t), onKeyDown: (i) => {
  (i.key === "Enter" || i.key === " ") && (i.preventDefault(), s(!t));
}, role: "button", style: t ? {
  maxHeight: lF
} : void 0, tabIndex: 0, children: /* @__PURE__ */ u.jsx(le, { caption: e, targetPlatform: "FB", trackEvent: r }) }) : /* @__PURE__ */ u.jsx("div", { className: "sp-text-base sp-leading-5 sp-text-white", children: /* @__PURE__ */ u.jsx(le, { caption: e, targetPlatform: "FB", trackEvent: r }) }), yF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = e.medias.collection[0], i = n?.url || e.imageUrl || n?.thumbnailUrl || "", a = r || n?.thumbnailUrl || e.imageUrl, l = {
    ...n || {},
    isVideo: _e(n) || _e({
      thumbnailUrl: a,
      url: i || a
    }),
    thumbnailUrl: a,
    url: i || a
  };
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "), platform: "FB", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-full sp-w-full", "data-uplift-renderer": "facebook", "data-uplift-layout": "facebook-story", children: [
    i ? /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-0", "data-uplift-media-frame-ratio": "9 / 16", children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", customVideoControls: !0, media: l, platform: "FB", surface: "story", videoCoverPreview: r }) }) : /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-0 sp-bg-[#1b4f9c]" }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[11px] sp-top-2.5 sp-h-1 sp-w-[380px] sp-rounded-full sp-bg-white/70", children: /* @__PURE__ */ u.jsx("div", { className: "sp-h-full sp-w-[190.504px] sp-rounded-full sp-bg-white" }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-2.5 sp-top-6 sp-flex sp-h-[36.487px] sp-w-[280px] sp-items-center sp-gap-2.5", children: [
      /* @__PURE__ */ u.jsx(Be, { className: "sp-h-[36.487px] sp-w-[36.487px]", src: e.profilePicture, alt: e.username }),
      /* @__PURE__ */ u.jsx(At, { className: "sp-text-sm sp-leading-[14px] sp-text-white", children: e.username }),
      /* @__PURE__ */ u.jsx("span", { className: "sp-text-sm sp-leading-none sp-text-white/70", children: "15h" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[317px] sp-top-[33.5px] sp-flex sp-h-[18px] sp-w-[74px] sp-items-center sp-justify-between sp-text-white", children: [
      /* @__PURE__ */ u.jsx(f0, { size: 18 }),
      /* @__PURE__ */ u.jsx(h0, { size: 18 }),
      /* @__PURE__ */ u.jsx(F0, { size: 18 })
    ] }),
    !i && be(e.caption) && /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[104px] sp-top-[341px] sp-w-[191px] sp-text-center sp-text-[22px] sp-font-semibold sp-leading-[27px] sp-text-white", children: /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "FB", trackEvent: s }) })
  ] }) });
}, Er = ({
  className: e,
  icon: t,
  count: s
}) => /* @__PURE__ */ u.jsxs("span", { className: ["sp-flex sp-items-center sp-gap-2", e].filter(Boolean).join(" "), children: [
  t,
  /* @__PURE__ */ u.jsx("span", { children: s })
] }), ru = ({
  children: e,
  size: t = 24,
  className: s = "sp-text-[#808080]"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: s, fill: "none", height: t, viewBox: "0 0 24 24", width: t, children: e }), BF = () => /* @__PURE__ */ u.jsx(ru, { size: 12, children: /* @__PURE__ */ u.jsx("path", { d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 0c2.5-2.7 3.8-5.7 3.8-9S14.5 5.7 12 3m0 18c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3M3.6 9h16.8M3.6 15h16.8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), p0 = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-current", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m0 11V10l4-8a3 3 0 0 1 3 3v4h5.7a2 2 0 0 1 2 2.3l-1.4 9a2 2 0 0 1-2 1.7H7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), Mr = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-current", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), d0 = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-current", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), f0 = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-white", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), h0 = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-white", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }) }), F0 = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-white", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "m6 6 12 12M18 6 6 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2" }) }), bF = ({
  size: e = 24
}) => /* @__PURE__ */ u.jsx(ru, { className: "sp-text-current", size: e, children: /* @__PURE__ */ u.jsx("path", { d: "M4 9v6h4l5 4V5L8 9H4Zm13 1 4 4m0-4-4 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), m0 = (e) => {
  try {
    return new URL(e).hostname;
  } catch {
    return e;
  }
}, C0 = (e) => e.type === "video" && e.providedPost?.videoPostType === "reel", ln = ({
  ariaLabel: e = "Media carousel",
  className: t,
  countClassName: s = "sp-right-2.5 sp-top-2.5",
  dotClassName: r = "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2",
  medias: n,
  onIndexChange: i,
  arrowClassName: a,
  renderSlide: l,
  showArrows: o = !0,
  showCount: D = !0,
  showDots: E = !0,
  slideClassName: p
}) => {
  const [m, c] = re(0), f = Math.min(m, Math.max(0, n.length - 1)), C = f > 0, g = f < n.length - 1, x = wF(n.length, f);
  if (n.length === 0)
    return null;
  const d = () => {
    if (C) {
      const F = f - 1;
      c(F), i?.(F);
    }
  }, h = () => {
    if (g) {
      const F = f + 1;
      c(F), i?.(F);
    }
  };
  return /* @__PURE__ */ u.jsxs("div", { "aria-label": e, className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", t].filter(Boolean).join(" "), "data-uplift-carousel-count": n.length, "data-uplift-carousel-index": f + 1, children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-full sp-transition-transform sp-duration-200", style: {
      transform: `translateX(-${f * 100}%)`
    }, children: n.map((F, A) => /* @__PURE__ */ u.jsx("div", { className: ["sp-relative sp-h-full sp-w-full sp-shrink-0", p].filter(Boolean).join(" "), "data-uplift-carousel-slide": A + 1, children: l(F, {
      index: A,
      isActive: A === f
    }) }, A)) }),
    o && C ? /* @__PURE__ */ u.jsx(Ki, { ariaLabel: "Previous media", className: ["sp-left-2", a].filter(Boolean).join(" "), direction: "previous", onClick: d }) : null,
    o && g ? /* @__PURE__ */ u.jsx(Ki, { ariaLabel: "Next media", className: ["sp-right-2", a].filter(Boolean).join(" "), direction: "next", onClick: h }) : null,
    D ? /* @__PURE__ */ u.jsxs("div", { className: ["sp-absolute sp-rounded-full sp-bg-black/40 sp-px-2 sp-py-1 sp-text-sm sp-leading-none sp-text-white", s].join(" "), children: [
      f + 1,
      "/",
      n.length
    ] }) : null,
    E ? /* @__PURE__ */ u.jsx("div", { className: ["sp-absolute sp-flex sp-items-center sp-gap-1", r].join(" "), children: x.map((F) => /* @__PURE__ */ u.jsx("span", { className: ["sp-block sp-h-1.5 sp-w-1.5 sp-rounded-full", F === f ? "sp-bg-[#0095f6]" : "sp-bg-[#c7c7c7]"].join(" "), "data-uplift-carousel-dot": F + 1 }, F)) }) : null
  ] });
}, wF = (e, t) => {
  const s = Math.min(e, 5), r = Math.max(0, e - s), n = Math.min(Math.max(0, t - 2), r);
  return Array.from({
    length: s
  }, (i, a) => n + a);
}, Ki = ({
  ariaLabel: e,
  className: t,
  direction: s,
  onClick: r
}) => /* @__PURE__ */ u.jsx("button", { "aria-label": e, className: ["sp-absolute sp-top-1/2 sp-flex sp-h-8 sp-w-8 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-white/90 sp-p-0 sp-text-black sp-shadow-[0_2px_8px_rgba(0,0,0,0.18)]", t].join(" "), onClick: r, type: "button", children: /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", fill: "none", height: "20", viewBox: "0 0 24 24", width: "20", children: s === "next" ? /* @__PURE__ */ u.jsx("path", { d: "m9 18 6-6-6-6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) : /* @__PURE__ */ u.jsx("path", { d: "m15 18-6-6 6-6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }) }), jF = /* @__PURE__ */ new Set(["image", "multiMedia"]), _F = /* @__PURE__ */ new Set(["image", "multiMedia", "reel", "story", "video"]), kF = 16, E0 = 33, cn = 52, NF = 11, Yi = 16, x0 = 4, A0 = 1, TF = 50, SF = 1, PF = (e) => e.platform === "IG" && _F.has(e.type), IF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => WF(e) ? /* @__PURE__ */ u.jsx(Xi, { post: e, className: t, trackEvent: s, videoCoverPreview: r }) : GF(e) ? /* @__PURE__ */ u.jsx(Xi, { dataLayout: "instagram-igtv", post: e, className: t, trackEvent: s, title: "Video", videoCoverPreview: r }) : e.type === "story" ? /* @__PURE__ */ u.jsx(LF, { post: e, className: t, videoCoverPreview: r }) : jF.has(e.type) ? /* @__PURE__ */ u.jsx(OF, { post: e, className: t, trackEvent: s, videoCoverPreview: r }) : null, OF = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = Dn(e), i = n.length > 1, a = be(e.caption), l = e.comment.trim(), o = e.productTags.length > 0, D = !o && e.tags.length > 0, [E, p] = re(0), [m, c] = re(!1), f = Dt(null), C = Dt(null), g = Math.min(E, Math.max(0, n.length - 1)), x = Es({
    media: n[0],
    platform: "IG",
    surface: i ? "carousel" : "feed",
    width: 400
  }), d = 57, h = d + x.height, F = h + 12.391, A = F + 11, B = F + 40, w = MF({
    actionsTop: F,
    caption: e.caption,
    captionExpanded: m,
    captionTop: B,
    firstComment: l,
    hasCaption: a,
    username: e.username
  }), k = h - 85.609, U = h - 42.609, L = ZF(n.length, g);
  return ls(() => {
    const T = f.current, S = C.current;
    if (!T || !S)
      return;
    const I = () => {
      const R = S.getBoundingClientRect().height || S.scrollHeight;
      R <= 0 || (T.style.height = `${B + R + E0}px`);
    };
    if (I(), typeof ResizeObserver > "u")
      return;
    const j = new ResizeObserver(I);
    return j.observe(S), () => j.disconnect();
  }, [m, B, l, e.caption, e.username]), /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-text-sm sp-leading-4 sp-shadow-none", t].filter(Boolean).join(" "), platform: "IG", children: /* @__PURE__ */ u.jsxs("article", { ref: f, className: "sp-relative sp-w-full", "data-uplift-renderer": "instagram", "data-uplift-layout": "instagram-feed", style: {
    height: w
  }, children: [
    /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-[10px] sp-top-[11px] sp-flex sp-h-[34px] sp-w-[380px] sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ u.jsx(RF, { post: e }),
      /* @__PURE__ */ u.jsx(pn, { className: "sp-text-black" })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-[#f2f2f2]", "data-uplift-media-frame-ratio": x.publishedRatio, style: {
      height: x.height,
      top: d
    }, children: i ? /* @__PURE__ */ u.jsx(ln, { ariaLabel: "Instagram feed carousel", countClassName: "sp-right-[10px] sp-top-[9px]", medias: n, onIndexChange: p, renderSlide: (T, {
      index: S,
      isActive: I
    }) => /* @__PURE__ */ u.jsx(ht, { className: "sp-h-full", coverScope: "none", isActive: I, media: T, mediaCount: n.length, mediaIndex: S, surface: "carousel" }), showDots: !1, showCount: !1 }) : n[0] && /* @__PURE__ */ u.jsx(ht, { media: n[0], videoCoverPreview: r, className: "sp-h-full" }) }),
    o && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Ji, { style: {
        top: k
      }, children: /* @__PURE__ */ u.jsx(em, {}) }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-0 sp-box-border sp-flex sp-h-[43px] sp-w-full sp-items-center sp-justify-between sp-bg-[#c77735] sp-px-2 sp-text-base sp-font-semibold sp-leading-4 sp-text-white", style: {
        top: U
      }, children: [
        /* @__PURE__ */ u.jsx("span", { children: "Shop now" }),
        /* @__PURE__ */ u.jsx(tm, {})
      ] })
    ] }),
    D && /* @__PURE__ */ u.jsx(Ji, { style: {
      top: U
    }, children: /* @__PURE__ */ u.jsx(um, {}) }),
    i && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[354px] sp-top-[66px] sp-flex sp-h-[27px] sp-w-9 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-text-sm sp-leading-none sp-text-white", children: [
        g + 1,
        "/",
        n.length
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[177px] sp-flex sp-h-[7px] sp-w-[47px] sp-items-center sp-justify-center sp-gap-1", style: {
        top: A
      }, children: L.map((T) => {
        const S = n[T];
        return /* @__PURE__ */ u.jsx("span", { className: ["sp-block sp-rounded-full", T === g ? "sp-h-[6px] sp-w-[6px] sp-bg-[#0095f6]" : "sp-h-[5px] sp-w-[5px] sp-bg-[#d9d9d9]"].join(" ") }, S.url ?? S.thumbnailUrl ?? S.fileName ?? `${T}-${S.type ?? "media"}-${S.width ?? "w"}x${S.height ?? "h"}`);
      }) })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-2 sp-flex sp-h-[27px] sp-w-[381px] sp-items-center sp-justify-between", style: {
      top: F
    }, children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ u.jsx(v0, {}),
        /* @__PURE__ */ u.jsx(y0, {}),
        /* @__PURE__ */ u.jsx(B0, {})
      ] }),
      /* @__PURE__ */ u.jsx(XF, {})
    ] }),
    (a || l) && /* @__PURE__ */ u.jsxs("div", { ref: C, className: "sp-absolute sp-left-[10px] sp-flex sp-w-[370px] sp-flex-col sp-gap-[11px]", "data-uplift-caption-stack": "instagram-feed", style: {
      top: B
    }, children: [
      a && /* @__PURE__ */ u.jsx(g0, { caption: e.caption, charsPerLine: cn, collapsedLines: x0, expanded: m, onExpandedChange: c, textClassName: "sp-text-sm sp-leading-4", targetPlatform: "IG", trackEvent: s, username: e.username }),
      l && /* @__PURE__ */ u.jsx($F, { username: e.username, caption: l, maxLines: A0, trackEvent: s })
    ] })
  ] }) });
}, LF = ({
  post: e,
  className: t,
  videoCoverPreview: s
}) => {
  const r = Dn(e), n = r[0], i = qF(e.storyStickerHeight);
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "), platform: "IG", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-full sp-w-full", "data-uplift-renderer": "instagram", "data-uplift-layout": "instagram-story", "data-uplift-media-frame-ratio": "9 / 16", children: [
    r.length > 1 ? /* @__PURE__ */ u.jsx(ln, { ariaLabel: "Instagram story carousel", className: "sp-absolute sp-inset-0", countClassName: "sp-right-5 sp-top-[76px]", dotClassName: "sp-left-1/2 sp-top-3 -sp-translate-x-1/2", medias: r, renderSlide: (a, {
      index: l,
      isActive: o
    }) => /* @__PURE__ */ u.jsx(ht, { className: "sp-absolute sp-inset-0 sp-h-full", coverScope: "firstVideoOnly", isActive: o, media: a, mediaCount: r.length, mediaIndex: Uu(r, l), surface: "story", videoCoverPreview: s }), showDots: !1 }) : n && /* @__PURE__ */ u.jsx(ht, { media: n, videoCoverPreview: s, className: "sp-absolute sp-inset-0 sp-h-full", surface: "story" }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[11px] sp-top-[9px] sp-h-0.5 sp-w-[378px] sp-rounded-full sp-bg-white/70" }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-6 sp-right-[11px] sp-top-7 sp-flex sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3.5", children: [
        /* @__PURE__ */ u.jsx(Be, { className: "sp-h-[34px] sp-w-[34px]", src: e.profilePicture, alt: e.username }),
        /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-2 sp-text-[15px] sp-leading-none", children: [
          /* @__PURE__ */ u.jsx("span", { className: "sp-font-semibold", children: e.username }),
          /* @__PURE__ */ u.jsx("span", { className: "sp-text-white/60", children: "15h" })
        ] })
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-5", children: [
        /* @__PURE__ */ u.jsx(pn, { className: "sp-text-white" }),
        /* @__PURE__ */ u.jsx(JF, {})
      ] })
    ] }),
    e.storyUrl && /* @__PURE__ */ u.jsxs("a", { className: "sp-absolute sp-left-[81px] sp-box-border sp-flex sp-h-11 sp-w-[238px] sp-items-center sp-justify-center sp-gap-2.5 sp-rounded-[5.666px] sp-bg-white sp-px-[13px] sp-text-center sp-text-[26.761px] sp-font-bold sp-uppercase sp-leading-[1.2] sp-text-[#436ce1] sp-no-underline sp-shadow-[2px_3px_9px_rgba(0,0,0,0.2)]", href: e.storyUrl, rel: "noreferrer", style: {
      maxWidth: "calc(100% - 32px)",
      top: `${i}px`
    }, target: "_blank", children: [
      /* @__PURE__ */ u.jsx(QF, {}),
      /* @__PURE__ */ u.jsx("span", { className: "sp-truncate", children: e.storyLabel || "View products" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[17px] sp-top-[656px] sp-flex sp-items-center sp-gap-5 sp-opacity-80", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-box-border sp-flex sp-h-[47px] sp-w-[276px] sp-items-center sp-rounded-full sp-border-[1.5px] sp-border-solid sp-border-white sp-pl-[22px] sp-pr-5 sp-text-lg sp-leading-none", children: "Send Message" }),
      /* @__PURE__ */ u.jsx(KF, {}),
      /* @__PURE__ */ u.jsx(YF, {})
    ] })
  ] }) });
}, Xi = ({
  post: e,
  className: t,
  dataLayout: s = "instagram-reel",
  trackEvent: r,
  title: n = "Reels",
  videoCoverPreview: i
}) => {
  const l = Dn(e)[0], o = be(e.caption), [D, E] = re(!1);
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "), platform: "IG", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-full sp-w-full", "data-uplift-renderer": "instagram", "data-uplift-layout": s, "data-uplift-media-frame-ratio": "9 / 16", children: [
    l && /* @__PURE__ */ u.jsx(ht, { media: l, videoCoverPreview: i, className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[710px]", customVideoControls: !0, surface: "reel" }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[254px] sp-bg-gradient-to-b sp-from-black/40 sp-to-transparent" }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-inset-x-0 sp-top-[404px] sp-h-[254px] sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent" }),
    /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-5 sp-right-5 sp-top-9 sp-flex sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ u.jsx(sm, {}),
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-lg sp-font-bold sp-leading-none sp-tracking-normal", children: n }),
      /* @__PURE__ */ u.jsx(rm, {})
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-right-5 sp-top-[344px] sp-flex sp-flex-col sp-gap-7", children: [
      /* @__PURE__ */ u.jsx(v0, { className: "sp-text-white" }),
      /* @__PURE__ */ u.jsx(y0, { className: "sp-text-white" }),
      /* @__PURE__ */ u.jsx(B0, { className: "sp-text-white" }),
      /* @__PURE__ */ u.jsx(pn, { className: "sp-text-white" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-bottom-[72px] sp-left-[19px] sp-right-16 sp-flex sp-max-h-[566px] sp-flex-col sp-gap-3 sp-overflow-hidden", "data-uplift-reel-info": "true", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-shrink-0 sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ u.jsx(Be, { className: "sp-h-[34px] sp-w-[34px]", src: e.profilePicture, alt: e.username }),
        /* @__PURE__ */ u.jsx("span", { className: "sp-text-[15px] sp-font-semibold sp-leading-none", children: e.username }),
        /* @__PURE__ */ u.jsx("button", { className: "sp-cursor-default sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white", type: "button", children: "Follow" })
      ] }),
      o && /* @__PURE__ */ u.jsx("div", { className: "sp-min-h-0 sp-overflow-y-auto", "data-uplift-reel-caption-scroll": "true", children: /* @__PURE__ */ u.jsx(g0, { caption: e.caption, charsPerLine: TF, clampCollapsedWithCss: !0, collapsedLines: SF, expanded: D, onExpandedChange: E, textClassName: "sp-whitespace-pre-line sp-text-[15px] sp-leading-[18px] sp-text-white [&_*]:sp-inline", targetPlatform: "IG", trackEvent: r }) })
    ] }),
    /* @__PURE__ */ u.jsxs("footer", { className: "sp-absolute sp-inset-x-0 sp-bottom-0 sp-flex sp-h-[52px] sp-items-center sp-justify-around sp-bg-black sp-px-6", children: [
      /* @__PURE__ */ u.jsx(nm, {}),
      /* @__PURE__ */ u.jsx(im, {}),
      /* @__PURE__ */ u.jsx(am, {}),
      /* @__PURE__ */ u.jsx(om, {}),
      /* @__PURE__ */ u.jsx(Be, { className: "sp-h-[22px] sp-w-[22px]", src: e.profilePicture, alt: e.username })
    ] })
  ] }) });
}, RF = ({
  post: e
}) => {
  const t = (e.collaboratingIgUsers ?? []).filter((r) => r.username !== e.username);
  if (t.length === 0)
    return /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2", children: [
      /* @__PURE__ */ u.jsx(Be, { className: "sp-h-[34px] sp-w-[34px]", src: e.profilePicture, alt: e.username }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-min-w-0", children: /* @__PURE__ */ u.jsx(At, { className: "sp-text-sm sp-leading-[14px]", children: e.username }) })
    ] });
  const s = t.length === 1 ? t[0]?.username : `${t.length} others`;
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-[34px] sp-w-[34px] sp-shrink-0", children: [
      /* @__PURE__ */ u.jsx(Be, { className: "sp-absolute sp-bottom-0 sp-left-0 sp-z-10 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white", src: e.profilePicture, alt: e.username }),
      /* @__PURE__ */ u.jsx(Be, { className: "sp-absolute sp-right-0 sp-top-0 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white", src: t[0]?.profilePictureUrl, alt: t[0]?.username ?? "" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0 sp-whitespace-nowrap sp-text-sm sp-leading-4 sp-text-black", children: [
      /* @__PURE__ */ u.jsx("span", { className: "sp-font-semibold", children: e.username }),
      s ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx("span", { children: " and " }),
        /* @__PURE__ */ u.jsx("span", { className: "sp-font-semibold", children: s })
      ] }) : null
    ] })
  ] });
}, g0 = ({
  caption: e,
  charsPerLine: t,
  clampCollapsedWithCss: s = !1,
  collapsedLines: r,
  expanded: n,
  onExpandedChange: i,
  targetPlatform: a,
  textClassName: l,
  trackEvent: o,
  username: D
}) => {
  const E = UF({
    caption: e,
    charsPerLine: t,
    collapsedLines: r,
    leadingText: D
  });
  return (s ? HF({
    caption: e,
    charsPerLine: t,
    leadingText: D
  }) > r : E !== e.trim()) ? /* @__PURE__ */ u.jsxs("div", { "aria-expanded": n, className: [l, "sp-cursor-pointer sp-break-words", !n && s ? zF(r) : void 0, n || s ? void 0 : "sp-overflow-hidden"].filter(Boolean).join(" "), onClick: () => i(!n), role: "button", tabIndex: 0, onKeyDown: (m) => {
    (m.key === "Enter" || m.key === " ") && (m.preventDefault(), i(!n));
  }, children: [
    D ? /* @__PURE__ */ u.jsx("span", { className: "sp-mr-1 sp-font-semibold", children: D }) : null,
    /* @__PURE__ */ u.jsx(le, { caption: n || s ? e : E, targetPlatform: a, trackEvent: o }),
    n || s ? null : /* @__PURE__ */ u.jsx("span", { className: "sp-ml-0.5 sp-font-inherit sp-leading-inherit sp-text-inherit", children: "..." })
  ] }) : /* @__PURE__ */ u.jsxs("div", { className: l, children: [
    D ? /* @__PURE__ */ u.jsx("span", { className: "sp-mr-1 sp-font-semibold", children: D }) : null,
    /* @__PURE__ */ u.jsx(le, { caption: e, targetPlatform: a, trackEvent: o })
  ] });
}, ht = ({
  media: e,
  className: t,
  coverScope: s = "singlePostOnly",
  customVideoControls: r,
  isActive: n,
  mediaCount: i,
  mediaIndex: a,
  surface: l = "feed",
  videoCoverPreview: o
}) => /* @__PURE__ */ u.jsx(xe, { className: t, coverScope: s, customVideoControls: r, isActive: n, media: e, mediaCount: i, mediaIndex: a, platform: "IG", surface: l, videoCoverPreview: o }), $F = ({
  username: e,
  caption: t,
  maxLines: s = 2,
  trackEvent: r
}) => /* @__PURE__ */ u.jsxs("div", { className: ["sp-break-words sp-text-sm sp-leading-4", s === 1 ? "sp-line-clamp-1" : s === 4 ? "sp-line-clamp-4" : "sp-line-clamp-2"].join(" "), children: [
  /* @__PURE__ */ u.jsx("span", { className: "sp-mr-1 sp-font-semibold", children: e }),
  /* @__PURE__ */ u.jsx(le, { caption: t, targetPlatform: "IG", trackEvent: r })
] }), MF = ({
  actionsTop: e,
  caption: t,
  captionExpanded: s,
  captionTop: r,
  firstComment: n,
  hasCaption: i,
  username: a
}) => {
  const l = i ? an({
    charsPerLine: cn,
    collapsedLines: x0,
    expanded: s,
    leadingText: a,
    lineHeight: Yi,
    text: t
  }) : 0, o = n ? VF({
    caption: n,
    maxLines: A0,
    username: a
  }) : 0;
  if (!l && !o)
    return e + 27 + kF;
  const D = l && o ? NF : 0;
  return r + l + o * Yi + D + E0;
}, UF = ({
  caption: e,
  charsPerLine: t,
  collapsedLines: s,
  leadingText: r
}) => {
  const n = e.trim();
  if (!n)
    return "";
  const i = r ? r.length + 1 : 0, a = t * s - i - 3;
  return n.length <= a ? n : n.slice(0, Math.max(0, a)).trimEnd();
}, HF = ({
  caption: e,
  charsPerLine: t,
  leadingText: s
}) => (s ? `${s} ${e}` : e).trim().split(/\r?\n/).reduce((n, i) => n + Math.max(1, Math.ceil(i.length / t)), 0), zF = (e) => e <= 1 ? "sp-line-clamp-1" : e === 2 ? "sp-line-clamp-2" : e === 3 ? "sp-line-clamp-3" : "sp-line-clamp-4", VF = ({
  caption: e,
  maxLines: t,
  username: s
}) => {
  const r = e.trim();
  if (!r)
    return 0;
  const i = r.split(/\r?\n/).reduce((a, l, o) => {
    const D = o === 0 ? `${s} ${l}`.length : l.length;
    return a + Math.max(1, Math.ceil(D / cn));
  }, 0);
  return Math.min(t, i);
}, Dn = (e) => e.medias.collection.length > 0 ? e.medias.collection : [{
  isVideo: !1,
  thumbnailUrl: e.imageUrl,
  url: e.imageUrl
}], WF = (e) => e.type === "video" || e.type === "reel" || e.type === "story" && e.storyType === "reel", GF = (e) => e.type === "story" && e.storyType === "igtv", qF = (e) => {
  const t = e ? Math.round(e * 560) : 131;
  return Math.max(96, Math.min(t, 590));
}, ZF = (e, t) => {
  const s = Math.min(e, 5), r = Math.max(0, e - s), n = Math.min(Math.max(0, t - 2), r);
  return Array.from({
    length: s
  }, (i, a) => n + a);
}, Te = ({
  children: e,
  className: t = "sp-text-black",
  size: s = 24,
  viewBox: r = "0 0 24 24"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: "none", height: s, viewBox: r, width: s, children: e }), Ji = ({
  children: e,
  style: t
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[10px] sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#3f3f3f]/90 sp-text-white", style: t, children: e }), v0 = ({
  className: e = "sp-text-black"
}) => /* @__PURE__ */ u.jsx(Te, { className: e, children: /* @__PURE__ */ u.jsx("path", { d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), KF = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-text-white", fill: "none", height: "22", viewBox: "0 0 24 24", width: "25.356", children: /* @__PURE__ */ u.jsx("path", { d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), y0 = ({
  className: e = "sp-text-black"
}) => /* @__PURE__ */ u.jsx(Te, { className: e, children: /* @__PURE__ */ u.jsx("path", { d: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), B0 = ({
  className: e = "sp-text-black"
}) => /* @__PURE__ */ u.jsx(Te, { className: e, children: /* @__PURE__ */ u.jsx("path", { d: "m22 2-7 20-4-9-9-4 20-7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), YF = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-text-white", fill: "none", height: "18", viewBox: "0 0 24 24", width: "22.24", children: /* @__PURE__ */ u.jsx("path", { d: "m22 2-7 20-4-9-9-4 20-7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), XF = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-text-black", fill: "none", height: "24", viewBox: "5 0 14 24", width: "14", children: /* @__PURE__ */ u.jsx("path", { d: "M6 3h12v18l-6-4-6 4V3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), pn = ({
  className: e = "sp-text-black"
}) => /* @__PURE__ */ u.jsx(Te, { className: e, viewBox: "0 0 24 24", children: /* @__PURE__ */ u.jsx("path", { d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }) }), JF = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", children: /* @__PURE__ */ u.jsx("path", { d: "m18 6-12 12M6 6l12 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2" }) }), QF = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-[#436ce1]", size: 28, children: /* @__PURE__ */ u.jsx("path", { d: "M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20.1l1.1-1.1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), em = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 16, viewBox: "0 0 16 16", children: /* @__PURE__ */ u.jsx("path", { d: "M5.25 6.25V5a2.75 2.75 0 1 1 5.5 0v1.25h1.03c.63 0 1.15.48 1.22 1.1l.58 5.25A1.25 1.25 0 0 1 12.34 14H3.66a1.25 1.25 0 0 1-1.24-1.4L3 7.35c.07-.62.59-1.1 1.22-1.1h1.03Zm1.5 0h2.5V5a1.25 1.25 0 1 0-2.5 0v1.25Zm-.75 2a.75.75 0 0 0 .75-.75H5.25c0 .41.34.75.75.75Zm4 0a.75.75 0 0 0 .75-.75h-1.5c0 .41.34.75.75.75Z", fill: "currentColor" }) }), um = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 16, viewBox: "0 0 16 16", children: /* @__PURE__ */ u.jsx("path", { d: "M8 8.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm-5.6 4.93c.62-2.33 2.74-4.05 5.6-4.05s4.98 1.72 5.6 4.05c.17.64-.35 1.07-.94 1.07H3.34c-.59 0-1.11-.43-.94-1.07Z", fill: "currentColor" }) }), tm = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "m9 4 6 7-6 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), sm = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", children: /* @__PURE__ */ u.jsx("path", { d: "m15 18-6-6 6-6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), rm = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", children: /* @__PURE__ */ u.jsx("path", { d: "M4 8a2 2 0 0 1 2-2h2l2-2h4l2 2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Zm8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), nm = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), im = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), am = () => /* @__PURE__ */ u.jsxs(Te, { className: "sp-text-white", size: 22, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M12 7v10M7 12h10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2" }),
  /* @__PURE__ */ u.jsx("rect", { height: "18", rx: "5", stroke: "currentColor", strokeWidth: "1.8", width: "18", x: "3", y: "3" })
] }), om = () => /* @__PURE__ */ u.jsx(Te, { className: "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "M4 7h16v13H4V7Zm2-4 2.5 4M12 3l2.5 4M18 3l2 4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), lm = /* @__PURE__ */ new Set(["document", "image", "multiMedia", "text", "video"]), b0 = 58, w0 = 3, cm = 20, Tu = 104, it = 12, Dm = 16, pm = 20, _u = pm + Dm, dm = 620, fm = (e) => e.platform === "LI" && lm.has(e.type) && (e.type === "document" || !Tm(e)), hm = ({
  post: e,
  className: t,
  videoCoverPreview: s,
  preferVideoCoverPreviewOverride: r,
  trackEvent: n
}) => {
  const i = jm(e), [a, l] = re(!1), o = j0(e, a), D = [e.caption, e.redirectUrl ?? "", a ? "expanded" : "collapsed"].join("|"), [E, p] = re(null), m = Dt(null), c = E?.key === D ? E.height : void 0, f = bm(e, i, a, c);
  return ls(() => {
    if (!a) {
      p(null);
      return;
    }
    const C = m.current;
    if (!C)
      return;
    const g = Math.ceil(C.scrollHeight);
    g > 0 && Math.abs(g - o) > 1 && p({
      height: g,
      key: D
    });
  }, [a, D, o]), /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-white sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "), platform: "LI", children: /* @__PURE__ */ u.jsxs("article", { className: "sp-relative sp-w-full sp-bg-white", "data-uplift-layout": f.dataLayout, "data-uplift-renderer": "linkedin", style: {
    height: f.height
  }, children: [
    /* @__PURE__ */ u.jsx(Fm, { post: e }),
    f.captionHeight > 0 && /* @__PURE__ */ u.jsx(mm, { captionRef: m, expanded: a, height: f.captionHeight, onExpandedChange: l, post: e, top: f.captionTop, trackEvent: n }),
    e.redirectUrl && f.linkRect.height > 0 && /* @__PURE__ */ u.jsx(Cm, { post: e, rect: f.linkRect }),
    f.kind === "document" && /* @__PURE__ */ u.jsx(xm, { media: f.documentMedia, rect: f.documentRect }),
    f.kind === "single-media" && /* @__PURE__ */ u.jsx(Qi, { media: i[0], mediaCount: i.length, mediaIndex: 0, preferVideoCoverPreviewOverride: r, rect: f.mediaRects[0], videoCoverPreview: s }),
    f.kind === "collage" && /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-overflow-hidden sp-bg-white", "data-linkedin-media-count": Math.min(i.length, 5), style: {
      height: 400,
      left: 0,
      top: f.collageTop,
      width: 400
    }, children: f.mediaRects.map((C, g) => /* @__PURE__ */ u.jsx(Qi, { media: i[g], mediaCount: i.length, mediaIndex: Uu(i, g), preferVideoCoverPreviewOverride: r, rect: C, videoCoverPreview: s, children: i.length > 5 && g === 4 ? /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/40 sp-text-2xl sp-font-semibold sp-leading-none sp-text-white", children: [
      "+",
      i.length - 5
    ] }) : null }, Nm(i[g], C))) }),
    f.dividerTop ? /* @__PURE__ */ u.jsx("span", { "aria-hidden": "true", className: "sp-absolute sp-left-4 sp-h-px sp-w-[368px] sp-bg-[#e6e6e6]", style: {
      top: f.dividerTop
    } }) : null,
    /* @__PURE__ */ u.jsx(Am, { top: f.actionsTop })
  ] }) });
}, Fm = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-h-[51px] sp-w-[368px] sp-items-center sp-gap-2", children: [
  /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-12 sp-w-12 sp-rounded-full", src: e.profilePicture }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-h-[51px] sp-min-w-0 sp-flex-1 sp-items-start sp-justify-between", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0", children: [
      /* @__PURE__ */ u.jsx(At, { className: "sp-text-base sp-font-semibold sp-leading-[19px]", children: e.username }),
      /* @__PURE__ */ u.jsx("div", { "aria-hidden": "true", className: "sp-h-4 sp-text-xs sp-leading-4", children: " " }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1 sp-text-xs sp-leading-4 sp-text-[#333]", children: [
        /* @__PURE__ */ u.jsx("span", { children: "Just now" }),
        /* @__PURE__ */ u.jsx("span", { className: "sp-text-sm sp-font-semibold sp-leading-4 sp-text-black", children: "·" }),
        /* @__PURE__ */ u.jsx(Im, {})
      ] })
    ] }),
    /* @__PURE__ */ u.jsx(Pm, {})
  ] })
] }), mm = ({
  captionRef: e,
  expanded: t,
  height: s,
  onExpandedChange: r,
  post: n,
  top: i,
  trackEvent: a
}) => /* @__PURE__ */ u.jsx("div", { ref: e, className: "sp-absolute sp-left-4 sp-w-[368px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-font-semibold [&_a]:sp-text-[#4f31ff] [&_a]:sp-no-underline", style: {
  height: s,
  top: i
}, children: /* @__PURE__ */ u.jsx(r0, { caption: n.caption, charsPerLine: b0, collapsedLines: w0, contentClassName: "sp-whitespace-pre-line", expanded: t, expandOnContentClick: !0, measurementText: _0(n), onExpandedChange: r, targetPlatform: "LI", trackEvent: a, triggerLabel: "...more", buttonClassName: "sp-bg-white sp-pl-1 sp-text-[#666] sp-cursor-pointer", suffix: lt(n) ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  " ",
  /* @__PURE__ */ u.jsx("a", { className: "sp-break-words sp-font-semibold sp-text-[#4f31ff] sp-no-underline", href: lt(n), rel: "noreferrer", target: "_blank", children: lt(n) })
] }) : null }) }), Qi = ({
  children: e,
  media: t,
  mediaCount: s,
  mediaIndex: r,
  preferVideoCoverPreviewOverride: n,
  rect: i,
  videoCoverPreview: a
}) => {
  const l = T0(t);
  return /* @__PURE__ */ u.jsxs(Mu, { className: "sp-absolute sp-bg-[#f2f2f2]", "data-uplift-media-frame-ratio": `${i.width} / ${i.height}`, style: {
    height: i.height,
    left: i.left,
    top: i.top,
    width: i.width
  }, children: [
    /* @__PURE__ */ u.jsx(xe, { coverScope: l ? "none" : void 0, media: t, mediaCount: s, mediaIndex: r, platform: "LI", preferVideoCoverPreviewOverride: n, surface: l ? "video" : "grid", videoCoverPreview: l ? a : void 0 }),
    l && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-right-4 sp-top-4 sp-rounded sp-bg-[#454545] sp-px-2 sp-py-1 sp-text-xs sp-font-semibold sp-leading-[15px] sp-text-white", children: "02:30" }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-4 sp-right-4 sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#454545] sp-text-white", children: /* @__PURE__ */ u.jsx(zm, {}) })
    ] }),
    e
  ] });
}, Cm = ({
  post: e,
  rect: t
}) => /* @__PURE__ */ u.jsx(Em, { "data-linkedin-link-card": "compact", style: {
  height: t.height,
  left: t.left,
  top: t.top,
  width: t.width
}, children: /* @__PURE__ */ u.jsx(ma, { className: "sp-m-0", lazy: !1, media: ["image", "logo"], size: "normal", url: e.redirectUrl }) }), Em = _.div`
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fff;

  .microlink_card {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    max-width: none;
    gap: 12px;
    align-items: center;
    padding: 12px;
    border: 0;
    border-radius: 0;
    background: #fff;
    box-shadow: none;
    --microlink-hover-background-color: #fff;
    --microlink-hover-border-color: transparent;
  }

  .microlink_card__media {
    flex: 0 0 120px;
    width: 120px;
    height: 80px;
    border-radius: 8px;
    background-color: #e6e6e6;
  }

  .microlink_card__media::before {
    display: none;
  }

  .microlink_card__content {
    flex: 1 1 auto;
    min-width: 0;
    height: 80px;
    justify-content: center;
    gap: 8px;
    padding: 0;
  }

  .microlink_card__content_title {
    flex: 0 0 auto;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333;
  }

  .microlink_card__content_description {
    display: none;
  }

  .microlink_card__content_url {
    justify-content: flex-start;
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    color: #666;
  }

  .microlink_card__content_url span[title="microlink.io"] {
    display: none;
  }
`, xm = ({
  media: e,
  rect: t
}) => {
  const s = S0(e), r = Sm(e), n = e?.thumbnailUrl || e?.url || "", i = !!(n && !ct(n));
  return /* @__PURE__ */ u.jsx("a", { className: "sp-absolute sp-box-border sp-block sp-overflow-hidden sp-bg-white sp-p-2 sp-text-inherit sp-no-underline", "data-linkedin-document-card": "true", href: e?.url || n, rel: "noreferrer", style: {
    height: t.height,
    left: t.left,
    top: t.top,
    width: t.width
  }, target: "_blank", children: /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-flex sp-h-full sp-w-full sp-gap-2 sp-overflow-hidden", children: [
    [0, 1].map((a) => /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-h-full sp-w-[200px] sp-shrink-0 sp-overflow-hidden sp-border-2 sp-border-solid sp-border-[#6840f5] sp-bg-[#f4f4f6]", children: i ? /* @__PURE__ */ u.jsx("img", { alt: "", className: "sp-h-full sp-w-full sp-object-cover", src: n }) : /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-full sp-w-full sp-items-center sp-justify-center sp-text-[#676767]", children: /* @__PURE__ */ u.jsx(Om, {}) }) }, a)),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-0 sp-top-2 sp-rounded-lg sp-bg-black/70 sp-px-2 sp-py-1 sp-text-xs sp-leading-4 sp-text-white", children: [
      /* @__PURE__ */ u.jsx("span", { className: "sp-font-semibold", children: s }),
      /* @__PURE__ */ u.jsxs("span", { children: [
        " ",
        "• ",
        r,
        " ",
        r === 1 ? "page" : "pages"
      ] })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-right-0 sp-top-1/2 sp-flex sp-h-6 sp-w-6 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-lg sp-bg-black/70 sp-text-white", children: /* @__PURE__ */ u.jsx(Um, {}) }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-0 sp-right-0 sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-rounded-lg sp-bg-black/70 sp-text-white", children: /* @__PURE__ */ u.jsx(Hm, {}) })
  ] }) });
}, Am = ({
  top: e
}) => /* @__PURE__ */ u.jsxs("footer", { className: "sp-absolute sp-left-4 sp-flex sp-h-5 sp-w-[368px] sp-items-center sp-gap-6 sp-text-sm sp-font-semibold sp-leading-none sp-text-[#676767]", style: {
  top: e
}, children: [
  /* @__PURE__ */ u.jsx(Mt, { icon: /* @__PURE__ */ u.jsx(Lm, {}), count: 1 }),
  /* @__PURE__ */ u.jsx(Mt, { icon: /* @__PURE__ */ u.jsx(Rm, {}), count: 1 }),
  /* @__PURE__ */ u.jsx(Mt, { icon: /* @__PURE__ */ u.jsx($m, {}), count: 1 }),
  /* @__PURE__ */ u.jsx(Mt, { icon: /* @__PURE__ */ u.jsx(Mm, {}), count: 1 })
] }), Mt = ({
  icon: e,
  count: t
}) => /* @__PURE__ */ u.jsxs("span", { className: "sp-flex sp-items-center sp-gap-1", children: [
  /* @__PURE__ */ u.jsx("span", { className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-leading-none", children: e }),
  /* @__PURE__ */ u.jsx("span", { className: "sp-leading-[17px]", children: t })
] }), Ue = {
  height: 0,
  left: 0,
  top: 0,
  width: 0
}, Ye = 79, dn = 72, gm = 151, vm = 159, as = 12, j0 = (e, t) => be(e.caption) ? an({
  charsPerLine: b0,
  collapsedLines: w0,
  expanded: t,
  lineHeight: cm,
  text: _0(e)
}) : 0, _0 = (e) => lt(e) ? `${e.caption} ${lt(e)}` : e.caption, lt = (e) => e.redirectUrl && !k0(e) && !e.caption.includes(e.redirectUrl) ? e.redirectUrl : "", k0 = (e) => !!(e.redirectUrl && (e.type === "text" || e.type === "image" || e.type === "multiMedia" || e.type === "video")), ym = ({
  captionExpanded: e,
  captionHeight: t,
  hasLinkCard: s
}) => {
  const r = N0(t, e), n = s ? r : 0, i = s ? n + Tu + it : r;
  return {
    firstContentTop: r,
    linkTop: n,
    mediaTop: i
  };
}, N0 = (e, t) => e > 0 ? t ? Ye + e + as : Math.max(gm, Ye + e + as) : dn, Bm = (e, t) => e > 0 ? t ? Ye + e + as : Math.max(vm, Ye + e + as) : dn, bm = (e, t, s, r) => {
  const n = e.type === "text" && !!e.redirectUrl, i = k0(e), a = r ?? j0(e, s), {
    firstContentTop: l,
    linkTop: o,
    mediaTop: D
  } = ym({
    captionExpanded: s,
    captionHeight: a,
    hasLinkCard: i
  }), E = be(e.caption) && /(^|\s)#\w+/.test(e.caption);
  if (n) {
    const c = l + Tu + it;
    return {
      actionsTop: c,
      captionHeight: a,
      captionTop: Ye,
      dataLayout: "linkedin-link",
      height: c + _u,
      kind: "link",
      documentRect: Ue,
      linkRect: {
        height: Tu,
        left: 16,
        top: l,
        width: 368
      },
      mediaRects: []
    };
  }
  if (e.type === "text" || t.length === 0) {
    const c = E ? 78 : Ye, f = a === 0 ? dn : Math.max(E ? 240 : 159, c + a + 20);
    return {
      actionsTop: f,
      captionHeight: a,
      captionTop: c,
      dataLayout: E ? "linkedin-text-hashtag" : "linkedin-text",
      dividerTop: a === 0 ? void 0 : f - 11,
      height: f + _u,
      kind: "text",
      documentRect: Ue,
      linkRect: Ue,
      mediaRects: []
    };
  }
  if (e.type === "document") {
    const c = N0(a, s), f = c + 299 + it;
    return {
      actionsTop: f,
      captionHeight: a,
      captionTop: Ye,
      dataLayout: "linkedin-document",
      documentMedia: _m(e),
      documentRect: {
        height: 299,
        left: 0,
        top: c,
        width: 400
      },
      height: f + _u,
      kind: "document",
      linkRect: Ue,
      mediaRects: []
    };
  }
  if (T0(t[0]) || e.type === "video") {
    const c = ea(t[0], "video", D), f = c.top + c.height + it;
    return {
      actionsTop: f,
      captionHeight: a,
      captionTop: Ye,
      dataLayout: i ? "linkedin-video-link" : "linkedin-video",
      height: f + _u,
      kind: "single-media",
      documentRect: Ue,
      linkRect: i ? {
        height: Tu,
        left: 16,
        top: o,
        width: 368
      } : Ue,
      mediaRects: [c]
    };
  }
  if (t.length === 1) {
    const c = ea(t[0], "grid", D), f = c.top + c.height + it, C = f + _u;
    return {
      actionsTop: f,
      captionHeight: a,
      captionTop: Ye,
      dataLayout: i ? "linkedin-image-link" : "linkedin-image",
      height: !i && a > 0 ? Math.max(C, dm) : C,
      kind: "single-media",
      documentRect: Ue,
      linkRect: i ? {
        height: Tu,
        left: 16,
        top: o,
        width: 368
      } : Ue,
      mediaRects: [c]
    };
  }
  const p = i ? D : Bm(a, s), m = p + 400 + 16;
  return {
    actionsTop: m,
    captionHeight: a,
    captionTop: 83,
    collageTop: p,
    dataLayout: `linkedin-collage-${Math.min(t.length, 5)}${t.length > 5 ? "-plus" : ""}${i ? "-link" : ""}`,
    height: m + _u,
    kind: "collage",
    documentRect: Ue,
    linkRect: i ? {
      height: Tu,
      left: 16,
      top: o,
      width: 368
    } : Ue,
    mediaRects: wm(t.length)
  };
}, ea = (e, t, s) => {
  const r = Es({
    media: e,
    platform: "LI",
    surface: t,
    width: 400
  });
  return {
    height: r.height,
    left: 0,
    top: s,
    width: r.width
  };
}, wm = (e) => e === 2 ? [{
  height: 400,
  left: 0,
  top: 0,
  width: 199
}, {
  height: 400,
  left: 201,
  top: 0,
  width: 199
}] : e === 3 ? [{
  height: 240,
  left: 0,
  top: 0,
  width: 400
}, {
  height: 158,
  left: 0,
  top: 242,
  width: 199
}, {
  height: 158,
  left: 201,
  top: 242,
  width: 199
}] : e === 4 ? [{
  height: 240,
  left: 0,
  top: 0,
  width: 400
}, {
  height: 158,
  left: 0,
  top: 242,
  width: 132
}, {
  height: 158,
  left: 134,
  top: 242,
  width: 132
}, {
  height: 158,
  left: 268,
  top: 242,
  width: 132
}] : [{
  height: 240,
  left: 0,
  top: 0,
  width: 199
}, {
  height: 240,
  left: 201,
  top: 0,
  width: 199
}, {
  height: 158,
  left: 0,
  top: 242,
  width: 132
}, {
  height: 158,
  left: 134,
  top: 242,
  width: 132
}, {
  height: 158,
  left: 268,
  top: 242,
  width: 132
}], jm = (e) => {
  if (e.type === "text")
    return [];
  const t = e.medias.collection.filter((s) => !s.url?.includes(".pdf"));
  return t.length > 0 ? t : [{
    isVideo: e.type === "video",
    thumbnailUrl: e.imageUrl,
    url: e.imageUrl
  }];
}, _m = (e) => e.medias.collection.find(fn) ?? km(e)[0] ?? (e.imageUrl ? {
  fileName: S0({
    url: e.imageUrl
  }),
  isVideo: !1,
  thumbnailUrl: e.imageUrl,
  url: e.imageUrl
} : void 0), km = (e) => e.sourcePost.medias?.medias?.filter(fn) ?? [], Nm = (e, t) => [e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media", t.left, t.top, t.width, t.height].join("-"), T0 = (e) => _e(e), fn = (e) => !!(e && (e.type === "application/pdf" || ct(e.url) || ct(e.thumbnailUrl) || ct(e.fileName))), Tm = (e) => ct(e.imageUrl) || e.medias.collection.some(fn), ct = (e) => !!e?.toLowerCase().includes(".pdf"), S0 = (e) => e?.fileName || ua(e?.url) || ua(e?.thumbnailUrl) || "Document.pdf", Sm = (e) => {
  const t = e;
  return e?.pages || t?.meta?.pages || 1;
}, ua = (e) => {
  if (!e)
    return "";
  try {
    const s = new URL(e).pathname.split("/").filter(Boolean).pop();
    return s ? decodeURIComponent(s) : "";
  } catch {
    const t = e.split("/").filter(Boolean).pop();
    return t ? decodeURIComponent(t) : "";
  }
}, Ge = ({
  children: e,
  className: t = "sp-text-current",
  size: s = 20
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: "none", height: s, viewBox: "0 0 24 24", width: s, children: e }), Pm = () => /* @__PURE__ */ u.jsx(Ge, { className: "sp-text-[#333]", size: 32, children: /* @__PURE__ */ u.jsx("path", { d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }) }), Im = () => /* @__PURE__ */ u.jsxs(Ge, { className: "sp-text-[#333]", size: 12, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }),
  /* @__PURE__ */ u.jsx("path", { d: "M3.6 9h16.8M3.6 15h16.8M12 3a13.8 13.8 0 0 1 0 18M12 3a13.8 13.8 0 0 0 0 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" })
] }), Om = () => /* @__PURE__ */ u.jsxs(Ge, { className: "sp-text-[#676767]", size: 54, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M7 3h7l5 5v13H7V3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.6" }),
  /* @__PURE__ */ u.jsx("path", { d: "M14 3v5h5M10 13h6M10 17h6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.6" })
] }), Lm = () => /* @__PURE__ */ u.jsx(Ge, { children: /* @__PURE__ */ u.jsx("path", { d: "M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m0 11V10l4-8a3 3 0 0 1 3 3v4h5.7a2 2 0 0 1 2 2.3l-1.4 9a2 2 0 0 1-2 1.7H7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), Rm = () => /* @__PURE__ */ u.jsx(Ge, { children: /* @__PURE__ */ u.jsx("path", { d: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), $m = () => /* @__PURE__ */ u.jsx(Ge, { children: /* @__PURE__ */ u.jsx("path", { d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), Mm = () => /* @__PURE__ */ u.jsx(Ge, { children: /* @__PURE__ */ u.jsx("path", { d: "m22 2-7 20-4-9-9-4 20-7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), Um = () => /* @__PURE__ */ u.jsx(Ge, { className: "sp-text-white", size: 18, children: /* @__PURE__ */ u.jsx("path", { d: "m9 18 6-6-6-6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), Hm = () => /* @__PURE__ */ u.jsx(Ge, { className: "sp-text-white", size: 16, children: /* @__PURE__ */ u.jsx("path", { d: "M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5M3 3l6 6M21 3l-6 6M3 21l6-6M21 21l-6-6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), zm = () => /* @__PURE__ */ u.jsx(Ge, { className: "sp-text-white", size: 16, children: /* @__PURE__ */ u.jsx("path", { d: "m3 9 4-4v14l-4-4H1V9h2Zm14-1 6 6m0-6-6 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), Vm = /* @__PURE__ */ new Set(["image", "multiMedia", "text", "video"]), Pe = 48, P0 = 320, Wm = 20, I0 = 24, Gm = 20, qm = 8, Zm = 8, Ut = 8, Km = 20, Ym = 2, Xm = (e) => e.platform === "TW" && Vm.has(e.type), Jm = ({
  post: e,
  className: t,
  videoCoverPreview: s,
  trackEvent: r
}) => {
  const n = nC(e), i = tC(e, n), a = be(e.caption);
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-base sp-leading-5", t].filter(Boolean).join(" "), platform: "TW", children: /* @__PURE__ */ u.jsxs("article", { className: "sp-relative sp-m-4 sp-w-[368px] sp-bg-white", "data-uplift-layout": i.dataLayout, "data-uplift-renderer": "twitter", style: {
    height: i.height
  }, children: [
    /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-absolute sp-left-0 sp-top-0 sp-h-10 sp-w-10", src: e.profilePicture }),
    /* @__PURE__ */ u.jsx(Qm, { username: e.username }),
    i.captionHeight > 0 && /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-12 sp-w-[320px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline", style: {
      height: i.captionHeight,
      top: I0
    }, children: [
      a && /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "TW", trackEvent: r }),
      e.redirectUrl && e.type !== "text" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        a && " ",
        /* @__PURE__ */ u.jsx("a", { className: "sp-break-words sp-text-[#1694e0] sp-no-underline", href: e.redirectUrl, rel: "noreferrer", target: "_blank", children: e.redirectUrl })
      ] })
    ] }),
    i.kind === "link" && /* @__PURE__ */ u.jsx(eC, { media: n[0], post: e, rect: i.linkRect }),
    i.kind === "single-media" && /* @__PURE__ */ u.jsx(ta, { media: n[0], mediaCount: n.length, mediaIndex: 0, rect: i.mediaRects[0], videoCoverPreview: s }),
    i.kind === "collage" && /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-overflow-hidden sp-rounded-lg sp-bg-white", "data-twitter-media-count": Math.min(n.length, 4), style: {
      height: 180,
      left: Pe,
      top: i.mediaTop,
      width: P0
    }, children: i.mediaRects.map((l, o) => /* @__PURE__ */ u.jsx(ta, { media: n[o], mediaCount: n.length, mediaIndex: Uu(n, o), rect: {
      ...l,
      left: l.left - Pe,
      top: l.top - i.mediaTop
    }, videoCoverPreview: hn(n[o]) ? s : void 0 }, iC(n[o], l))) }),
    /* @__PURE__ */ u.jsx(uC, { top: i.actionsTop })
  ] }) });
}, Qm = ({
  username: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-12 sp-top-0 sp-flex sp-h-6 sp-w-[320px] sp-items-center sp-justify-between sp-gap-2", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1", children: [
    /* @__PURE__ */ u.jsx("span", { className: "sp-truncate sp-text-base sp-font-semibold sp-leading-[19px] sp-text-black", children: e }),
    /* @__PURE__ */ u.jsxs("span", { className: "sp-truncate sp-text-sm sp-leading-[17px] sp-text-[#666]", children: [
      "@",
      aC(e)
    ] }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-text-sm sp-font-semibold sp-leading-[17px] sp-text-[#666]", children: "." }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-whitespace-nowrap sp-text-sm sp-leading-[17px] sp-text-[#666]", children: "Just now" })
  ] }),
  /* @__PURE__ */ u.jsx(lC, {})
] }), ta = ({
  media: e,
  mediaCount: t,
  mediaIndex: s,
  rect: r,
  videoCoverPreview: n
}) => {
  const i = hn(e);
  return /* @__PURE__ */ u.jsxs(Mu, { className: "sp-absolute sp-rounded-lg", "data-uplift-media-frame-ratio": `${r.width} / ${r.height}`, style: {
    height: r.height,
    left: r.left,
    top: r.top,
    width: r.width
  }, children: [
    /* @__PURE__ */ u.jsx(xe, { coverScope: "firstVideoOnly", media: e, mediaCount: t, mediaIndex: s, platform: "TW", surface: i ? "video" : "grid", videoCoverPreview: i ? n : void 0 }),
    i && /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-bottom-4 sp-right-4 sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#454545] sp-text-white", children: /* @__PURE__ */ u.jsx(FC, {}) })
  ] });
}, eC = ({
  media: e,
  post: t,
  rect: s
}) => (
  // Uplift link cards are static platform-shaped previews; legacy Microlink is intentionally not reused.
  /* @__PURE__ */ u.jsxs("a", { className: "sp-absolute sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline", href: t.redirectUrl, rel: "noreferrer", style: {
    height: s.height,
    left: s.left,
    top: s.top,
    width: s.width
  }, target: "_blank", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-h-[203px] sp-w-full sp-overflow-hidden sp-bg-[#d8d8d8]", children: /* @__PURE__ */ u.jsx(xe, { media: e, platform: "TW", surface: "grid" }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-box-border sp-h-[55px] sp-w-full sp-px-4 sp-py-2", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]", children: O0(t.redirectUrl) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-leading-[19px] sp-text-black", children: oC(t.redirectUrl) })
    ] })
  ] })
), uC = ({
  top: e
}) => /* @__PURE__ */ u.jsxs("footer", { className: "sp-absolute sp-left-12 sp-flex sp-h-5 sp-w-[320px] sp-items-center sp-justify-between sp-text-sm sp-leading-[17px] sp-text-[#526572]", style: {
  top: e
}, children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-start sp-gap-8", children: [
    /* @__PURE__ */ u.jsx(Ht, { icon: /* @__PURE__ */ u.jsx(cC, {}) }),
    /* @__PURE__ */ u.jsx(Ht, { icon: /* @__PURE__ */ u.jsx(DC, {}) }),
    /* @__PURE__ */ u.jsx(Ht, { icon: /* @__PURE__ */ u.jsx(pC, {}) }),
    /* @__PURE__ */ u.jsx(Ht, { icon: /* @__PURE__ */ u.jsx(dC, {}) })
  ] }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-2", children: [
    /* @__PURE__ */ u.jsx(fC, {}),
    /* @__PURE__ */ u.jsx(hC, {})
  ] })
] }), Ht = ({
  icon: e
}) => /* @__PURE__ */ u.jsxs("span", { className: "sp-flex sp-items-center sp-gap-1", children: [
  e,
  /* @__PURE__ */ u.jsx("span", { children: "1" })
] }), tC = (e, t) => {
  const s = e.type === "text" && !!e.redirectUrl, r = t[0], n = rC(e), i = ra(n);
  if (s) {
    const l = {
      height: 258,
      left: Pe,
      top: i,
      width: 320
    }, o = l.top + l.height + Ut;
    return {
      actionsTop: o,
      captionHeight: n,
      dataLayout: "twitter-link",
      height: ut(o),
      kind: "link",
      linkRect: l,
      mediaTop: i,
      mediaRects: []
    };
  }
  if (e.type === "text" && t.length === 0) {
    const l = ra(n);
    return {
      actionsTop: l,
      captionHeight: n,
      dataLayout: "twitter-text",
      height: ut(l),
      kind: "text",
      linkRect: zt,
      mediaTop: i,
      mediaRects: []
    };
  }
  if (e.type === "video" || hn(r)) {
    const l = sa(r, "video", i), o = l.top + l.height + Ut;
    return {
      actionsTop: o,
      captionHeight: n,
      dataLayout: "twitter-video",
      height: ut(o),
      kind: "single-media",
      linkRect: zt,
      mediaTop: i,
      mediaRects: [l]
    };
  }
  if (t.length <= 1) {
    const l = sa(r, "grid", i), o = l.top + l.height + Ut;
    return {
      actionsTop: o,
      captionHeight: n,
      dataLayout: "twitter-image",
      height: ut(o),
      kind: "single-media",
      linkRect: zt,
      mediaTop: i,
      mediaRects: [l]
    };
  }
  const a = i + 180 + Ut;
  return {
    actionsTop: a,
    captionHeight: n,
    dataLayout: `twitter-collage-${Math.min(t.length, 4)}${t.length > 4 ? "-plus" : ""}`,
    height: ut(a),
    kind: "collage",
    linkRect: zt,
    mediaTop: i,
    mediaRects: sC(t.length, i)
  };
}, sa = (e, t, s) => {
  const r = Es({
    media: e,
    platform: "TW",
    surface: t,
    width: P0
  });
  return {
    height: r.height,
    left: Pe,
    top: s,
    width: r.width
  };
}, zt = {
  height: 0,
  left: 0,
  top: 0,
  width: 0
}, sC = (e, t) => e === 2 ? [{
  height: 180,
  left: Pe,
  top: t,
  width: 158
}, {
  height: 180,
  left: Pe + 162,
  top: t,
  width: 158
}] : e === 3 ? [{
  height: 180,
  left: Pe,
  top: t,
  width: 158
}, {
  height: 88,
  left: Pe + 162,
  top: t,
  width: 158
}, {
  height: 88,
  left: Pe + 162,
  top: t + 92,
  width: 158
}] : [{
  height: 88,
  left: Pe,
  top: t,
  width: 158
}, {
  height: 88,
  left: Pe + 162,
  top: t,
  width: 158
}, {
  height: 88,
  left: Pe,
  top: t + 92,
  width: 158
}, {
  height: 88,
  left: Pe + 162,
  top: t + 92,
  width: 158
}], ra = (e) => e > 0 ? I0 + e + qm : Wm + Zm, ut = (e) => e + Km - Ym, rC = (e) => {
  const t = [e.caption.trim(), e.redirectUrl && e.type !== "text" ? e.redirectUrl : ""].filter(Boolean).join(" ");
  if (!t)
    return 0;
  const s = t.split(`
`).reduce((r, n) => r + Math.max(1, Math.ceil(n.length / 36)), 0);
  return Math.min(120, s * Gm);
}, nC = (e) => {
  if (e.type === "text" && !e.redirectUrl)
    return [];
  if (e.type === "text" && e.redirectUrl)
    return e.imageUrl ? [{
      isVideo: !1,
      thumbnailUrl: e.imageUrl,
      url: e.imageUrl
    }] : [];
  const t = e.medias.collection;
  return t.length > 0 ? t : [{
    isVideo: e.type === "video",
    thumbnailUrl: e.imageUrl,
    url: e.imageUrl
  }];
}, iC = (e, t) => [e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media", t.left, t.top, t.width, t.height].join("-"), hn = (e) => _e(e), aC = (e) => e.toLowerCase().replace(/[^a-z0-9_]+/g, ""), O0 = (e) => {
  try {
    return new URL(e).hostname;
  } catch {
    return e;
  }
}, oC = (e) => {
  const t = O0(e);
  return t === e ? e : t;
}, nu = ({
  children: e,
  className: t = "sp-text-current",
  size: s = 20
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: "none", height: s, viewBox: "0 0 24 24", width: s, children: e }), lC = () => /* @__PURE__ */ u.jsx(nu, { className: "sp-text-[#c4c4c4]", size: 24, children: /* @__PURE__ */ u.jsx("path", { d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }) }), cC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), DC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), pC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), dC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "M4 20V10M10.7 20V4M17.3 20v-7", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2" }) }), fC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "M6 4.5A1.5 1.5 0 0 1 7.5 3h9A1.5 1.5 0 0 1 18 4.5V21l-6-3.5L6 21V4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), hC = () => /* @__PURE__ */ u.jsx(nu, { children: /* @__PURE__ */ u.jsx("path", { d: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 16V4m0 0 4 4m-4-4-4 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), FC = () => /* @__PURE__ */ u.jsx(nu, { size: 20, children: /* @__PURE__ */ u.jsx("path", { d: "M11 5 6.5 9H3v6h3.5L11 19V5ZM17 9l4 4m0-4-4 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), mC = /* @__PURE__ */ new Set(["audio", "image", "multiMedia", "text", "video"]), CC = (e) => e.platform === "TH" && mC.has(e.type), EC = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = BC(e), i = e.type === "text" && !!e.redirectUrl, a = e.type === "audio", l = be(e.caption), o = l || !!(e.redirectUrl && e.type !== "text");
  return /* @__PURE__ */ u.jsx(Je, { className: ["sp-rounded-lg sp-border-[#e6e6e6] sp-p-4 sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "), platform: "TH", children: /* @__PURE__ */ u.jsxs("article", { className: "sp-flex sp-items-start sp-gap-2", "data-uplift-renderer": "threads", "data-uplift-layout": bC(e, n), children: [
    /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-10 sp-w-10 sp-shrink-0", src: e.profilePicture }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-2", children: [
      /* @__PURE__ */ u.jsx(xC, { username: e.username }),
      o && /* @__PURE__ */ u.jsxs("div", { className: "sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline", children: [
        l && /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "TH", trackEvent: s }),
        e.redirectUrl && e.type !== "text" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          l && " ",
          /* @__PURE__ */ u.jsx("a", { className: "sp-break-words sp-text-[#1694e0] sp-no-underline", href: e.redirectUrl, rel: "noreferrer", target: "_blank", children: e.redirectUrl })
        ] })
      ] }),
      i && /* @__PURE__ */ u.jsx(gC, { url: e.redirectUrl }),
      a && /* @__PURE__ */ u.jsx(vC, {}),
      n.length > 0 && /* @__PURE__ */ u.jsx(AC, { medias: n, videoCoverPreview: r }),
      /* @__PURE__ */ u.jsx(yC, {})
    ] })
  ] }) });
}, xC = ({
  username: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-flex sp-min-w-0 sp-items-center sp-justify-between sp-gap-2", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1", children: [
    /* @__PURE__ */ u.jsx("span", { className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5 sp-text-black", children: e }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-whitespace-nowrap sp-text-sm sp-leading-5 sp-text-[#666]", children: "Just now" })
  ] }),
  /* @__PURE__ */ u.jsx(kC, {})
] }), AC = ({
  medias: e,
  videoCoverPreview: t
}) => {
  const [s, r] = re(0), n = e.length > 0 ? s % e.length : 0;
  if (e.length === 1) {
    const o = e[0], D = Ft(o), E = Wu({
      media: o,
      platform: "TH",
      surface: D ? "video" : "grid"
    });
    return /* @__PURE__ */ u.jsx("div", { className: ["sp-relative sp-overflow-hidden sp-rounded-lg sp-bg-[#f2f2f2]", D ? "sp-w-[265px]" : "sp-w-full"].filter(Boolean).join(" "), "data-uplift-media-frame-ratio": E.publishedRatio, style: {
      aspectRatio: E.publishedRatio
    }, children: /* @__PURE__ */ u.jsx(na, { className: "sp-h-full sp-w-full", media: o, mediaCount: e.length, mediaIndex: 0, videoCoverPreview: D ? t : void 0 }) });
  }
  const i = wC(e, n), a = () => {
    r((o) => (o + e.length - 1) % e.length);
  }, l = () => {
    r((o) => (o + 1) % e.length);
  };
  return /* @__PURE__ */ u.jsxs("div", { className: "sp-relative", "data-threads-carousel-controls": "true", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-[169px] sp-w-full sp-gap-2 sp-overflow-hidden", "data-threads-carousel-start-index": n, "data-threads-media-count": i.length, children: i.map(({
      media: o,
      originalIndex: D
    }, E) => /* @__PURE__ */ u.jsx(na, { className: [E === 0 ? "sp-w-[236px]" : "sp-w-[123px]", "sp-shrink-0 sp-rounded-lg"].filter(Boolean).join(" "), media: o, mediaCount: e.length, mediaIndex: Uu(e, D), videoCoverPreview: Ft(o) ? t : void 0 }, `${o.url}-${D}`)) }),
    /* @__PURE__ */ u.jsx(ia, { ariaLabel: "Previous media", direction: "previous", onClick: a }),
    /* @__PURE__ */ u.jsx(ia, { ariaLabel: "Next media", direction: "next", onClick: l })
  ] });
}, na = ({
  media: e,
  className: t,
  children: s,
  mediaCount: r = 1,
  mediaIndex: n = 0,
  videoCoverPreview: i
}) => Ft(e) ? /* @__PURE__ */ u.jsxs(Mu, { className: ["sp-relative", t].filter(Boolean).join(" "), children: [
  /* @__PURE__ */ u.jsx(xe, { coverScope: "firstVideoOnly", media: e, mediaCount: r, mediaIndex: n, platform: "TH", surface: "video", videoCoverPreview: i }),
  s
] }) : /* @__PURE__ */ u.jsxs(Mu, { className: ["sp-relative", t].filter(Boolean).join(" "), children: [
  /* @__PURE__ */ u.jsx(xe, { media: e, platform: "TH", surface: "grid" }),
  s
] }), gC = ({
  url: e
}) => (
  // Uplift link cards are static platform-shaped previews; legacy Microlink is intentionally not reused.
  /* @__PURE__ */ u.jsxs("a", { className: "sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline", href: e, rel: "noreferrer", target: "_blank", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-h-[203px] sp-bg-[#d8d8d8]" }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-px-4 sp-py-2", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]", children: jC(e) }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-leading-5 sp-text-black", children: "Why does my dog have a pink nose?" })
    ] })
  ] })
), vC = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-box-border sp-flex sp-w-[225px] sp-items-center sp-gap-2 sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-px-4 sp-py-2", "data-threads-audio-card": "true", children: [
  /* @__PURE__ */ u.jsx(IC, {}),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-6 sp-w-[153px] sp-items-center sp-gap-0.5", children: _C.map((e, t) => /* @__PURE__ */ u.jsx("span", { className: ["sp-w-0.5 sp-rounded-full sp-bg-[#111]", e].filter(Boolean).join(" ") }, `${e}-${t}`)) })
] }), yC = () => /* @__PURE__ */ u.jsxs("footer", { className: "sp-flex sp-items-start sp-gap-6 sp-text-sm sp-leading-5 sp-text-[#526572]", children: [
  /* @__PURE__ */ u.jsx(xr, { icon: /* @__PURE__ */ u.jsx(NC, {}) }),
  /* @__PURE__ */ u.jsx(xr, { icon: /* @__PURE__ */ u.jsx(TC, {}) }),
  /* @__PURE__ */ u.jsx(xr, { icon: /* @__PURE__ */ u.jsx(SC, {}) }),
  /* @__PURE__ */ u.jsx(PC, {})
] }), xr = ({
  icon: e
}) => /* @__PURE__ */ u.jsxs("span", { className: "sp-flex sp-items-center sp-gap-1", children: [
  e,
  /* @__PURE__ */ u.jsx("span", { children: "1" })
] }), BC = (e) => {
  if (e.type === "text" || e.type === "audio")
    return [];
  const t = e.medias.collection;
  return t.length > 0 ? t : [{
    isVideo: e.type === "video",
    thumbnailUrl: e.imageUrl,
    url: e.imageUrl
  }];
}, bC = (e, t) => e.type === "audio" ? "threads-audio" : e.type === "text" && e.redirectUrl ? "threads-link" : e.type === "text" ? "threads-text" : t.length > 1 ? t.some(Ft) ? "threads-carousel-video" : "threads-carousel-image" : t[0] && Ft(t[0]) ? "threads-single-video" : "threads-single-image", Ft = (e) => _e(e), wC = (e, t) => Array.from({
  length: Math.min(e.length, 4)
}, (s, r) => {
  const n = (t + r) % e.length;
  return {
    media: e[n],
    originalIndex: n
  };
}), jC = (e) => {
  try {
    return new URL(e).hostname;
  } catch {
    return e;
  }
}, _C = ["sp-h-[8px]", "sp-h-[11px]", "sp-h-[14px]", "sp-h-[17px]", "sp-h-[20px]", "sp-h-[14px]", "sp-h-[11px]", "sp-h-[17px]", "sp-h-[20px]", "sp-h-[8px]", "sp-h-[11px]", "sp-h-[14px]", "sp-h-[17px]", "sp-h-[20px]", "sp-h-[14px]", "sp-h-[11px]", "sp-h-[17px]", "sp-h-[20px]", "sp-h-[8px]", "sp-h-[11px]", "sp-h-[14px]", "sp-h-[17px]", "sp-h-[20px]", "sp-h-[14px]"], yu = ({
  children: e,
  className: t = "sp-text-current",
  size: s = 20
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: "none", height: s, viewBox: "0 0 24 24", width: s, children: e }), kC = () => /* @__PURE__ */ u.jsx(yu, { size: 24, children: /* @__PURE__ */ u.jsx("path", { d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", fill: "currentColor" }) }), NC = () => /* @__PURE__ */ u.jsx(yu, { children: /* @__PURE__ */ u.jsx("path", { d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), TC = () => /* @__PURE__ */ u.jsx(yu, { children: /* @__PURE__ */ u.jsx("path", { d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), SC = () => /* @__PURE__ */ u.jsx(yu, { children: /* @__PURE__ */ u.jsx("path", { d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), PC = () => /* @__PURE__ */ u.jsx(yu, { children: /* @__PURE__ */ u.jsx("path", { d: "m22 2-7 20-4-9-9-4 20-7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), IC = () => /* @__PURE__ */ u.jsx(yu, { size: 24, children: /* @__PURE__ */ u.jsx("path", { d: "M8 5v14l11-7L8 5Z", fill: "currentColor" }) }), ia = ({
  ariaLabel: e,
  direction: t,
  onClick: s
}) => /* @__PURE__ */ u.jsx("button", { "aria-label": e, className: ["sp-absolute sp-top-1/2 sp-z-10 sp-flex sp-h-8 sp-w-8 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border sp-border-solid sp-border-[#d8d8d8] sp-bg-white sp-p-0 sp-text-[#526572] sp-shadow-[0_2px_6px_rgba(16,24,40,0.18)]", t === "previous" ? "sp-left-2" : "sp-right-2"].join(" "), onClick: s, style: {
  transform: "translateY(-50%)"
}, type: "button", children: /* @__PURE__ */ u.jsx(OC, { direction: t }) }), OC = ({
  direction: e
}) => /* @__PURE__ */ u.jsx(yu, { size: 18, children: /* @__PURE__ */ u.jsx("path", { d: e === "previous" ? "m15 18-6-6 6-6" : "m9 6 6 6-6 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), LC = /* @__PURE__ */ new Set(["image", "video"]), RC = (e) => e.platform === "PI" && LC.has(e.type), $C = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  if (e.type === "text")
    return null;
  const n = ZC(e), i = !!(n && R0(n)), a = GC(n), l = L0(e);
  return /* @__PURE__ */ u.jsx("div", { className: ["sp-box-border sp-mx-auto sp-overflow-hidden sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", i ? "sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-[32px]" : WC(a, l), t].filter(Boolean).join(" "), "data-preview-platform": "PI", "data-preview-variant": "uplift", children: i ? /* @__PURE__ */ u.jsx(MC, { media: n, post: e, trackEvent: s, videoCoverPreview: r }) : /* @__PURE__ */ u.jsx(UC, { layout: a, bodyHeight: l, media: n, post: e, trackEvent: s }) });
}, MC = ({
  media: e,
  post: t,
  trackEvent: s,
  videoCoverPreview: r
}) => /* @__PURE__ */ u.jsxs("article", { className: "sp-flex sp-h-full sp-flex-col", "data-uplift-layout": "pinterest-video", "data-uplift-renderer": "pinterest", children: [
  /* @__PURE__ */ u.jsx(HC, { media: e, videoCoverPreview: r }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-box-border sp-flex sp-flex-1 sp-flex-col sp-gap-3 sp-overflow-hidden sp-p-4", children: [
    /* @__PURE__ */ u.jsx(Ur, { post: t }),
    /* @__PURE__ */ u.jsx(Hr, { post: t, trackEvent: s }),
    /* @__PURE__ */ u.jsx(zr, { showVisit: !1, width: "narrow" })
  ] })
] }), UC = ({
  layout: e,
  bodyHeight: t,
  media: s,
  post: r,
  trackEvent: n
}) => e.name === "pinterest-image-portrait" ? /* @__PURE__ */ u.jsxs("article", { className: "sp-box-border sp-flex sp-w-full sp-flex-col", "data-uplift-layout": e.name, "data-uplift-renderer": "pinterest", children: [
  /* @__PURE__ */ u.jsx(aa, { layout: e, media: s }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-box-border sp-w-full sp-px-4 sp-pt-4", children: [
    /* @__PURE__ */ u.jsx(Ur, { post: r }),
    t > 0 ? /* @__PURE__ */ u.jsx(Hr, { post: r, trackEvent: n }) : null
  ] }),
  /* @__PURE__ */ u.jsx(zr, { className: "sp-mx-4 sp-mb-4 sp-mt-4", showVisit: !!r.redirectUrl, width: "narrow" })
] }) : /* @__PURE__ */ u.jsxs("article", { className: "sp-relative sp-h-full sp-w-full", "data-uplift-layout": e.name, "data-uplift-renderer": "pinterest", children: [
  /* @__PURE__ */ u.jsx(aa, { layout: e, media: s }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-4 sp-w-[368px]", style: {
    height: oa(t),
    top: e.contentTop
  }, children: [
    /* @__PURE__ */ u.jsx(Ur, { post: r }),
    t > 0 ? /* @__PURE__ */ u.jsx(Hr, { post: r, trackEvent: n }) : null
  ] }),
  /* @__PURE__ */ u.jsx(zr, { showVisit: !!r.redirectUrl, top: e.contentTop + oa(t) + 16 })
] }), aa = ({
  layout: e,
  media: t
}) => /* @__PURE__ */ u.jsx(Mu, { className: ["sp-overflow-hidden sp-bg-[#f2f2f2]", e.name !== "pinterest-image-portrait" && "sp-absolute", e.mediaClassName].filter(Boolean).join(" "), "data-uplift-media-frame-ratio": `${e.mediaWidth} / ${e.mediaHeight}`, style: {
  height: e.mediaHeight,
  left: e.name === "pinterest-image-portrait" ? void 0 : e.mediaLeft,
  top: e.name === "pinterest-image-portrait" ? void 0 : e.mediaTop,
  width: e.mediaWidth
}, children: /* @__PURE__ */ u.jsx(xe, { imageClassName: e.imageClassName, media: t, platform: "PI", surface: "pin" }) }), HC = ({
  media: e,
  videoCoverPreview: t
}) => {
  const s = Wu({
    media: e,
    platform: "PI",
    surface: "pin"
  });
  return R0(e) ? /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-w-full sp-overflow-hidden sp-rounded-t-[32px] sp-bg-[#f2f2f2]", "data-uplift-media-frame-ratio": s.publishedRatio, style: {
    aspectRatio: s.publishedRatio
  }, children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", customVideoControls: !0, media: e, platform: "PI", surface: "pin", videoCoverPreview: t }) }) : null;
}, Ur = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-flex sp-h-12 sp-items-center sp-gap-2", children: [
  /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-12 sp-w-12", src: e.profilePicture }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5", children: e.username }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-text-xs sp-leading-4 sp-text-[#1a1a1a]", children: "888 followers" })
  ] })
] }), Hr = ({
  post: e,
  trackEvent: t
}) => {
  const s = be(e.piTitle), r = be(e.caption);
  return !s && !r ? null : /* @__PURE__ */ u.jsxs("div", { className: "sp-mt-3 sp-flex sp-flex-col sp-break-words", style: {
    height: L0(e)
  }, children: [
    s ? /* @__PURE__ */ u.jsx("div", { className: "sp-line-clamp-1 sp-h-[30px] sp-text-xl sp-font-semibold sp-leading-[30px]", children: e.piTitle }) : null,
    r ? /* @__PURE__ */ u.jsx("div", { className: "sp-line-clamp-2 sp-h-10 sp-whitespace-pre-line sp-text-base sp-leading-5", children: /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "PI", trackEvent: t }) }) : null
  ] });
}, zr = ({
  className: e,
  showVisit: t,
  top: s,
  width: r = "narrow"
}) => /* @__PURE__ */ u.jsxs("footer", { className: ["sp-grid sp-h-[52px] sp-grid-cols-[24px_1fr_24px] sp-items-center", r === "wide" ? "sp-w-[400px]" : "sp-w-[368px]", s !== void 0 && "sp-absolute sp-left-4", e].filter(Boolean).join(" "), "data-pinterest-actions-width": r, style: s !== void 0 ? {
  top: s
} : void 0, children: [
  /* @__PURE__ */ u.jsx("span", { className: "sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-justify-self-start", children: /* @__PURE__ */ u.jsx(KC, {}) }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-h-[52px] sp-items-center sp-justify-center sp-gap-2 sp-justify-self-center", children: [
    t && /* @__PURE__ */ u.jsx("span", { className: "sp-flex sp-h-[52px] sp-w-20 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#efefef] sp-text-lg sp-font-semibold sp-leading-7 sp-text-[#333]", children: "Visit" }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-flex sp-h-[52px] sp-w-[94px] sp-items-center sp-justify-center sp-rounded-full sp-bg-[#e60022] sp-text-lg sp-font-semibold sp-leading-7 sp-text-white", children: "Saved" })
  ] }),
  /* @__PURE__ */ u.jsx("span", { className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-justify-self-end", children: /* @__PURE__ */ u.jsx(YC, {}) })
] }), zC = {
  actionsTop: 426,
  contentTop: 280,
  imageClassName: "sp-object-[center_35%]",
  mediaClassName: "sp-rounded-t-[32px]",
  mediaHeight: 264,
  mediaLeft: 0,
  mediaTop: 0,
  mediaWidth: 400,
  name: "pinterest-image-horizontal",
  shellClassName: "sp-h-[494px] sp-w-[400px] sp-rounded-[32px]"
}, VC = {
  actionsTop: 694,
  contentTop: 532,
  imageClassName: "sp-object-[center_38%]",
  mediaClassName: "sp-rounded-t-[32px]",
  mediaHeight: 516,
  mediaLeft: 0,
  mediaTop: 0,
  mediaWidth: 400,
  name: "pinterest-image-portrait",
  shellClassName: "sp-min-h-[746px] sp-w-[400px] sp-rounded-[32px]"
}, L0 = (e) => {
  const t = be(e.piTitle), s = be(e.caption);
  return t && s ? 70 : t ? 30 : s ? 40 : 0;
}, oa = (e) => e > 0 ? 60 + e : 48, WC = (e, t) => {
  if (e.name === "pinterest-image-portrait")
    return t === 70 ? e.shellClassName : "sp-w-[400px] sp-rounded-[32px]";
  switch (t) {
    case 0:
      return "sp-h-[412px] sp-w-[400px] sp-rounded-[32px]";
    case 30:
      return "sp-h-[454px] sp-w-[400px] sp-rounded-[32px]";
    case 40:
      return "sp-h-[464px] sp-w-[400px] sp-rounded-[32px]";
    default:
      return e.shellClassName;
  }
}, GC = (e) => {
  const t = qC(e);
  return t !== void 0 && t < 1 ? VC : zC;
}, qC = (e) => {
  if (!(!e?.width || !e.height || e.width <= 0 || e.height <= 0))
    return e.width / e.height;
}, ZC = (e) => e.medias.collection[0] || {
  isVideo: e.type === "video",
  thumbnailUrl: e.imageUrl,
  url: e.imageUrl
}, R0 = (e) => _e(e), $0 = ({
  children: e,
  className: t = "sp-text-current",
  size: s = 24,
  viewBox: r = "0 0 24 24"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: "none", height: s, viewBox: r, width: s, children: e }), KC = () => /* @__PURE__ */ u.jsxs($0, { children: [
  /* @__PURE__ */ u.jsx("path", { d: "M5.25 4.75h13.5a1.75 1.75 0 0 1 1.75 1.75v8.75A1.75 1.75 0 0 1 18.75 17H12l-5.5 4v-4H5.25a1.75 1.75 0 0 1-1.75-1.75V6.5a1.75 1.75 0 0 1 1.75-1.75Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "2" }),
  /* @__PURE__ */ u.jsx("path", { d: "M12 14.25s-3.75-2.15-3.75-4.55c0-1.15.85-2.05 1.95-2.05.7 0 1.35.38 1.8.98.45-.6 1.1-.98 1.8-.98 1.1 0 1.95.9 1.95 2.05 0 2.4-3.75 4.55-3.75 4.55Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.6" })
] }), YC = () => /* @__PURE__ */ u.jsx($0, { size: 20, children: /* @__PURE__ */ u.jsx("path", { d: "M10 4h5.5a1.5 1.5 0 0 1 1.5 1.5V11m-4-7h4v4M17 4 9 12M6 8.5H4.5A1.5 1.5 0 0 0 3 10v5.5A1.5 1.5 0 0 0 4.5 17h5.5a1.5 1.5 0 0 0 1.5-1.5V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), XC = /* @__PURE__ */ new Set(["image", "multiMedia", "video"]), JC = 36, QC = 2, eE = (e) => {
  if (e.platform !== "TT" || !XC.has(e.type))
    return !1;
  const t = M0(e);
  return e.type === "video" || t.every((r) => !U0(r));
}, uE = ({
  post: e,
  className: t,
  trackEvent: s,
  videoCoverPreview: r
}) => {
  const n = M0(e), i = e.type === "video" || U0(n[0]), a = i ? "tiktok-video" : "tiktok-carousel-photo", l = n[0];
  return /* @__PURE__ */ u.jsxs("div", { className: ["sp-relative sp-mx-auto sp-h-[856px] sp-w-[400px] sp-overflow-hidden sp-rounded-none sp-bg-black sp-font-sans sp-text-white sp-shadow-none sp-antialiased", t].filter(Boolean).join(" "), "data-preview-platform": "TT", "data-preview-variant": "uplift", "data-uplift-layout": a, "data-uplift-renderer": "tiktok", children: [
    i ? /* @__PURE__ */ u.jsx(tE, { isVideoPost: i, media: l, videoCoverPreview: r }) : /* @__PURE__ */ u.jsx(sE, { medias: n }),
    i ? /* @__PURE__ */ u.jsx(rE, {}) : null,
    /* @__PURE__ */ u.jsx(nE, {}),
    /* @__PURE__ */ u.jsx(aE, { post: e }),
    /* @__PURE__ */ u.jsx(oE, { post: e, trackEvent: s }),
    /* @__PURE__ */ u.jsx(lE, {})
  ] });
}, tE = ({
  media: e,
  isVideoPost: t,
  videoCoverPreview: s
}) => {
  const r = e?.url || e?.thumbnailUrl || "";
  return t ? /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-0 sp-top-0 sp-h-[856px] sp-w-full sp-bg-[#1c1c1c]", "data-uplift-media-frame-ratio": "9 / 16", children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full sp-object-cover", coverScope: "singlePostOnly", customVideoControls: !0, media: e, platform: "TT", surface: "video", videoCoverPreview: s }) }) : /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]", children: r && /* @__PURE__ */ u.jsx(xe, { media: e, platform: "TT", surface: "carousel" }) });
}, sE = ({
  medias: e
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]", children: /* @__PURE__ */ u.jsx(ln, { ariaLabel: "TikTok photo carousel", arrowClassName: "sp-z-20", dotClassName: "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2", medias: e, renderSlide: (t, {
  index: s,
  isActive: r
}) => /* @__PURE__ */ u.jsx(xe, { isActive: r, media: t, mediaCount: e.length, mediaIndex: s, platform: "TT", surface: "carousel" }), showCount: !1 }) }), rE = () => /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-0 sp-top-[532px] sp-h-[254px] sp-w-full sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent sp-opacity-50" }), nE = () => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-4 sp-right-4 sp-top-[50px] sp-flex sp-items-start sp-justify-between", children: [
  /* @__PURE__ */ u.jsx(iE, {}),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[107px] sp-top-[5px] sp-flex sp-items-start sp-gap-[19px] sp-text-base sp-font-semibold sp-leading-[1.21] sp-tracking-[0.24px] sp-drop-shadow-[0_5px_12px_rgba(0,0,0,0.15)]", children: [
    /* @__PURE__ */ u.jsx("span", { className: "sp-opacity-60", children: "Following" }),
    /* @__PURE__ */ u.jsxs("span", { className: "sp-relative", children: [
      "For you",
      /* @__PURE__ */ u.jsx("span", { className: "sp-absolute sp-left-1/2 sp-top-[27px] sp-h-[2px] sp-w-[26px] -sp-translate-x-1/2 sp-bg-white" })
    ] })
  ] }),
  /* @__PURE__ */ u.jsx(DE, { className: "sp-absolute sp-left-[346px] sp-top-[5px] sp-text-white" })
] }), iE = () => /* @__PURE__ */ u.jsxs(Qe, { className: "sp-text-white", size: 30, viewBox: "0 0 30 28", children: [
  /* @__PURE__ */ u.jsx("path", { d: "M6.5 5.5h17c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2h-17c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2ZM10.5 5.5 7.5 2M18.5 5.5 22 2M8 26h14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }),
  /* @__PURE__ */ u.jsx("text", { fill: "currentColor", fontFamily: "Inter, sans-serif", fontSize: "8.8", fontWeight: "700", textAnchor: "middle", x: "15", y: "17.2", children: "LIVE" })
] }), aE = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("aside", { className: "sp-absolute sp-left-[332px] sp-top-[412px] sp-flex sp-w-[45px] sp-flex-col sp-items-center sp-gap-9", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-[58.273px] sp-w-[45px]", children: [
    /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-box-border sp-h-[45px] sp-w-[45px] sp-border-2 sp-border-white", src: e.profilePicture }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-absolute sp-bottom-[-10px] sp-left-1/2 sp-flex sp-h-[20px] sp-w-[20px] -sp-translate-x-1/2 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#fe2c55] sp-text-lg sp-font-semibold sp-leading-none", children: "+" })
  ] }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-[31px] sp-w-[34.207px] sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx(pE, {}) }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-[33.246px] sp-w-[34.354px] sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx(dE, {}) }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-[27.491px] sp-w-[35.51px] sp-items-center sp-justify-center", children: /* @__PURE__ */ u.jsx(fE, {}) })
] }), oE = ({
  post: e,
  trackEvent: t
}) => {
  const s = be(e.caption), [r, n] = re(!1), i = s && xt({
    charsPerLine: JC,
    text: e.caption
  }) > QC;
  return /* @__PURE__ */ u.jsxs("div", { className: ["sp-absolute sp-left-4 sp-w-[315px] sp-text-sm sp-leading-[1.1]", s ? "sp-bottom-[84px] sp-min-h-[64px]" : "sp-top-[708px]"].join(" "), "data-uplift-tiktok-caption": "true", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-font-bold sp-leading-normal", children: e.username }),
    s ? /* @__PURE__ */ u.jsxs("div", { className: ["sp-relative sp-mt-1", r ? "sp-max-h-[200px] sp-overflow-y-auto" : ""].filter(Boolean).join(" "), children: [
      /* @__PURE__ */ u.jsx("div", { "aria-expanded": i ? r : void 0, className: ["sp-break-words", !r && i ? "sp-w-[261px] sp-line-clamp-2" : "sp-pr-2"].join(" "), children: /* @__PURE__ */ u.jsx(le, { caption: e.caption, targetPlatform: "TT", trackEvent: t }) }),
      i ? /* @__PURE__ */ u.jsx("button", { "aria-expanded": r, className: ["sp-border-0 sp-bg-transparent sp-p-0 sp-text-left sp-font-medium sp-leading-[1.33] sp-text-white sp-opacity-80", r ? "sp-mt-1" : "sp-absolute sp-bottom-0 sp-left-[267px]"].join(" "), onClick: () => n(!r), type: "button", children: r ? "less" : "more" }) : null
    ] }) : null
  ] });
}, lE = () => /* @__PURE__ */ u.jsxs("nav", { className: "sp-absolute sp-left-0 sp-top-[786px] sp-h-[70px] sp-w-full sp-bg-[#070707]", children: [
  /* @__PURE__ */ u.jsx(Vt, { className: "sp-left-[26px] sp-top-1.5 sp-w-[26px]", icon: /* @__PURE__ */ u.jsx(hE, {}), label: "Home" }),
  /* @__PURE__ */ u.jsx(Vt, { className: "sp-left-[104px] sp-top-2 sp-w-[33px]", icon: /* @__PURE__ */ u.jsx(FE, {}), label: "Friends" }),
  /* @__PURE__ */ u.jsx(cE, {}),
  /* @__PURE__ */ u.jsx(Vt, { className: "sp-left-[268px] sp-top-2 sp-w-6", icon: /* @__PURE__ */ u.jsx(mE, {}), label: "Inbox" }),
  /* @__PURE__ */ u.jsx(Vt, { className: "sp-left-[346px] sp-top-2 sp-w-7", icon: /* @__PURE__ */ u.jsx(CE, {}), label: "Profile" })
] }), Vt = ({
  className: e,
  icon: t,
  label: s
}) => /* @__PURE__ */ u.jsxs("div", { className: ["sp-absolute sp-flex sp-flex-col sp-items-center sp-gap-0.5 sp-text-[9px] sp-font-medium sp-leading-[1.33]", e].join(" "), children: [
  t,
  /* @__PURE__ */ u.jsx("span", { children: s })
] }), cE = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[178.49px] sp-top-2 sp-h-[29.318px] sp-w-[44.821px]", children: [
  /* @__PURE__ */ u.jsx("span", { className: "sp-absolute sp-left-[7.91px] sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#fe2c55]" }),
  /* @__PURE__ */ u.jsx("span", { className: "sp-absolute sp-left-0 sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#20d5ec]" }),
  /* @__PURE__ */ u.jsx("span", { className: "sp-absolute sp-left-[3.955px] sp-top-0 sp-flex sp-h-[29.002px] sp-w-[36.912px] sp-items-center sp-justify-center sp-rounded-[6.435px] sp-bg-white sp-text-[23px] sp-leading-none sp-text-[#333]", children: "+" })
] }), M0 = (e) => (e.medias.collection.length ? e.medias.collection : [{
  isVideo: e.type === "video",
  thumbnailUrl: e.imageUrl,
  url: e.imageUrl
}]).filter(Boolean), U0 = (e) => _e(e), Qe = ({
  children: e,
  className: t = "sp-text-current",
  fill: s = "none",
  size: r = 24,
  viewBox: n = "0 0 24 24"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: s, height: r, viewBox: n, width: r, children: e }), DE = ({
  className: e
}) => /* @__PURE__ */ u.jsx(Qe, { className: e ?? "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "m20 20-4.3-4.3m2.3-5.2a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2.2" }) }), pE = () => /* @__PURE__ */ u.jsx(Qe, { className: "sp-text-white", fill: "currentColor", size: 45, children: /* @__PURE__ */ u.jsx("path", { d: "M12 21.4 10.6 20C5.6 15.5 2.3 12.5 2.3 8.8 2.3 5.8 4.7 3.5 7.6 3.5c1.7 0 3.3.8 4.4 2 1-1.2 2.7-2 4.4-2 3 0 5.3 2.3 5.3 5.3 0 3.7-3.3 6.7-8.3 11.2L12 21.4Z" }) }), dE = () => /* @__PURE__ */ u.jsxs(Qe, { className: "sp-text-white", fill: "currentColor", size: 45, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M4 11.5C4 7.4 7.6 4 12 4s8 3.4 8 7.5S16.4 19 12 19c-.8 0-1.7-.1-2.4-.4L5.7 21l1-3.9A7.2 7.2 0 0 1 4 11.5Z" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "8.8", cy: "11.5", fill: "black", r: "1" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "11.5", fill: "black", r: "1" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "15.2", cy: "11.5", fill: "black", r: "1" })
] }), fE = () => /* @__PURE__ */ u.jsx(Qe, { className: "sp-text-white", fill: "currentColor", size: 45, children: /* @__PURE__ */ u.jsx("path", { d: "M20 3v7.2C12.6 10.7 8.2 14.1 6.4 21 5.8 14 9.2 8.1 20 7.3V3Z" }) }), hE = () => /* @__PURE__ */ u.jsx(Qe, { className: "sp-text-white", fill: "currentColor", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "M3 10.5 11 3l8 7.5V20h-5v-6H8v6H3v-9.5Z" }) }), FE = () => /* @__PURE__ */ u.jsx(Qe, { className: "sp-text-white", size: 22, children: /* @__PURE__ */ u.jsx("path", { d: "M8.5 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3 19c.5-3.4 2.4-5.2 5.5-5.2S13.5 15.6 14 19H3Zm10.5-3.8c.7-.7 1.6-1 2.8-1 2.3 0 3.7 1.3 4.1 3.8h-4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8" }) }), mE = () => /* @__PURE__ */ u.jsxs(Qe, { className: "sp-text-white", size: 22, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M4 5h16v12H8l-4 3V5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }),
  /* @__PURE__ */ u.jsx("path", { d: "M8 9h8M8 13h5", stroke: "currentColor", strokeWidth: "1.8" })
] }), CE = () => /* @__PURE__ */ u.jsxs(Qe, { className: "sp-text-white", size: 22, children: [
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "7", r: "3.2", stroke: "currentColor", strokeWidth: "1.8" }),
  /* @__PURE__ */ u.jsx("path", { d: "M5 20c.8-4.1 3.1-6.1 7-6.1s6.2 2 7 6.1", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.8" })
] }), EE = /* @__PURE__ */ new Set(["gmb", "image", "multiMedia", "text", "video"]), xE = (e) => e.platform === "GMB" && EE.has(e.type) && !!W0(e), AE = ({
  post: e,
  className: t,
  videoCoverPreview: s
}) => {
  const r = W0(e), n = G0(e), i = q0(e.callToAction), a = _E(e.event), l = !!(a && kE(a)) && (e.topicType === "EVENT" || e.topicType === "OFFER" || r === "gmb-single-image-buy" || r === "gmb-single-image-sign-up"), o = be(e.caption);
  return r ? /* @__PURE__ */ u.jsxs("article", { className: Hu("sp-relative sp-mx-auto sp-w-[400px] sp-overflow-hidden sp-rounded-lg sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", SE(r, o), t), "data-preview-platform": "GMB", "data-preview-variant": "uplift", "data-uplift-layout": r, "data-uplift-renderer": "google-my-business", children: [
    /* @__PURE__ */ u.jsx(gE, { post: e }),
    r === "gmb-text" ? /* @__PURE__ */ u.jsx(la, { action: i, caption: e.caption }) : null,
    r === "gmb-link" ? /* @__PURE__ */ u.jsx(la, { action: i, caption: e.caption, captionClassName: "sp-line-clamp-8" }) : null,
    r.startsWith("gmb-single-image") ? /* @__PURE__ */ u.jsx(vE, { action: i, event: a, media: n[0], post: e, showEvent: l, hasCaption: o }) : null,
    r === "gmb-carousel" || r === "gmb-carousel-book" ? /* @__PURE__ */ u.jsx(yE, { action: i, hasCaption: o, medias: n, post: e }) : null,
    r === "gmb-video" || r === "gmb-video-learn-more" ? /* @__PURE__ */ u.jsx(BE, { action: i, hasCaption: o, media: n[0], post: e, videoCoverPreview: s }) : null
  ] }) : null;
}, gE = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-gap-2", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-relative sp-h-12 sp-w-12 sp-shrink-0", children: [
    /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-12 sp-w-12", src: e.profilePicture }),
    /* @__PURE__ */ u.jsx(RE, {})
  ] }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-flex-1 sp-items-center sp-justify-between", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-flex-col sp-justify-center sp-gap-1", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-font-normal sp-leading-none sp-text-black", children: e.username }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-sm sp-font-normal sp-leading-none sp-text-[#4d4d4d]", children: "Just now" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-shrink-0 sp-items-start sp-gap-2 sp-text-black", children: [
      /* @__PURE__ */ u.jsx($E, {}),
      /* @__PURE__ */ u.jsx(ME, {})
    ] })
  ] })
] }), la = ({
  action: e,
  caption: t,
  captionClassName: s
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-ml-[15px] sp-mr-[17px] sp-pt-[75px] sp-pb-[17px]", children: [
  /* @__PURE__ */ u.jsx(z0, { caption: t, className: s }),
  /* @__PURE__ */ u.jsx(xs, { action: e, className: "sp-static sp-mt-6" })
] }), vE = ({
  action: e,
  event: t,
  media: s,
  post: r,
  hasCaption: n,
  showEvent: i
}) => /* @__PURE__ */ u.jsxs("div", { className: "sp-pt-[79px]", children: [
  /* @__PURE__ */ u.jsx(jE, { media: s }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-ml-[15px] sp-mr-[17px] sp-mt-4 sp-pb-[17px]", children: [
    i ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(bE, { event: t }),
      /* @__PURE__ */ u.jsx(wE, { event: t })
    ] }) : null,
    n ? /* @__PURE__ */ u.jsx(z0, { caption: r.caption, className: i ? "sp-mt-4" : void 0 }) : null,
    /* @__PURE__ */ u.jsx(xs, { action: e, className: "sp-static sp-mt-6" })
  ] })
] }), yE = ({
  action: e,
  hasCaption: t,
  medias: s,
  post: r
}) => {
  const n = s[0], i = s[1] || s[0];
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[340px] sp-w-[632px] sp-overflow-hidden", children: [
      /* @__PURE__ */ u.jsx(ca, { className: "sp-left-0 sp-top-0 sp-h-[340px] sp-w-[340px]", media: n, surface: "carousel" }),
      /* @__PURE__ */ u.jsx(ca, { className: "sp-left-[348px] sp-top-0 sp-h-[340px] sp-w-[340px]", media: i, surface: "carousel" })
    ] }),
    /* @__PURE__ */ u.jsxs("span", { className: "sp-absolute sp-left-[347px] sp-top-[95px] sp-rounded-[24px] sp-bg-black/40 sp-px-2 sp-py-0.5 sp-text-xs sp-font-medium sp-leading-5 sp-text-white", children: [
      "1/",
      Math.max(1, s.length)
    ] }),
    t ? /* @__PURE__ */ u.jsx(H0, { caption: r.caption, className: "sp-left-4 sp-top-[435px] sp-line-clamp-4" }) : null,
    /* @__PURE__ */ u.jsx(xs, { action: e, className: t ? "sp-top-[559px]" : "sp-top-[435px]" })
  ] });
}, BE = ({
  action: e,
  hasCaption: t,
  media: s,
  post: r,
  videoCoverPreview: n
}) => {
  const i = s?.url || r.imageUrl || s?.thumbnailUrl || "", a = n || s?.thumbnailUrl || r.imageUrl || i;
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]", "data-uplift-media-frame-ratio": "400 / 264", children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", customVideoControls: !0, media: {
      ...s || {},
      isVideo: !0,
      thumbnailUrl: a,
      url: i
    }, platform: "GMB", surface: "video", videoCoverPreview: n }) }),
    t ? /* @__PURE__ */ u.jsx(H0, { caption: r.caption, className: "sp-left-4 sp-top-[360px] sp-line-clamp-5" }) : null,
    /* @__PURE__ */ u.jsx(xs, { action: e, className: t ? void 0 : "sp-top-[360px]" })
  ] });
}, H0 = ({
  caption: e = "",
  className: t
}) => be(e) ? /* @__PURE__ */ u.jsx("div", { className: Hu("sp-absolute sp-w-[368px] sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", t), children: /* @__PURE__ */ u.jsx(V0, { caption: e }) }) : null, z0 = ({
  caption: e = "",
  className: t
}) => {
  if (!be(e))
    return null;
  const s = t?.includes("sp-line-clamp-") ? t : Hu("sp-line-clamp-5", t);
  return /* @__PURE__ */ u.jsx("div", { className: Hu("sp-w-full sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", s), children: /* @__PURE__ */ u.jsx(V0, { caption: e }) });
}, V0 = ({
  caption: e
}) => {
  if (!e)
    return null;
  const t = e.split(IE);
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: t.map((s, r) => s ? OE.test(s) ? /* @__PURE__ */ u.jsx("a", { href: s, rel: "noreferrer", target: "_blank", children: s }, `${s}-${r}`) : s : null) });
}, bE = ({
  event: e
}) => /* @__PURE__ */ u.jsx("p", { className: "sp-m-0 sp-w-full sp-truncate sp-text-xl sp-font-medium sp-leading-7 sp-text-[#202125]", children: e?.title || "PINK NOSE DOG" }), wE = ({
  event: e
}) => {
  const t = NE(e);
  return /* @__PURE__ */ u.jsx("p", { className: "sp-m-0 sp-mt-[10px] sp-w-full sp-truncate sp-text-sm sp-font-medium sp-leading-5 sp-text-[#70747a]", children: t });
}, jE = ({
  media: e
}) => {
  const t = e?.url || e?.thumbnailUrl || "";
  return /* @__PURE__ */ u.jsx("div", { className: "sp-ml-[-1px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]", "data-uplift-media-frame-ratio": "400 / 264", children: t ? /* @__PURE__ */ u.jsx(xe, { media: e, platform: "GMB", surface: "feed" }) : null });
}, ca = ({
  className: e,
  media: t,
  surface: s = "feed"
}) => {
  const r = t?.url || t?.thumbnailUrl || "";
  return /* @__PURE__ */ u.jsx("div", { className: Hu("sp-absolute sp-overflow-hidden sp-bg-[#e6e6e6]", e || "sp-left-0 sp-top-[80px] sp-h-[264px] sp-w-[400px]"), "data-uplift-media-frame-ratio": s === "carousel" ? "1 / 1" : "400 / 264", children: r ? /* @__PURE__ */ u.jsx(xe, { media: t, platform: "GMB", surface: s }) : null });
}, xs = ({
  action: e,
  className: t
}) => {
  if (!e)
    return null;
  const s = t?.includes("sp-static"), r = /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(LE, { icon: e.icon }),
    /* @__PURE__ */ u.jsx("span", { className: "sp-text-sm sp-font-medium sp-leading-5 sp-text-[#3771e0]", children: e.label })
  ] }), n = Hu(s ? null : "sp-absolute sp-left-4", "sp-box-border sp-flex sp-h-10 sp-w-fit sp-items-center sp-gap-1 sp-rounded-[20px] sp-border sp-border-solid sp-border-[#c4c4c4] sp-px-4 sp-py-2 sp-text-[#3771e0] sp-no-underline", t || "sp-top-[484px]");
  return e.url ? /* @__PURE__ */ u.jsx("a", { className: n, href: e.url, rel: "noreferrer", target: "_blank", children: r }) : /* @__PURE__ */ u.jsx("div", { className: n, children: r });
}, W0 = (e) => {
  const t = G0(e), s = q0(e.callToAction), r = t.length > 0, n = t.some(PE);
  if (!r && (e.type === "text" || e.type === "gmb"))
    return e.redirectUrl ? "gmb-link" : "gmb-text";
  if (n)
    return s ? s.actionType === "LEARN_MORE" ? "gmb-video-learn-more" : null : "gmb-video";
  if (t.length > 1)
    return s ? s.actionType === "BOOK" ? "gmb-carousel-book" : null : "gmb-carousel";
  if (!r)
    return null;
  if (!s)
    return "gmb-single-image";
  switch (s.actionType) {
    case "BOOK":
      return "gmb-single-image-book";
    case "LEARN_MORE":
      return "gmb-single-image-learn-more";
    case "SHOP":
      return "gmb-single-image-buy";
    case "SIGN_UP":
      return "gmb-single-image-sign-up";
    default:
      return "gmb-single-image";
  }
}, G0 = (e) => (e.medias.collection.length ? e.medias.collection : e.imageUrl ? [{
  isVideo: e.type === "video",
  thumbnailUrl: e.imageUrl,
  url: e.imageUrl
}] : []).filter(Boolean), q0 = (e) => {
  if (!e || typeof e == "string")
    return null;
  switch (e.actionType) {
    case "BOOK":
      return {
        actionType: "BOOK",
        icon: "book",
        label: "Book",
        url: e.url
      };
    case "CALL":
      return {
        actionType: "CALL",
        icon: "info",
        label: "Call now",
        url: e.url
      };
    case "LEARN_MORE":
      return {
        actionType: "LEARN_MORE",
        icon: "info",
        label: "Learn more",
        url: e.url
      };
    case "ORDER":
      return {
        actionType: "ORDER",
        icon: "shopping-cart",
        label: "Order online",
        url: e.url
      };
    case "SHOP":
      return {
        actionType: "SHOP",
        icon: "shopping-cart",
        label: "Buy",
        url: e.url
      };
    case "SIGN_UP":
      return {
        actionType: "SIGN_UP",
        icon: "book",
        label: "Sign up",
        url: e.url
      };
    default:
      return null;
  }
}, _E = (e) => e && typeof e == "object" ? e : null, kE = (e) => !!(e && typeof e == "object" && e.title && e.startDate && e.endDate), NE = (e) => {
  if (!e?.startDate || !e?.endDate)
    return "";
  const t = new Date(e.startDate), s = new Date(e.endDate);
  return Number.isNaN(t.getTime()) || Number.isNaN(s.getTime()) ? "" : `${TE(t)}, ${Da(t)} - ${Da(s)}`;
}, TE = (e) => new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  timeZone: "UTC"
}).format(e), Da = (e) => new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  hour12: !0,
  minute: "2-digit",
  timeZone: "UTC"
}).format(e).toLowerCase(), SE = (e, t) => {
  if (!t)
    switch (e) {
      case "gmb-carousel":
      case "gmb-carousel-book":
        return "sp-h-[492px]";
      case "gmb-single-image":
      case "gmb-single-image-book":
      case "gmb-single-image-buy":
      case "gmb-single-image-learn-more":
      case "gmb-single-image-sign-up":
        return "sp-min-h-[416px]";
      case "gmb-link":
      case "gmb-text":
        return "sp-min-h-[88px]";
      default:
        return "sp-h-[416px]";
    }
  switch (e) {
    case "gmb-carousel":
    case "gmb-carousel-book":
      return "sp-h-[616px]";
    case "gmb-single-image":
    case "gmb-single-image-book":
    case "gmb-single-image-buy":
    case "gmb-single-image-learn-more":
    case "gmb-single-image-sign-up":
      return "sp-min-h-[416px]";
    case "gmb-link":
      return "sp-min-h-[252px]";
    case "gmb-text":
      return "sp-min-h-[192px]";
    default:
      return "sp-h-[540px]";
  }
}, PE = (e) => _e(e), Hu = (...e) => e.filter(Boolean).join(" "), IE = /(https?:\/\/[^\s]+)/g, OE = /^https?:\/\/[^\s]+$/, Gu = ({
  children: e,
  className: t = "sp-text-current",
  fill: s = "none",
  size: r = 24,
  viewBox: n = "0 0 24 24"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: s, height: r, viewBox: n, width: r, children: e }), LE = ({
  icon: e
}) => {
  switch (e) {
    case "book":
      return /* @__PURE__ */ u.jsx(UE, {});
    case "shopping-cart":
      return /* @__PURE__ */ u.jsx(zE, {});
    default:
      return /* @__PURE__ */ u.jsx(HE, {});
  }
}, RE = () => /* @__PURE__ */ u.jsxs(Gu, { className: "sp-absolute -sp-bottom-1 -sp-right-1", fill: "none", size: 24, viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ u.jsx("path", { d: "M12 2.5 5 5.6v5.7c0 4.4 2.8 8.4 7 9.9 4.2-1.5 7-5.5 7-9.9V5.6l-7-3.1Z", fill: "#3771e0" }),
  /* @__PURE__ */ u.jsx("path", { d: "m8.1 11.8 2.5 2.5 5.4-5.7", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })
] }), $E = () => /* @__PURE__ */ u.jsx(Gu, { children: /* @__PURE__ */ u.jsx("path", { d: "M12 4v10m0-10 3.5 3.5M12 4 8.5 7.5M5 11v8h14v-8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), ME = () => /* @__PURE__ */ u.jsxs(Gu, { fill: "currentColor", children: [
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "5", r: "1.8" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "12", r: "1.8" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "19", r: "1.8" })
] }), UE = () => /* @__PURE__ */ u.jsx(Gu, { children: /* @__PURE__ */ u.jsx("path", { d: "M7 4h10v16l-5-3-5 3V4Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "2" }) }), HE = () => /* @__PURE__ */ u.jsxs(Gu, { children: [
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "2" }),
  /* @__PURE__ */ u.jsx("path", { d: "M12 10v6m0-9h.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2" })
] }), zE = () => /* @__PURE__ */ u.jsx(Gu, { children: /* @__PURE__ */ u.jsx("path", { d: "M4 5h2l2 10h9.5l2-7H7m2 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), VE = /* @__PURE__ */ new Set(["image", "multiMedia", "story", "video"]), WE = (e) => e.platform === "SC" && VE.has(e.type) && !!Z0(e), GE = ({
  post: e,
  className: t,
  videoCoverPreview: s
}) => {
  const r = Z0(e);
  return r ? /* @__PURE__ */ u.jsxs("div", { className: ["sp-relative sp-mx-auto sp-h-[823px] sp-w-[400px] sp-overflow-hidden sp-rounded-t-[16px] sp-bg-[#1e1e1e] sp-font-sans sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "), "data-preview-platform": "SC", "data-preview-variant": "uplift", "data-snapchat-media-count": e.medias.count, "data-uplift-layout": "snapchat-default", "data-uplift-renderer": "snapchat", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-0 sp-top-0 sp-h-[704px] sp-w-full sp-overflow-hidden sp-bg-white", "data-uplift-media-frame-ratio": "400 / 704", children: [
      /* @__PURE__ */ u.jsx(qE, { media: r, videoCoverPreview: s }),
      /* @__PURE__ */ u.jsx(ZE, { post: e })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-absolute sp-left-[180.5px] sp-top-[712px] sp-h-[6px] sp-w-[39px] sp-rounded-lg sp-bg-[#717171]" }),
    /* @__PURE__ */ u.jsx(KE, {})
  ] }) : null;
}, qE = ({
  media: e,
  videoCoverPreview: t
}) => /* @__PURE__ */ u.jsx(xe, { className: "sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full sp-bg-[#f2f2f2] sp-object-cover", coverScope: "singlePostOnly", customVideoControls: YE(e), media: e, platform: "SC", surface: "story", videoCoverPreview: t }), ZE = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-justify-between sp-text-white", children: [
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2", children: [
    /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-10 sp-w-10 sp-shrink-0", src: e.profilePicture }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5", children: e.username }),
      /* @__PURE__ */ u.jsx("div", { className: "sp-text-xs sp-font-medium sp-leading-4 sp-text-white/80", children: "Just now" })
    ] })
  ] }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-shrink-0 sp-items-center sp-gap-4", children: [
    /* @__PURE__ */ u.jsx(XE, {}),
    /* @__PURE__ */ u.jsx(JE, {})
  ] })
] }), KE = () => /* @__PURE__ */ u.jsxs("div", { className: "sp-absolute sp-left-0 sp-top-[726px] sp-box-border sp-flex sp-h-[50px] sp-w-full sp-items-start sp-gap-4 sp-px-2", children: [
  /* @__PURE__ */ u.jsx(pa, { className: "sp-w-16", children: /* @__PURE__ */ u.jsx(QE, {}) }),
  /* @__PURE__ */ u.jsx("div", { className: "sp-flex sp-h-[50px] sp-min-w-0 sp-flex-1 sp-items-center sp-rounded-[40px] sp-bg-[#404040] sp-px-4 sp-text-base sp-font-semibold sp-leading-5", children: "Send a Chat" }),
  /* @__PURE__ */ u.jsx(pa, { className: "sp-w-16", children: /* @__PURE__ */ u.jsx(e3, {}) })
] }), pa = ({
  children: e,
  className: t
}) => /* @__PURE__ */ u.jsx("div", { className: ["sp-flex sp-h-[50px] sp-shrink-0 sp-items-center sp-justify-center sp-rounded-[40px] sp-bg-[#404040] sp-text-white", t].filter(Boolean).join(" "), children: e }), Z0 = (e) => {
  const t = e.medias.collection[0];
  return t?.url || t?.thumbnailUrl ? t : e.imageUrl ? {
    isVideo: e.type === "video",
    thumbnailUrl: e.imageUrl,
    url: e.imageUrl
  } : null;
}, YE = (e) => _e(e), As = ({
  children: e,
  className: t = "sp-text-current",
  fill: s = "none",
  size: r = 24,
  viewBox: n = "0 0 24 24"
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: t, fill: s, height: r, viewBox: n, width: r, children: e }), XE = () => /* @__PURE__ */ u.jsxs(As, { size: 24, children: [
  /* @__PURE__ */ u.jsx("path", { d: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
  /* @__PURE__ */ u.jsx("path", { d: "M13.7 21a2 2 0 0 1-3.4 0", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })
] }), JE = () => /* @__PURE__ */ u.jsxs(As, { fill: "currentColor", size: 24, children: [
  /* @__PURE__ */ u.jsx("circle", { cx: "5", cy: "12", r: "2" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "12", r: "2" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "19", cy: "12", r: "2" })
] }), QE = () => /* @__PURE__ */ u.jsxs(As, { size: 32, viewBox: "0 0 32 32", children: [
  /* @__PURE__ */ u.jsx("path", { d: "M9.5 10 11 7h10l1.5 3H26a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "2.4" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "16", cy: "17", r: "5", stroke: "currentColor", strokeWidth: "2.4" })
] }), e3 = () => /* @__PURE__ */ u.jsx(As, { fill: "currentColor", size: 32, viewBox: "0 0 32 32", children: /* @__PURE__ */ u.jsx("path", { d: "M27.6 4.8 4.5 15.1c-1.8.8-1.6 3.5.3 4l8.1 2.1 2.1 8.1c.5 1.9 3.2 2.1 4 .3L29.2 6.4c.5-1.1-.5-2.1-1.6-1.6Zm-5.5 7.1-5.8 13.2-1.2-4.8 7-8.4Zm-8.4 7-4.8-1.2 13.2-5.8-8.4 7Z" }) }), u3 = (e) => e.platform === "YT" && e.type === "video", t3 = ({
  post: e,
  className: t,
  videoCoverPreview: s
}) => {
  const r = r3(e), n = be(e.caption), i = Wu({
    media: r,
    platform: "YT",
    surface: "video"
  });
  return /* @__PURE__ */ u.jsxs("article", { className: ["sp-mx-auto sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "), "data-preview-platform": "YT", "data-preview-variant": "uplift", "data-uplift-layout": "youtube-video", "data-uplift-renderer": "youtube", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-relative sp-w-full sp-overflow-hidden sp-bg-black", "data-uplift-media-frame-ratio": i.publishedRatio, style: {
      aspectRatio: i.publishedRatio
    }, children: /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", media: r, platform: "YT", surface: "video", videoCoverPreview: s }) }),
    /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-flex-col sp-gap-3 sp-p-4", children: [
      /* @__PURE__ */ u.jsx("div", { className: "sp-line-clamp-2 sp-text-lg sp-font-semibold sp-leading-6", children: e.ytTitle || "Untitled video" }),
      /* @__PURE__ */ u.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-10 sp-w-10", src: e.profilePicture }),
        /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0", children: [
          /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-sm sp-font-semibold sp-leading-5", children: e.username }),
          /* @__PURE__ */ u.jsx("div", { className: "sp-text-xs sp-leading-4 sp-text-[#606060]", children: "Just now" })
        ] })
      ] }),
      n ? /* @__PURE__ */ u.jsx("div", { className: "sp-line-clamp-3 sp-whitespace-pre-line sp-break-words sp-text-sm sp-leading-5 sp-text-[#333] [&_a]:sp-text-[#065fd4] [&_a]:sp-no-underline", children: /* @__PURE__ */ u.jsx(le, { caption: e.caption }) }) : null,
      /* @__PURE__ */ u.jsx(s3, {})
    ] })
  ] });
}, s3 = () => /* @__PURE__ */ u.jsxs("footer", { className: "sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-pt-3 sp-text-xs sp-font-medium sp-leading-none sp-text-[#606060]", children: [
  /* @__PURE__ */ u.jsx(Ar, { icon: /* @__PURE__ */ u.jsx(n3, {}), label: "Like" }),
  /* @__PURE__ */ u.jsx(Ar, { icon: /* @__PURE__ */ u.jsx(i3, {}), label: "Comment" }),
  /* @__PURE__ */ u.jsx(Ar, { icon: /* @__PURE__ */ u.jsx(a3, {}), label: "Share" })
] }), Ar = ({
  icon: e,
  label: t
}) => /* @__PURE__ */ u.jsxs("span", { className: "sp-flex sp-items-center sp-gap-1.5", children: [
  e,
  t
] }), r3 = (e) => {
  const t = e.medias.collection[0];
  return t || {
    isVideo: !0,
    thumbnailUrl: e.imageUrl,
    url: e.imageUrl
  };
}, Fn = ({
  children: e
}) => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", fill: "none", height: "18", viewBox: "0 0 24 24", width: "18", children: e }), n3 = () => /* @__PURE__ */ u.jsx(Fn, { children: /* @__PURE__ */ u.jsx("path", { d: "M7 10v10H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3Zm0 0 4.6-6.2c.6-.8 1.9-.4 1.9.6V9h4.3a2 2 0 0 1 2 2.3l-1 6.5a2 2 0 0 1-2 1.7H7V10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), i3 = () => /* @__PURE__ */ u.jsx(Fn, { children: /* @__PURE__ */ u.jsx("path", { d: "M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }) }), a3 = () => /* @__PURE__ */ u.jsxs(Fn, { children: [
  /* @__PURE__ */ u.jsx("path", { d: "M18 8 8 13l10 5V8Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8" }),
  /* @__PURE__ */ u.jsx("path", { d: "M8 13H3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.8" })
] }), o3 = /* @__PURE__ */ new Set(["image", "multiMedia", "story", "text", "video"]), l3 = (e) => e.platform === "OT" && o3.has(e.type), c3 = ({
  post: e,
  className: t,
  videoCoverPreview: s
}) => {
  const r = F3(e), n = m3(e, r), i = be(e.caption);
  return /* @__PURE__ */ u.jsxs("article", { className: ["sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "), "data-preview-platform": "OT", "data-preview-variant": "uplift", "data-uplift-layout": n, "data-uplift-renderer": "other-notification", children: [
    /* @__PURE__ */ u.jsx(D3, { post: e }),
    i ? /* @__PURE__ */ u.jsx(p3, { caption: e.caption }) : null,
    r ? /* @__PURE__ */ u.jsx(d3, { media: r, post: e, videoCoverPreview: s }) : null,
    e.redirectUrl && !r ? /* @__PURE__ */ u.jsx(f3, { url: e.redirectUrl }) : null,
    /* @__PURE__ */ u.jsx(h3, { hasRedirect: !!e.redirectUrl })
  ] });
}, D3 = ({
  post: e
}) => /* @__PURE__ */ u.jsxs("header", { className: "sp-flex sp-items-center sp-gap-3 sp-p-4 sp-pb-0", children: [
  /* @__PURE__ */ u.jsx(Be, { alt: e.username, className: "sp-h-10 sp-w-10 sp-shrink-0", src: e.profilePicture }),
  /* @__PURE__ */ u.jsxs("div", { className: "sp-min-w-0 sp-flex-1", children: [
    /* @__PURE__ */ u.jsx("div", { className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5", children: e.username }),
    /* @__PURE__ */ u.jsx("div", { className: "sp-text-sm sp-leading-5 sp-text-[#737373]", children: "Notification preview" })
  ] }),
  /* @__PURE__ */ u.jsx(E3, {})
] }), p3 = ({
  caption: e
}) => /* @__PURE__ */ u.jsx("div", { className: "sp-line-clamp-4 sp-whitespace-pre-line sp-break-words sp-px-4 sp-pt-3 sp-text-base sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline", children: /* @__PURE__ */ u.jsx(le, { caption: e }) }), d3 = ({
  media: e,
  post: t,
  videoCoverPreview: s
}) => {
  const r = _e(e), n = r ? "video" : t.type === "story" ? "story" : "feed", i = Wu({
    media: e,
    platform: "OT",
    surface: n
  }), a = /* @__PURE__ */ u.jsxs(Mu, { className: "sp-relative sp-w-full sp-rounded-lg", "data-uplift-media-frame-ratio": i.publishedRatio, style: {
    aspectRatio: i.publishedRatio
  }, children: [
    /* @__PURE__ */ u.jsx(xe, { className: "sp-h-full sp-w-full", coverScope: "singlePostOnly", media: e, platform: "OT", surface: n, videoCoverPreview: r ? s : void 0 }),
    t.medias.count > 1 ? /* @__PURE__ */ u.jsxs("span", { className: "sp-absolute sp-right-2 sp-top-2 sp-rounded-full sp-bg-black/50 sp-px-2 sp-py-1 sp-text-xs sp-font-medium sp-leading-none sp-text-white", children: [
      "1/",
      t.medias.count
    ] }) : null
  ] });
  return t.redirectUrl ? /* @__PURE__ */ u.jsx("a", { className: "sp-mx-4 sp-mt-3 sp-block sp-text-inherit sp-no-underline", "data-other-notification-redirect": "true", href: t.redirectUrl, rel: "noreferrer", target: "_blank", children: a }) : /* @__PURE__ */ u.jsx("div", { className: "sp-mx-4 sp-mt-3", children: a });
}, f3 = ({
  url: e
}) => /* @__PURE__ */ u.jsxs("a", { className: "sp-mx-4 sp-mt-3 sp-flex sp-items-center sp-justify-between sp-rounded-lg sp-border sp-border-solid sp-border-[#d6d6d6] sp-px-3 sp-py-2 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#1877f2] sp-no-underline", "data-other-notification-redirect": "true", href: e, rel: "noreferrer", target: "_blank", children: [
  /* @__PURE__ */ u.jsx("span", { className: "sp-truncate", children: C3(e) }),
  /* @__PURE__ */ u.jsx(x3, {})
] }), h3 = ({
  hasRedirect: e
}) => /* @__PURE__ */ u.jsxs("footer", { className: "sp-mt-4 sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-px-4 sp-py-3 sp-text-sm sp-font-medium sp-leading-none sp-text-[#737373]", children: [
  /* @__PURE__ */ u.jsx("span", { children: "Preview" }),
  e ? /* @__PURE__ */ u.jsx("span", { children: "Open link" }) : /* @__PURE__ */ u.jsx("span", { children: "Draft" })
] }), F3 = (e) => {
  if (e.type === "text")
    return;
  const t = e.medias.collection[0];
  if (t)
    return t;
  if (e.type === "image" || e.type === "video")
    return {
      isVideo: e.type === "video",
      thumbnailUrl: e.imageUrl,
      url: e.imageUrl
    };
}, m3 = (e, t) => t ? e.type === "story" ? "other-notification-story-first-media" : e.type === "multiMedia" ? "other-notification-multimedia-first-media" : _e(t) ? "other-notification-video" : "other-notification-image" : "other-notification-text", C3 = (e) => {
  try {
    return new URL(e).hostname.replace(/^www\./, "");
  } catch {
    return e;
  }
}, E3 = () => /* @__PURE__ */ u.jsxs("svg", { "aria-hidden": "true", className: "sp-h-6 sp-w-6 sp-text-[#737373]", fill: "currentColor", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ u.jsx("circle", { cx: "6", cy: "12", r: "1.5" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "12", cy: "12", r: "1.5" }),
  /* @__PURE__ */ u.jsx("circle", { cx: "18", cy: "12", r: "1.5" })
] }), x3 = () => /* @__PURE__ */ u.jsx("svg", { "aria-hidden": "true", className: "sp-h-4 sp-w-4 sp-shrink-0", fill: "none", viewBox: "0 0 24 24", children: /* @__PURE__ */ u.jsx("path", { d: "M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4m-7-9h7m0 0v7m0-7-9 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }) }), I3 = (e) => {
  const t = s0(e);
  return t ? K0(i0(t)) !== null : !1;
}, K0 = (e) => cF(e) ? "facebook" : PF(e) ? "instagram" : fm(e) ? "linkedin" : Xm(e) ? "twitter" : CC(e) ? "threads" : RC(e) ? "pinterest" : eE(e) ? "tiktok" : xE(e) ? "google-my-business" : WE(e) ? "snapchat" : u3(e) ? "youtube" : l3(e) ? "other-notification" : null, A3 = ({
  post: e,
  trackEvent: t,
  className: s,
  videoCoverPreview: r,
  preferVideoCoverPreviewOverride: n
}) => {
  const i = i0(e), a = K0(i);
  return a === "facebook" ? /* @__PURE__ */ u.jsx(DF, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "instagram" ? /* @__PURE__ */ u.jsx(IF, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "linkedin" ? /* @__PURE__ */ u.jsx(hm, { post: i, className: s, videoCoverPreview: r, preferVideoCoverPreviewOverride: n, trackEvent: t }) : a === "twitter" ? /* @__PURE__ */ u.jsx(Jm, { post: i, className: s, videoCoverPreview: r, trackEvent: t }) : a === "threads" ? /* @__PURE__ */ u.jsx(EC, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "pinterest" ? /* @__PURE__ */ u.jsx($C, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "tiktok" ? /* @__PURE__ */ u.jsx(uE, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "google-my-business" ? /* @__PURE__ */ u.jsx(AE, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "snapchat" ? /* @__PURE__ */ u.jsx(GE, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "youtube" ? /* @__PURE__ */ u.jsx(t3, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : a === "other-notification" ? /* @__PURE__ */ u.jsx(c3, { post: i, className: s, trackEvent: t, videoCoverPreview: r }) : null;
}, O3 = ({
  post: e,
  trackEvent: t,
  className: s,
  env: r,
  videoCoverPreview: n,
  preferVideoCoverPreviewOverride: i,
  previewVariant: a = "legacy"
}) => {
  const l = s0(e);
  return /* @__PURE__ */ u.jsx(mh, { post: e || {}, children: /* @__PURE__ */ u.jsx(g3, { post: l, trackEvent: t, className: s, videoCoverPreview: n, env: r, preferVideoCoverPreviewOverride: i, previewVariant: a, legacyContextPost: e }, e?.id) });
}, g3 = ({
  post: e,
  trackEvent: t,
  className: s,
  env: r,
  videoCoverPreview: n,
  preferVideoCoverPreviewOverride: i,
  previewVariant: a = "legacy",
  legacyContextPost: l
}) => {
  if (e === null)
    throw new Error("PreviewBuilder: null post, unknown platform");
  if (!xh(e))
    return /* @__PURE__ */ u.jsx(gr, { children: /* @__PURE__ */ u.jsx(zi, { className: s, post: e }) });
  if (a === "uplift") {
    const o = A3({
      post: e,
      trackEvent: t,
      className: s,
      videoCoverPreview: n,
      preferVideoCoverPreviewOverride: i
    });
    return o || /* @__PURE__ */ u.jsx(gr, { children: /* @__PURE__ */ u.jsx(zi, { className: s, copy: {
      title: "Post preview not available",
      message: "This post type is not available in the new preview yet."
    }, post: e }) });
  }
  return /* @__PURE__ */ u.jsx(gr, { children: /* @__PURE__ */ u.jsx(sn.Provider, { value: {
    post: l,
    className: s,
    env: r,
    videoCoverPreview: n,
    preferVideoCoverPreviewOverride: i,
    previewVariant: a
  }, children: /* @__PURE__ */ u.jsx(v3, { post: e, trackEvent: t, className: s, env: r, videoCoverPreview: n }) }) });
}, v3 = ({
  post: e,
  trackEvent: t,
  className: s,
  env: r,
  videoCoverPreview: n
}) => {
  if (e === null)
    throw new Error("PreviewBuilder: null post, unknown platform");
  const i = e.platform;
  switch (i) {
    case "IG":
      return /* @__PURE__ */ u.jsx(Fd, { post: e, className: s, env: r });
    case "FB":
      return /* @__PURE__ */ u.jsx(kd, { post: e });
    case "TW":
      return /* @__PURE__ */ u.jsx(Ud, { post: e });
    case "LI":
      return /* @__PURE__ */ u.jsx(p2, { post: e, trackEvent: t });
    case "GMB":
      return /* @__PURE__ */ u.jsx(j2, { post: e });
    case "YT":
      return /* @__PURE__ */ u.jsx(I2, { post: e });
    case "PI":
      return /* @__PURE__ */ u.jsx(q2, { post: e });
    case "SC":
      return /* @__PURE__ */ u.jsx(hf, { post: e });
    case "TT":
      return /* @__PURE__ */ u.jsx(qf, { post: e, env: r, videoCoverPreview: n });
    case "TH":
      return /* @__PURE__ */ u.jsx(rh, { post: e });
    case "OT":
      return /* @__PURE__ */ u.jsx(Fh, { post: e });
    default:
      throw new Error(`PreviewBuilder: unknown platform ${i}`);
  }
}, gr = _.div`
  font-family:
    "Gotham SSm A", "Gotham SSm B", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`, da = /^https?:\/\/sked-customer-uploads\.s3(\.[a-z0-9-]+)?\.amazonaws\.com\/(.+)$/, fa = "https://s3.amazonaws.com/sked-customer-uploads", ha = "https://customer-uploads.skedsocial.com";
function os(e) {
  return !e || typeof e != "string" ? e : da.test(e) ? e.replace(da, ha + "/$2") : e.startsWith(fa) ? e.replace(fa, ha) : e;
}
class Y0 {
  constructor(t) {
    this.medias = [t], t.mediaFiles && t.mediaFiles.length > 0 && (this.medias = t.mediaFiles.map((s, r) => r !== 0 || !t.thumbnailUrl || !y3(s) || !B3(t) ? s : {
      ...s,
      thumbnailUrl: t.thumbnailUrl
    })), this.collection = this.buildCollection(this.medias), this.count = this.collection.length;
  }
  buildCollection(t) {
    let s = t.map((r) => {
      if (r.url) {
        const i = (r.url.toLowerCase().endsWith(".heic") || r.url.toLowerCase().endsWith(".heif")) && r.thumbnailUrl ? r.thumbnailUrl : r.url;
        return {
          thumbnailUrl: os(r.thumbnailUrl),
          fileName: r.fileName,
          pages: r.meta?.pages ?? r.pages,
          width: r.meta?.width ?? r.width,
          height: r.meta?.height ?? r.height,
          url: os(i),
          type: r.type,
          isVideo: r.isVideo
        };
      }
    });
    return s[0] ? s : [];
  }
}
function y3(e) {
  return e?.isVideo === !0;
}
function B3(e) {
  return e?.platform === "LI" || e?.platformType === "LI" || e?.platforms?.[0]?.platformType === "LI";
}
class L3 {
  constructor(t, s, r, n) {
    this.providedPost = t, this.id = t.post_id, this.stage = t.post_stage, this.caption = t.caption, this.currentStatusKey = t.post_status_key, this.rejectionReason = "", this.scheduledFor = t.when, this.image_url = os(t.url), this.comment = t.firstcomment || t.first_comment, this.locationName = t.location && t.location.name, this.redirectUrl = t.redirectUrl ? t.redirectUrl : "", this.storyUrl = t.storyUrl ? t.storyUrl : "", this.storyLabel = t.storyLabel ? t.storyLabel : "", this.storyStickerHeight = t.storyStickerHeight ? t.storyStickerHeight : null, this.medias = new Y0(t), this.callToAction = t.gmbCallToAction ? t.gmbCallToAction : "", this.event = t.gmbEvent ? t.gmbEvent : "", this.topicType = t.gmbTopicType ? t.gmbTopicType : null, this.offer = t.gmbOffer ? {
      ...t.gmbOffer,
      redeemOnlineUrl: t.gmbOffer.redeemOnlineUrl || t.redirectUrl
    } : null, this.platform = t.platform, this.type = t.type, this.storyType = t.storyType || null, this.ytTitle = t.ytTitle || null, this.ytCategoryId = t.ytCategoryId || null, this.ytTags = t.ytTags || "", s && s.username ? (this.username = s.username, this.profilePicture = s.profile_picture_url) : t.username || t.profilePicture ? (this.username = t.username, this.profilePicture = t.profilePicture) : (this.username = "Failed to find account", this.profilePicture = "https://picsum.photos/id/1/200/200"), this.approvedKey = r, this.rejectedKey = n;
    let i = null, a = null;
    if (t.piBoards && t.piBoards.length > 0 && s.boards && s.boards.length > 0) {
      let l = s.boards.find((o) => o.id === t.piBoards[0]);
      if (l && (i = l.name, l.sections && l.sections.length > 0 && t.piSectionId)) {
        let o = l.sections.find((D) => D.id === t.piSectionId);
        o && (a = o.title);
      }
    }
    this.boardTitle = i || null, this.boardSectionTitle = a || null, this.piTitle = t.piTitle || null, this.postOptions = t.postOptions || null;
  }
  get status() {
    switch (this.currentStatusKey) {
      case this.approvedKey:
        return "approved";
      case this.rejectedKey:
        return "rejected";
      default:
        return "initial";
    }
  }
  approve() {
    this.currentStatusKey = this.approvedKey;
  }
  reject(t) {
    this.currentStatusKey = this.rejectedKey, this.rejectionReason = t;
  }
}
class R3 {
  constructor(t, s) {
    const r = t.schedule ? t.schedule : t;
    this.providedPost = r, this.id = r._id, this.stage = "draft", r.scheduledFor ? this.stage = "scheduled" : r.queued && (this.stage = "queued"), this.caption = r.caption || "", this.currentStatusKey = r.normalizedPost_status_key, this.rejectionReason = "", this.scheduledFor = r.when, this.image_url = os(r.url), this.comment = r.firstcomment || "", this.locationName = r.location && r.location.name, this.redirectUrl = r.redirectUrl ? r.redirectUrl : "", this.storyUrl = r.storyUrl ? r.storyUrl : "", this.storyLabel = r.storyLabel ? r.storyLabel : "", this.storyStickerHeight = r.storyStickerHeight ? r.storyStickerHeight : null, this.callToAction = r.gmbCallToAction ? r.gmbCallToAction : "", this.event = r.gmbEvent ? r.gmbEvent : "", this.topicType = r.gmbTopicType ? r.gmbTopicType : null, this.offer = r.gmbOffer ? {
      ...r.gmbOffer,
      redeemOnlineUrl: r.gmbOffer.redeemOnlineUrl || r.redirectUrl
    } : null, this.medias = new Y0(r), this.platform = r.platformType || "IG", r.platforms && r.platforms.length > 0 && (this.platform = r.platforms[0].platformType), this.type = r.type, this.storyType = r.storyType || null, this.username = s.login, this.profilePicture = s.profilePictureUrl || "", this.ytTitle = r.ytTitle || null, this.ytCategoryId = r.ytCategoryId || null, this.ytTags = r.ytTags || "";
    let n = "", i = null;
    if (r.piBoards && r.piBoards.length > 0 && s.boards && s.boards.length > 0) {
      let a = s.boards.find((l) => l.id === r.piBoards[0]);
      if (a && (n = a.name, a.sections && a.sections.length > 0 && r.piSectionId)) {
        let l = a.sections.find((o) => o.id === r.piSectionId);
        l && (i = l.title);
      }
    }
    this.boardTitle = n || null, this.boardSectionTitle = i || null, this.piTitle = r.piTitle || null, this.postOptions = r.postOptions || null;
  }
}
export {
  Eh as P,
  le as R,
  k3 as S,
  k1 as a,
  Ch as b,
  L3 as c,
  R3 as d,
  O3 as e,
  I3 as f,
  Au as g,
  T3 as h,
  is as i,
  Hh as j,
  S3 as k,
  Mh as l,
  gh as m,
  e0 as n,
  N3 as o,
  Ah as p,
  vh as q,
  ms as r,
  yh as s,
  xh as t,
  P3 as u,
  n0 as v,
  zh as w,
  Uh as x
};
//# sourceMappingURL=sked-preview-sCNY_GbN.js.map
